/**
* We are assuming that this file will be places along the protocol directory.
* SRC
*    - autogenerated/ZoomBridge.js
*    - protocol/<All Protocol required files>
*/
// *********** IMPORT START ********************
import AbstractMap from "../protocol/AbstractMap";
import Collection from "../protocol/Collection";
import ErrorId from "../protocol/ErrorId";
import HashMap from "../protocol/HashMap";
import HashMapIterator from "../protocol/HashMapIterator";
import HashSet from "../protocol/HashSet";
import HashSetIterator from "../protocol/HashSetIterator";
import HttpOperation from "../protocol/HttpOperation";
import IAuthenticator from  "../protocol/IAuthenticator";
import Iterator from "../protocol/Iterator";
import MapEntry from "../protocol/MapEntry";
import SerializationUtil from "../protocol/SerializationUtil";
// *********** IMPORT END ********************

/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AutoCompleteEntry {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._humanReadableName = null;
    /**
     * @type {number}
     * @private
     */
    this._userImageId = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {string}
     * @private
     */
    this._email = null;

  }

    /**
   * @return {string}
   */
  getHumanReadableName() {
    return this._humanReadableName;
  }

  /**
   * @param humanReadableName{string}
   * @return {AutoCompleteEntry}
   */
  setHumanReadableName(humanReadableName) {
    this._humanReadableName = humanReadableName;
    return this;
  }
  /**
   * @return {number}
   */
  getUserImageId() {
    return this._userImageId;
  }

  /**
   * @param userImageId{number}
   * @return {AutoCompleteEntry}
   */
  setUserImageId(userImageId) {
    this._userImageId = userImageId;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {AutoCompleteEntry}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {string}
   */
  getEmail() {
    return this._email;
  }

  /**
   * @param email{string}
   * @return {AutoCompleteEntry}
   */
  setEmail(email) {
    this._email = email;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AutoCompleteEntry.CLASS_ID;
    
	//Serializing _humanReadableName
	if (this._humanReadableName)
		json['humanReadableName'] = this._humanReadableName;

	//Serializing _userImageId
	if (this._userImageId)
		json['userImageId'] = this._userImageId;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;

	//Serializing _email
	if (this._email)
		json['email'] = this._email;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._humanReadableName = json.hasOwnProperty("humanReadableName")?json["humanReadableName"]:null;
		this._userImageId = json.hasOwnProperty("userImageId")?json["userImageId"]:0;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
		this._email = json.hasOwnProperty("email")?json["email"]:null;


  }
}

/**
 * @returns {string}
 */
AutoCompleteEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.AutoCompleteEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MoveAssetsMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._sourceBranch = null;
    /**
     * @type {string}
     * @private
     */
    this._destPath = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2PathMap = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {string}
   */
  getSourceBranch() {
    return this._sourceBranch;
  }

  /**
   * @param sourceBranch{string}
   * @return {MoveAssetsMessage}
   */
  setSourceBranch(sourceBranch) {
    this._sourceBranch = sourceBranch;
    return this;
  }
  /**
   * @return {string}
   */
  getDestPath() {
    return this._destPath;
  }

  /**
   * @param destPath{string}
   * @return {MoveAssetsMessage}
   */
  setDestPath(destPath) {
    this._destPath = destPath;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {MoveAssetsMessage}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {java.util.Map<number,String>}
   */
  getFuid2PathMap() {
    return this._fuid2PathMap;
  }

  /**
   * @param fuid2PathMap{java.util.Map<number,String>}
   * @return {MoveAssetsMessage}
   */
  setFuid2PathMap(fuid2PathMap) {
    this._fuid2PathMap = fuid2PathMap;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {MoveAssetsMessage}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MoveAssetsMessage.CLASS_ID;
    
	//Serializing _sourceBranch
	if (this._sourceBranch)
		json['sourceBranch'] = this._sourceBranch;

	//Serializing _destPath
	if (this._destPath)
		json['destPath'] = this._destPath;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;
    SerializationUtil.serializeHashMap(json,"fuid2PathMap", this._fuid2PathMap);
		    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._sourceBranch = json.hasOwnProperty("sourceBranch")?json["sourceBranch"]:null;
		this._destPath = json.hasOwnProperty("destPath")?json["destPath"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
//Map of type INT. Decode as tree:false
		if (this._fuid2PathMap == null)
			this._fuid2PathMap = new HashMap();
		this._fuid2PathMap.clear();
		let fuid2PathMapJSONArray = json.hasOwnProperty("fuid2PathMap") ? json["fuid2PathMap"] : [];
		this._fuid2PathMap = SerializationUtil.deserializeMap(fuid2PathMapJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
MoveAssetsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.MoveAssetsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetCollectionSettingsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._propName2ValueMap = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SetCollectionSettingsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {SetCollectionSettingsMessage}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getPropName2ValueMap() {
    return this._propName2ValueMap;
  }

  /**
   * @param propName2ValueMap{java.util.Map<String,String>}
   * @return {SetCollectionSettingsMessage}
   */
  setPropName2ValueMap(propName2ValueMap) {
    this._propName2ValueMap = propName2ValueMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetCollectionSettingsMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;
    SerializationUtil.serializeHashMap(json,"propName2ValueMap", this._propName2ValueMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
//Map of type STRING. Decode as tree:false
		if (this._propName2ValueMap == null)
			this._propName2ValueMap = new HashMap();
		this._propName2ValueMap.clear();
		let propName2ValueMapJSONArray = json.hasOwnProperty("propName2ValueMap") ? json["propName2ValueMap"] : [];
		this._propName2ValueMap = SerializationUtil.deserializeMap(propName2ValueMapJSONArray);



  }
}

/**
 * @returns {string}
 */
SetCollectionSettingsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionSettingsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetSpotLightQueryRes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._hasMoreEntries = false;
    /**
     * @type {Array<SpotLightDetail>}
     * @private
     */
    this._spotLightDetails = null;

  }

    /**
   * @return {boolean}
   */
  isHasMoreEntries() {
    return this._hasMoreEntries;
  }

  /**
   * @param hasMoreEntries{boolean}
   * @return {GetSpotLightQueryRes}
   */
  setHasMoreEntries(hasMoreEntries) {
    this._hasMoreEntries = hasMoreEntries;
    return this;
  }
  /**
   * @return {Array<SpotLightDetail>}
   */
  getSpotLightDetails() {
    return this._spotLightDetails;
  }

  /**
   * @param spotLightDetails{Array<SpotLightDetail>}
   * @return {GetSpotLightQueryRes}
   */
  setSpotLightDetails(spotLightDetails) {
    this._spotLightDetails = spotLightDetails;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetSpotLightQueryRes.CLASS_ID;
    
	//Serializing _hasMoreEntries
	if (this._hasMoreEntries)
		json['hasMoreEntries'] = this._hasMoreEntries;
  if (this._spotLightDetails && this._spotLightDetails.length > 0) {
    let spotLightDetails_JSON = [];
    /**
     * @type {SpotLightDetail}
     */
    this._spotLightDetails.forEach((o318) => {
      if (o318) {
        if (o318.serializeJson && (typeof (o318.serializeJson) === 'function')) {
          spotLightDetails_JSON.push(o318.serializeJson());
        } else {
          spotLightDetails_JSON.push(o318);
        }
      }
    });
    json['spotLightDetails'] = spotLightDetails_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._hasMoreEntries = json.hasOwnProperty("hasMoreEntries")?json["hasMoreEntries"]:false;
		//set of type SpotLightDetail
		this._spotLightDetails = [];
		let spotLightDetailsJSONArray = json.hasOwnProperty("spotLightDetails") ? json["spotLightDetails"] : [];

		spotLightDetailsJSONArray.forEach((o319)=>{
			if (o319){
				let classObj = new SpotLightDetail();
				classObj.deserializeJson(o319);
				this._spotLightDetails.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetSpotLightQueryRes.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSpotLightQueryRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ShareAssetsQuery extends HttpOperation {

  constructor(name = "ShareAssets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {ShareAssetsRequestData}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ShareAssetsRequestData}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {int}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ShareAssetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ShareAssetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new int();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new int();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ShareAssetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ShareAssets";
/**
 * @returns {string}
 */
ShareAssetsQuery.QUERY_NAME = "ShareAssets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LoadNextSearchPageMsg {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNo = null;
    /**
     * @type {boolean}
     * @private
     */
    this._useBrowseSession = false;
    /**
     * @type {string}
     * @private
     */
    this._searchInsideText = null;

  }

    /**
   * @return {number}
   */
  getPageNo() {
    return this._pageNo;
  }

  /**
   * @param pageNo{number}
   * @return {LoadNextSearchPageMsg}
   */
  setPageNo(pageNo) {
    this._pageNo = pageNo;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseBrowseSession() {
    return this._useBrowseSession;
  }

  /**
   * @param useBrowseSession{boolean}
   * @return {LoadNextSearchPageMsg}
   */
  setUseBrowseSession(useBrowseSession) {
    this._useBrowseSession = useBrowseSession;
    return this;
  }
  /**
   * @return {string}
   */
  getSearchInsideText() {
    return this._searchInsideText;
  }

  /**
   * @param searchInsideText{string}
   * @return {LoadNextSearchPageMsg}
   */
  setSearchInsideText(searchInsideText) {
    this._searchInsideText = searchInsideText;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LoadNextSearchPageMsg.CLASS_ID;
    
	//Serializing _pageNo
	if (this._pageNo)
		json['pageNo'] = this._pageNo;

	//Serializing _useBrowseSession
	if (this._useBrowseSession)
		json['useBrowseSession'] = this._useBrowseSession;

	//Serializing _searchInsideText
	if (this._searchInsideText)
		json['searchInsideText'] = this._searchInsideText;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNo = json.hasOwnProperty("pageNo")?json["pageNo"]:0;
		this._useBrowseSession = json.hasOwnProperty("useBrowseSession")?json["useBrowseSession"]:false;
		this._searchInsideText = json.hasOwnProperty("searchInsideText")?json["searchInsideText"]:null;


  }
}

/**
 * @returns {string}
 */
LoadNextSearchPageMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadNextSearchPageMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ResolveAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {ResolveAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ResolveAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;


  }
}

/**
 * @returns {string}
 */
ResolveAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ResolveAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetSpotLightQueryMsg {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._spotLightId = null;

  }

    /**
   * @return {number}
   */
  getSpotLightId() {
    return this._spotLightId;
  }

  /**
   * @param spotLightId{number}
   * @return {GetSpotLightQueryMsg}
   */
  setSpotLightId(spotLightId) {
    this._spotLightId = spotLightId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetSpotLightQueryMsg.CLASS_ID;
    
	//Serializing _spotLightId
	if (this._spotLightId)
		json['spotLightId'] = this._spotLightId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._spotLightId = json.hasOwnProperty("spotLightId")?json["spotLightId"]:0;


  }
}

/**
 * @returns {string}
 */
GetSpotLightQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSpotLightQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClientDelinkMsg {

  constructor() {
    
        /**
     * @type {Array<FuidBidInfoJson>}
     * @private
     */
    this._infilesJsonArray = null;

  }

    /**
   * @return {Array<FuidBidInfoJson>}
   */
  getInfilesJsonArray() {
    return this._infilesJsonArray;
  }

  /**
   * @param infilesJsonArray{Array<FuidBidInfoJson>}
   * @return {ClientDelinkMsg}
   */
  setInfilesJsonArray(infilesJsonArray) {
    this._infilesJsonArray = infilesJsonArray;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClientDelinkMsg.CLASS_ID;
      if (this._infilesJsonArray && this._infilesJsonArray.length > 0) {
    let infilesJsonArray_JSON = [];
    /**
     * @type {FuidBidInfoJson}
     */
    this._infilesJsonArray.forEach((o310) => {
      if (o310) {
        if (o310.serializeJson && (typeof (o310.serializeJson) === 'function')) {
          infilesJsonArray_JSON.push(o310.serializeJson());
        } else {
          infilesJsonArray_JSON.push(o310);
        }
      }
    });
    json['infilesJsonArray'] = infilesJsonArray_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type FuidBidInfoJson
		this._infilesJsonArray = [];
		let infilesJsonArrayJSONArray = json.hasOwnProperty("infilesJsonArray") ? json["infilesJsonArray"] : [];

		infilesJsonArrayJSONArray.forEach((o311)=>{
			if (o311){
				let classObj = new FuidBidInfoJson();
				classObj.deserializeJson(o311);
				this._infilesJsonArray.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
ClientDelinkMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ClientDelinkMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionAssetsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._showDeleted = false;
    /**
     * @type {boolean}
     * @private
     */
    this._showExpired = false;
    /**
     * @type {number}
     * @private
     */
    this._pageLimit = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showArchived = false;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuidFilters = null;

  }

    /**
   * @return {boolean}
   */
  isShowDeleted() {
    return this._showDeleted;
  }

  /**
   * @param showDeleted{boolean}
   * @return {LsZmCollectionAssetsMessage}
   */
  setShowDeleted(showDeleted) {
    this._showDeleted = showDeleted;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowExpired() {
    return this._showExpired;
  }

  /**
   * @param showExpired{boolean}
   * @return {LsZmCollectionAssetsMessage}
   */
  setShowExpired(showExpired) {
    this._showExpired = showExpired;
    return this;
  }
  /**
   * @return {number}
   */
  getPageLimit() {
    return this._pageLimit;
  }

  /**
   * @param pageLimit{number}
   * @return {LsZmCollectionAssetsMessage}
   */
  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowArchived() {
    return this._showArchived;
  }

  /**
   * @param showArchived{boolean}
   * @return {LsZmCollectionAssetsMessage}
   */
  setShowArchived(showArchived) {
    this._showArchived = showArchived;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {LsZmCollectionAssetsMessage}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {LsZmCollectionAssetsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {LsZmCollectionAssetsMessage}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }
  /**
   * If passed then only given matching fuids are returned.
   * @return {Array<Integer>}
   */
  getFuidFilters() {
    return this._fuidFilters;
  }

  /**
   * @param fuidFilters{Array<Integer>}
   * @return {LsZmCollectionAssetsMessage}
   */
  setFuidFilters(fuidFilters) {
    this._fuidFilters = fuidFilters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionAssetsMessage.CLASS_ID;
    
	//Serializing _showDeleted
	if (this._showDeleted)
		json['showDeleted'] = this._showDeleted;

	//Serializing _showExpired
	if (this._showExpired)
		json['showExpired'] = this._showExpired;

	//Serializing _pageLimit
	if (this._pageLimit)
		json['pageLimit'] = this._pageLimit;

	//Serializing _showArchived
	if (this._showArchived)
		json['showArchived'] = this._showArchived;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		  if (this._fuidFilters && this._fuidFilters.length > 0) {
    let fuidFilters_JSON = [];
    /**
     * @type {int}
     */
    this._fuidFilters.forEach((o218) => {
      if (o218) {
        if (o218.serializeJson && (typeof (o218.serializeJson) === 'function')) {
          fuidFilters_JSON.push(o218.serializeJson());
        } else {
          fuidFilters_JSON.push(o218);
        }
      }
    });
    json['fuidFilters'] = fuidFilters_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._showDeleted = json.hasOwnProperty("showDeleted")?json["showDeleted"]:false;
		this._showExpired = json.hasOwnProperty("showExpired")?json["showExpired"]:false;
		this._pageLimit = json.hasOwnProperty("pageLimit")?json["pageLimit"]:0;
		this._showArchived = json.hasOwnProperty("showArchived")?json["showArchived"]:false;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}

		//set of type int
		this._fuidFilters = [];
		let fuidFiltersJSONArray = json.hasOwnProperty("fuidFilters") ? json["fuidFilters"] : [];

		fuidFiltersJSONArray.forEach((o219)=>{
			if (o219){
				this._fuidFilters.push(o219);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssetsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class RemoteStatusEntry {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isConnected = false;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._fqPath = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {boolean}
   */
  isIsConnected() {
    return this._isConnected;
  }

  /**
   * @param isConnected{boolean}
   * @return {RemoteStatusEntry}
   */
  setIsConnected(isConnected) {
    this._isConnected = isConnected;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {RemoteStatusEntry}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {RemoteStatusEntry}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getFqPath() {
    return this._fqPath;
  }

  /**
   * @param fqPath{string}
   * @return {RemoteStatusEntry}
   */
  setFqPath(fqPath) {
    this._fqPath = fqPath;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {RemoteStatusEntry}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = RemoteStatusEntry.CLASS_ID;
    
	//Serializing _isConnected
	if (this._isConnected)
		json['isConnected'] = this._isConnected;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _fqPath
	if (this._fqPath)
		json['fqPath'] = this._fqPath;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isConnected = json.hasOwnProperty("isConnected")?json["isConnected"]:false;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._fqPath = json.hasOwnProperty("fqPath")?json["fqPath"]:null;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
RemoteStatusEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.RemoteStatusEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCollectionMetadataForWebClientQuery extends HttpOperation {

  constructor(name = "GetCollectionMetadataForWebClient") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCollectionMetadataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCollectionMetadataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCollectionMetadataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCollectionMetadataForWebClientQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCollectionMetadataForWebClientQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCollectionMetadataForWebClientQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionMetadataForWebClient";
/**
 * @returns {string}
 */
GetCollectionMetadataForWebClientQuery.QUERY_NAME = "GetCollectionMetadataForWebClient";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FuidBidRrnWithAssetAiData {

  constructor() {
    
        /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<AssetAiDataWebclient>}
     * @private
     */
    this._assetAiData = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._groupName2DocumentIds = null;

  }

    /**
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {FuidBidRrnWithAssetAiData}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {Array<AssetAiDataWebclient>}
   */
  getAssetAiData() {
    return this._assetAiData;
  }

  /**
   * @param assetAiData{Array<AssetAiDataWebclient>}
   * @return {FuidBidRrnWithAssetAiData}
   */
  setAssetAiData(assetAiData) {
    this._assetAiData = assetAiData;
    return this;
  }

  /**
   * @return {java.util.Map<String,ValueList>}
   */
  getGroupName2DocumentIds() {
    return this._groupName2DocumentIds;
  }

  /**
   * @param groupName2DocumentIds{java.util.Map<String,ValueList>}
   * @return {FuidBidRrnWithAssetAiData}
   */
  setGroupName2DocumentIds(groupName2DocumentIds) {
    this._groupName2DocumentIds = groupName2DocumentIds;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FuidBidRrnWithAssetAiData.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._assetAiData && this._assetAiData.length > 0) {
    let assetAiData_JSON = [];
    /**
     * @type {AssetAiDataWebclient}
     */
    this._assetAiData.forEach((o1108) => {
      if (o1108) {
        if (o1108.serializeJson && (typeof (o1108.serializeJson) === 'function')) {
          assetAiData_JSON.push(o1108.serializeJson());
        } else {
          assetAiData_JSON.push(o1108);
        }
      }
    });
    json['assetAiData'] = assetAiData_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"groupName2DocumentIds", this._groupName2DocumentIds);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type AssetAiDataWebclient
		this._assetAiData = [];
		let assetAiDataJSONArray = json.hasOwnProperty("assetAiData") ? json["assetAiData"] : [];

		assetAiDataJSONArray.forEach((o1109)=>{
			if (o1109){
				let classObj = new AssetAiDataWebclient();
				classObj.deserializeJson(o1109);
				this._assetAiData.push(classObj);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._groupName2DocumentIds == null)
			this._groupName2DocumentIds = new HashMap();
		this._groupName2DocumentIds.clear();
		let groupName2DocumentIdsJSONArray = json.hasOwnProperty("groupName2DocumentIds") ? json["groupName2DocumentIds"] : [];
		this._groupName2DocumentIds = SerializationUtil.deserializeMap(groupName2DocumentIdsJSONArray);



  }
}

/**
 * @returns {string}
 */
FuidBidRrnWithAssetAiData.CLASS_ID = "com.zoom.vab.client.autogenerated.FuidBidRrnWithAssetAiData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCollectionParametersQuery extends HttpOperation {

  constructor(name = "GetCollectionParameters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCollectionParametersMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCollectionParametersMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {CollectionParametersObject}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCollectionParametersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCollectionParametersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new CollectionParametersObject();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new CollectionParametersObject();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCollectionParametersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionParameters";
/**
 * @returns {string}
 */
GetCollectionParametersQuery.QUERY_NAME = "GetCollectionParameters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ListFilesResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._totalAssets = null;
    /**
     * @type {number}
     * @private
     */
    this._maxRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._totalPageCount = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * @return {number}
   */
  getTotalAssets() {
    return this._totalAssets;
  }

  /**
   * @param totalAssets{number}
   * @return {ListFilesResponse}
   */
  setTotalAssets(totalAssets) {
    this._totalAssets = totalAssets;
    return this;
  }
  /**
   * Send response only if higher max rrn is available.
   * @return {number}
   */
  getMaxRrn() {
    return this._maxRrn;
  }

  /**
   * @param maxRrn{number}
   * @return {ListFilesResponse}
   */
  setMaxRrn(maxRrn) {
    this._maxRrn = maxRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalPageCount() {
    return this._totalPageCount;
  }

  /**
   * @param totalPageCount{number}
   * @return {ListFilesResponse}
   */
  setTotalPageCount(totalPageCount) {
    this._totalPageCount = totalPageCount;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {ListFilesResponse}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {ListFilesResponse}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ListFilesResponse.CLASS_ID;
    
	//Serializing _totalAssets
	if (this._totalAssets)
		json['totalAssets'] = this._totalAssets;

	//Serializing _maxRrn
	if (this._maxRrn)
		json['maxRrn'] = this._maxRrn;

	//Serializing _totalPageCount
	if (this._totalPageCount)
		json['totalPageCount'] = this._totalPageCount;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;
  if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o437) => {
      if (o437) {
        if (o437.serializeJson && (typeof (o437.serializeJson) === 'function')) {
          fuids_JSON.push(o437.serializeJson());
        } else {
          fuids_JSON.push(o437);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._totalAssets = json.hasOwnProperty("totalAssets")?json["totalAssets"]:0;
		this._maxRrn = json.hasOwnProperty("maxRrn")?json["maxRrn"]:0;
		this._totalPageCount = json.hasOwnProperty("totalPageCount")?json["totalPageCount"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o438)=>{
			if (o438){
				this._fuids.push(o438);
			}
		});


  }
}

/**
 * @returns {string}
 */
ListFilesResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ListFilesResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditFiltersMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._filterNewName = null;
    /**
     * @type {string}
     * @private
     */
    this._operationType = null;
    /**
     * @type {string}
     * @private
     */
    this._filterOldName = null;

  }

    /**
   * @return {string}
   */
  getFilterNewName() {
    return this._filterNewName;
  }

  /**
   * @param filterNewName{string}
   * @return {EditFiltersMsg}
   */
  setFilterNewName(filterNewName) {
    this._filterNewName = filterNewName;
    return this;
  }
  /**
   * @return {string}
   */
  getOperationType() {
    return this._operationType;
  }

  /**
   * @param operationType{string}
   * @return {EditFiltersMsg}
   */
  setOperationType(operationType) {
    this._operationType = operationType;
    return this;
  }
  /**
   * @return {string}
   */
  getFilterOldName() {
    return this._filterOldName;
  }

  /**
   * @param filterOldName{string}
   * @return {EditFiltersMsg}
   */
  setFilterOldName(filterOldName) {
    this._filterOldName = filterOldName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditFiltersMsg.CLASS_ID;
    
	//Serializing _filterNewName
	if (this._filterNewName)
		json['filterNewName'] = this._filterNewName;

	//Serializing _operationType
	if (this._operationType)
		json['operationType'] = this._operationType;

	//Serializing _filterOldName
	if (this._filterOldName)
		json['filterOldName'] = this._filterOldName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._filterNewName = json.hasOwnProperty("filterNewName")?json["filterNewName"]:null;
		this._operationType = json.hasOwnProperty("operationType")?json["operationType"]:null;
		this._filterOldName = json.hasOwnProperty("filterOldName")?json["filterOldName"]:null;


  }
}

/**
 * @returns {string}
 */
EditFiltersMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.EditFiltersMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SearchQuery extends HttpOperation {

  constructor(name = "Search") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SearchMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SearchMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesResponseData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SearchQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SearchQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SearchQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.Search";
/**
 * @returns {string}
 */
SearchQuery.QUERY_NAME = "Search";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MyProjectsMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._permission = null;
    /**
     * @type {string}
     * @private
     */
    this._userName = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {string}
   */
  getPermission() {
    return this._permission;
  }

  /**
   * @param permission{string}
   * @return {MyProjectsMessage}
   */
  setPermission(permission) {
    this._permission = permission;
    return this;
  }
  /**
   * @return {string}
   */
  getUserName() {
    return this._userName;
  }

  /**
   * @param userName{string}
   * @return {MyProjectsMessage}
   */
  setUserName(userName) {
    this._userName = userName;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {MyProjectsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MyProjectsMessage.CLASS_ID;
    
	//Serializing _permission
	if (this._permission)
		json['permission'] = this._permission;

	//Serializing _userName
	if (this._userName)
		json['userName'] = this._userName;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._permission = json.hasOwnProperty("permission")?json["permission"]:null;
		this._userName = json.hasOwnProperty("userName")?json["userName"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
MyProjectsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.MyProjectsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class KeyFrameMetadataEntries {

  constructor() {
    
        /**
     * @type {Array<KeyFrameMetadataEntry>}
     * @private
     */
    this._keyFrameMetadataEntryList = null;

  }

    /**
   * @return {Array<KeyFrameMetadataEntry>}
   */
  getKeyFrameMetadataEntryList() {
    return this._keyFrameMetadataEntryList;
  }

  /**
   * @param keyFrameMetadataEntryList{Array<KeyFrameMetadataEntry>}
   * @return {KeyFrameMetadataEntries}
   */
  setKeyFrameMetadataEntryList(keyFrameMetadataEntryList) {
    this._keyFrameMetadataEntryList = keyFrameMetadataEntryList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = KeyFrameMetadataEntries.CLASS_ID;
      if (this._keyFrameMetadataEntryList && this._keyFrameMetadataEntryList.length > 0) {
    let keyFrameMetadataEntryList_JSON = [];
    /**
     * @type {KeyFrameMetadataEntry}
     */
    this._keyFrameMetadataEntryList.forEach((o1121) => {
      if (o1121) {
        if (o1121.serializeJson && (typeof (o1121.serializeJson) === 'function')) {
          keyFrameMetadataEntryList_JSON.push(o1121.serializeJson());
        } else {
          keyFrameMetadataEntryList_JSON.push(o1121);
        }
      }
    });
    json['keyFrameMetadataEntryList'] = keyFrameMetadataEntryList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type KeyFrameMetadataEntry
		this._keyFrameMetadataEntryList = [];
		let keyFrameMetadataEntryListJSONArray = json.hasOwnProperty("keyFrameMetadataEntryList") ? json["keyFrameMetadataEntryList"] : [];

		keyFrameMetadataEntryListJSONArray.forEach((o1122)=>{
			if (o1122){
				let classObj = new KeyFrameMetadataEntry();
				classObj.deserializeJson(o1122);
				this._keyFrameMetadataEntryList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
KeyFrameMetadataEntries.CLASS_ID = "com.zoom.vab.client.autogenerated.KeyFrameMetadataEntries";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteTimelineMessage {

  constructor() {
    
        /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._assetsInfo = null;
    /**
     * @type {Array<DelId2KeyValPairList>}
     * @private
     */
    this._delId2KeyValPairList = null;

  }

    /**
   * @return {Array<FuidRrnInfo>}
   */
  getAssetsInfo() {
    return this._assetsInfo;
  }

  /**
   * @param assetsInfo{Array<FuidRrnInfo>}
   * @return {DeleteTimelineMessage}
   */
  setAssetsInfo(assetsInfo) {
    this._assetsInfo = assetsInfo;
    return this;
  }

  /**
   * @return {Array<DelId2KeyValPairList>}
   */
  getDelId2KeyValPairList() {
    return this._delId2KeyValPairList;
  }

  /**
   * @param delId2KeyValPairList{Array<DelId2KeyValPairList>}
   * @return {DeleteTimelineMessage}
   */
  setDelId2KeyValPairList(delId2KeyValPairList) {
    this._delId2KeyValPairList = delId2KeyValPairList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteTimelineMessage.CLASS_ID;
      if (this._assetsInfo && this._assetsInfo.length > 0) {
    let assetsInfo_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._assetsInfo.forEach((o166) => {
      if (o166) {
        if (o166.serializeJson && (typeof (o166.serializeJson) === 'function')) {
          assetsInfo_JSON.push(o166.serializeJson());
        } else {
          assetsInfo_JSON.push(o166);
        }
      }
    });
    json['assetsInfo'] = assetsInfo_JSON;
  }  
  if (this._delId2KeyValPairList && this._delId2KeyValPairList.length > 0) {
    let delId2KeyValPairList_JSON = [];
    /**
     * @type {DelId2KeyValPairList}
     */
    this._delId2KeyValPairList.forEach((o169) => {
      if (o169) {
        if (o169.serializeJson && (typeof (o169.serializeJson) === 'function')) {
          delId2KeyValPairList_JSON.push(o169.serializeJson());
        } else {
          delId2KeyValPairList_JSON.push(o169);
        }
      }
    });
    json['delId2KeyValPairList'] = delId2KeyValPairList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type FuidRrnInfo
		this._assetsInfo = [];
		let assetsInfoJSONArray = json.hasOwnProperty("assetsInfo") ? json["assetsInfo"] : [];

		assetsInfoJSONArray.forEach((o167)=>{
			if (o167){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o167);
				this._assetsInfo.push(classObj);
			}
		});
		//set of type DelId2KeyValPairList
		this._delId2KeyValPairList = [];
		let delId2KeyValPairListJSONArray = json.hasOwnProperty("delId2KeyValPairList") ? json["delId2KeyValPairList"] : [];

		delId2KeyValPairListJSONArray.forEach((o170)=>{
			if (o170){
				let classObj = new DelId2KeyValPairList();
				classObj.deserializeJson(o170);
				this._delId2KeyValPairList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
DeleteTimelineMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteTimelineMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SearchMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._fileName = null;
    /**
     * @type {string}
     * @private
     */
    this._log = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resetAllExceptFilters = false;
    /**
     * @type {number}
     * @private
     */
    this._resultLimitPerCategory = null;
    /**
     * @type {string}
     * @private
     */
    this._filterName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resetFilters = false;
    /**
     * @type {boolean}
     * @private
     */
    this._searchInMetadata = false;
    /**
     * @type {number}
     * @private
     */
    this._topIndex = null;
    /**
     * @type {boolean}
     * @private
     */
    this._createBrowseSession = false;
    /**
     * @type {string}
     * @private
     */
    this._searchInsideText = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resetAll = false;
    /**
     * @type {boolean}
     * @private
     */
    this._showDeleted = false;
    /**
     * @type {string}
     * @private
     */
    this._fileNameMatchEnum = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showArchived = false;
    /**
     * @type {number}
     * @private
     */
    this._pageNo = null;
    /**
     * @type {string}
     * @private
     */
    this._logMatcher = null;
    /**
     * @type {string}
     * @private
     */
    this._text = null;
    /**
     * @type {number}
     * @private
     */
    this._topRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyCollections = false;
    /**
     * @type {string}
     * @private
     */
    this._lastDate = null;
    /**
     * @type {boolean}
     * @private
     */
    this._autoCompleteQuery = false;
    /**
     * @type {string}
     * @private
     */
    this._dirtyArg = null;
    /**
     * @type {string}
     * @private
     */
    this._author = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showExpired = false;
    /**
     * @type {string}
     * @private
     */
    this._beginDate = null;
    /**
     * @type {string}
     * @private
     */
    this._authorMatcher = null;
    /**
     * @type {boolean}
     * @private
     */
    this._fileBrowsing = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isRefresh = false;
    /**
     * @type {boolean}
     * @private
     */
    this._searchInCollectionFiles = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyDirs = false;
    /**
     * @type {boolean}
     * @private
     */
    this._appendChangeInExistingParam = false;
    /**
     * @type {boolean}
     * @private
     */
    this._searchInCollectionNames = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyBins = false;
    /**
     * @type {boolean}
     * @private
     */
    this._uberSearch = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyFiles = false;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._valueMatchEnums = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._typeFilters = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._values = null;
    /**
     * @type {Array<Boolean>}
     * @private
     */
    this._notPathActionList = null;
    /**
     * @type {Array<Boolean>}
     * @private
     */
    this._notLinkageRoleList = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._linkageRoleFilters = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._pathActionFilters = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._metaPropertiesRelationship = null;
    /**
     * @type {Array<com.zoom.data.bindings.Proj2Br2Path>}
     * @private
     */
    this._flexPath = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._properties = null;
    /**
     * @type {Array<com.zoom.flex.search.AssetFilterInstance>}
     * @private
     */
    this._assetIdFilterList = null;

  }

    /**
   * @return {string}
   */
  getFileName() {
    return this._fileName;
  }

  /**
   * @param fileName{string}
   * @return {SearchMessage}
   */
  setFileName(fileName) {
    this._fileName = fileName;
    return this;
  }
  /**
   * @return {string}
   */
  getLog() {
    return this._log;
  }

  /**
   * @param log{string}
   * @return {SearchMessage}
   */
  setLog(log) {
    this._log = log;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResetAllExceptFilters() {
    return this._resetAllExceptFilters;
  }

  /**
   * @param resetAllExceptFilters{boolean}
   * @return {SearchMessage}
   */
  setResetAllExceptFilters(resetAllExceptFilters) {
    this._resetAllExceptFilters = resetAllExceptFilters;
    return this;
  }
  /**
   * @return {number}
   */
  getResultLimitPerCategory() {
    return this._resultLimitPerCategory;
  }

  /**
   * @param resultLimitPerCategory{number}
   * @return {SearchMessage}
   */
  setResultLimitPerCategory(resultLimitPerCategory) {
    this._resultLimitPerCategory = resultLimitPerCategory;
    return this;
  }
  /**
   * @return {string}
   */
  getFilterName() {
    return this._filterName;
  }

  /**
   * @param filterName{string}
   * @return {SearchMessage}
   */
  setFilterName(filterName) {
    this._filterName = filterName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResetFilters() {
    return this._resetFilters;
  }

  /**
   * @param resetFilters{boolean}
   * @return {SearchMessage}
   */
  setResetFilters(resetFilters) {
    this._resetFilters = resetFilters;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSearchInMetadata() {
    return this._searchInMetadata;
  }

  /**
   * @param searchInMetadata{boolean}
   * @return {SearchMessage}
   */
  setSearchInMetadata(searchInMetadata) {
    this._searchInMetadata = searchInMetadata;
    return this;
  }
  /**
   * @return {number}
   */
  getTopIndex() {
    return this._topIndex;
  }

  /**
   * @param topIndex{number}
   * @return {SearchMessage}
   */
  setTopIndex(topIndex) {
    this._topIndex = topIndex;
    return this;
  }
  /**
   * @return {boolean}
   */
  isCreateBrowseSession() {
    return this._createBrowseSession;
  }

  /**
   * @param createBrowseSession{boolean}
   * @return {SearchMessage}
   */
  setCreateBrowseSession(createBrowseSession) {
    this._createBrowseSession = createBrowseSession;
    return this;
  }
  /**
   * @return {string}
   */
  getSearchInsideText() {
    return this._searchInsideText;
  }

  /**
   * @param searchInsideText{string}
   * @return {SearchMessage}
   */
  setSearchInsideText(searchInsideText) {
    this._searchInsideText = searchInsideText;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResetAll() {
    return this._resetAll;
  }

  /**
   * @param resetAll{boolean}
   * @return {SearchMessage}
   */
  setResetAll(resetAll) {
    this._resetAll = resetAll;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowDeleted() {
    return this._showDeleted;
  }

  /**
   * @param showDeleted{boolean}
   * @return {SearchMessage}
   */
  setShowDeleted(showDeleted) {
    this._showDeleted = showDeleted;
    return this;
  }
  /**
   * @return {string}
   */
  getFileNameMatchEnum() {
    return this._fileNameMatchEnum;
  }

  /**
   * @param fileNameMatchEnum{string}
   * @return {SearchMessage}
   */
  setFileNameMatchEnum(fileNameMatchEnum) {
    this._fileNameMatchEnum = fileNameMatchEnum;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowArchived() {
    return this._showArchived;
  }

  /**
   * @param showArchived{boolean}
   * @return {SearchMessage}
   */
  setShowArchived(showArchived) {
    this._showArchived = showArchived;
    return this;
  }
  /**
   * @return {number}
   */
  getPageNo() {
    return this._pageNo;
  }

  /**
   * @param pageNo{number}
   * @return {SearchMessage}
   */
  setPageNo(pageNo) {
    this._pageNo = pageNo;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMatcher() {
    return this._logMatcher;
  }

  /**
   * @param logMatcher{string}
   * @return {SearchMessage}
   */
  setLogMatcher(logMatcher) {
    this._logMatcher = logMatcher;
    return this;
  }
  /**
   * @return {string}
   */
  getText() {
    return this._text;
  }

  /**
   * @param text{string}
   * @return {SearchMessage}
   */
  setText(text) {
    this._text = text;
    return this;
  }
  /**
   * @return {number}
   */
  getTopRrn() {
    return this._topRrn;
  }

  /**
   * @param topRrn{number}
   * @return {SearchMessage}
   */
  setTopRrn(topRrn) {
    this._topRrn = topRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SearchMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyCollections() {
    return this._onlyCollections;
  }

  /**
   * @param onlyCollections{boolean}
   * @return {SearchMessage}
   */
  setOnlyCollections(onlyCollections) {
    this._onlyCollections = onlyCollections;
    return this;
  }
  /**
   * @return {string}
   */
  getLastDate() {
    return this._lastDate;
  }

  /**
   * @param lastDate{string}
   * @return {SearchMessage}
   */
  setLastDate(lastDate) {
    this._lastDate = lastDate;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAutoCompleteQuery() {
    return this._autoCompleteQuery;
  }

  /**
   * @param autoCompleteQuery{boolean}
   * @return {SearchMessage}
   */
  setAutoCompleteQuery(autoCompleteQuery) {
    this._autoCompleteQuery = autoCompleteQuery;
    return this;
  }
  /**
   * @return {string}
   */
  getDirtyArg() {
    return this._dirtyArg;
  }

  /**
   * @param dirtyArg{string}
   * @return {SearchMessage}
   */
  setDirtyArg(dirtyArg) {
    this._dirtyArg = dirtyArg;
    return this;
  }
  /**
   * @return {string}
   */
  getAuthor() {
    return this._author;
  }

  /**
   * @param author{string}
   * @return {SearchMessage}
   */
  setAuthor(author) {
    this._author = author;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowExpired() {
    return this._showExpired;
  }

  /**
   * @param showExpired{boolean}
   * @return {SearchMessage}
   */
  setShowExpired(showExpired) {
    this._showExpired = showExpired;
    return this;
  }
  /**
   * @return {string}
   */
  getBeginDate() {
    return this._beginDate;
  }

  /**
   * @param beginDate{string}
   * @return {SearchMessage}
   */
  setBeginDate(beginDate) {
    this._beginDate = beginDate;
    return this;
  }
  /**
   * @return {string}
   */
  getAuthorMatcher() {
    return this._authorMatcher;
  }

  /**
   * @param authorMatcher{string}
   * @return {SearchMessage}
   */
  setAuthorMatcher(authorMatcher) {
    this._authorMatcher = authorMatcher;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFileBrowsing() {
    return this._fileBrowsing;
  }

  /**
   * @param fileBrowsing{boolean}
   * @return {SearchMessage}
   */
  setFileBrowsing(fileBrowsing) {
    this._fileBrowsing = fileBrowsing;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsRefresh() {
    return this._isRefresh;
  }

  /**
   * @param isRefresh{boolean}
   * @return {SearchMessage}
   */
  setIsRefresh(isRefresh) {
    this._isRefresh = isRefresh;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSearchInCollectionFiles() {
    return this._searchInCollectionFiles;
  }

  /**
   * @param searchInCollectionFiles{boolean}
   * @return {SearchMessage}
   */
  setSearchInCollectionFiles(searchInCollectionFiles) {
    this._searchInCollectionFiles = searchInCollectionFiles;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyDirs() {
    return this._onlyDirs;
  }

  /**
   * @param onlyDirs{boolean}
   * @return {SearchMessage}
   */
  setOnlyDirs(onlyDirs) {
    this._onlyDirs = onlyDirs;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAppendChangeInExistingParam() {
    return this._appendChangeInExistingParam;
  }

  /**
   * @param appendChangeInExistingParam{boolean}
   * @return {SearchMessage}
   */
  setAppendChangeInExistingParam(appendChangeInExistingParam) {
    this._appendChangeInExistingParam = appendChangeInExistingParam;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSearchInCollectionNames() {
    return this._searchInCollectionNames;
  }

  /**
   * @param searchInCollectionNames{boolean}
   * @return {SearchMessage}
   */
  setSearchInCollectionNames(searchInCollectionNames) {
    this._searchInCollectionNames = searchInCollectionNames;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyBins() {
    return this._onlyBins;
  }

  /**
   * @param onlyBins{boolean}
   * @return {SearchMessage}
   */
  setOnlyBins(onlyBins) {
    this._onlyBins = onlyBins;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUberSearch() {
    return this._uberSearch;
  }

  /**
   * @param uberSearch{boolean}
   * @return {SearchMessage}
   */
  setUberSearch(uberSearch) {
    this._uberSearch = uberSearch;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyFiles() {
    return this._onlyFiles;
  }

  /**
   * @param onlyFiles{boolean}
   * @return {SearchMessage}
   */
  setOnlyFiles(onlyFiles) {
    this._onlyFiles = onlyFiles;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {SearchMessage}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }
  /**
   * it is used to modify value string. e.g for contains, we have to put * in the fron and it. For numbers value will be exact
   * @return {Array<String>}
   */
  getValueMatchEnums() {
    return this._valueMatchEnums;
  }

  /**
   * @param valueMatchEnums{Array<String>}
   * @return {SearchMessage}
   */
  setValueMatchEnums(valueMatchEnums) {
    this._valueMatchEnums = valueMatchEnums;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getTypeFilters() {
    return this._typeFilters;
  }

  /**
   * @param typeFilters{Array<String>}
   * @return {SearchMessage}
   */
  setTypeFilters(typeFilters) {
    this._typeFilters = typeFilters;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getValues() {
    return this._values;
  }

  /**
   * @param values{Array<String>}
   * @return {SearchMessage}
   */
  setValues(values) {
    this._values = values;
    return this;
  }

  /**
   * @return {Array<Boolean>}
   */
  getNotPathActionList() {
    return this._notPathActionList;
  }

  /**
   * @param notPathActionList{Array<Boolean>}
   * @return {SearchMessage}
   */
  setNotPathActionList(notPathActionList) {
    this._notPathActionList = notPathActionList;
    return this;
  }

  /**
   * @return {Array<Boolean>}
   */
  getNotLinkageRoleList() {
    return this._notLinkageRoleList;
  }

  /**
   * @param notLinkageRoleList{Array<Boolean>}
   * @return {SearchMessage}
   */
  setNotLinkageRoleList(notLinkageRoleList) {
    this._notLinkageRoleList = notLinkageRoleList;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getLinkageRoleFilters() {
    return this._linkageRoleFilters;
  }

  /**
   * @param linkageRoleFilters{Array<String>}
   * @return {SearchMessage}
   */
  setLinkageRoleFilters(linkageRoleFilters) {
    this._linkageRoleFilters = linkageRoleFilters;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getPathActionFilters() {
    return this._pathActionFilters;
  }

  /**
   * @param pathActionFilters{Array<String>}
   * @return {SearchMessage}
   */
  setPathActionFilters(pathActionFilters) {
    this._pathActionFilters = pathActionFilters;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getMetaPropertiesRelationship() {
    return this._metaPropertiesRelationship;
  }

  /**
   * @param metaPropertiesRelationship{Array<String>}
   * @return {SearchMessage}
   */
  setMetaPropertiesRelationship(metaPropertiesRelationship) {
    this._metaPropertiesRelationship = metaPropertiesRelationship;
    return this;
  }

  /**
   * @return {Array<com.zoom.data.bindings.Proj2Br2Path>}
   */
  getFlexPath() {
    return this._flexPath;
  }

  /**
   * @param flexPath{Array<com.zoom.data.bindings.Proj2Br2Path>}
   * @return {SearchMessage}
   */
  setFlexPath(flexPath) {
    this._flexPath = flexPath;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getProperties() {
    return this._properties;
  }

  /**
   * @param properties{Array<String>}
   * @return {SearchMessage}
   */
  setProperties(properties) {
    this._properties = properties;
    return this;
  }

  /**
   * @return {Array<com.zoom.flex.search.AssetFilterInstance>}
   */
  getAssetIdFilterList() {
    return this._assetIdFilterList;
  }

  /**
   * @param assetIdFilterList{Array<com.zoom.flex.search.AssetFilterInstance>}
   * @return {SearchMessage}
   */
  setAssetIdFilterList(assetIdFilterList) {
    this._assetIdFilterList = assetIdFilterList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SearchMessage.CLASS_ID;
    
	//Serializing _fileName
	if (this._fileName)
		json['fileName'] = this._fileName;

	//Serializing _log
	if (this._log)
		json['log'] = this._log;

	//Serializing _resetAllExceptFilters
	if (this._resetAllExceptFilters)
		json['resetAllExceptFilters'] = this._resetAllExceptFilters;

	//Serializing _resultLimitPerCategory
	if (this._resultLimitPerCategory)
		json['resultLimitPerCategory'] = this._resultLimitPerCategory;

	//Serializing _filterName
	if (this._filterName)
		json['filterName'] = this._filterName;

	//Serializing _resetFilters
	if (this._resetFilters)
		json['resetFilters'] = this._resetFilters;

	//Serializing _searchInMetadata
	if (this._searchInMetadata)
		json['searchInMetadata'] = this._searchInMetadata;

	//Serializing _topIndex
	if (this._topIndex)
		json['topIndex'] = this._topIndex;

	//Serializing _createBrowseSession
	if (this._createBrowseSession)
		json['createBrowseSession'] = this._createBrowseSession;

	//Serializing _searchInsideText
	if (this._searchInsideText)
		json['searchInsideText'] = this._searchInsideText;

	//Serializing _resetAll
	if (this._resetAll)
		json['resetAll'] = this._resetAll;

	//Serializing _showDeleted
	if (this._showDeleted)
		json['showDeleted'] = this._showDeleted;

	//Serializing _fileNameMatchEnum
	if (this._fileNameMatchEnum)
		json['fileNameMatchEnum'] = this._fileNameMatchEnum;

	//Serializing _showArchived
	if (this._showArchived)
		json['showArchived'] = this._showArchived;

	//Serializing _pageNo
	if (this._pageNo)
		json['pageNo'] = this._pageNo;

	//Serializing _logMatcher
	if (this._logMatcher)
		json['logMatcher'] = this._logMatcher;

	//Serializing _text
	if (this._text)
		json['text'] = this._text;

	//Serializing _topRrn
	if (this._topRrn)
		json['topRrn'] = this._topRrn;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _onlyCollections
	if (this._onlyCollections)
		json['onlyCollections'] = this._onlyCollections;

	//Serializing _lastDate
	if (this._lastDate)
		json['lastDate'] = this._lastDate;

	//Serializing _autoCompleteQuery
	if (this._autoCompleteQuery)
		json['autoCompleteQuery'] = this._autoCompleteQuery;

	//Serializing _dirtyArg
	if (this._dirtyArg)
		json['dirtyArg'] = this._dirtyArg;

	//Serializing _author
	if (this._author)
		json['author'] = this._author;

	//Serializing _showExpired
	if (this._showExpired)
		json['showExpired'] = this._showExpired;

	//Serializing _beginDate
	if (this._beginDate)
		json['beginDate'] = this._beginDate;

	//Serializing _authorMatcher
	if (this._authorMatcher)
		json['authorMatcher'] = this._authorMatcher;

	//Serializing _fileBrowsing
	if (this._fileBrowsing)
		json['fileBrowsing'] = this._fileBrowsing;

	//Serializing _isRefresh
	if (this._isRefresh)
		json['isRefresh'] = this._isRefresh;

	//Serializing _searchInCollectionFiles
	if (this._searchInCollectionFiles)
		json['searchInCollectionFiles'] = this._searchInCollectionFiles;

	//Serializing _onlyDirs
	if (this._onlyDirs)
		json['onlyDirs'] = this._onlyDirs;

	//Serializing _appendChangeInExistingParam
	if (this._appendChangeInExistingParam)
		json['appendChangeInExistingParam'] = this._appendChangeInExistingParam;

	//Serializing _searchInCollectionNames
	if (this._searchInCollectionNames)
		json['searchInCollectionNames'] = this._searchInCollectionNames;

	//Serializing _onlyBins
	if (this._onlyBins)
		json['onlyBins'] = this._onlyBins;

	//Serializing _uberSearch
	if (this._uberSearch)
		json['uberSearch'] = this._uberSearch;

	//Serializing _onlyFiles
	if (this._onlyFiles)
		json['onlyFiles'] = this._onlyFiles;

	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		  if (this._valueMatchEnums && this._valueMatchEnums.length > 0) {
    let valueMatchEnums_JSON = [];
    /**
     * @type {string}
     */
    this._valueMatchEnums.forEach((o726) => {
      if (o726) {
        if (o726.serializeJson && (typeof (o726.serializeJson) === 'function')) {
          valueMatchEnums_JSON.push(o726.serializeJson());
        } else {
          valueMatchEnums_JSON.push(o726);
        }
      }
    });
    json['valueMatchEnums'] = valueMatchEnums_JSON;
  }  
  if (this._typeFilters && this._typeFilters.length > 0) {
    let typeFilters_JSON = [];
    /**
     * @type {string}
     */
    this._typeFilters.forEach((o729) => {
      if (o729) {
        if (o729.serializeJson && (typeof (o729.serializeJson) === 'function')) {
          typeFilters_JSON.push(o729.serializeJson());
        } else {
          typeFilters_JSON.push(o729);
        }
      }
    });
    json['typeFilters'] = typeFilters_JSON;
  }  
  if (this._values && this._values.length > 0) {
    let values_JSON = [];
    /**
     * @type {string}
     */
    this._values.forEach((o732) => {
      if (o732) {
        if (o732.serializeJson && (typeof (o732.serializeJson) === 'function')) {
          values_JSON.push(o732.serializeJson());
        } else {
          values_JSON.push(o732);
        }
      }
    });
    json['values'] = values_JSON;
  }  
  if (this._notPathActionList && this._notPathActionList.length > 0) {
    let notPathActionList_JSON = [];
    /**
     * @type {boolean}
     */
    this._notPathActionList.forEach((o735) => {
      if (o735) {
        if (o735.serializeJson && (typeof (o735.serializeJson) === 'function')) {
          notPathActionList_JSON.push(o735.serializeJson());
        } else {
          notPathActionList_JSON.push(o735);
        }
      }
    });
    json['notPathActionList'] = notPathActionList_JSON;
  }  
  if (this._notLinkageRoleList && this._notLinkageRoleList.length > 0) {
    let notLinkageRoleList_JSON = [];
    /**
     * @type {boolean}
     */
    this._notLinkageRoleList.forEach((o738) => {
      if (o738) {
        if (o738.serializeJson && (typeof (o738.serializeJson) === 'function')) {
          notLinkageRoleList_JSON.push(o738.serializeJson());
        } else {
          notLinkageRoleList_JSON.push(o738);
        }
      }
    });
    json['notLinkageRoleList'] = notLinkageRoleList_JSON;
  }  
  if (this._linkageRoleFilters && this._linkageRoleFilters.length > 0) {
    let linkageRoleFilters_JSON = [];
    /**
     * @type {string}
     */
    this._linkageRoleFilters.forEach((o741) => {
      if (o741) {
        if (o741.serializeJson && (typeof (o741.serializeJson) === 'function')) {
          linkageRoleFilters_JSON.push(o741.serializeJson());
        } else {
          linkageRoleFilters_JSON.push(o741);
        }
      }
    });
    json['linkageRoleFilters'] = linkageRoleFilters_JSON;
  }  
  if (this._pathActionFilters && this._pathActionFilters.length > 0) {
    let pathActionFilters_JSON = [];
    /**
     * @type {string}
     */
    this._pathActionFilters.forEach((o744) => {
      if (o744) {
        if (o744.serializeJson && (typeof (o744.serializeJson) === 'function')) {
          pathActionFilters_JSON.push(o744.serializeJson());
        } else {
          pathActionFilters_JSON.push(o744);
        }
      }
    });
    json['pathActionFilters'] = pathActionFilters_JSON;
  }  
  if (this._metaPropertiesRelationship && this._metaPropertiesRelationship.length > 0) {
    let metaPropertiesRelationship_JSON = [];
    /**
     * @type {string}
     */
    this._metaPropertiesRelationship.forEach((o747) => {
      if (o747) {
        if (o747.serializeJson && (typeof (o747.serializeJson) === 'function')) {
          metaPropertiesRelationship_JSON.push(o747.serializeJson());
        } else {
          metaPropertiesRelationship_JSON.push(o747);
        }
      }
    });
    json['metaPropertiesRelationship'] = metaPropertiesRelationship_JSON;
  }  
  if (this._flexPath && this._flexPath.length > 0) {
    let flexPath_JSON = [];
    /**
     * @type {Proj2Br2PathExt}
     */
    this._flexPath.forEach((o750) => {
      if (o750) {
        if (o750.serializeJson && (typeof (o750.serializeJson) === 'function')) {
          flexPath_JSON.push(o750.serializeJson());
        } else {
          flexPath_JSON.push(o750);
        }
      }
    });
    json['flexPath'] = flexPath_JSON;
  }  
  if (this._properties && this._properties.length > 0) {
    let properties_JSON = [];
    /**
     * @type {string}
     */
    this._properties.forEach((o753) => {
      if (o753) {
        if (o753.serializeJson && (typeof (o753.serializeJson) === 'function')) {
          properties_JSON.push(o753.serializeJson());
        } else {
          properties_JSON.push(o753);
        }
      }
    });
    json['properties'] = properties_JSON;
  }  
  if (this._assetIdFilterList && this._assetIdFilterList.length > 0) {
    let assetIdFilterList_JSON = [];
    /**
     * @type {AssetIdJson}
     */
    this._assetIdFilterList.forEach((o756) => {
      if (o756) {
        if (o756.serializeJson && (typeof (o756.serializeJson) === 'function')) {
          assetIdFilterList_JSON.push(o756.serializeJson());
        } else {
          assetIdFilterList_JSON.push(o756);
        }
      }
    });
    json['assetIdFilterList'] = assetIdFilterList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fileName = json.hasOwnProperty("fileName")?json["fileName"]:null;
		this._log = json.hasOwnProperty("log")?json["log"]:null;
		this._resetAllExceptFilters = json.hasOwnProperty("resetAllExceptFilters")?json["resetAllExceptFilters"]:false;
		this._resultLimitPerCategory = json.hasOwnProperty("resultLimitPerCategory")?json["resultLimitPerCategory"]:0;
		this._filterName = json.hasOwnProperty("filterName")?json["filterName"]:null;
		this._resetFilters = json.hasOwnProperty("resetFilters")?json["resetFilters"]:false;
		this._searchInMetadata = json.hasOwnProperty("searchInMetadata")?json["searchInMetadata"]:false;
		this._topIndex = json.hasOwnProperty("topIndex")?json["topIndex"]:0;
		this._createBrowseSession = json.hasOwnProperty("createBrowseSession")?json["createBrowseSession"]:false;
		this._searchInsideText = json.hasOwnProperty("searchInsideText")?json["searchInsideText"]:null;
		this._resetAll = json.hasOwnProperty("resetAll")?json["resetAll"]:false;
		this._showDeleted = json.hasOwnProperty("showDeleted")?json["showDeleted"]:false;
		this._fileNameMatchEnum = json.hasOwnProperty("fileNameMatchEnum")?json["fileNameMatchEnum"]:null;
		this._showArchived = json.hasOwnProperty("showArchived")?json["showArchived"]:false;
		this._pageNo = json.hasOwnProperty("pageNo")?json["pageNo"]:0;
		this._logMatcher = json.hasOwnProperty("logMatcher")?json["logMatcher"]:null;
		this._text = json.hasOwnProperty("text")?json["text"]:null;
		this._topRrn = json.hasOwnProperty("topRrn")?json["topRrn"]:0;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._onlyCollections = json.hasOwnProperty("onlyCollections")?json["onlyCollections"]:false;
		this._lastDate = json.hasOwnProperty("lastDate")?json["lastDate"]:null;
		this._autoCompleteQuery = json.hasOwnProperty("autoCompleteQuery")?json["autoCompleteQuery"]:false;
		this._dirtyArg = json.hasOwnProperty("dirtyArg")?json["dirtyArg"]:null;
		this._author = json.hasOwnProperty("author")?json["author"]:null;
		this._showExpired = json.hasOwnProperty("showExpired")?json["showExpired"]:false;
		this._beginDate = json.hasOwnProperty("beginDate")?json["beginDate"]:null;
		this._authorMatcher = json.hasOwnProperty("authorMatcher")?json["authorMatcher"]:null;
		this._fileBrowsing = json.hasOwnProperty("fileBrowsing")?json["fileBrowsing"]:false;
		this._isRefresh = json.hasOwnProperty("isRefresh")?json["isRefresh"]:false;
		this._searchInCollectionFiles = json.hasOwnProperty("searchInCollectionFiles")?json["searchInCollectionFiles"]:false;
		this._onlyDirs = json.hasOwnProperty("onlyDirs")?json["onlyDirs"]:false;
		this._appendChangeInExistingParam = json.hasOwnProperty("appendChangeInExistingParam")?json["appendChangeInExistingParam"]:false;
		this._searchInCollectionNames = json.hasOwnProperty("searchInCollectionNames")?json["searchInCollectionNames"]:false;
		this._onlyBins = json.hasOwnProperty("onlyBins")?json["onlyBins"]:false;
		this._uberSearch = json.hasOwnProperty("uberSearch")?json["uberSearch"]:false;
		this._onlyFiles = json.hasOwnProperty("onlyFiles")?json["onlyFiles"]:false;
		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}

		//set of type string
		this._valueMatchEnums = [];
		let valueMatchEnumsJSONArray = json.hasOwnProperty("valueMatchEnums") ? json["valueMatchEnums"] : [];

		valueMatchEnumsJSONArray.forEach((o727)=>{
			if (o727){
				this._valueMatchEnums.push(o727);
			}
		});
		//set of type string
		this._typeFilters = [];
		let typeFiltersJSONArray = json.hasOwnProperty("typeFilters") ? json["typeFilters"] : [];

		typeFiltersJSONArray.forEach((o730)=>{
			if (o730){
				this._typeFilters.push(o730);
			}
		});
		//set of type string
		this._values = [];
		let valuesJSONArray = json.hasOwnProperty("values") ? json["values"] : [];

		valuesJSONArray.forEach((o733)=>{
			if (o733){
				this._values.push(o733);
			}
		});
		//set of type boolean
		this._notPathActionList = [];
		let notPathActionListJSONArray = json.hasOwnProperty("notPathActionList") ? json["notPathActionList"] : [];

		notPathActionListJSONArray.forEach((o736)=>{
			if (o736){
				this._notPathActionList.push(o736);
			}
		});
		//set of type boolean
		this._notLinkageRoleList = [];
		let notLinkageRoleListJSONArray = json.hasOwnProperty("notLinkageRoleList") ? json["notLinkageRoleList"] : [];

		notLinkageRoleListJSONArray.forEach((o739)=>{
			if (o739){
				this._notLinkageRoleList.push(o739);
			}
		});
		//set of type string
		this._linkageRoleFilters = [];
		let linkageRoleFiltersJSONArray = json.hasOwnProperty("linkageRoleFilters") ? json["linkageRoleFilters"] : [];

		linkageRoleFiltersJSONArray.forEach((o742)=>{
			if (o742){
				this._linkageRoleFilters.push(o742);
			}
		});
		//set of type string
		this._pathActionFilters = [];
		let pathActionFiltersJSONArray = json.hasOwnProperty("pathActionFilters") ? json["pathActionFilters"] : [];

		pathActionFiltersJSONArray.forEach((o745)=>{
			if (o745){
				this._pathActionFilters.push(o745);
			}
		});
		//set of type string
		this._metaPropertiesRelationship = [];
		let metaPropertiesRelationshipJSONArray = json.hasOwnProperty("metaPropertiesRelationship") ? json["metaPropertiesRelationship"] : [];

		metaPropertiesRelationshipJSONArray.forEach((o748)=>{
			if (o748){
				this._metaPropertiesRelationship.push(o748);
			}
		});
		//set of type Proj2Br2PathExt
		this._flexPath = [];
		let flexPathJSONArray = json.hasOwnProperty("flexPath") ? json["flexPath"] : [];

		flexPathJSONArray.forEach((o751)=>{
			if (o751){
				let classObj = new Proj2Br2PathExt();
				classObj.deserializeJson(o751);
				this._flexPath.push(classObj);
			}
		});
		//set of type string
		this._properties = [];
		let propertiesJSONArray = json.hasOwnProperty("properties") ? json["properties"] : [];

		propertiesJSONArray.forEach((o754)=>{
			if (o754){
				this._properties.push(o754);
			}
		});
		//set of type AssetIdJson
		this._assetIdFilterList = [];
		let assetIdFilterListJSONArray = json.hasOwnProperty("assetIdFilterList") ? json["assetIdFilterList"] : [];

		assetIdFilterListJSONArray.forEach((o757)=>{
			if (o757){
				let classObj = new AssetIdJson();
				classObj.deserializeJson(o757);
				this._assetIdFilterList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SearchMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SearchMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetZmCollectionProjectsQuery extends HttpOperation {

  constructor(name = "GetZmCollectionProjects") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ArrayType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ArrayCollection}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetZmCollectionProjectsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetZmCollectionProjectsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetZmCollectionProjectsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetZmCollectionProjects";
/**
 * @returns {string}
 */
GetZmCollectionProjectsQuery.QUERY_NAME = "GetZmCollectionProjects";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LoadNextSearchPageQuery extends HttpOperation {

  constructor(name = "LoadNextSearchPage") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LoadNextSearchPageMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LoadNextSearchPageMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesResponseData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LoadNextSearchPageQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LoadNextSearchPageQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LoadNextSearchPageQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadNextSearchPage";
/**
 * @returns {string}
 */
LoadNextSearchPageQuery.QUERY_NAME = "LoadNextSearchPage";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateZmCollectionMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._numChildBins = null;
    /**
     * @type {ZmCollection}
     * @private
     */
    this._zmCollection = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidRrnList = null;
    /**
     * @type {Array<CollectionUserEntry>}
     * @private
     */
    this._collectionUsers = null;
    /**
     * @type {Array<CollectionMetadataValueObj>}
     * @private
     */
    this._metadataValues = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._metadataProps = null;
    /**
     * @type {Array<CollectionRoles>}
     * @private
     */
    this._collectionRolesArray = null;

  }

    /**
   * @return {number}
   */
  getNumChildBins() {
    return this._numChildBins;
  }

  /**
   * @param numChildBins{number}
   * @return {CreateZmCollectionMessage}
   */
  setNumChildBins(numChildBins) {
    this._numChildBins = numChildBins;
    return this;
  }
  /**
   * @return {ZmCollection}
   */
  getZmCollection() {
    return this._zmCollection;
  }

  /**
   * @param zmCollection{ZmCollection}
   * @return {CreateZmCollectionMessage}
   */
  setZmCollection(zmCollection) {
    this._zmCollection = zmCollection;
    return this;
  }
  /**
   * @return {Array<FuidRrnInfo>}
   */
  getFuidRrnList() {
    return this._fuidRrnList;
  }

  /**
   * @param fuidRrnList{Array<FuidRrnInfo>}
   * @return {CreateZmCollectionMessage}
   */
  setFuidRrnList(fuidRrnList) {
    this._fuidRrnList = fuidRrnList;
    return this;
  }

  /**
   * @return {Array<CollectionUserEntry>}
   */
  getCollectionUsers() {
    return this._collectionUsers;
  }

  /**
   * @param collectionUsers{Array<CollectionUserEntry>}
   * @return {CreateZmCollectionMessage}
   */
  setCollectionUsers(collectionUsers) {
    this._collectionUsers = collectionUsers;
    return this;
  }

  /**
   * @return {Array<CollectionMetadataValueObj>}
   */
  getMetadataValues() {
    return this._metadataValues;
  }

  /**
   * @param metadataValues{Array<CollectionMetadataValueObj>}
   * @return {CreateZmCollectionMessage}
   */
  setMetadataValues(metadataValues) {
    this._metadataValues = metadataValues;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getMetadataProps() {
    return this._metadataProps;
  }

  /**
   * @param metadataProps{Array<String>}
   * @return {CreateZmCollectionMessage}
   */
  setMetadataProps(metadataProps) {
    this._metadataProps = metadataProps;
    return this;
  }

  /**
   * @return {Array<CollectionRoles>}
   */
  getCollectionRolesArray() {
    return this._collectionRolesArray;
  }

  /**
   * @param collectionRolesArray{Array<CollectionRoles>}
   * @return {CreateZmCollectionMessage}
   */
  setCollectionRolesArray(collectionRolesArray) {
    this._collectionRolesArray = collectionRolesArray;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateZmCollectionMessage.CLASS_ID;
    
	//Serializing _numChildBins
	if (this._numChildBins)
		json['numChildBins'] = this._numChildBins;

	//Serializing ComplexType _$arrayName
	if (this._zmCollection)
		json['zmCollection'] = this._zmCollection.serializeJson();
		  if (this._fuidRrnList && this._fuidRrnList.length > 0) {
    let fuidRrnList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidRrnList.forEach((o1028) => {
      if (o1028) {
        if (o1028.serializeJson && (typeof (o1028.serializeJson) === 'function')) {
          fuidRrnList_JSON.push(o1028.serializeJson());
        } else {
          fuidRrnList_JSON.push(o1028);
        }
      }
    });
    json['fuidRrnList'] = fuidRrnList_JSON;
  }  
  if (this._collectionUsers && this._collectionUsers.length > 0) {
    let collectionUsers_JSON = [];
    /**
     * @type {CollectionUserEntry}
     */
    this._collectionUsers.forEach((o1031) => {
      if (o1031) {
        if (o1031.serializeJson && (typeof (o1031.serializeJson) === 'function')) {
          collectionUsers_JSON.push(o1031.serializeJson());
        } else {
          collectionUsers_JSON.push(o1031);
        }
      }
    });
    json['collectionUsers'] = collectionUsers_JSON;
  }  
  if (this._metadataValues && this._metadataValues.length > 0) {
    let metadataValues_JSON = [];
    /**
     * @type {CollectionMetadataValueObj}
     */
    this._metadataValues.forEach((o1034) => {
      if (o1034) {
        if (o1034.serializeJson && (typeof (o1034.serializeJson) === 'function')) {
          metadataValues_JSON.push(o1034.serializeJson());
        } else {
          metadataValues_JSON.push(o1034);
        }
      }
    });
    json['metadataValues'] = metadataValues_JSON;
  }  
  if (this._metadataProps && this._metadataProps.length > 0) {
    let metadataProps_JSON = [];
    /**
     * @type {string}
     */
    this._metadataProps.forEach((o1037) => {
      if (o1037) {
        if (o1037.serializeJson && (typeof (o1037.serializeJson) === 'function')) {
          metadataProps_JSON.push(o1037.serializeJson());
        } else {
          metadataProps_JSON.push(o1037);
        }
      }
    });
    json['metadataProps'] = metadataProps_JSON;
  }  
  if (this._collectionRolesArray && this._collectionRolesArray.length > 0) {
    let collectionRolesArray_JSON = [];
    /**
     * @type {CollectionRoles}
     */
    this._collectionRolesArray.forEach((o1040) => {
      if (o1040) {
        if (o1040.serializeJson && (typeof (o1040.serializeJson) === 'function')) {
          collectionRolesArray_JSON.push(o1040.serializeJson());
        } else {
          collectionRolesArray_JSON.push(o1040);
        }
      }
    });
    json['collectionRolesArray'] = collectionRolesArray_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._numChildBins = json.hasOwnProperty("numChildBins")?json["numChildBins"]:0;
		if (json.hasOwnProperty("zmCollection")){
			if (!this._zmCollection && this._zmCollection == null)
				this._zmCollection = new ZmCollection();
			this._zmCollection.deserializeJson(json.hasOwnProperty("zmCollection") ? json["zmCollection"] : null);
		}

		//set of type FuidRrnInfo
		this._fuidRrnList = [];
		let fuidRrnListJSONArray = json.hasOwnProperty("fuidRrnList") ? json["fuidRrnList"] : [];

		fuidRrnListJSONArray.forEach((o1029)=>{
			if (o1029){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o1029);
				this._fuidRrnList.push(classObj);
			}
		});
		//set of type CollectionUserEntry
		this._collectionUsers = [];
		let collectionUsersJSONArray = json.hasOwnProperty("collectionUsers") ? json["collectionUsers"] : [];

		collectionUsersJSONArray.forEach((o1032)=>{
			if (o1032){
				let classObj = new CollectionUserEntry();
				classObj.deserializeJson(o1032);
				this._collectionUsers.push(classObj);
			}
		});
		//set of type CollectionMetadataValueObj
		this._metadataValues = [];
		let metadataValuesJSONArray = json.hasOwnProperty("metadataValues") ? json["metadataValues"] : [];

		metadataValuesJSONArray.forEach((o1035)=>{
			if (o1035){
				let classObj = new CollectionMetadataValueObj();
				classObj.deserializeJson(o1035);
				this._metadataValues.push(classObj);
			}
		});
		//set of type string
		this._metadataProps = [];
		let metadataPropsJSONArray = json.hasOwnProperty("metadataProps") ? json["metadataProps"] : [];

		metadataPropsJSONArray.forEach((o1038)=>{
			if (o1038){
				this._metadataProps.push(o1038);
			}
		});
		//set of type CollectionRoles
		this._collectionRolesArray = [];
		let collectionRolesArrayJSONArray = json.hasOwnProperty("collectionRolesArray") ? json["collectionRolesArray"] : [];

		collectionRolesArrayJSONArray.forEach((o1041)=>{
			if (o1041){
				let classObj = new CollectionRoles();
				classObj.deserializeJson(o1041);
				this._collectionRolesArray.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
CreateZmCollectionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateZmCollectionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ClearSessionQuery extends HttpOperation {

  constructor(name = "ClearSession") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {ClearSessionMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ClearSessionMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ClearSessionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ClearSessionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ClearSessionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ClearSession";
/**
 * @returns {string}
 */
ClearSessionQuery.QUERY_NAME = "ClearSession";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LoadMetadataSpecResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._globalRestrictPattern = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._editableProps = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._propId2InfoMap = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._groupCode2GroupInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._engineId2Details = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {LoadMetadataSpecResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getGlobalRestrictPattern() {
    return this._globalRestrictPattern;
  }

  /**
   * @param globalRestrictPattern{string}
   * @return {LoadMetadataSpecResponse}
   */
  setGlobalRestrictPattern(globalRestrictPattern) {
    this._globalRestrictPattern = globalRestrictPattern;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getEditableProps() {
    return this._editableProps;
  }

  /**
   * @param editableProps{Array<String>}
   * @return {LoadMetadataSpecResponse}
   */
  setEditableProps(editableProps) {
    this._editableProps = editableProps;
    return this;
  }

  /**
   * @return {java.util.Map<String,PropInfo>}
   */
  getPropId2InfoMap() {
    return this._propId2InfoMap;
  }

  /**
   * @param propId2InfoMap{java.util.Map<String,PropInfo>}
   * @return {LoadMetadataSpecResponse}
   */
  setPropId2InfoMap(propId2InfoMap) {
    this._propId2InfoMap = propId2InfoMap;
    return this;
  }

  /**
   * @return {java.util.Map<String,GroupInfo>}
   */
  getGroupCode2GroupInfo() {
    return this._groupCode2GroupInfo;
  }

  /**
   * @param groupCode2GroupInfo{java.util.Map<String,GroupInfo>}
   * @return {LoadMetadataSpecResponse}
   */
  setGroupCode2GroupInfo(groupCode2GroupInfo) {
    this._groupCode2GroupInfo = groupCode2GroupInfo;
    return this;
  }

  /**
   * @return {java.util.Map<String,AiEngineInfo>}
   */
  getEngineId2Details() {
    return this._engineId2Details;
  }

  /**
   * @param engineId2Details{java.util.Map<String,AiEngineInfo>}
   * @return {LoadMetadataSpecResponse}
   */
  setEngineId2Details(engineId2Details) {
    this._engineId2Details = engineId2Details;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LoadMetadataSpecResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _globalRestrictPattern
	if (this._globalRestrictPattern)
		json['globalRestrictPattern'] = this._globalRestrictPattern;
  if (this._editableProps && this._editableProps.length > 0) {
    let editableProps_JSON = [];
    /**
     * @type {string}
     */
    this._editableProps.forEach((o810) => {
      if (o810) {
        if (o810.serializeJson && (typeof (o810.serializeJson) === 'function')) {
          editableProps_JSON.push(o810.serializeJson());
        } else {
          editableProps_JSON.push(o810);
        }
      }
    });
    json['editableProps'] = editableProps_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"propId2InfoMap", this._propId2InfoMap);
		    SerializationUtil.serializeHashMap(json,"groupCode2GroupInfo", this._groupCode2GroupInfo);
		    SerializationUtil.serializeHashMap(json,"engineId2Details", this._engineId2Details);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._globalRestrictPattern = json.hasOwnProperty("globalRestrictPattern")?json["globalRestrictPattern"]:null;
		//set of type string
		this._editableProps = [];
		let editablePropsJSONArray = json.hasOwnProperty("editableProps") ? json["editableProps"] : [];

		editablePropsJSONArray.forEach((o811)=>{
			if (o811){
				this._editableProps.push(o811);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._propId2InfoMap == null)
			this._propId2InfoMap = new HashMap();
		this._propId2InfoMap.clear();
		let propId2InfoMapJSONArray = json.hasOwnProperty("propId2InfoMap") ? json["propId2InfoMap"] : [];
		this._propId2InfoMap = SerializationUtil.deserializeMap(propId2InfoMapJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._groupCode2GroupInfo == null)
			this._groupCode2GroupInfo = new HashMap();
		this._groupCode2GroupInfo.clear();
		let groupCode2GroupInfoJSONArray = json.hasOwnProperty("groupCode2GroupInfo") ? json["groupCode2GroupInfo"] : [];
		this._groupCode2GroupInfo = SerializationUtil.deserializeMap(groupCode2GroupInfoJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._engineId2Details == null)
			this._engineId2Details = new HashMap();
		this._engineId2Details.clear();
		let engineId2DetailsJSONArray = json.hasOwnProperty("engineId2Details") ? json["engineId2Details"] : [];
		this._engineId2Details = SerializationUtil.deserializeMap(engineId2DetailsJSONArray);



  }
}

/**
 * @returns {string}
 */
LoadMetadataSpecResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadMetadataSpecResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SaveAnnotationsQuery extends HttpOperation {

  constructor(name = "SaveAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SaveAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SaveAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SaveAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SaveAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SaveAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SaveAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SaveAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SaveAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveAnnotations";
/**
 * @returns {string}
 */
SaveAnnotationsQuery.QUERY_NAME = "SaveAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionPathEntry {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {CollectionPathEntry}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {CollectionPathEntry}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionPathEntry.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
CollectionPathEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionPathEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DelId2KeyValPairList {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._timeCodeId = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {string}
     * @private
     */
    this._key = null;

  }

    /**
   * @return {number}
   */
  getTimeCodeId() {
    return this._timeCodeId;
  }

  /**
   * @param timeCodeId{number}
   * @return {DelId2KeyValPairList}
   */
  setTimeCodeId(timeCodeId) {
    this._timeCodeId = timeCodeId;
    return this;
  }
  /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {DelId2KeyValPairList}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {string}
   */
  getKey() {
    return this._key;
  }

  /**
   * @param key{string}
   * @return {DelId2KeyValPairList}
   */
  setKey(key) {
    this._key = key;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DelId2KeyValPairList.CLASS_ID;
    
	//Serializing _timeCodeId
	if (this._timeCodeId)
		json['timeCodeId'] = this._timeCodeId;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing _key
	if (this._key)
		json['key'] = this._key;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._timeCodeId = json.hasOwnProperty("timeCodeId")?json["timeCodeId"]:0;
		this._value = json.hasOwnProperty("value")?json["value"]:null;
		this._key = json.hasOwnProperty("key")?json["key"]:null;


  }
}

/**
 * @returns {string}
 */
DelId2KeyValPairList.CLASS_ID = "com.zoom.vab.client.autogenerated.DelId2KeyValPairList";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveDrawingAnnotationsMessage {

  constructor() {
    
        /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<DrawingAnnotation>}
     * @private
     */
    this._shapes = null;

  }

    /**
   * optional: Collection scope for comment. May be omitted in edits if unchanged.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {SaveDrawingAnnotationsMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comment. May be omitted in edits if unchanged.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {SaveDrawingAnnotationsMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {Array<DrawingAnnotation>}
   */
  getShapes() {
    return this._shapes;
  }

  /**
   * @param shapes{Array<DrawingAnnotation>}
   * @return {SaveDrawingAnnotationsMessage}
   */
  setShapes(shapes) {
    this._shapes = shapes;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveDrawingAnnotationsMessage.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._shapes && this._shapes.length > 0) {
    let shapes_JSON = [];
    /**
     * @type {DrawingAnnotation}
     */
    this._shapes.forEach((o294) => {
      if (o294) {
        if (o294.serializeJson && (typeof (o294.serializeJson) === 'function')) {
          shapes_JSON.push(o294.serializeJson());
        } else {
          shapes_JSON.push(o294);
        }
      }
    });
    json['shapes'] = shapes_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type DrawingAnnotation
		this._shapes = [];
		let shapesJSONArray = json.hasOwnProperty("shapes") ? json["shapes"] : [];

		shapesJSONArray.forEach((o295)=>{
			if (o295){
				let classObj = new DrawingAnnotation();
				classObj.deserializeJson(o295);
				this._shapes.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SaveDrawingAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveDrawingAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditFiltersResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {EditFiltersResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {EditFiltersResp}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditFiltersResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;


  }
}

/**
 * @returns {string}
 */
EditFiltersResp.CLASS_ID = "com.zoom.vab.client.autogenerated.EditFiltersResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class MoveAssetsQuery extends HttpOperation {

  constructor(name = "MoveAssets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {MoveAssetsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{MoveAssetsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {MoveAssetsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = MoveAssetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (MoveAssetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new MoveAssetsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new MoveAssetsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
MoveAssetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.MoveAssets";
/**
 * @returns {string}
 */
MoveAssetsQuery.QUERY_NAME = "MoveAssets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetZmCollectionUsersQuery extends HttpOperation {

  constructor(name = "GetZmCollectionUsers") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {CollectionUsersInfo}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetZmCollectionUsersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetZmCollectionUsersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new CollectionUsersInfo();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new CollectionUsersInfo();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetZmCollectionUsersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetZmCollectionUsers";
/**
 * @returns {string}
 */
GetZmCollectionUsersQuery.QUERY_NAME = "GetZmCollectionUsers";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class WebclientAddFolderQuery extends HttpOperation {

  constructor(name = "WebclientAddFolder") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {WebclientAddFolderMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{WebclientAddFolderMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {WebclientAddFolderResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = WebclientAddFolderQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (WebclientAddFolderQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new WebclientAddFolderResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new WebclientAddFolderResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
WebclientAddFolderQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.WebclientAddFolder";
/**
 * @returns {string}
 */
WebclientAddFolderQuery.QUERY_NAME = "WebclientAddFolder";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateUniqueUrlResponse {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._url = null;
    /**
     * @type {string}
     * @private
     */
    this._uniqueId = null;

  }

    /**
   * @return {string}
   */
  getUrl() {
    return this._url;
  }

  /**
   * @param url{string}
   * @return {CreateUniqueUrlResponse}
   */
  setUrl(url) {
    this._url = url;
    return this;
  }
  /**
   * @return {string}
   */
  getUniqueId() {
    return this._uniqueId;
  }

  /**
   * @param uniqueId{string}
   * @return {CreateUniqueUrlResponse}
   */
  setUniqueId(uniqueId) {
    this._uniqueId = uniqueId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateUniqueUrlResponse.CLASS_ID;
    
	//Serializing _url
	if (this._url)
		json['url'] = this._url;

	//Serializing _uniqueId
	if (this._uniqueId)
		json['uniqueId'] = this._uniqueId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._url = json.hasOwnProperty("url")?json["url"]:null;
		this._uniqueId = json.hasOwnProperty("uniqueId")?json["uniqueId"]:null;


  }
}

/**
 * @returns {string}
 */
CreateUniqueUrlResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateUniqueUrlResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Node {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._size = null;
    /**
     * @type {boolean}
     * @private
     */
    this._childNodesLoaded = false;
    /**
     * @type {string}
     * @private
     */
    this._lastModifiedAsString = null;
    /**
     * @type {string}
     * @private
     */
    this._sizeInKB = null;
    /**
     * @type {number}
     * @private
     */
    this._lastModified = null;
    /**
     * @type {string}
     * @private
     */
    this._type = null;
    /**
     * @type {string}
     * @private
     */
    this._key = null;
    /**
     * @type {string}
     * @private
     */
    this._status = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasMoreObjects = false;
    /**
     * @type {Array<Node>}
     * @private
     */
    this._childNodes = null;

  }

    /**
   * @return {number}
   */
  getSize() {
    return this._size;
  }

  /**
   * @param size{number}
   * @return {Node}
   */
  setSize(size) {
    this._size = size;
    return this;
  }
  /**
   * @return {boolean}
   */
  isChildNodesLoaded() {
    return this._childNodesLoaded;
  }

  /**
   * @param childNodesLoaded{boolean}
   * @return {Node}
   */
  setChildNodesLoaded(childNodesLoaded) {
    this._childNodesLoaded = childNodesLoaded;
    return this;
  }
  /**
   * @return {string}
   */
  getLastModifiedAsString() {
    return this._lastModifiedAsString;
  }

  /**
   * @param lastModifiedAsString{string}
   * @return {Node}
   */
  setLastModifiedAsString(lastModifiedAsString) {
    this._lastModifiedAsString = lastModifiedAsString;
    return this;
  }
  /**
   * @return {string}
   */
  getSizeInKB() {
    return this._sizeInKB;
  }

  /**
   * @param sizeInKB{string}
   * @return {Node}
   */
  setSizeInKB(sizeInKB) {
    this._sizeInKB = sizeInKB;
    return this;
  }
  /**
   * @return {number}
   */
  getLastModified() {
    return this._lastModified;
  }

  /**
   * @param lastModified{number}
   * @return {Node}
   */
  setLastModified(lastModified) {
    this._lastModified = lastModified;
    return this;
  }
  /**
   * @return {string}
   */
  getType() {
    return this._type;
  }

  /**
   * @param type{string}
   * @return {Node}
   */
  setType(type) {
    this._type = type;
    return this;
  }
  /**
   * @return {string}
   */
  getKey() {
    return this._key;
  }

  /**
   * @param key{string}
   * @return {Node}
   */
  setKey(key) {
    this._key = key;
    return this;
  }
  /**
   * @return {string}
   */
  getStatus() {
    return this._status;
  }

  /**
   * @param status{string}
   * @return {Node}
   */
  setStatus(status) {
    this._status = status;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasMoreObjects() {
    return this._hasMoreObjects;
  }

  /**
   * @param hasMoreObjects{boolean}
   * @return {Node}
   */
  setHasMoreObjects(hasMoreObjects) {
    this._hasMoreObjects = hasMoreObjects;
    return this;
  }
  /**
   * @return {Array<Node>}
   */
  getChildNodes() {
    return this._childNodes;
  }

  /**
   * @param childNodes{Array<Node>}
   * @return {Node}
   */
  setChildNodes(childNodes) {
    this._childNodes = childNodes;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Node.CLASS_ID;
    
	//Serializing _size
	if (this._size)
		json['size'] = this._size;

	//Serializing _childNodesLoaded
	if (this._childNodesLoaded)
		json['childNodesLoaded'] = this._childNodesLoaded;

	//Serializing _lastModifiedAsString
	if (this._lastModifiedAsString)
		json['lastModifiedAsString'] = this._lastModifiedAsString;

	//Serializing _sizeInKB
	if (this._sizeInKB)
		json['sizeInKB'] = this._sizeInKB;

	//Serializing _lastModified
	if (this._lastModified)
		json['lastModified'] = this._lastModified;

	//Serializing _type
	if (this._type)
		json['type'] = this._type;

	//Serializing _key
	if (this._key)
		json['key'] = this._key;

	//Serializing _status
	if (this._status)
		json['status'] = this._status;

	//Serializing _hasMoreObjects
	if (this._hasMoreObjects)
		json['hasMoreObjects'] = this._hasMoreObjects;
  if (this._childNodes && this._childNodes.length > 0) {
    let childNodes_JSON = [];
    /**
     * @type {Node}
     */
    this._childNodes.forEach((o902) => {
      if (o902) {
        if (o902.serializeJson && (typeof (o902.serializeJson) === 'function')) {
          childNodes_JSON.push(o902.serializeJson());
        } else {
          childNodes_JSON.push(o902);
        }
      }
    });
    json['childNodes'] = childNodes_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._size = json.hasOwnProperty("size")?json["size"]:0;
		this._childNodesLoaded = json.hasOwnProperty("childNodesLoaded")?json["childNodesLoaded"]:false;
		this._lastModifiedAsString = json.hasOwnProperty("lastModifiedAsString")?json["lastModifiedAsString"]:null;
		this._sizeInKB = json.hasOwnProperty("sizeInKB")?json["sizeInKB"]:null;
		this._lastModified = json.hasOwnProperty("lastModified")?json["lastModified"]:0;
		this._type = json.hasOwnProperty("type")?json["type"]:null;
		this._key = json.hasOwnProperty("key")?json["key"]:null;
		this._status = json.hasOwnProperty("status")?json["status"]:null;
		this._hasMoreObjects = json.hasOwnProperty("hasMoreObjects")?json["hasMoreObjects"]:false;
		//set of type Node
		this._childNodes = [];
		let childNodesJSONArray = json.hasOwnProperty("childNodes") ? json["childNodes"] : [];

		childNodesJSONArray.forEach((o903)=>{
			if (o903){
				let classObj = new Node();
				classObj.deserializeJson(o903);
				this._childNodes.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
Node.CLASS_ID = "com.zoom.vab.client.autogenerated.Node";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LoadFiltersResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._filterNames = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {LoadFiltersResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {LoadFiltersResp}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getFilterNames() {
    return this._filterNames;
  }

  /**
   * @param filterNames{Array<String>}
   * @return {LoadFiltersResp}
   */
  setFilterNames(filterNames) {
    this._filterNames = filterNames;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LoadFiltersResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;
  if (this._filterNames && this._filterNames.length > 0) {
    let filterNames_JSON = [];
    /**
     * @type {string}
     */
    this._filterNames.forEach((o1164) => {
      if (o1164) {
        if (o1164.serializeJson && (typeof (o1164.serializeJson) === 'function')) {
          filterNames_JSON.push(o1164.serializeJson());
        } else {
          filterNames_JSON.push(o1164);
        }
      }
    });
    json['filterNames'] = filterNames_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		//set of type string
		this._filterNames = [];
		let filterNamesJSONArray = json.hasOwnProperty("filterNames") ? json["filterNames"] : [];

		filterNamesJSONArray.forEach((o1165)=>{
			if (o1165){
				this._filterNames.push(o1165);
			}
		});


  }
}

/**
 * @returns {string}
 */
LoadFiltersResp.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadFiltersResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveDrawingAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {Array<DrawingAnnotation>}
     * @private
     */
    this._shapes = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {SaveDrawingAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * saved shape data; not returned in case of deletes.
   * @return {Array<DrawingAnnotation>}
   */
  getShapes() {
    return this._shapes;
  }

  /**
   * @param shapes{Array<DrawingAnnotation>}
   * @return {SaveDrawingAnnotationsResponse}
   */
  setShapes(shapes) {
    this._shapes = shapes;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveDrawingAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;
  if (this._shapes && this._shapes.length > 0) {
    let shapes_JSON = [];
    /**
     * @type {DrawingAnnotation}
     */
    this._shapes.forEach((o302) => {
      if (o302) {
        if (o302.serializeJson && (typeof (o302.serializeJson) === 'function')) {
          shapes_JSON.push(o302.serializeJson());
        } else {
          shapes_JSON.push(o302);
        }
      }
    });
    json['shapes'] = shapes_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		//set of type DrawingAnnotation
		this._shapes = [];
		let shapesJSONArray = json.hasOwnProperty("shapes") ? json["shapes"] : [];

		shapesJSONArray.forEach((o303)=>{
			if (o303){
				let classObj = new DrawingAnnotation();
				classObj.deserializeJson(o303);
				this._shapes.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SaveDrawingAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveDrawingAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LsZmCollectionsNextPageQuery extends HttpOperation {

  constructor(name = "LsZmCollectionsNextPage") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LsZmCollectionsNextPageMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LsZmCollectionsNextPageMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LsZmCollectionsNextPageResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LsZmCollectionsNextPageQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LsZmCollectionsNextPageQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LsZmCollectionsNextPageResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LsZmCollectionsNextPageResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LsZmCollectionsNextPageQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionsNextPage";
/**
 * @returns {string}
 */
LsZmCollectionsNextPageQuery.QUERY_NAME = "LsZmCollectionsNextPage";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AssetAiDataWebclient {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._confidence = null;
    /**
     * @type {string}
     * @private
     */
    this._aiType = null;
    /**
     * @type {string}
     * @private
     */
    this._uuid = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {TimeCode}
     * @private
     */
    this._timeCode = null;
    /**
     * @type {Array<BoundingBoxCoordinates>}
     * @private
     */
    this._boundingBox = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._properties = null;

  }

    /**
   * @return {number}
   */
  getConfidence() {
    return this._confidence;
  }

  /**
   * @param confidence{number}
   * @return {AssetAiDataWebclient}
   */
  setConfidence(confidence) {
    this._confidence = confidence;
    return this;
  }
  /**
   * @return {string}
   */
  getAiType() {
    return this._aiType;
  }

  /**
   * @param aiType{string}
   * @return {AssetAiDataWebclient}
   */
  setAiType(aiType) {
    this._aiType = aiType;
    return this;
  }
  /**
   * @return {string}
   */
  getUuid() {
    return this._uuid;
  }

  /**
   * @param uuid{string}
   * @return {AssetAiDataWebclient}
   */
  setUuid(uuid) {
    this._uuid = uuid;
    return this;
  }
  /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {AssetAiDataWebclient}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {TimeCode}
   */
  getTimeCode() {
    return this._timeCode;
  }

  /**
   * @param timeCode{TimeCode}
   * @return {AssetAiDataWebclient}
   */
  setTimeCode(timeCode) {
    this._timeCode = timeCode;
    return this;
  }
  /**
   * @return {Array<BoundingBoxCoordinates>}
   */
  getBoundingBox() {
    return this._boundingBox;
  }

  /**
   * @param boundingBox{Array<BoundingBoxCoordinates>}
   * @return {AssetAiDataWebclient}
   */
  setBoundingBox(boundingBox) {
    this._boundingBox = boundingBox;
    return this;
  }

  /**
   * @return {java.util.Map<String,ValueList>}
   */
  getProperties() {
    return this._properties;
  }

  /**
   * @param properties{java.util.Map<String,ValueList>}
   * @return {AssetAiDataWebclient}
   */
  setProperties(properties) {
    this._properties = properties;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AssetAiDataWebclient.CLASS_ID;
    
	//Serializing _confidence
	if (this._confidence)
		json['confidence'] = this._confidence;

	//Serializing _aiType
	if (this._aiType)
		json['aiType'] = this._aiType;

	//Serializing _uuid
	if (this._uuid)
		json['uuid'] = this._uuid;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing ComplexType _$arrayName
	if (this._timeCode)
		json['timeCode'] = this._timeCode.serializeJson();
		  if (this._boundingBox && this._boundingBox.length > 0) {
    let boundingBox_JSON = [];
    /**
     * @type {BoundingBoxCoordinates}
     */
    this._boundingBox.forEach((o1098) => {
      if (o1098) {
        if (o1098.serializeJson && (typeof (o1098.serializeJson) === 'function')) {
          boundingBox_JSON.push(o1098.serializeJson());
        } else {
          boundingBox_JSON.push(o1098);
        }
      }
    });
    json['boundingBox'] = boundingBox_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"properties", this._properties);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._confidence = json.hasOwnProperty("confidence")?json["confidence"]:0;
		this._aiType = json.hasOwnProperty("aiType")?json["aiType"]:null;
		this._uuid = json.hasOwnProperty("uuid")?json["uuid"]:null;
		this._value = json.hasOwnProperty("value")?json["value"]:null;
		if (json.hasOwnProperty("timeCode")){
			if (!this._timeCode && this._timeCode == null)
				this._timeCode = new TimeCode();
			this._timeCode.deserializeJson(json.hasOwnProperty("timeCode") ? json["timeCode"] : null);
		}

		//set of type BoundingBoxCoordinates
		this._boundingBox = [];
		let boundingBoxJSONArray = json.hasOwnProperty("boundingBox") ? json["boundingBox"] : [];

		boundingBoxJSONArray.forEach((o1099)=>{
			if (o1099){
				let classObj = new BoundingBoxCoordinates();
				classObj.deserializeJson(o1099);
				this._boundingBox.push(classObj);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._properties == null)
			this._properties = new HashMap();
		this._properties.clear();
		let propertiesJSONArray = json.hasOwnProperty("properties") ? json["properties"] : [];
		this._properties = SerializationUtil.deserializeMap(propertiesJSONArray);



  }
}

/**
 * @returns {string}
 */
AssetAiDataWebclient.CLASS_ID = "com.zoom.vab.client.autogenerated.AssetAiDataWebclient";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAssetsInfoMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._maxRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._rootFuid = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * Send response only if higher max rrn is available.
   * @return {number}
   */
  getMaxRrn() {
    return this._maxRrn;
  }

  /**
   * @param maxRrn{number}
   * @return {GetAssetsInfoMessage}
   */
  setMaxRrn(maxRrn) {
    this._maxRrn = maxRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getRootFuid() {
    return this._rootFuid;
  }

  /**
   * @param rootFuid{number}
   * @return {GetAssetsInfoMessage}
   */
  setRootFuid(rootFuid) {
    this._rootFuid = rootFuid;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {GetAssetsInfoMessage}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {GetAssetsInfoMessage}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAssetsInfoMessage.CLASS_ID;
    
	//Serializing _maxRrn
	if (this._maxRrn)
		json['maxRrn'] = this._maxRrn;

	//Serializing _rootFuid
	if (this._rootFuid)
		json['rootFuid'] = this._rootFuid;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;
  if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o616) => {
      if (o616) {
        if (o616.serializeJson && (typeof (o616.serializeJson) === 'function')) {
          fuids_JSON.push(o616.serializeJson());
        } else {
          fuids_JSON.push(o616);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._maxRrn = json.hasOwnProperty("maxRrn")?json["maxRrn"]:0;
		this._rootFuid = json.hasOwnProperty("rootFuid")?json["rootFuid"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o617)=>{
			if (o617){
				this._fuids.push(o617);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetAssetsInfoMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsInfoMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EnableDisableLinkSharingQuery extends HttpOperation {

  constructor(name = "EnableDisableLinkSharing") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EnableDisableLinkSharingMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EnableDisableLinkSharingMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {EnableDisableLinkSharingResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EnableDisableLinkSharingQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EnableDisableLinkSharingQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new EnableDisableLinkSharingResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new EnableDisableLinkSharingResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EnableDisableLinkSharingQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EnableDisableLinkSharing";
/**
 * @returns {string}
 */
EnableDisableLinkSharingQuery.QUERY_NAME = "EnableDisableLinkSharing";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionParametersObject {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._collectionParams = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {CollectionParametersObject}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getCollectionParams() {
    return this._collectionParams;
  }

  /**
   * @param collectionParams{java.util.Map<String,String>}
   * @return {CollectionParametersObject}
   */
  setCollectionParams(collectionParams) {
    this._collectionParams = collectionParams;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionParametersObject.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
    SerializationUtil.serializeHashMap(json,"collectionParams", this._collectionParams);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
//Map of type STRING. Decode as tree:false
		if (this._collectionParams == null)
			this._collectionParams = new HashMap();
		this._collectionParams.clear();
		let collectionParamsJSONArray = json.hasOwnProperty("collectionParams") ? json["collectionParams"] : [];
		this._collectionParams = SerializationUtil.deserializeMap(collectionParamsJSONArray);



  }
}

/**
 * @returns {string}
 */
CollectionParametersObject.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionParametersObject";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AssignCollectionUsersData {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<CollectionUserEntry>}
     * @private
     */
    this._collectionUsers = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {AssignCollectionUsersData}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<CollectionUserEntry>}
   */
  getCollectionUsers() {
    return this._collectionUsers;
  }

  /**
   * @param collectionUsers{Array<CollectionUserEntry>}
   * @return {AssignCollectionUsersData}
   */
  setCollectionUsers(collectionUsers) {
    this._collectionUsers = collectionUsers;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AssignCollectionUsersData.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._collectionUsers && this._collectionUsers.length > 0) {
    let collectionUsers_JSON = [];
    /**
     * @type {CollectionUserEntry}
     */
    this._collectionUsers.forEach((o970) => {
      if (o970) {
        if (o970.serializeJson && (typeof (o970.serializeJson) === 'function')) {
          collectionUsers_JSON.push(o970.serializeJson());
        } else {
          collectionUsers_JSON.push(o970);
        }
      }
    });
    json['collectionUsers'] = collectionUsers_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type CollectionUserEntry
		this._collectionUsers = [];
		let collectionUsersJSONArray = json.hasOwnProperty("collectionUsers") ? json["collectionUsers"] : [];

		collectionUsersJSONArray.forEach((o971)=>{
			if (o971){
				let classObj = new CollectionUserEntry();
				classObj.deserializeJson(o971);
				this._collectionUsers.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
AssignCollectionUsersData.CLASS_ID = "com.zoom.vab.client.autogenerated.AssignCollectionUsersData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAssetsPathFuidsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._fetchDetailsForPathFuids = false;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * @return {boolean}
   */
  isFetchDetailsForPathFuids() {
    return this._fetchDetailsForPathFuids;
  }

  /**
   * @param fetchDetailsForPathFuids{boolean}
   * @return {GetAssetsPathFuidsMessage}
   */
  setFetchDetailsForPathFuids(fetchDetailsForPathFuids) {
    this._fetchDetailsForPathFuids = fetchDetailsForPathFuids;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {GetAssetsPathFuidsMessage}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAssetsPathFuidsMessage.CLASS_ID;
    
	//Serializing _fetchDetailsForPathFuids
	if (this._fetchDetailsForPathFuids)
		json['fetchDetailsForPathFuids'] = this._fetchDetailsForPathFuids;
  if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o107) => {
      if (o107) {
        if (o107.serializeJson && (typeof (o107.serializeJson) === 'function')) {
          fuids_JSON.push(o107.serializeJson());
        } else {
          fuids_JSON.push(o107);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fetchDetailsForPathFuids = json.hasOwnProperty("fetchDetailsForPathFuids")?json["fetchDetailsForPathFuids"]:false;
		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o108)=>{
			if (o108){
				this._fuids.push(o108);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetAssetsPathFuidsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsPathFuidsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AiEngineInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._engineId = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {AiEngineInfo}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getEngineId() {
    return this._engineId;
  }

  /**
   * @param engineId{string}
   * @return {AiEngineInfo}
   */
  setEngineId(engineId) {
    this._engineId = engineId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AiEngineInfo.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _engineId
	if (this._engineId)
		json['engineId'] = this._engineId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._engineId = json.hasOwnProperty("engineId")?json["engineId"]:null;


  }
}

/**
 * @returns {string}
 */
AiEngineInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.AiEngineInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteTimelineQuery extends HttpOperation {

  constructor(name = "DeleteTimeline") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteTimelineMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteTimelineMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {DeleteTimelineResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteTimelineQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteTimelineQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new DeleteTimelineResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new DeleteTimelineResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteTimelineQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteTimeline";
/**
 * @returns {string}
 */
DeleteTimelineQuery.QUERY_NAME = "DeleteTimeline";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditZmCollectionAssetsQuery extends HttpOperation {

  constructor(name = "EditZmCollectionAssets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EditZmCollectionAssetsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditZmCollectionAssetsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SimpleResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditZmCollectionAssetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditZmCollectionAssetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditZmCollectionAssetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollectionAssets";
/**
 * @returns {string}
 */
EditZmCollectionAssetsQuery.QUERY_NAME = "EditZmCollectionAssets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetUserLinkDefaultPermissionsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._defaultPermissions = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SetUserLinkDefaultPermissionsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getDefaultPermissions() {
    return this._defaultPermissions;
  }

  /**
   * @param defaultPermissions{java.util.Map<number,Boolean>}
   * @return {SetUserLinkDefaultPermissionsMessage}
   */
  setDefaultPermissions(defaultPermissions) {
    this._defaultPermissions = defaultPermissions;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetUserLinkDefaultPermissionsMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
    SerializationUtil.serializeHashMap(json,"defaultPermissions", this._defaultPermissions);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
//Map of type INT. Decode as tree:false
		if (this._defaultPermissions == null)
			this._defaultPermissions = new HashMap();
		this._defaultPermissions.clear();
		let defaultPermissionsJSONArray = json.hasOwnProperty("defaultPermissions") ? json["defaultPermissions"] : [];
		this._defaultPermissions = SerializationUtil.deserializeMap(defaultPermissionsJSONArray);



  }
}

/**
 * @returns {string}
 */
SetUserLinkDefaultPermissionsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SetUserLinkDefaultPermissionsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class WCStatusRespObject {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._wcToolTip = null;
    /**
     * @type {string}
     * @private
     */
    this._wcID = null;
    /**
     * @type {string}
     * @private
     */
    this._wcRoot = null;
    /**
     * @type {string}
     * @private
     */
    this._fileStatus = null;
    /**
     * @type {string}
     * @private
     */
    this._modTime = null;
    /**
     * @type {string}
     * @private
     */
    this._localPath = null;
    /**
     * @type {string}
     * @private
     */
    this._wcStatus = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;

  }

    /**
   * @return {string}
   */
  getWcToolTip() {
    return this._wcToolTip;
  }

  /**
   * @param wcToolTip{string}
   * @return {WCStatusRespObject}
   */
  setWcToolTip(wcToolTip) {
    this._wcToolTip = wcToolTip;
    return this;
  }
  /**
   * @return {string}
   */
  getWcID() {
    return this._wcID;
  }

  /**
   * @param wcID{string}
   * @return {WCStatusRespObject}
   */
  setWcID(wcID) {
    this._wcID = wcID;
    return this;
  }
  /**
   * @return {string}
   */
  getWcRoot() {
    return this._wcRoot;
  }

  /**
   * @param wcRoot{string}
   * @return {WCStatusRespObject}
   */
  setWcRoot(wcRoot) {
    this._wcRoot = wcRoot;
    return this;
  }
  /**
   * @return {string}
   */
  getFileStatus() {
    return this._fileStatus;
  }

  /**
   * @param fileStatus{string}
   * @return {WCStatusRespObject}
   */
  setFileStatus(fileStatus) {
    this._fileStatus = fileStatus;
    return this;
  }
  /**
   * @return {string}
   */
  getModTime() {
    return this._modTime;
  }

  /**
   * @param modTime{string}
   * @return {WCStatusRespObject}
   */
  setModTime(modTime) {
    this._modTime = modTime;
    return this;
  }
  /**
   * @return {string}
   */
  getLocalPath() {
    return this._localPath;
  }

  /**
   * @param localPath{string}
   * @return {WCStatusRespObject}
   */
  setLocalPath(localPath) {
    this._localPath = localPath;
    return this;
  }
  /**
   * @return {string}
   */
  getWcStatus() {
    return this._wcStatus;
  }

  /**
   * @param wcStatus{string}
   * @return {WCStatusRespObject}
   */
  setWcStatus(wcStatus) {
    this._wcStatus = wcStatus;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {WCStatusRespObject}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = WCStatusRespObject.CLASS_ID;
    
	//Serializing _wcToolTip
	if (this._wcToolTip)
		json['wcToolTip'] = this._wcToolTip;

	//Serializing _wcID
	if (this._wcID)
		json['wcID'] = this._wcID;

	//Serializing _wcRoot
	if (this._wcRoot)
		json['wcRoot'] = this._wcRoot;

	//Serializing _fileStatus
	if (this._fileStatus)
		json['fileStatus'] = this._fileStatus;

	//Serializing _modTime
	if (this._modTime)
		json['modTime'] = this._modTime;

	//Serializing _localPath
	if (this._localPath)
		json['localPath'] = this._localPath;

	//Serializing _wcStatus
	if (this._wcStatus)
		json['wcStatus'] = this._wcStatus;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._wcToolTip = json.hasOwnProperty("wcToolTip")?json["wcToolTip"]:null;
		this._wcID = json.hasOwnProperty("wcID")?json["wcID"]:null;
		this._wcRoot = json.hasOwnProperty("wcRoot")?json["wcRoot"]:null;
		this._fileStatus = json.hasOwnProperty("fileStatus")?json["fileStatus"]:null;
		this._modTime = json.hasOwnProperty("modTime")?json["modTime"]:null;
		this._localPath = json.hasOwnProperty("localPath")?json["localPath"]:null;
		this._wcStatus = json.hasOwnProperty("wcStatus")?json["wcStatus"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;


  }
}

/**
 * @returns {string}
 */
WCStatusRespObject.CLASS_ID = "com.zoom.vab.client.autogenerated.WCStatusRespObject";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ResolveAnnotationsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._commentId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resolved = false;

  }

    /**
   * @return {number}
   */
  getCommentId() {
    return this._commentId;
  }

  /**
   * @param commentId{number}
   * @return {ResolveAnnotationsMessage}
   */
  setCommentId(commentId) {
    this._commentId = commentId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResolved() {
    return this._resolved;
  }

  /**
   * @param resolved{boolean}
   * @return {ResolveAnnotationsMessage}
   */
  setResolved(resolved) {
    this._resolved = resolved;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ResolveAnnotationsMessage.CLASS_ID;
    
	//Serializing _commentId
	if (this._commentId)
		json['commentId'] = this._commentId;

	//Serializing _resolved
	if (this._resolved)
		json['resolved'] = this._resolved;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._commentId = json.hasOwnProperty("commentId")?json["commentId"]:0;
		this._resolved = json.hasOwnProperty("resolved")?json["resolved"]:false;


  }
}

/**
 * @returns {string}
 */
ResolveAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ResolveAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditMetadataMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._multipleValues = false;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._keyframeImportDirUniqueKey = null;
    /**
     * @type {boolean}
     * @private
     */
    this._append = false;
    /**
     * @type {string}
     * @private
     */
    this._keyframePropertyToAssignedDataForFile = null;
    /**
     * @type {string}
     * @private
     */
    this._keyframeFileName = null;
    /**
     * @type {Array<KeyFrameMetadataEntry>}
     * @private
     */
    this._keyFrameMetadataEntryList = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._assetsInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._newData = null;
    /**
     * @type {HashSet}
     * @private
     */
    this._delData = null;

  }

    /**
   * @return {boolean}
   */
  isMultipleValues() {
    return this._multipleValues;
  }

  /**
   * @param multipleValues{boolean}
   * @return {EditMetadataMsg}
   */
  setMultipleValues(multipleValues) {
    this._multipleValues = multipleValues;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {EditMetadataMsg}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getKeyframeImportDirUniqueKey() {
    return this._keyframeImportDirUniqueKey;
  }

  /**
   * @param keyframeImportDirUniqueKey{string}
   * @return {EditMetadataMsg}
   */
  setKeyframeImportDirUniqueKey(keyframeImportDirUniqueKey) {
    this._keyframeImportDirUniqueKey = keyframeImportDirUniqueKey;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAppend() {
    return this._append;
  }

  /**
   * @param append{boolean}
   * @return {EditMetadataMsg}
   */
  setAppend(append) {
    this._append = append;
    return this;
  }
  /**
   * @return {string}
   */
  getKeyframePropertyToAssignedDataForFile() {
    return this._keyframePropertyToAssignedDataForFile;
  }

  /**
   * @param keyframePropertyToAssignedDataForFile{string}
   * @return {EditMetadataMsg}
   */
  setKeyframePropertyToAssignedDataForFile(keyframePropertyToAssignedDataForFile) {
    this._keyframePropertyToAssignedDataForFile = keyframePropertyToAssignedDataForFile;
    return this;
  }
  /**
   * @return {string}
   */
  getKeyframeFileName() {
    return this._keyframeFileName;
  }

  /**
   * @param keyframeFileName{string}
   * @return {EditMetadataMsg}
   */
  setKeyframeFileName(keyframeFileName) {
    this._keyframeFileName = keyframeFileName;
    return this;
  }
  /**
   * @return {Array<KeyFrameMetadataEntry>}
   */
  getKeyFrameMetadataEntryList() {
    return this._keyFrameMetadataEntryList;
  }

  /**
   * @param keyFrameMetadataEntryList{Array<KeyFrameMetadataEntry>}
   * @return {EditMetadataMsg}
   */
  setKeyFrameMetadataEntryList(keyFrameMetadataEntryList) {
    this._keyFrameMetadataEntryList = keyFrameMetadataEntryList;
    return this;
  }

  /**
   * @return {Array<FuidRrnInfo>}
   */
  getAssetsInfo() {
    return this._assetsInfo;
  }

  /**
   * @param assetsInfo{Array<FuidRrnInfo>}
   * @return {EditMetadataMsg}
   */
  setAssetsInfo(assetsInfo) {
    this._assetsInfo = assetsInfo;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getNewData() {
    return this._newData;
  }

  /**
   * @param newData{java.util.Map<String,String>}
   * @return {EditMetadataMsg}
   */
  setNewData(newData) {
    this._newData = newData;
    return this;
  }

  /**
   * @return {HashSet}
   */
  getDelData() {
    return this._delData;
  }

  /**
   * @param delData{HashSet}
   * @return {EditMetadataMsg}
   */
  setDelData(delData) {
    this._delData = delData;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditMetadataMsg.CLASS_ID;
    
	//Serializing _multipleValues
	if (this._multipleValues)
		json['multipleValues'] = this._multipleValues;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _keyframeImportDirUniqueKey
	if (this._keyframeImportDirUniqueKey)
		json['keyframeImportDirUniqueKey'] = this._keyframeImportDirUniqueKey;

	//Serializing _append
	if (this._append)
		json['append'] = this._append;

	//Serializing _keyframePropertyToAssignedDataForFile
	if (this._keyframePropertyToAssignedDataForFile)
		json['keyframePropertyToAssignedDataForFile'] = this._keyframePropertyToAssignedDataForFile;

	//Serializing _keyframeFileName
	if (this._keyframeFileName)
		json['keyframeFileName'] = this._keyframeFileName;
  if (this._keyFrameMetadataEntryList && this._keyFrameMetadataEntryList.length > 0) {
    let keyFrameMetadataEntryList_JSON = [];
    /**
     * @type {KeyFrameMetadataEntry}
     */
    this._keyFrameMetadataEntryList.forEach((o200) => {
      if (o200) {
        if (o200.serializeJson && (typeof (o200.serializeJson) === 'function')) {
          keyFrameMetadataEntryList_JSON.push(o200.serializeJson());
        } else {
          keyFrameMetadataEntryList_JSON.push(o200);
        }
      }
    });
    json['keyFrameMetadataEntryList'] = keyFrameMetadataEntryList_JSON;
  }  
  if (this._assetsInfo && this._assetsInfo.length > 0) {
    let assetsInfo_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._assetsInfo.forEach((o203) => {
      if (o203) {
        if (o203.serializeJson && (typeof (o203.serializeJson) === 'function')) {
          assetsInfo_JSON.push(o203.serializeJson());
        } else {
          assetsInfo_JSON.push(o203);
        }
      }
    });
    json['assetsInfo'] = assetsInfo_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"newData", this._newData);
		SerializationUtil.serializeSet(json, "delData", this._delData, true);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._multipleValues = json.hasOwnProperty("multipleValues")?json["multipleValues"]:false;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._keyframeImportDirUniqueKey = json.hasOwnProperty("keyframeImportDirUniqueKey")?json["keyframeImportDirUniqueKey"]:null;
		this._append = json.hasOwnProperty("append")?json["append"]:false;
		this._keyframePropertyToAssignedDataForFile = json.hasOwnProperty("keyframePropertyToAssignedDataForFile")?json["keyframePropertyToAssignedDataForFile"]:null;
		this._keyframeFileName = json.hasOwnProperty("keyframeFileName")?json["keyframeFileName"]:null;
		//set of type KeyFrameMetadataEntry
		this._keyFrameMetadataEntryList = [];
		let keyFrameMetadataEntryListJSONArray = json.hasOwnProperty("keyFrameMetadataEntryList") ? json["keyFrameMetadataEntryList"] : [];

		keyFrameMetadataEntryListJSONArray.forEach((o201)=>{
			if (o201){
				let classObj = new KeyFrameMetadataEntry();
				classObj.deserializeJson(o201);
				this._keyFrameMetadataEntryList.push(classObj);
			}
		});
		//set of type FuidRrnInfo
		this._assetsInfo = [];
		let assetsInfoJSONArray = json.hasOwnProperty("assetsInfo") ? json["assetsInfo"] : [];

		assetsInfoJSONArray.forEach((o204)=>{
			if (o204){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o204);
				this._assetsInfo.push(classObj);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._newData == null)
			this._newData = new HashMap();
		this._newData.clear();
		let newDataJSONArray = json.hasOwnProperty("newData") ? json["newData"] : [];
		this._newData = SerializationUtil.deserializeMap(newDataJSONArray);

//set of type STRING
		if (!this._delData)
			this._delData = new HashSet();
		this._delData.clear();
		let delDataJSONArray = json.hasOwnProperty("delData") ? json["delData"] : [];
		this._delData = SerializationUtil.deserializeSet(delDataJSONArray);

  }
}

/**
 * @returns {string}
 */
EditMetadataMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.EditMetadataMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SimpleArgsClassServer {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._tooltip = null;
    /**
     * @type {string}
     * @private
     */
    this._label = null;
    /**
     * @type {Array<KeyValuePair>}
     * @private
     */
    this._varNameToValue = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {SimpleArgsClassServer}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getTooltip() {
    return this._tooltip;
  }

  /**
   * @param tooltip{string}
   * @return {SimpleArgsClassServer}
   */
  setTooltip(tooltip) {
    this._tooltip = tooltip;
    return this;
  }
  /**
   * @return {string}
   */
  getLabel() {
    return this._label;
  }

  /**
   * @param label{string}
   * @return {SimpleArgsClassServer}
   */
  setLabel(label) {
    this._label = label;
    return this;
  }
  /**
   * @return {Array<KeyValuePair>}
   */
  getVarNameToValue() {
    return this._varNameToValue;
  }

  /**
   * @param varNameToValue{Array<KeyValuePair>}
   * @return {SimpleArgsClassServer}
   */
  setVarNameToValue(varNameToValue) {
    this._varNameToValue = varNameToValue;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SimpleArgsClassServer.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _tooltip
	if (this._tooltip)
		json['tooltip'] = this._tooltip;

	//Serializing _label
	if (this._label)
		json['label'] = this._label;
  if (this._varNameToValue && this._varNameToValue.length > 0) {
    let varNameToValue_JSON = [];
    /**
     * @type {KeyValuePair}
     */
    this._varNameToValue.forEach((o670) => {
      if (o670) {
        if (o670.serializeJson && (typeof (o670.serializeJson) === 'function')) {
          varNameToValue_JSON.push(o670.serializeJson());
        } else {
          varNameToValue_JSON.push(o670);
        }
      }
    });
    json['varNameToValue'] = varNameToValue_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._tooltip = json.hasOwnProperty("tooltip")?json["tooltip"]:null;
		this._label = json.hasOwnProperty("label")?json["label"]:null;
		//set of type KeyValuePair
		this._varNameToValue = [];
		let varNameToValueJSONArray = json.hasOwnProperty("varNameToValue") ? json["varNameToValue"] : [];

		varNameToValueJSONArray.forEach((o671)=>{
			if (o671){
				let classObj = new KeyValuePair();
				classObj.deserializeJson(o671);
				this._varNameToValue.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SimpleArgsClassServer.CLASS_ID = "com.zoom.vab.client.autogenerated.SimpleArgsClassServer";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LiveDrawSpecQuery extends HttpOperation {

  constructor(name = "LiveDrawSpec") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LiveDrawSpecMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LiveDrawSpecMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LiveDrawSpecResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LiveDrawSpecQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LiveDrawSpecQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LiveDrawSpecResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LiveDrawSpecResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LiveDrawSpecQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LiveDrawSpec";
/**
 * @returns {string}
 */
LiveDrawSpecQuery.QUERY_NAME = "LiveDrawSpec";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveSettingsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {SaveSettingsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveSettingsResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
SaveSettingsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveSettingsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditUserFromWebClientQuery extends HttpOperation {

  constructor(name = "EditUserFromWebClient") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {EditUserFromWebClientMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditUserFromWebClientMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditUserFromWebClientQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditUserFromWebClientQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditUserFromWebClientQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditUserFromWebClient";
/**
 * @returns {string}
 */
EditUserFromWebClientQuery.QUERY_NAME = "EditUserFromWebClient";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionSettingsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._nonVcsRrn = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._cid2Uid2Settings = null;

  }

    /**
   * @return {number}
   */
  getNonVcsRrn() {
    return this._nonVcsRrn;
  }

  /**
   * @param nonVcsRrn{number}
   * @return {GetCollectionSettingsResponse}
   */
  setNonVcsRrn(nonVcsRrn) {
    this._nonVcsRrn = nonVcsRrn;
    return this;
  }
  /**
   * @return {java.util.Map<number,Uid2SettingsMap>}
   */
  getCid2Uid2Settings() {
    return this._cid2Uid2Settings;
  }

  /**
   * @param cid2Uid2Settings{java.util.Map<number,Uid2SettingsMap>}
   * @return {GetCollectionSettingsResponse}
   */
  setCid2Uid2Settings(cid2Uid2Settings) {
    this._cid2Uid2Settings = cid2Uid2Settings;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionSettingsResponse.CLASS_ID;
    
	//Serializing _nonVcsRrn
	if (this._nonVcsRrn)
		json['nonVcsRrn'] = this._nonVcsRrn;
    SerializationUtil.serializeHashMap(json,"cid2Uid2Settings", this._cid2Uid2Settings);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._nonVcsRrn = json.hasOwnProperty("nonVcsRrn")?json["nonVcsRrn"]:0;
//Map of type INT. Decode as tree:false
		if (this._cid2Uid2Settings == null)
			this._cid2Uid2Settings = new HashMap();
		this._cid2Uid2Settings.clear();
		let cid2Uid2SettingsJSONArray = json.hasOwnProperty("cid2Uid2Settings") ? json["cid2Uid2Settings"] : [];
		this._cid2Uid2Settings = SerializationUtil.deserializeMap(cid2Uid2SettingsJSONArray);



  }
}

/**
 * @returns {string}
 */
GetCollectionSettingsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionSettingsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EnableDisableLinkSharingResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {EnableDisableLinkSharingResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EnableDisableLinkSharingResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
EnableDisableLinkSharingResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.EnableDisableLinkSharingResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MarkCommentAsReadResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;

  }

    /**
   * If +ve then mark is successful else not.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {MarkCommentAsReadResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MarkCommentAsReadResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;


  }
}

/**
 * @returns {string}
 */
MarkCommentAsReadResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.MarkCommentAsReadResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditZmCollectionUserPermissionQuery extends HttpOperation {

  constructor(name = "EditZmCollectionUserPermission") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {EditZmCollectionUserPermissionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditZmCollectionUserPermissionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditZmCollectionUserPermissionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditZmCollectionUserPermissionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditZmCollectionUserPermissionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollectionUserPermission";
/**
 * @returns {string}
 */
EditZmCollectionUserPermissionQuery.QUERY_NAME = "EditZmCollectionUserPermission";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditUserFromWebClientMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isImageRemoved = false;
    /**
     * @type {string}
     * @private
     */
    this._oldPassword = null;
    /**
     * @type {string}
     * @private
     */
    this._newPassword = null;
    /**
     * @type {UserDetails}
     * @private
     */
    this._userDetails = null;

  }

    /**
   * @return {boolean}
   */
  isIsImageRemoved() {
    return this._isImageRemoved;
  }

  /**
   * @param isImageRemoved{boolean}
   * @return {EditUserFromWebClientMessage}
   */
  setIsImageRemoved(isImageRemoved) {
    this._isImageRemoved = isImageRemoved;
    return this;
  }
  /**
   * @return {string}
   */
  getOldPassword() {
    return this._oldPassword;
  }

  /**
   * @param oldPassword{string}
   * @return {EditUserFromWebClientMessage}
   */
  setOldPassword(oldPassword) {
    this._oldPassword = oldPassword;
    return this;
  }
  /**
   * @return {string}
   */
  getNewPassword() {
    return this._newPassword;
  }

  /**
   * @param newPassword{string}
   * @return {EditUserFromWebClientMessage}
   */
  setNewPassword(newPassword) {
    this._newPassword = newPassword;
    return this;
  }
  /**
   * @return {UserDetails}
   */
  getUserDetails() {
    return this._userDetails;
  }

  /**
   * @param userDetails{UserDetails}
   * @return {EditUserFromWebClientMessage}
   */
  setUserDetails(userDetails) {
    this._userDetails = userDetails;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditUserFromWebClientMessage.CLASS_ID;
    
	//Serializing _isImageRemoved
	if (this._isImageRemoved)
		json['isImageRemoved'] = this._isImageRemoved;

	//Serializing _oldPassword
	if (this._oldPassword)
		json['oldPassword'] = this._oldPassword;

	//Serializing _newPassword
	if (this._newPassword)
		json['newPassword'] = this._newPassword;

	//Serializing ComplexType _$arrayName
	if (this._userDetails)
		json['userDetails'] = this._userDetails.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isImageRemoved = json.hasOwnProperty("isImageRemoved")?json["isImageRemoved"]:false;
		this._oldPassword = json.hasOwnProperty("oldPassword")?json["oldPassword"]:null;
		this._newPassword = json.hasOwnProperty("newPassword")?json["newPassword"]:null;
		if (json.hasOwnProperty("userDetails")){
			if (!this._userDetails && this._userDetails == null)
				this._userDetails = new UserDetails();
			this._userDetails.deserializeJson(json.hasOwnProperty("userDetails") ? json["userDetails"] : null);
		}



  }
}

/**
 * @returns {string}
 */
EditUserFromWebClientMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EditUserFromWebClientMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LsZmCollectionAssetsQuery extends HttpOperation {

  constructor(name = "LsZmCollectionAssets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LsZmCollectionAssetsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LsZmCollectionAssetsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LsZmCollectionAssetsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LsZmCollectionAssetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LsZmCollectionAssetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LsZmCollectionAssetsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LsZmCollectionAssetsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssets";
/**
 * @returns {string}
 */
LsZmCollectionAssetsQuery.QUERY_NAME = "LsZmCollectionAssets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CommentId {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._commentId = null;

  }

    /**
   * @return {number}
   */
  getCommentId() {
    return this._commentId;
  }

  /**
   * @param commentId{number}
   * @return {CommentId}
   */
  setCommentId(commentId) {
    this._commentId = commentId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CommentId.CLASS_ID;
    
	//Serializing _commentId
	if (this._commentId)
		json['commentId'] = this._commentId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._commentId = json.hasOwnProperty("commentId")?json["commentId"]:0;


  }
}

/**
 * @returns {string}
 */
CommentId.CLASS_ID = "com.zoom.vab.client.autogenerated.CommentId";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditZmCollectionAssetsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {ImportQueryResponse}
     * @private
     */
    this._importQueryResponse = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidRrnList = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {EditZmCollectionAssetsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {ImportQueryResponse}
   */
  getImportQueryResponse() {
    return this._importQueryResponse;
  }

  /**
   * @param importQueryResponse{ImportQueryResponse}
   * @return {EditZmCollectionAssetsMessage}
   */
  setImportQueryResponse(importQueryResponse) {
    this._importQueryResponse = importQueryResponse;
    return this;
  }
  /**
   * @return {Array<FuidRrnInfo>}
   */
  getFuidRrnList() {
    return this._fuidRrnList;
  }

  /**
   * @param fuidRrnList{Array<FuidRrnInfo>}
   * @return {EditZmCollectionAssetsMessage}
   */
  setFuidRrnList(fuidRrnList) {
    this._fuidRrnList = fuidRrnList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditZmCollectionAssetsMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._importQueryResponse)
		json['importQueryResponse'] = this._importQueryResponse.serializeJson();
		  if (this._fuidRrnList && this._fuidRrnList.length > 0) {
    let fuidRrnList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidRrnList.forEach((o992) => {
      if (o992) {
        if (o992.serializeJson && (typeof (o992.serializeJson) === 'function')) {
          fuidRrnList_JSON.push(o992.serializeJson());
        } else {
          fuidRrnList_JSON.push(o992);
        }
      }
    });
    json['fuidRrnList'] = fuidRrnList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("importQueryResponse")){
			if (!this._importQueryResponse && this._importQueryResponse == null)
				this._importQueryResponse = new ImportQueryResponse();
			this._importQueryResponse.deserializeJson(json.hasOwnProperty("importQueryResponse") ? json["importQueryResponse"] : null);
		}

		//set of type FuidRrnInfo
		this._fuidRrnList = [];
		let fuidRrnListJSONArray = json.hasOwnProperty("fuidRrnList") ? json["fuidRrnList"] : [];

		fuidRrnListJSONArray.forEach((o993)=>{
			if (o993){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o993);
				this._fuidRrnList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
EditZmCollectionAssetsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollectionAssetsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ExportAssetQuery extends HttpOperation {

  constructor(name = "ExportAsset") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ExportAssetMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ExportAssetMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ExportAssetResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ExportAssetQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ExportAssetQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ExportAssetResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ExportAssetResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ExportAssetQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ExportAsset";
/**
 * @returns {string}
 */
ExportAssetQuery.QUERY_NAME = "ExportAsset";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteDrawingAnnotationsMessage {

  constructor() {
    
        /**
     * @type {Array<ShapeId>}
     * @private
     */
    this._deletedShapes = null;

  }

    /**
   * @return {Array<ShapeId>}
   */
  getDeletedShapes() {
    return this._deletedShapes;
  }

  /**
   * @param deletedShapes{Array<ShapeId>}
   * @return {DeleteDrawingAnnotationsMessage}
   */
  setDeletedShapes(deletedShapes) {
    this._deletedShapes = deletedShapes;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteDrawingAnnotationsMessage.CLASS_ID;
      if (this._deletedShapes && this._deletedShapes.length > 0) {
    let deletedShapes_JSON = [];
    /**
     * @type {ShapeId}
     */
    this._deletedShapes.forEach((o864) => {
      if (o864) {
        if (o864.serializeJson && (typeof (o864.serializeJson) === 'function')) {
          deletedShapes_JSON.push(o864.serializeJson());
        } else {
          deletedShapes_JSON.push(o864);
        }
      }
    });
    json['deletedShapes'] = deletedShapes_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type ShapeId
		this._deletedShapes = [];
		let deletedShapesJSONArray = json.hasOwnProperty("deletedShapes") ? json["deletedShapes"] : [];

		deletedShapesJSONArray.forEach((o865)=>{
			if (o865){
				let classObj = new ShapeId();
				classObj.deserializeJson(o865);
				this._deletedShapes.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
DeleteDrawingAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteDrawingAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ImportQueryResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._uniqueKey = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {ImportQueryResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getUniqueKey() {
    return this._uniqueKey;
  }

  /**
   * @param uniqueKey{string}
   * @return {ImportQueryResponse}
   */
  setUniqueKey(uniqueKey) {
    this._uniqueKey = uniqueKey;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {ImportQueryResponse}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {ImportQueryResponse}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {ImportQueryResponse}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ImportQueryResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _uniqueKey
	if (this._uniqueKey)
		json['uniqueKey'] = this._uniqueKey;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;
  if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o246) => {
      if (o246) {
        if (o246.serializeJson && (typeof (o246.serializeJson) === 'function')) {
          fuids_JSON.push(o246.serializeJson());
        } else {
          fuids_JSON.push(o246);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._uniqueKey = json.hasOwnProperty("uniqueKey")?json["uniqueKey"]:null;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;
		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o247)=>{
			if (o247){
				this._fuids.push(o247);
			}
		});


  }
}

/**
 * @returns {string}
 */
ImportQueryResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ImportQueryResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class PropInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._metadataFieldEnum = null;
    /**
     * @type {boolean}
     * @private
     */
    this._allowMultiple = false;
    /**
     * @type {boolean}
     * @private
     */
    this._editable = false;
    /**
     * @type {boolean}
     * @private
     */
    this._multiline = false;
    /**
     * @type {string}
     * @private
     */
    this._userCanType = null;
    /**
     * @type {string}
     * @private
     */
    this._key = null;
    /**
     * @type {string}
     * @private
     */
    this._valueRestrictPattern = null;
    /**
     * @type {string}
     * @private
     */
    this._groupCode = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._possibleValues = null;

  }

    /**
   * @return {string}
   */
  getMetadataFieldEnum() {
    return this._metadataFieldEnum;
  }

  /**
   * @param metadataFieldEnum{string}
   * @return {PropInfo}
   */
  setMetadataFieldEnum(metadataFieldEnum) {
    this._metadataFieldEnum = metadataFieldEnum;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAllowMultiple() {
    return this._allowMultiple;
  }

  /**
   * @param allowMultiple{boolean}
   * @return {PropInfo}
   */
  setAllowMultiple(allowMultiple) {
    this._allowMultiple = allowMultiple;
    return this;
  }
  /**
   * @return {boolean}
   */
  isEditable() {
    return this._editable;
  }

  /**
   * @param editable{boolean}
   * @return {PropInfo}
   */
  setEditable(editable) {
    this._editable = editable;
    return this;
  }
  /**
   * @return {boolean}
   */
  isMultiline() {
    return this._multiline;
  }

  /**
   * @param multiline{boolean}
   * @return {PropInfo}
   */
  setMultiline(multiline) {
    this._multiline = multiline;
    return this;
  }
  /**
   * @return {string}
   */
  getUserCanType() {
    return this._userCanType;
  }

  /**
   * @param userCanType{string}
   * @return {PropInfo}
   */
  setUserCanType(userCanType) {
    this._userCanType = userCanType;
    return this;
  }
  /**
   * @return {string}
   */
  getKey() {
    return this._key;
  }

  /**
   * @param key{string}
   * @return {PropInfo}
   */
  setKey(key) {
    this._key = key;
    return this;
  }
  /**
   * @return {string}
   */
  getValueRestrictPattern() {
    return this._valueRestrictPattern;
  }

  /**
   * @param valueRestrictPattern{string}
   * @return {PropInfo}
   */
  setValueRestrictPattern(valueRestrictPattern) {
    this._valueRestrictPattern = valueRestrictPattern;
    return this;
  }
  /**
   * @return {string}
   */
  getGroupCode() {
    return this._groupCode;
  }

  /**
   * @param groupCode{string}
   * @return {PropInfo}
   */
  setGroupCode(groupCode) {
    this._groupCode = groupCode;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getPossibleValues() {
    return this._possibleValues;
  }

  /**
   * @param possibleValues{Array<String>}
   * @return {PropInfo}
   */
  setPossibleValues(possibleValues) {
    this._possibleValues = possibleValues;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = PropInfo.CLASS_ID;
    
	//Serializing _metadataFieldEnum
	if (this._metadataFieldEnum)
		json['metadataFieldEnum'] = this._metadataFieldEnum;

	//Serializing _allowMultiple
	if (this._allowMultiple)
		json['allowMultiple'] = this._allowMultiple;

	//Serializing _editable
	if (this._editable)
		json['editable'] = this._editable;

	//Serializing _multiline
	if (this._multiline)
		json['multiline'] = this._multiline;

	//Serializing _userCanType
	if (this._userCanType)
		json['userCanType'] = this._userCanType;

	//Serializing _key
	if (this._key)
		json['key'] = this._key;

	//Serializing _valueRestrictPattern
	if (this._valueRestrictPattern)
		json['valueRestrictPattern'] = this._valueRestrictPattern;

	//Serializing _groupCode
	if (this._groupCode)
		json['groupCode'] = this._groupCode;
  if (this._possibleValues && this._possibleValues.length > 0) {
    let possibleValues_JSON = [];
    /**
     * @type {string}
     */
    this._possibleValues.forEach((o805) => {
      if (o805) {
        if (o805.serializeJson && (typeof (o805.serializeJson) === 'function')) {
          possibleValues_JSON.push(o805.serializeJson());
        } else {
          possibleValues_JSON.push(o805);
        }
      }
    });
    json['possibleValues'] = possibleValues_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._metadataFieldEnum = json.hasOwnProperty("metadataFieldEnum")?json["metadataFieldEnum"]:null;
		this._allowMultiple = json.hasOwnProperty("allowMultiple")?json["allowMultiple"]:false;
		this._editable = json.hasOwnProperty("editable")?json["editable"]:false;
		this._multiline = json.hasOwnProperty("multiline")?json["multiline"]:false;
		this._userCanType = json.hasOwnProperty("userCanType")?json["userCanType"]:null;
		this._key = json.hasOwnProperty("key")?json["key"]:null;
		this._valueRestrictPattern = json.hasOwnProperty("valueRestrictPattern")?json["valueRestrictPattern"]:null;
		this._groupCode = json.hasOwnProperty("groupCode")?json["groupCode"]:null;
		//set of type string
		this._possibleValues = [];
		let possibleValuesJSONArray = json.hasOwnProperty("possibleValues") ? json["possibleValues"] : [];

		possibleValuesJSONArray.forEach((o806)=>{
			if (o806){
				this._possibleValues.push(o806);
			}
		});


  }
}

/**
 * @returns {string}
 */
PropInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.PropInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MarkCommentAsReadMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._markAsUnread = false;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<Long>}
     * @private
     */
    this._commentIds = null;
    /**
     * @type {Array<Long>}
     * @private
     */
    this._threadIds = null;

  }

    /**
   * For the cases where user wants to mark the comment as un read ever after reading it.
   * @return {boolean}
   */
  isMarkAsUnread() {
    return this._markAsUnread;
  }

  /**
   * @param markAsUnread{boolean}
   * @return {MarkCommentAsReadMessage}
   */
  setMarkAsUnread(markAsUnread) {
    this._markAsUnread = markAsUnread;
    return this;
  }
  /**
   * If no comment OR thread id is set, then mark all the conversations in given scope as read.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {MarkCommentAsReadMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comments.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {MarkCommentAsReadMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {Array<Long>}
   */
  getCommentIds() {
    return this._commentIds;
  }

  /**
   * @param commentIds{Array<Long>}
   * @return {MarkCommentAsReadMessage}
   */
  setCommentIds(commentIds) {
    this._commentIds = commentIds;
    return this;
  }

  /**
   * @return {Array<Long>}
   */
  getThreadIds() {
    return this._threadIds;
  }

  /**
   * @param threadIds{Array<Long>}
   * @return {MarkCommentAsReadMessage}
   */
  setThreadIds(threadIds) {
    this._threadIds = threadIds;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MarkCommentAsReadMessage.CLASS_ID;
    
	//Serializing _markAsUnread
	if (this._markAsUnread)
		json['markAsUnread'] = this._markAsUnread;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._commentIds && this._commentIds.length > 0) {
    let commentIds_JSON = [];
    /**
     * @type {long}
     */
    this._commentIds.forEach((o146) => {
      if (o146) {
        if (o146.serializeJson && (typeof (o146.serializeJson) === 'function')) {
          commentIds_JSON.push(o146.serializeJson());
        } else {
          commentIds_JSON.push(o146);
        }
      }
    });
    json['commentIds'] = commentIds_JSON;
  }  
  if (this._threadIds && this._threadIds.length > 0) {
    let threadIds_JSON = [];
    /**
     * @type {long}
     */
    this._threadIds.forEach((o149) => {
      if (o149) {
        if (o149.serializeJson && (typeof (o149.serializeJson) === 'function')) {
          threadIds_JSON.push(o149.serializeJson());
        } else {
          threadIds_JSON.push(o149);
        }
      }
    });
    json['threadIds'] = threadIds_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._markAsUnread = json.hasOwnProperty("markAsUnread")?json["markAsUnread"]:false;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type long
		this._commentIds = [];
		let commentIdsJSONArray = json.hasOwnProperty("commentIds") ? json["commentIds"] : [];

		commentIdsJSONArray.forEach((o147)=>{
			if (o147){
				this._commentIds.push(o147);
			}
		});
		//set of type long
		this._threadIds = [];
		let threadIdsJSONArray = json.hasOwnProperty("threadIds") ? json["threadIds"] : [];

		threadIdsJSONArray.forEach((o150)=>{
			if (o150){
				this._threadIds.push(o150);
			}
		});


  }
}

/**
 * @returns {string}
 */
MarkCommentAsReadMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.MarkCommentAsReadMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AddFavItemsMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._actionType = null;
    /**
     * @type {Array<FavItemDetail>}
     * @private
     */
    this._favItemObjectArray = null;

  }

    /**
   * @return {string}
   */
  getActionType() {
    return this._actionType;
  }

  /**
   * @param actionType{string}
   * @return {AddFavItemsMsg}
   */
  setActionType(actionType) {
    this._actionType = actionType;
    return this;
  }
  /**
   * @return {Array<FavItemDetail>}
   */
  getFavItemObjectArray() {
    return this._favItemObjectArray;
  }

  /**
   * @param favItemObjectArray{Array<FavItemDetail>}
   * @return {AddFavItemsMsg}
   */
  setFavItemObjectArray(favItemObjectArray) {
    this._favItemObjectArray = favItemObjectArray;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AddFavItemsMsg.CLASS_ID;
    
	//Serializing _actionType
	if (this._actionType)
		json['actionType'] = this._actionType;
  if (this._favItemObjectArray && this._favItemObjectArray.length > 0) {
    let favItemObjectArray_JSON = [];
    /**
     * @type {FavItemDetail}
     */
    this._favItemObjectArray.forEach((o1056) => {
      if (o1056) {
        if (o1056.serializeJson && (typeof (o1056.serializeJson) === 'function')) {
          favItemObjectArray_JSON.push(o1056.serializeJson());
        } else {
          favItemObjectArray_JSON.push(o1056);
        }
      }
    });
    json['favItemObjectArray'] = favItemObjectArray_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._actionType = json.hasOwnProperty("actionType")?json["actionType"]:null;
		//set of type FavItemDetail
		this._favItemObjectArray = [];
		let favItemObjectArrayJSONArray = json.hasOwnProperty("favItemObjectArray") ? json["favItemObjectArray"] : [];

		favItemObjectArrayJSONArray.forEach((o1057)=>{
			if (o1057){
				let classObj = new FavItemDetail();
				classObj.deserializeJson(o1057);
				this._favItemObjectArray.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
AddFavItemsMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.AddFavItemsMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCloudCredentialsForTransferMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._providerCode = null;
    /**
     * @type {string}
     * @private
     */
    this._containerName = null;

  }

    /**
   * @return {string}
   */
  getProviderCode() {
    return this._providerCode;
  }

  /**
   * @param providerCode{string}
   * @return {GetCloudCredentialsForTransferMessage}
   */
  setProviderCode(providerCode) {
    this._providerCode = providerCode;
    return this;
  }
  /**
   * @return {string}
   */
  getContainerName() {
    return this._containerName;
  }

  /**
   * @param containerName{string}
   * @return {GetCloudCredentialsForTransferMessage}
   */
  setContainerName(containerName) {
    this._containerName = containerName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCloudCredentialsForTransferMessage.CLASS_ID;
    
	//Serializing _providerCode
	if (this._providerCode)
		json['providerCode'] = this._providerCode;

	//Serializing _containerName
	if (this._containerName)
		json['containerName'] = this._containerName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._providerCode = json.hasOwnProperty("providerCode")?json["providerCode"]:null;
		this._containerName = json.hasOwnProperty("containerName")?json["containerName"]:null;


  }
}

/**
 * @returns {string}
 */
GetCloudCredentialsForTransferMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCloudCredentialsForTransferMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ExportAssetResponse {

  constructor() {
    
    
  }

  

  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ExportAssetResponse.CLASS_ID;
    

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    

  }
}

/**
 * @returns {string}
 */
ExportAssetResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ExportAssetResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FilesStatData {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._hasDirtyFilters = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {boolean}
     * @private
     */
    this._reset = false;
    /**
     * @type {number}
     * @private
     */
    this._totalFiles = null;
    /**
     * @type {Array<CategoryWiseDetail>}
     * @private
     */
    this._categoryList = null;
    /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._resultFiles = null;

  }

    /**
   * @return {boolean}
   */
  isHasDirtyFilters() {
    return this._hasDirtyFilters;
  }

  /**
   * @param hasDirtyFilters{boolean}
   * @return {FilesStatData}
   */
  setHasDirtyFilters(hasDirtyFilters) {
    this._hasDirtyFilters = hasDirtyFilters;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FilesStatData}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {boolean}
   */
  isReset() {
    return this._reset;
  }

  /**
   * @param reset{boolean}
   * @return {FilesStatData}
   */
  setReset(reset) {
    this._reset = reset;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalFiles() {
    return this._totalFiles;
  }

  /**
   * @param totalFiles{number}
   * @return {FilesStatData}
   */
  setTotalFiles(totalFiles) {
    this._totalFiles = totalFiles;
    return this;
  }
  /**
   * @return {Array<CategoryWiseDetail>}
   */
  getCategoryList() {
    return this._categoryList;
  }

  /**
   * @param categoryList{Array<CategoryWiseDetail>}
   * @return {FilesStatData}
   */
  setCategoryList(categoryList) {
    this._categoryList = categoryList;
    return this;
  }

  /**
   * @return {Array<RepoItem>}
   */
  getResultFiles() {
    return this._resultFiles;
  }

  /**
   * @param resultFiles{Array<RepoItem>}
   * @return {FilesStatData}
   */
  setResultFiles(resultFiles) {
    this._resultFiles = resultFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FilesStatData.CLASS_ID;
    
	//Serializing _hasDirtyFilters
	if (this._hasDirtyFilters)
		json['hasDirtyFilters'] = this._hasDirtyFilters;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _reset
	if (this._reset)
		json['reset'] = this._reset;

	//Serializing _totalFiles
	if (this._totalFiles)
		json['totalFiles'] = this._totalFiles;
  if (this._categoryList && this._categoryList.length > 0) {
    let categoryList_JSON = [];
    /**
     * @type {CategoryWiseDetail}
     */
    this._categoryList.forEach((o472) => {
      if (o472) {
        if (o472.serializeJson && (typeof (o472.serializeJson) === 'function')) {
          categoryList_JSON.push(o472.serializeJson());
        } else {
          categoryList_JSON.push(o472);
        }
      }
    });
    json['categoryList'] = categoryList_JSON;
  }  
  if (this._resultFiles && this._resultFiles.length > 0) {
    let resultFiles_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._resultFiles.forEach((o475) => {
      if (o475) {
        if (o475.serializeJson && (typeof (o475.serializeJson) === 'function')) {
          resultFiles_JSON.push(o475.serializeJson());
        } else {
          resultFiles_JSON.push(o475);
        }
      }
    });
    json['resultFiles'] = resultFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._hasDirtyFilters = json.hasOwnProperty("hasDirtyFilters")?json["hasDirtyFilters"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._reset = json.hasOwnProperty("reset")?json["reset"]:false;
		this._totalFiles = json.hasOwnProperty("totalFiles")?json["totalFiles"]:0;
		//set of type CategoryWiseDetail
		this._categoryList = [];
		let categoryListJSONArray = json.hasOwnProperty("categoryList") ? json["categoryList"] : [];

		categoryListJSONArray.forEach((o473)=>{
			if (o473){
				let classObj = new CategoryWiseDetail();
				classObj.deserializeJson(o473);
				this._categoryList.push(classObj);
			}
		});
		//set of type RepoItem
		this._resultFiles = [];
		let resultFilesJSONArray = json.hasOwnProperty("resultFiles") ? json["resultFiles"] : [];

		resultFilesJSONArray.forEach((o476)=>{
			if (o476){
				let classObj = new RepoItem();
				classObj.deserializeJson(o476);
				this._resultFiles.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FilesStatData.CLASS_ID = "com.zoom.vab.client.autogenerated.FilesStatData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ResolveAnnotationsQuery extends HttpOperation {

  constructor(name = "ResolveAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ResolveAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ResolveAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ResolveAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ResolveAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ResolveAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ResolveAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ResolveAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ResolveAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ResolveAnnotations";
/**
 * @returns {string}
 */
ResolveAnnotationsQuery.QUERY_NAME = "ResolveAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetSettingsQuery extends HttpOperation {

  constructor(name = "GetSettings") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetSettingsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetSettingsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetSettingsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetSettingsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetSettingsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetSettingsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSettings";
/**
 * @returns {string}
 */
GetSettingsQuery.QUERY_NAME = "GetSettings";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetActivityPanelDataResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._replyCommentCount = null;
    /**
     * @type {number}
     * @private
     */
    this._resolvedCommentCount = null;
    /**
     * @type {number}
     * @private
     */
    this._newCommentCount = null;
    /**
     * @type {number}
     * @private
     */
    this._parentId = null;
    /**
     * @type {string}
     * @private
     */
    this._status = null;

  }

    /**
   * @return {number}
   */
  getReplyCommentCount() {
    return this._replyCommentCount;
  }

  /**
   * @param replyCommentCount{number}
   * @return {GetActivityPanelDataResponse}
   */
  setReplyCommentCount(replyCommentCount) {
    this._replyCommentCount = replyCommentCount;
    return this;
  }
  /**
   * @return {number}
   */
  getResolvedCommentCount() {
    return this._resolvedCommentCount;
  }

  /**
   * @param resolvedCommentCount{number}
   * @return {GetActivityPanelDataResponse}
   */
  setResolvedCommentCount(resolvedCommentCount) {
    this._resolvedCommentCount = resolvedCommentCount;
    return this;
  }
  /**
   * @return {number}
   */
  getNewCommentCount() {
    return this._newCommentCount;
  }

  /**
   * @param newCommentCount{number}
   * @return {GetActivityPanelDataResponse}
   */
  setNewCommentCount(newCommentCount) {
    this._newCommentCount = newCommentCount;
    return this;
  }
  /**
   * @return {number}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{number}
   * @return {GetActivityPanelDataResponse}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }
  /**
   * @return {string}
   */
  getStatus() {
    return this._status;
  }

  /**
   * @param status{string}
   * @return {GetActivityPanelDataResponse}
   */
  setStatus(status) {
    this._status = status;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetActivityPanelDataResponse.CLASS_ID;
    
	//Serializing _replyCommentCount
	if (this._replyCommentCount)
		json['replyCommentCount'] = this._replyCommentCount;

	//Serializing _resolvedCommentCount
	if (this._resolvedCommentCount)
		json['resolvedCommentCount'] = this._resolvedCommentCount;

	//Serializing _newCommentCount
	if (this._newCommentCount)
		json['newCommentCount'] = this._newCommentCount;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;

	//Serializing _status
	if (this._status)
		json['status'] = this._status;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._replyCommentCount = json.hasOwnProperty("replyCommentCount")?json["replyCommentCount"]:0;
		this._resolvedCommentCount = json.hasOwnProperty("resolvedCommentCount")?json["resolvedCommentCount"]:0;
		this._newCommentCount = json.hasOwnProperty("newCommentCount")?json["newCommentCount"]:0;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:0;
		this._status = json.hasOwnProperty("status")?json["status"]:null;


  }
}

/**
 * @returns {string}
 */
GetActivityPanelDataResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivityPanelDataResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionParametersMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {string}
     * @private
     */
    this._privateLink = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetCollectionParametersMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {string}
   */
  getPrivateLink() {
    return this._privateLink;
  }

  /**
   * @param privateLink{string}
   * @return {GetCollectionParametersMessage}
   */
  setPrivateLink(privateLink) {
    this._privateLink = privateLink;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionParametersMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _privateLink
	if (this._privateLink)
		json['privateLink'] = this._privateLink;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._privateLink = json.hasOwnProperty("privateLink")?json["privateLink"]:null;


  }
}

/**
 * @returns {string}
 */
GetCollectionParametersMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionParametersMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteZmCollectionUsersMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._deleteAll = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {CollectionUserEntry}
     * @private
     */
    this._collectionUserEntry = null;

  }

    /**
   * @return {boolean}
   */
  isDeleteAll() {
    return this._deleteAll;
  }

  /**
   * @param deleteAll{boolean}
   * @return {DeleteZmCollectionUsersMessage}
   */
  setDeleteAll(deleteAll) {
    this._deleteAll = deleteAll;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {DeleteZmCollectionUsersMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {CollectionUserEntry}
   */
  getCollectionUserEntry() {
    return this._collectionUserEntry;
  }

  /**
   * @param collectionUserEntry{CollectionUserEntry}
   * @return {DeleteZmCollectionUsersMessage}
   */
  setCollectionUserEntry(collectionUserEntry) {
    this._collectionUserEntry = collectionUserEntry;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteZmCollectionUsersMessage.CLASS_ID;
    
	//Serializing _deleteAll
	if (this._deleteAll)
		json['deleteAll'] = this._deleteAll;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._collectionUserEntry)
		json['collectionUserEntry'] = this._collectionUserEntry.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._deleteAll = json.hasOwnProperty("deleteAll")?json["deleteAll"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("collectionUserEntry")){
			if (!this._collectionUserEntry && this._collectionUserEntry == null)
				this._collectionUserEntry = new CollectionUserEntry();
			this._collectionUserEntry.deserializeJson(json.hasOwnProperty("collectionUserEntry") ? json["collectionUserEntry"] : null);
		}



  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionUsersMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollectionUsersMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ShapeId {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._shapeId = null;

  }

    /**
   * @return {number}
   */
  getShapeId() {
    return this._shapeId;
  }

  /**
   * @param shapeId{number}
   * @return {ShapeId}
   */
  setShapeId(shapeId) {
    this._shapeId = shapeId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ShapeId.CLASS_ID;
    
	//Serializing _shapeId
	if (this._shapeId)
		json['shapeId'] = this._shapeId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._shapeId = json.hasOwnProperty("shapeId")?json["shapeId"]:0;


  }
}

/**
 * @returns {string}
 */
ShapeId.CLASS_ID = "com.zoom.vab.client.autogenerated.ShapeId";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ImportQueryQuery extends HttpOperation {

  constructor(name = "ImportQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ImportQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ImportQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ImportQueryResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ImportQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ImportQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ImportQueryResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ImportQueryResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ImportQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ImportQuery";
/**
 * @returns {string}
 */
ImportQueryQuery.QUERY_NAME = "ImportQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class RepoItem {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._smartCopySrcFlatten = false;
    /**
     * @type {string}
     * @private
     */
    this._remotePath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasToLinks = false;
    /**
     * @type {string}
     * @private
     */
    this._smartCopySrcPath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._imageSeq = false;
    /**
     * @type {string}
     * @private
     */
    this._lowResArchiveStatus = null;
    /**
     * @type {string}
     * @private
     */
    this._delta = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;
    /**
     * @type {boolean}
     * @private
     */
    this._smartShareSrc = false;
    /**
     * @type {string}
     * @private
     */
    this._midResArchiveStatus = null;
    /**
     * @type {boolean}
     * @private
     */
    this._archived = false;
    /**
     * @type {string}
     * @private
     */
    this._hiResArchiveStatus = null;
    /**
     * @type {boolean}
     * @private
     */
    this._expired = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isDeleted = false;
    /**
     * @type {string}
     * @private
     */
    this._lockTime = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isLocked = false;
    /**
     * @type {number}
     * @private
     */
    this._smartCopySrcFuid = null;
    /**
     * @type {string}
     * @private
     */
    this._action = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isSmartCopySrc = false;
    /**
     * @type {number}
     * @private
     */
    this._frn = null;
    /**
     * @type {string}
     * @private
     */
    this._prettyTime = null;
    /**
     * @type {string}
     * @private
     */
    this._pathStatus = null;
    /**
     * @type {boolean}
     * @private
     */
    this._readOnlySmartShare = false;
    /**
     * @type {string}
     * @private
     */
    this._author = null;
    /**
     * @type {number}
     * @private
     */
    this._smartCopySrcFrn = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;
    /**
     * @type {string}
     * @private
     */
    this._smartShareSrcPath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._proxy = false;
    /**
     * @type {boolean}
     * @private
     */
    this._hasFromLinks = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isSmartCopy = false;
    /**
     * @type {boolean}
     * @private
     */
    this._hasLayers = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._lockOwner = null;
    /**
     * @type {number}
     * @private
     */
    this._deltaSize = null;
    /**
     * @type {string}
     * @private
     */
    this._comment = null;
    /**
     * @type {boolean}
     * @private
     */
    this._smartShare = false;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isSmartLink = false;
    /**
     * @type {BasicFileAttributes}
     * @private
     */
    this._basicFileAttributes = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._collectionAssetProperties = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {boolean}
   */
  isSmartCopySrcFlatten() {
    return this._smartCopySrcFlatten;
  }

  /**
   * @param smartCopySrcFlatten{boolean}
   * @return {RepoItem}
   */
  setSmartCopySrcFlatten(smartCopySrcFlatten) {
    this._smartCopySrcFlatten = smartCopySrcFlatten;
    return this;
  }
  /**
   * @return {string}
   */
  getRemotePath() {
    return this._remotePath;
  }

  /**
   * @param remotePath{string}
   * @return {RepoItem}
   */
  setRemotePath(remotePath) {
    this._remotePath = remotePath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasToLinks() {
    return this._hasToLinks;
  }

  /**
   * @param hasToLinks{boolean}
   * @return {RepoItem}
   */
  setHasToLinks(hasToLinks) {
    this._hasToLinks = hasToLinks;
    return this;
  }
  /**
   * @return {string}
   */
  getSmartCopySrcPath() {
    return this._smartCopySrcPath;
  }

  /**
   * @param smartCopySrcPath{string}
   * @return {RepoItem}
   */
  setSmartCopySrcPath(smartCopySrcPath) {
    this._smartCopySrcPath = smartCopySrcPath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isImageSeq() {
    return this._imageSeq;
  }

  /**
   * @param imageSeq{boolean}
   * @return {RepoItem}
   */
  setImageSeq(imageSeq) {
    this._imageSeq = imageSeq;
    return this;
  }
  /**
   * @return {string}
   */
  getLowResArchiveStatus() {
    return this._lowResArchiveStatus;
  }

  /**
   * @param lowResArchiveStatus{string}
   * @return {RepoItem}
   */
  setLowResArchiveStatus(lowResArchiveStatus) {
    this._lowResArchiveStatus = lowResArchiveStatus;
    return this;
  }
  /**
   * @return {string}
   */
  getDelta() {
    return this._delta;
  }

  /**
   * @param delta{string}
   * @return {RepoItem}
   */
  setDelta(delta) {
    this._delta = delta;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {RepoItem}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {RepoItem}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSmartShareSrc() {
    return this._smartShareSrc;
  }

  /**
   * @param smartShareSrc{boolean}
   * @return {RepoItem}
   */
  setSmartShareSrc(smartShareSrc) {
    this._smartShareSrc = smartShareSrc;
    return this;
  }
  /**
   * @return {string}
   */
  getMidResArchiveStatus() {
    return this._midResArchiveStatus;
  }

  /**
   * @param midResArchiveStatus{string}
   * @return {RepoItem}
   */
  setMidResArchiveStatus(midResArchiveStatus) {
    this._midResArchiveStatus = midResArchiveStatus;
    return this;
  }
  /**
   * @return {boolean}
   */
  isArchived() {
    return this._archived;
  }

  /**
   * @param archived{boolean}
   * @return {RepoItem}
   */
  setArchived(archived) {
    this._archived = archived;
    return this;
  }
  /**
   * @return {string}
   */
  getHiResArchiveStatus() {
    return this._hiResArchiveStatus;
  }

  /**
   * @param hiResArchiveStatus{string}
   * @return {RepoItem}
   */
  setHiResArchiveStatus(hiResArchiveStatus) {
    this._hiResArchiveStatus = hiResArchiveStatus;
    return this;
  }
  /**
   * @return {boolean}
   */
  isExpired() {
    return this._expired;
  }

  /**
   * @param expired{boolean}
   * @return {RepoItem}
   */
  setExpired(expired) {
    this._expired = expired;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsDeleted() {
    return this._isDeleted;
  }

  /**
   * @param isDeleted{boolean}
   * @return {RepoItem}
   */
  setIsDeleted(isDeleted) {
    this._isDeleted = isDeleted;
    return this;
  }
  /**
   * @return {string}
   */
  getLockTime() {
    return this._lockTime;
  }

  /**
   * @param lockTime{string}
   * @return {RepoItem}
   */
  setLockTime(lockTime) {
    this._lockTime = lockTime;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsLocked() {
    return this._isLocked;
  }

  /**
   * @param isLocked{boolean}
   * @return {RepoItem}
   */
  setIsLocked(isLocked) {
    this._isLocked = isLocked;
    return this;
  }
  /**
   * @return {number}
   */
  getSmartCopySrcFuid() {
    return this._smartCopySrcFuid;
  }

  /**
   * @param smartCopySrcFuid{number}
   * @return {RepoItem}
   */
  setSmartCopySrcFuid(smartCopySrcFuid) {
    this._smartCopySrcFuid = smartCopySrcFuid;
    return this;
  }
  /**
   * @return {string}
   */
  getAction() {
    return this._action;
  }

  /**
   * @param action{string}
   * @return {RepoItem}
   */
  setAction(action) {
    this._action = action;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {RepoItem}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsSmartCopySrc() {
    return this._isSmartCopySrc;
  }

  /**
   * @param isSmartCopySrc{boolean}
   * @return {RepoItem}
   */
  setIsSmartCopySrc(isSmartCopySrc) {
    this._isSmartCopySrc = isSmartCopySrc;
    return this;
  }
  /**
   * @return {number}
   */
  getFrn() {
    return this._frn;
  }

  /**
   * @param frn{number}
   * @return {RepoItem}
   */
  setFrn(frn) {
    this._frn = frn;
    return this;
  }
  /**
   * @return {string}
   */
  getPrettyTime() {
    return this._prettyTime;
  }

  /**
   * @param prettyTime{string}
   * @return {RepoItem}
   */
  setPrettyTime(prettyTime) {
    this._prettyTime = prettyTime;
    return this;
  }
  /**
   * @return {string}
   */
  getPathStatus() {
    return this._pathStatus;
  }

  /**
   * @param pathStatus{string}
   * @return {RepoItem}
   */
  setPathStatus(pathStatus) {
    this._pathStatus = pathStatus;
    return this;
  }
  /**
   * @return {boolean}
   */
  isReadOnlySmartShare() {
    return this._readOnlySmartShare;
  }

  /**
   * @param readOnlySmartShare{boolean}
   * @return {RepoItem}
   */
  setReadOnlySmartShare(readOnlySmartShare) {
    this._readOnlySmartShare = readOnlySmartShare;
    return this;
  }
  /**
   * @return {string}
   */
  getAuthor() {
    return this._author;
  }

  /**
   * @param author{string}
   * @return {RepoItem}
   */
  setAuthor(author) {
    this._author = author;
    return this;
  }
  /**
   * @return {number}
   */
  getSmartCopySrcFrn() {
    return this._smartCopySrcFrn;
  }

  /**
   * @param smartCopySrcFrn{number}
   * @return {RepoItem}
   */
  setSmartCopySrcFrn(smartCopySrcFrn) {
    this._smartCopySrcFrn = smartCopySrcFrn;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {RepoItem}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }
  /**
   * @return {string}
   */
  getSmartShareSrcPath() {
    return this._smartShareSrcPath;
  }

  /**
   * @param smartShareSrcPath{string}
   * @return {RepoItem}
   */
  setSmartShareSrcPath(smartShareSrcPath) {
    this._smartShareSrcPath = smartShareSrcPath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isProxy() {
    return this._proxy;
  }

  /**
   * @param proxy{boolean}
   * @return {RepoItem}
   */
  setProxy(proxy) {
    this._proxy = proxy;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasFromLinks() {
    return this._hasFromLinks;
  }

  /**
   * @param hasFromLinks{boolean}
   * @return {RepoItem}
   */
  setHasFromLinks(hasFromLinks) {
    this._hasFromLinks = hasFromLinks;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsSmartCopy() {
    return this._isSmartCopy;
  }

  /**
   * @param isSmartCopy{boolean}
   * @return {RepoItem}
   */
  setIsSmartCopy(isSmartCopy) {
    this._isSmartCopy = isSmartCopy;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasLayers() {
    return this._hasLayers;
  }

  /**
   * @param hasLayers{boolean}
   * @return {RepoItem}
   */
  setHasLayers(hasLayers) {
    this._hasLayers = hasLayers;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {RepoItem}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getLockOwner() {
    return this._lockOwner;
  }

  /**
   * @param lockOwner{string}
   * @return {RepoItem}
   */
  setLockOwner(lockOwner) {
    this._lockOwner = lockOwner;
    return this;
  }
  /**
   * @return {number}
   */
  getDeltaSize() {
    return this._deltaSize;
  }

  /**
   * @param deltaSize{number}
   * @return {RepoItem}
   */
  setDeltaSize(deltaSize) {
    this._deltaSize = deltaSize;
    return this;
  }
  /**
   * @return {string}
   */
  getComment() {
    return this._comment;
  }

  /**
   * @param comment{string}
   * @return {RepoItem}
   */
  setComment(comment) {
    this._comment = comment;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSmartShare() {
    return this._smartShare;
  }

  /**
   * @param smartShare{boolean}
   * @return {RepoItem}
   */
  setSmartShare(smartShare) {
    this._smartShare = smartShare;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {RepoItem}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsSmartLink() {
    return this._isSmartLink;
  }

  /**
   * @param isSmartLink{boolean}
   * @return {RepoItem}
   */
  setIsSmartLink(isSmartLink) {
    this._isSmartLink = isSmartLink;
    return this;
  }
  /**
   * @return {BasicFileAttributes}
   */
  getBasicFileAttributes() {
    return this._basicFileAttributes;
  }

  /**
   * @param basicFileAttributes{BasicFileAttributes}
   * @return {RepoItem}
   */
  setBasicFileAttributes(basicFileAttributes) {
    this._basicFileAttributes = basicFileAttributes;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getCollectionAssetProperties() {
    return this._collectionAssetProperties;
  }

  /**
   * @param collectionAssetProperties{java.util.Map<String,String>}
   * @return {RepoItem}
   */
  setCollectionAssetProperties(collectionAssetProperties) {
    this._collectionAssetProperties = collectionAssetProperties;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {RepoItem}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = RepoItem.CLASS_ID;
    
	//Serializing _smartCopySrcFlatten
	if (this._smartCopySrcFlatten)
		json['smartCopySrcFlatten'] = this._smartCopySrcFlatten;

	//Serializing _remotePath
	if (this._remotePath)
		json['remotePath'] = this._remotePath;

	//Serializing _hasToLinks
	if (this._hasToLinks)
		json['hasToLinks'] = this._hasToLinks;

	//Serializing _smartCopySrcPath
	if (this._smartCopySrcPath)
		json['smartCopySrcPath'] = this._smartCopySrcPath;

	//Serializing _imageSeq
	if (this._imageSeq)
		json['imageSeq'] = this._imageSeq;

	//Serializing _lowResArchiveStatus
	if (this._lowResArchiveStatus)
		json['lowResArchiveStatus'] = this._lowResArchiveStatus;

	//Serializing _delta
	if (this._delta)
		json['delta'] = this._delta;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;

	//Serializing _smartShareSrc
	if (this._smartShareSrc)
		json['smartShareSrc'] = this._smartShareSrc;

	//Serializing _midResArchiveStatus
	if (this._midResArchiveStatus)
		json['midResArchiveStatus'] = this._midResArchiveStatus;

	//Serializing _archived
	if (this._archived)
		json['archived'] = this._archived;

	//Serializing _hiResArchiveStatus
	if (this._hiResArchiveStatus)
		json['hiResArchiveStatus'] = this._hiResArchiveStatus;

	//Serializing _expired
	if (this._expired)
		json['expired'] = this._expired;

	//Serializing _isDeleted
	if (this._isDeleted)
		json['isDeleted'] = this._isDeleted;

	//Serializing _lockTime
	if (this._lockTime)
		json['lockTime'] = this._lockTime;

	//Serializing _isLocked
	if (this._isLocked)
		json['isLocked'] = this._isLocked;

	//Serializing _smartCopySrcFuid
	if (this._smartCopySrcFuid)
		json['smartCopySrcFuid'] = this._smartCopySrcFuid;

	//Serializing _action
	if (this._action)
		json['action'] = this._action;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _isSmartCopySrc
	if (this._isSmartCopySrc)
		json['isSmartCopySrc'] = this._isSmartCopySrc;

	//Serializing _frn
	if (this._frn)
		json['frn'] = this._frn;

	//Serializing _prettyTime
	if (this._prettyTime)
		json['prettyTime'] = this._prettyTime;

	//Serializing _pathStatus
	if (this._pathStatus)
		json['pathStatus'] = this._pathStatus;

	//Serializing _readOnlySmartShare
	if (this._readOnlySmartShare)
		json['readOnlySmartShare'] = this._readOnlySmartShare;

	//Serializing _author
	if (this._author)
		json['author'] = this._author;

	//Serializing _smartCopySrcFrn
	if (this._smartCopySrcFrn)
		json['smartCopySrcFrn'] = this._smartCopySrcFrn;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;

	//Serializing _smartShareSrcPath
	if (this._smartShareSrcPath)
		json['smartShareSrcPath'] = this._smartShareSrcPath;

	//Serializing _proxy
	if (this._proxy)
		json['proxy'] = this._proxy;

	//Serializing _hasFromLinks
	if (this._hasFromLinks)
		json['hasFromLinks'] = this._hasFromLinks;

	//Serializing _isSmartCopy
	if (this._isSmartCopy)
		json['isSmartCopy'] = this._isSmartCopy;

	//Serializing _hasLayers
	if (this._hasLayers)
		json['hasLayers'] = this._hasLayers;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _lockOwner
	if (this._lockOwner)
		json['lockOwner'] = this._lockOwner;

	//Serializing _deltaSize
	if (this._deltaSize)
		json['deltaSize'] = this._deltaSize;

	//Serializing _comment
	if (this._comment)
		json['comment'] = this._comment;

	//Serializing _smartShare
	if (this._smartShare)
		json['smartShare'] = this._smartShare;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _isSmartLink
	if (this._isSmartLink)
		json['isSmartLink'] = this._isSmartLink;

	//Serializing ComplexType _$arrayName
	if (this._basicFileAttributes)
		json['basicFileAttributes'] = this._basicFileAttributes.serializeJson();
		    SerializationUtil.serializeHashMap(json,"collectionAssetProperties", this._collectionAssetProperties);
		    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._smartCopySrcFlatten = json.hasOwnProperty("smartCopySrcFlatten")?json["smartCopySrcFlatten"]:false;
		this._remotePath = json.hasOwnProperty("remotePath")?json["remotePath"]:null;
		this._hasToLinks = json.hasOwnProperty("hasToLinks")?json["hasToLinks"]:false;
		this._smartCopySrcPath = json.hasOwnProperty("smartCopySrcPath")?json["smartCopySrcPath"]:null;
		this._imageSeq = json.hasOwnProperty("imageSeq")?json["imageSeq"]:false;
		this._lowResArchiveStatus = json.hasOwnProperty("lowResArchiveStatus")?json["lowResArchiveStatus"]:null;
		this._delta = json.hasOwnProperty("delta")?json["delta"]:null;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;
		this._smartShareSrc = json.hasOwnProperty("smartShareSrc")?json["smartShareSrc"]:false;
		this._midResArchiveStatus = json.hasOwnProperty("midResArchiveStatus")?json["midResArchiveStatus"]:null;
		this._archived = json.hasOwnProperty("archived")?json["archived"]:false;
		this._hiResArchiveStatus = json.hasOwnProperty("hiResArchiveStatus")?json["hiResArchiveStatus"]:null;
		this._expired = json.hasOwnProperty("expired")?json["expired"]:false;
		this._isDeleted = json.hasOwnProperty("isDeleted")?json["isDeleted"]:false;
		this._lockTime = json.hasOwnProperty("lockTime")?json["lockTime"]:null;
		this._isLocked = json.hasOwnProperty("isLocked")?json["isLocked"]:false;
		this._smartCopySrcFuid = json.hasOwnProperty("smartCopySrcFuid")?json["smartCopySrcFuid"]:0;
		this._action = json.hasOwnProperty("action")?json["action"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._isSmartCopySrc = json.hasOwnProperty("isSmartCopySrc")?json["isSmartCopySrc"]:false;
		this._frn = json.hasOwnProperty("frn")?json["frn"]:0;
		this._prettyTime = json.hasOwnProperty("prettyTime")?json["prettyTime"]:null;
		this._pathStatus = json.hasOwnProperty("pathStatus")?json["pathStatus"]:null;
		this._readOnlySmartShare = json.hasOwnProperty("readOnlySmartShare")?json["readOnlySmartShare"]:false;
		this._author = json.hasOwnProperty("author")?json["author"]:null;
		this._smartCopySrcFrn = json.hasOwnProperty("smartCopySrcFrn")?json["smartCopySrcFrn"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;
		this._smartShareSrcPath = json.hasOwnProperty("smartShareSrcPath")?json["smartShareSrcPath"]:null;
		this._proxy = json.hasOwnProperty("proxy")?json["proxy"]:false;
		this._hasFromLinks = json.hasOwnProperty("hasFromLinks")?json["hasFromLinks"]:false;
		this._isSmartCopy = json.hasOwnProperty("isSmartCopy")?json["isSmartCopy"]:false;
		this._hasLayers = json.hasOwnProperty("hasLayers")?json["hasLayers"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._lockOwner = json.hasOwnProperty("lockOwner")?json["lockOwner"]:null;
		this._deltaSize = json.hasOwnProperty("deltaSize")?json["deltaSize"]:0;
		this._comment = json.hasOwnProperty("comment")?json["comment"]:null;
		this._smartShare = json.hasOwnProperty("smartShare")?json["smartShare"]:false;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._isSmartLink = json.hasOwnProperty("isSmartLink")?json["isSmartLink"]:false;
		if (json.hasOwnProperty("basicFileAttributes")){
			if (!this._basicFileAttributes && this._basicFileAttributes == null)
				this._basicFileAttributes = new BasicFileAttributes();
			this._basicFileAttributes.deserializeJson(json.hasOwnProperty("basicFileAttributes") ? json["basicFileAttributes"] : null);
		}

//Map of type STRING. Decode as tree:false
		if (this._collectionAssetProperties == null)
			this._collectionAssetProperties = new HashMap();
		this._collectionAssetProperties.clear();
		let collectionAssetPropertiesJSONArray = json.hasOwnProperty("collectionAssetProperties") ? json["collectionAssetProperties"] : [];
		this._collectionAssetProperties = SerializationUtil.deserializeMap(collectionAssetPropertiesJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
RepoItem.CLASS_ID = "com.zoom.vab.client.autogenerated.RepoItem";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ImageAiData {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._planarAxis = null;
    /**
     * @type {string}
     * @private
     */
    this._valueType = null;
    /**
     * @type {string}
     * @private
     */
    this._aiType = null;
    /**
     * @type {number}
     * @private
     */
    this._confidence = null;
    /**
     * @type {string}
     * @private
     */
    this._measuringUnits = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {ChildDocument}
     * @private
     */
    this._childDocument = null;

  }

    /**
   * @return {string}
   */
  getPlanarAxis() {
    return this._planarAxis;
  }

  /**
   * @param planarAxis{string}
   * @return {ImageAiData}
   */
  setPlanarAxis(planarAxis) {
    this._planarAxis = planarAxis;
    return this;
  }
  /**
   * @return {string}
   */
  getValueType() {
    return this._valueType;
  }

  /**
   * @param valueType{string}
   * @return {ImageAiData}
   */
  setValueType(valueType) {
    this._valueType = valueType;
    return this;
  }
  /**
   * @return {string}
   */
  getAiType() {
    return this._aiType;
  }

  /**
   * @param aiType{string}
   * @return {ImageAiData}
   */
  setAiType(aiType) {
    this._aiType = aiType;
    return this;
  }
  /**
   * @return {number}
   */
  getConfidence() {
    return this._confidence;
  }

  /**
   * @param confidence{number}
   * @return {ImageAiData}
   */
  setConfidence(confidence) {
    this._confidence = confidence;
    return this;
  }
  /**
   * @return {string}
   */
  getMeasuringUnits() {
    return this._measuringUnits;
  }

  /**
   * @param measuringUnits{string}
   * @return {ImageAiData}
   */
  setMeasuringUnits(measuringUnits) {
    this._measuringUnits = measuringUnits;
    return this;
  }
  /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {ImageAiData}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {ChildDocument}
   */
  getChildDocument() {
    return this._childDocument;
  }

  /**
   * @param childDocument{ChildDocument}
   * @return {ImageAiData}
   */
  setChildDocument(childDocument) {
    this._childDocument = childDocument;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ImageAiData.CLASS_ID;
    
	//Serializing _planarAxis
	if (this._planarAxis)
		json['planarAxis'] = this._planarAxis;

	//Serializing _valueType
	if (this._valueType)
		json['valueType'] = this._valueType;

	//Serializing _aiType
	if (this._aiType)
		json['aiType'] = this._aiType;

	//Serializing _confidence
	if (this._confidence)
		json['confidence'] = this._confidence;

	//Serializing _measuringUnits
	if (this._measuringUnits)
		json['measuringUnits'] = this._measuringUnits;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing ComplexType _$arrayName
	if (this._childDocument)
		json['childDocument'] = this._childDocument.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._planarAxis = json.hasOwnProperty("planarAxis")?json["planarAxis"]:null;
		this._valueType = json.hasOwnProperty("valueType")?json["valueType"]:null;
		this._aiType = json.hasOwnProperty("aiType")?json["aiType"]:null;
		this._confidence = json.hasOwnProperty("confidence")?json["confidence"]:0;
		this._measuringUnits = json.hasOwnProperty("measuringUnits")?json["measuringUnits"]:null;
		this._value = json.hasOwnProperty("value")?json["value"]:null;
		if (json.hasOwnProperty("childDocument")){
			if (!this._childDocument && this._childDocument == null)
				this._childDocument = new ChildDocument();
			this._childDocument.deserializeJson(json.hasOwnProperty("childDocument") ? json["childDocument"] : null);
		}



  }
}

/**
 * @returns {string}
 */
ImageAiData.CLASS_ID = "com.zoom.vab.client.autogenerated.ImageAiData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CloudCredentialsForTransfer {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {string}
     * @private
     */
    this._password = null;
    /**
     * @type {string}
     * @private
     */
    this._providerCode = null;
    /**
     * @type {string}
     * @private
     */
    this._containerName = null;
    /**
     * @type {string}
     * @private
     */
    this._location = null;
    /**
     * @type {string}
     * @private
     */
    this._userName = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {CloudCredentialsForTransfer}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {string}
   */
  getPassword() {
    return this._password;
  }

  /**
   * @param password{string}
   * @return {CloudCredentialsForTransfer}
   */
  setPassword(password) {
    this._password = password;
    return this;
  }
  /**
   * @return {string}
   */
  getProviderCode() {
    return this._providerCode;
  }

  /**
   * @param providerCode{string}
   * @return {CloudCredentialsForTransfer}
   */
  setProviderCode(providerCode) {
    this._providerCode = providerCode;
    return this;
  }
  /**
   * @return {string}
   */
  getContainerName() {
    return this._containerName;
  }

  /**
   * @param containerName{string}
   * @return {CloudCredentialsForTransfer}
   */
  setContainerName(containerName) {
    this._containerName = containerName;
    return this;
  }
  /**
   * @return {string}
   */
  getLocation() {
    return this._location;
  }

  /**
   * @param location{string}
   * @return {CloudCredentialsForTransfer}
   */
  setLocation(location) {
    this._location = location;
    return this;
  }
  /**
   * @return {string}
   */
  getUserName() {
    return this._userName;
  }

  /**
   * @param userName{string}
   * @return {CloudCredentialsForTransfer}
   */
  setUserName(userName) {
    this._userName = userName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CloudCredentialsForTransfer.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _password
	if (this._password)
		json['password'] = this._password;

	//Serializing _providerCode
	if (this._providerCode)
		json['providerCode'] = this._providerCode;

	//Serializing _containerName
	if (this._containerName)
		json['containerName'] = this._containerName;

	//Serializing _location
	if (this._location)
		json['location'] = this._location;

	//Serializing _userName
	if (this._userName)
		json['userName'] = this._userName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._password = json.hasOwnProperty("password")?json["password"]:null;
		this._providerCode = json.hasOwnProperty("providerCode")?json["providerCode"]:null;
		this._containerName = json.hasOwnProperty("containerName")?json["containerName"]:null;
		this._location = json.hasOwnProperty("location")?json["location"]:null;
		this._userName = json.hasOwnProperty("userName")?json["userName"]:null;


  }
}

/**
 * @returns {string}
 */
CloudCredentialsForTransfer.CLASS_ID = "com.zoom.vab.client.autogenerated.CloudCredentialsForTransfer";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteZmCollectionMessage {

  constructor() {
    
        /**
     * @type {Array<Integer>}
     * @private
     */
    this._collectionIds = null;

  }

    /**
   * @return {Array<Integer>}
   */
  getCollectionIds() {
    return this._collectionIds;
  }

  /**
   * @param collectionIds{Array<Integer>}
   * @return {DeleteZmCollectionMessage}
   */
  setCollectionIds(collectionIds) {
    this._collectionIds = collectionIds;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteZmCollectionMessage.CLASS_ID;
      if (this._collectionIds && this._collectionIds.length > 0) {
    let collectionIds_JSON = [];
    /**
     * @type {int}
     */
    this._collectionIds.forEach((o632) => {
      if (o632) {
        if (o632.serializeJson && (typeof (o632.serializeJson) === 'function')) {
          collectionIds_JSON.push(o632.serializeJson());
        } else {
          collectionIds_JSON.push(o632);
        }
      }
    });
    json['collectionIds'] = collectionIds_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type int
		this._collectionIds = [];
		let collectionIdsJSONArray = json.hasOwnProperty("collectionIds") ? json["collectionIds"] : [];

		collectionIdsJSONArray.forEach((o633)=>{
			if (o633){
				this._collectionIds.push(o633);
			}
		});


  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollectionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ArchiveDetailsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._message = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._detailsMap = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {ArchiveDetailsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {ArchiveDetailsResponse}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }
  /**
   * @return {java.util.Map<number,KVMap>}
   */
  getDetailsMap() {
    return this._detailsMap;
  }

  /**
   * @param detailsMap{java.util.Map<number,KVMap>}
   * @return {ArchiveDetailsResponse}
   */
  setDetailsMap(detailsMap) {
    this._detailsMap = detailsMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ArchiveDetailsResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;
    SerializationUtil.serializeHashMap(json,"detailsMap", this._detailsMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._message = json.hasOwnProperty("message")?json["message"]:null;
//Map of type INT. Decode as tree:false
		if (this._detailsMap == null)
			this._detailsMap = new HashMap();
		this._detailsMap.clear();
		let detailsMapJSONArray = json.hasOwnProperty("detailsMap") ? json["detailsMap"] : [];
		this._detailsMap = SerializationUtil.deserializeMap(detailsMapJSONArray);



  }
}

/**
 * @returns {string}
 */
ArchiveDetailsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveDetailsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class HelpData {

  constructor() {
    
        /**
     * @type {HelpInfo}
     * @private
     */
    this._helpInfo = null;
    /**
     * @type {Array<HelpInfo>}
     * @private
     */
    this._helpItems = null;

  }

    /**
   * @return {HelpInfo}
   */
  getHelpInfo() {
    return this._helpInfo;
  }

  /**
   * @param helpInfo{HelpInfo}
   * @return {HelpData}
   */
  setHelpInfo(helpInfo) {
    this._helpInfo = helpInfo;
    return this;
  }
  /**
   * @return {Array<HelpInfo>}
   */
  getHelpItems() {
    return this._helpItems;
  }

  /**
   * @param helpItems{Array<HelpInfo>}
   * @return {HelpData}
   */
  setHelpItems(helpItems) {
    this._helpItems = helpItems;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = HelpData.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._helpInfo)
		json['helpInfo'] = this._helpInfo.serializeJson();
		  if (this._helpItems && this._helpItems.length > 0) {
    let helpItems_JSON = [];
    /**
     * @type {HelpInfo}
     */
    this._helpItems.forEach((o355) => {
      if (o355) {
        if (o355.serializeJson && (typeof (o355.serializeJson) === 'function')) {
          helpItems_JSON.push(o355.serializeJson());
        } else {
          helpItems_JSON.push(o355);
        }
      }
    });
    json['helpItems'] = helpItems_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("helpInfo")){
			if (!this._helpInfo && this._helpInfo == null)
				this._helpInfo = new HelpInfo();
			this._helpInfo.deserializeJson(json.hasOwnProperty("helpInfo") ? json["helpInfo"] : null);
		}

		//set of type HelpInfo
		this._helpItems = [];
		let helpItemsJSONArray = json.hasOwnProperty("helpItems") ? json["helpItems"] : [];

		helpItemsJSONArray.forEach((o356)=>{
			if (o356){
				let classObj = new HelpInfo();
				classObj.deserializeJson(o356);
				this._helpItems.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
HelpData.CLASS_ID = "com.zoom.vab.client.autogenerated.HelpData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetDrawingAnnotationsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._shapeId = null;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;

  }

    /**
   * optional: only get those threads which have been created/modified after this RRN
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {GetDrawingAnnotationsMessage}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * optional: can be specified to get specific shape data only; other scope params do not take effect if specified.
   * @return {number}
   */
  getShapeId() {
    return this._shapeId;
  }

  /**
   * @param shapeId{number}
   * @return {GetDrawingAnnotationsMessage}
   */
  setShapeId(shapeId) {
    this._shapeId = shapeId;
    return this;
  }
  /**
   * optional: Collection scope for comments.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {GetDrawingAnnotationsMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comments.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {GetDrawingAnnotationsMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetDrawingAnnotationsMessage.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;

	//Serializing _shapeId
	if (this._shapeId)
		json['shapeId'] = this._shapeId;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		this._shapeId = json.hasOwnProperty("shapeId")?json["shapeId"]:0;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
GetDrawingAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetDrawingAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClientExecMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._cmdName = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._target = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._path = null;

  }

    /**
   * @return {string}
   */
  getCmdName() {
    return this._cmdName;
  }

  /**
   * @param cmdName{string}
   * @return {ClientExecMsg}
   */
  setCmdName(cmdName) {
    this._cmdName = cmdName;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {ClientExecMsg}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getTarget() {
    return this._target;
  }

  /**
   * @param target{string}
   * @return {ClientExecMsg}
   */
  setTarget(target) {
    this._target = target;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{Array<String>}
   * @return {ClientExecMsg}
   */
  setPath(path) {
    this._path = path;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClientExecMsg.CLASS_ID;
    
	//Serializing _cmdName
	if (this._cmdName)
		json['cmdName'] = this._cmdName;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _target
	if (this._target)
		json['target'] = this._target;
  if (this._path && this._path.length > 0) {
    let path_JSON = [];
    /**
     * @type {string}
     */
    this._path.forEach((o872) => {
      if (o872) {
        if (o872.serializeJson && (typeof (o872.serializeJson) === 'function')) {
          path_JSON.push(o872.serializeJson());
        } else {
          path_JSON.push(o872);
        }
      }
    });
    json['path'] = path_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._cmdName = json.hasOwnProperty("cmdName")?json["cmdName"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._target = json.hasOwnProperty("target")?json["target"]:null;
		//set of type string
		this._path = [];
		let pathJSONArray = json.hasOwnProperty("path") ? json["path"] : [];

		pathJSONArray.forEach((o873)=>{
			if (o873){
				this._path.push(o873);
			}
		});


  }
}

/**
 * @returns {string}
 */
ClientExecMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ClientExecMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FileFilters {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._filterText = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._extension = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._fileTypes = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._filter2ValueMap = null;

  }

    /**
   * @return {string}
   */
  getFilterText() {
    return this._filterText;
  }

  /**
   * @param filterText{string}
   * @return {FileFilters}
   */
  setFilterText(filterText) {
    this._filterText = filterText;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getExtension() {
    return this._extension;
  }

  /**
   * @param extension{Array<String>}
   * @return {FileFilters}
   */
  setExtension(extension) {
    this._extension = extension;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getFileTypes() {
    return this._fileTypes;
  }

  /**
   * @param fileTypes{Array<String>}
   * @return {FileFilters}
   */
  setFileTypes(fileTypes) {
    this._fileTypes = fileTypes;
    return this;
  }

  /**
   * @return {java.util.Map<String,Boolean>}
   */
  getFilter2ValueMap() {
    return this._filter2ValueMap;
  }

  /**
   * @param filter2ValueMap{java.util.Map<String,Boolean>}
   * @return {FileFilters}
   */
  setFilter2ValueMap(filter2ValueMap) {
    this._filter2ValueMap = filter2ValueMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FileFilters.CLASS_ID;
    
	//Serializing _filterText
	if (this._filterText)
		json['filterText'] = this._filterText;
  if (this._extension && this._extension.length > 0) {
    let extension_JSON = [];
    /**
     * @type {string}
     */
    this._extension.forEach((o422) => {
      if (o422) {
        if (o422.serializeJson && (typeof (o422.serializeJson) === 'function')) {
          extension_JSON.push(o422.serializeJson());
        } else {
          extension_JSON.push(o422);
        }
      }
    });
    json['extension'] = extension_JSON;
  }  
  if (this._fileTypes && this._fileTypes.length > 0) {
    let fileTypes_JSON = [];
    /**
     * @type {string}
     */
    this._fileTypes.forEach((o425) => {
      if (o425) {
        if (o425.serializeJson && (typeof (o425.serializeJson) === 'function')) {
          fileTypes_JSON.push(o425.serializeJson());
        } else {
          fileTypes_JSON.push(o425);
        }
      }
    });
    json['fileTypes'] = fileTypes_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"filter2ValueMap", this._filter2ValueMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._filterText = json.hasOwnProperty("filterText")?json["filterText"]:null;
		//set of type string
		this._extension = [];
		let extensionJSONArray = json.hasOwnProperty("extension") ? json["extension"] : [];

		extensionJSONArray.forEach((o423)=>{
			if (o423){
				this._extension.push(o423);
			}
		});
		//set of type string
		this._fileTypes = [];
		let fileTypesJSONArray = json.hasOwnProperty("fileTypes") ? json["fileTypes"] : [];

		fileTypesJSONArray.forEach((o426)=>{
			if (o426){
				this._fileTypes.push(o426);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._filter2ValueMap == null)
			this._filter2ValueMap = new HashMap();
		this._filter2ValueMap.clear();
		let filter2ValueMapJSONArray = json.hasOwnProperty("filter2ValueMap") ? json["filter2ValueMap"] : [];
		this._filter2ValueMap = SerializationUtil.deserializeMap(filter2ValueMapJSONArray);



  }
}

/**
 * @returns {string}
 */
FileFilters.CLASS_ID = "com.zoom.vab.client.autogenerated.FileFilters";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class HelpQueryMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageLength = null;
    /**
     * @type {string}
     * @private
     */
    this._helpKey = null;
    /**
     * @type {number}
     * @private
     */
    this._currentPage = null;

  }

    /**
   * @return {number}
   */
  getPageLength() {
    return this._pageLength;
  }

  /**
   * @param pageLength{number}
   * @return {HelpQueryMessage}
   */
  setPageLength(pageLength) {
    this._pageLength = pageLength;
    return this;
  }
  /**
   * @return {string}
   */
  getHelpKey() {
    return this._helpKey;
  }

  /**
   * @param helpKey{string}
   * @return {HelpQueryMessage}
   */
  setHelpKey(helpKey) {
    this._helpKey = helpKey;
    return this;
  }
  /**
   * @return {number}
   */
  getCurrentPage() {
    return this._currentPage;
  }

  /**
   * @param currentPage{number}
   * @return {HelpQueryMessage}
   */
  setCurrentPage(currentPage) {
    this._currentPage = currentPage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = HelpQueryMessage.CLASS_ID;
    
	//Serializing _pageLength
	if (this._pageLength)
		json['pageLength'] = this._pageLength;

	//Serializing _helpKey
	if (this._helpKey)
		json['helpKey'] = this._helpKey;

	//Serializing _currentPage
	if (this._currentPage)
		json['currentPage'] = this._currentPage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageLength = json.hasOwnProperty("pageLength")?json["pageLength"]:0;
		this._helpKey = json.hasOwnProperty("helpKey")?json["helpKey"]:null;
		this._currentPage = json.hasOwnProperty("currentPage")?json["currentPage"]:0;


  }
}

/**
 * @returns {string}
 */
HelpQueryMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.HelpQueryMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetMetadataQuery extends HttpOperation {

  constructor(name = "GetMetadata") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetMetadataMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetMetadataMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetMetadataResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetMetadataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetMetadataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetMetadataResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetMetadataResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetMetadataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadata";
/**
 * @returns {string}
 */
GetMetadataQuery.QUERY_NAME = "GetMetadata";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class FlexSmartCopyQuery extends HttpOperation {

  constructor(name = "FlexSmartCopy") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexSmartCopyArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexSmartCopyArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexSmartCopyResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexSmartCopyQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexSmartCopyQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexSmartCopyResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexSmartCopyResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexSmartCopyQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartCopy";
/**
 * @returns {string}
 */
FlexSmartCopyQuery.QUERY_NAME = "FlexSmartCopy";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class PageRequestData {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNumber = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._absolutePageNumber = false;

  }

    /**
   * @return {number}
   */
  getPageNumber() {
    return this._pageNumber;
  }

  /**
   * @param pageNumber{number}
   * @return {PageRequestData}
   */
  setPageNumber(pageNumber) {
    this._pageNumber = pageNumber;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {PageRequestData}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAbsolutePageNumber() {
    return this._absolutePageNumber;
  }

  /**
   * @param absolutePageNumber{boolean}
   * @return {PageRequestData}
   */
  setAbsolutePageNumber(absolutePageNumber) {
    this._absolutePageNumber = absolutePageNumber;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = PageRequestData.CLASS_ID;
    
	//Serializing _pageNumber
	if (this._pageNumber)
		json['pageNumber'] = this._pageNumber;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;

	//Serializing _absolutePageNumber
	if (this._absolutePageNumber)
		json['absolutePageNumber'] = this._absolutePageNumber;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNumber = json.hasOwnProperty("pageNumber")?json["pageNumber"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		this._absolutePageNumber = json.hasOwnProperty("absolutePageNumber")?json["absolutePageNumber"]:false;


  }
}

/**
 * @returns {string}
 */
PageRequestData.CLASS_ID = "com.zoom.vab.client.autogenerated.PageRequestData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FuidToUnreadComments {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._fileName = null;
    /**
     * @type {number}
     * @private
     */
    this._unreadCount = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<Annotation>}
     * @private
     */
    this._annotations = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._commentIdToThreadId = null;
    /**
     * @type {HashSet}
     * @private
     */
    this._unreadCommentsIds = null;

  }

    /**
   * @return {string}
   */
  getFileName() {
    return this._fileName;
  }

  /**
   * @param fileName{string}
   * @return {FuidToUnreadComments}
   */
  setFileName(fileName) {
    this._fileName = fileName;
    return this;
  }
  /**
   * @return {number}
   */
  getUnreadCount() {
    return this._unreadCount;
  }

  /**
   * @param unreadCount{number}
   * @return {FuidToUnreadComments}
   */
  setUnreadCount(unreadCount) {
    this._unreadCount = unreadCount;
    return this;
  }
  /**
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {FuidToUnreadComments}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * Contains the replies which are not read.                Only last entry in the replies would be unread comment. Previous are for just displaying.
   * @return {Array<Annotation>}
   */
  getAnnotations() {
    return this._annotations;
  }

  /**
   * @param annotations{Array<Annotation>}
   * @return {FuidToUnreadComments}
   */
  setAnnotations(annotations) {
    this._annotations = annotations;
    return this;
  }

  /**
   * @return {java.util.Map<number,Long>}
   */
  getCommentIdToThreadId() {
    return this._commentIdToThreadId;
  }

  /**
   * @param commentIdToThreadId{java.util.Map<number,Long>}
   * @return {FuidToUnreadComments}
   */
  setCommentIdToThreadId(commentIdToThreadId) {
    this._commentIdToThreadId = commentIdToThreadId;
    return this;
  }

  /**
   * List of unread comments ids.
   * @return {HashSet}
   */
  getUnreadCommentsIds() {
    return this._unreadCommentsIds;
  }

  /**
   * @param unreadCommentsIds{HashSet}
   * @return {FuidToUnreadComments}
   */
  setUnreadCommentsIds(unreadCommentsIds) {
    this._unreadCommentsIds = unreadCommentsIds;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FuidToUnreadComments.CLASS_ID;
    
	//Serializing _fileName
	if (this._fileName)
		json['fileName'] = this._fileName;

	//Serializing _unreadCount
	if (this._unreadCount)
		json['unreadCount'] = this._unreadCount;

	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._annotations && this._annotations.length > 0) {
    let annotations_JSON = [];
    /**
     * @type {Annotation}
     */
    this._annotations.forEach((o559) => {
      if (o559) {
        if (o559.serializeJson && (typeof (o559.serializeJson) === 'function')) {
          annotations_JSON.push(o559.serializeJson());
        } else {
          annotations_JSON.push(o559);
        }
      }
    });
    json['annotations'] = annotations_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"commentIdToThreadId", this._commentIdToThreadId);
		SerializationUtil.serializeSet(json, "unreadCommentsIds", this._unreadCommentsIds, true);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fileName = json.hasOwnProperty("fileName")?json["fileName"]:null;
		this._unreadCount = json.hasOwnProperty("unreadCount")?json["unreadCount"]:0;
		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type Annotation
		this._annotations = [];
		let annotationsJSONArray = json.hasOwnProperty("annotations") ? json["annotations"] : [];

		annotationsJSONArray.forEach((o560)=>{
			if (o560){
				let classObj = new Annotation();
				classObj.deserializeJson(o560);
				this._annotations.push(classObj);
			}
		});
//Map of type LONG. Decode as tree:false
		if (this._commentIdToThreadId == null)
			this._commentIdToThreadId = new HashMap();
		this._commentIdToThreadId.clear();
		let commentIdToThreadIdJSONArray = json.hasOwnProperty("commentIdToThreadId") ? json["commentIdToThreadId"] : [];
		this._commentIdToThreadId = SerializationUtil.deserializeMap(commentIdToThreadIdJSONArray);

//set of type LONG
		if (!this._unreadCommentsIds)
			this._unreadCommentsIds = new HashSet();
		this._unreadCommentsIds.clear();
		let unreadCommentsIdsJSONArray = json.hasOwnProperty("unreadCommentsIds") ? json["unreadCommentsIds"] : [];
		this._unreadCommentsIds = SerializationUtil.deserializeSet(unreadCommentsIdsJSONArray);

  }
}

/**
 * @returns {string}
 */
FuidToUnreadComments.CLASS_ID = "com.zoom.vab.client.autogenerated.FuidToUnreadComments";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditMetadataRes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {EditMetadataRes}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {EditMetadataRes}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditMetadataRes.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;


  }
}

/**
 * @returns {string}
 */
EditMetadataRes.CLASS_ID = "com.zoom.vab.client.autogenerated.EditMetadataRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DownloadFormatResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._multiFormatRespMap = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {DownloadFormatResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {java.util.Map<String,MultiFormatDownloadsServerResp>}
   */
  getMultiFormatRespMap() {
    return this._multiFormatRespMap;
  }

  /**
   * @param multiFormatRespMap{java.util.Map<String,MultiFormatDownloadsServerResp>}
   * @return {DownloadFormatResp}
   */
  setMultiFormatRespMap(multiFormatRespMap) {
    this._multiFormatRespMap = multiFormatRespMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DownloadFormatResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
    SerializationUtil.serializeHashMap(json,"multiFormatRespMap", this._multiFormatRespMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
//Map of type STRING. Decode as tree:false
		if (this._multiFormatRespMap == null)
			this._multiFormatRespMap = new HashMap();
		this._multiFormatRespMap.clear();
		let multiFormatRespMapJSONArray = json.hasOwnProperty("multiFormatRespMap") ? json["multiFormatRespMap"] : [];
		this._multiFormatRespMap = SerializationUtil.deserializeMap(multiFormatRespMapJSONArray);



  }
}

/**
 * @returns {string}
 */
DownloadFormatResp.CLASS_ID = "com.zoom.vab.client.autogenerated.DownloadFormatResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AwsRegion {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._description = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {AwsRegion}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getDescription() {
    return this._description;
  }

  /**
   * @param description{string}
   * @return {AwsRegion}
   */
  setDescription(description) {
    this._description = description;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AwsRegion.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _description
	if (this._description)
		json['description'] = this._description;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._description = json.hasOwnProperty("description")?json["description"]:null;


  }
}

/**
 * @returns {string}
 */
AwsRegion.CLASS_ID = "com.zoom.vab.client.autogenerated.AwsRegion";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AnnotationAttachment {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._editor = null;
    /**
     * @type {string}
     * @private
     */
    this._creator = null;
    /**
     * @type {string}
     * @private
     */
    this._fileName = null;
    /**
     * @type {number}
     * @private
     */
    this._mRrn = null;
    /**
     * @type {string}
     * @private
     */
    this._data = null;
    /**
     * @type {number}
     * @private
     */
    this._cRrn = null;
    /**
     * @type {string}
     * @private
     */
    this._dataType = null;
    /**
     * @type {number}
     * @private
     */
    this._commentId = null;
    /**
     * @type {number}
     * @private
     */
    this._parentCommentId = null;
    /**
     * @type {number}
     * @private
     */
    this._cTime = null;
    /**
     * @type {number}
     * @private
     */
    this._mTime = null;

  }

    /**
   * optional: no edits if unspecified.
   * @return {string}
   */
  getEditor() {
    return this._editor;
  }

  /**
   * @param editor{string}
   * @return {AnnotationAttachment}
   */
  setEditor(editor) {
    this._editor = editor;
    return this;
  }
  /**
   * @return {string}
   */
  getCreator() {
    return this._creator;
  }

  /**
   * @param creator{string}
   * @return {AnnotationAttachment}
   */
  setCreator(creator) {
    this._creator = creator;
    return this;
  }
  /**
   * @return {string}
   */
  getFileName() {
    return this._fileName;
  }

  /**
   * @param fileName{string}
   * @return {AnnotationAttachment}
   */
  setFileName(fileName) {
    this._fileName = fileName;
    return this;
  }
  /**
   * optional: no edits if unspecified.
   * @return {number}
   */
  getMRrn() {
    return this._mRrn;
  }

  /**
   * @param mRrn{number}
   * @return {AnnotationAttachment}
   */
  setMRrn(mRrn) {
    this._mRrn = mRrn;
    return this;
  }
  /**
   * @return {string}
   */
  getData() {
    return this._data;
  }

  /**
   * @param data{string}
   * @return {AnnotationAttachment}
   */
  setData(data) {
    this._data = data;
    return this;
  }
  /**
   * @return {number}
   */
  getCRrn() {
    return this._cRrn;
  }

  /**
   * @param cRrn{number}
   * @return {AnnotationAttachment}
   */
  setCRrn(cRrn) {
    this._cRrn = cRrn;
    return this;
  }
  /**
   * Enum: TEXT, SVG, URL, REVIEW
   * @return {string}
   */
  getDataType() {
    return this._dataType;
  }

  /**
   * @param dataType{string}
   * @return {AnnotationAttachment}
   */
  setDataType(dataType) {
    this._dataType = dataType;
    return this;
  }
  /**
   * @return {number}
   */
  getCommentId() {
    return this._commentId;
  }

  /**
   * @param commentId{number}
   * @return {AnnotationAttachment}
   */
  setCommentId(commentId) {
    this._commentId = commentId;
    return this;
  }
  /**
   * optional: top-level comment if unspecified.
   * @return {number}
   */
  getParentCommentId() {
    return this._parentCommentId;
  }

  /**
   * @param parentCommentId{number}
   * @return {AnnotationAttachment}
   */
  setParentCommentId(parentCommentId) {
    this._parentCommentId = parentCommentId;
    return this;
  }
  /**
   * @return {number}
   */
  getCTime() {
    return this._cTime;
  }

  /**
   * @param cTime{number}
   * @return {AnnotationAttachment}
   */
  setCTime(cTime) {
    this._cTime = cTime;
    return this;
  }
  /**
   * optional: no edits if unspecified.
   * @return {number}
   */
  getMTime() {
    return this._mTime;
  }

  /**
   * @param mTime{number}
   * @return {AnnotationAttachment}
   */
  setMTime(mTime) {
    this._mTime = mTime;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AnnotationAttachment.CLASS_ID;
    
	//Serializing _editor
	if (this._editor)
		json['editor'] = this._editor;

	//Serializing _creator
	if (this._creator)
		json['creator'] = this._creator;

	//Serializing _fileName
	if (this._fileName)
		json['fileName'] = this._fileName;

	//Serializing _mRrn
	if (this._mRrn)
		json['mRrn'] = this._mRrn;

	//Serializing _data
	if (this._data)
		json['data'] = this._data;

	//Serializing _cRrn
	if (this._cRrn)
		json['cRrn'] = this._cRrn;

	//Serializing _dataType
	if (this._dataType)
		json['dataType'] = this._dataType;

	//Serializing _commentId
	if (this._commentId)
		json['commentId'] = this._commentId;

	//Serializing _parentCommentId
	if (this._parentCommentId)
		json['parentCommentId'] = this._parentCommentId;

	//Serializing _cTime
	if (this._cTime)
		json['cTime'] = this._cTime;

	//Serializing _mTime
	if (this._mTime)
		json['mTime'] = this._mTime;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._editor = json.hasOwnProperty("editor")?json["editor"]:null;
		this._creator = json.hasOwnProperty("creator")?json["creator"]:null;
		this._fileName = json.hasOwnProperty("fileName")?json["fileName"]:null;
		this._mRrn = json.hasOwnProperty("mRrn")?json["mRrn"]:0;
		this._data = json.hasOwnProperty("data")?json["data"]:null;
		this._cRrn = json.hasOwnProperty("cRrn")?json["cRrn"]:0;
		this._dataType = json.hasOwnProperty("dataType")?json["dataType"]:null;
		this._commentId = json.hasOwnProperty("commentId")?json["commentId"]:0;
		this._parentCommentId = json.hasOwnProperty("parentCommentId")?json["parentCommentId"]:0;
		this._cTime = json.hasOwnProperty("cTime")?json["cTime"]:0;
		this._mTime = json.hasOwnProperty("mTime")?json["mTime"]:0;


  }
}

/**
 * @returns {string}
 */
AnnotationAttachment.CLASS_ID = "com.zoom.vab.client.autogenerated.AnnotationAttachment";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClientExecResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMsg = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {ClientExecResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMsg() {
    return this._successMsg;
  }

  /**
   * @param successMsg{string}
   * @return {ClientExecResp}
   */
  setSuccessMsg(successMsg) {
    this._successMsg = successMsg;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClientExecResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMsg
	if (this._successMsg)
		json['successMsg'] = this._successMsg;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMsg = json.hasOwnProperty("successMsg")?json["successMsg"]:null;


  }
}

/**
 * @returns {string}
 */
ClientExecResp.CLASS_ID = "com.zoom.vab.client.autogenerated.ClientExecResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetAnnotationsQuery extends HttpOperation {

  constructor(name = "GetAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAnnotations";
/**
 * @returns {string}
 */
GetAnnotationsQuery.QUERY_NAME = "GetAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class PathFuidsList {

  constructor() {
    
        /**
     * @type {Array<Integer>}
     * @private
     */
    this._pathFuidsList = null;

  }

    /**
   * @return {Array<Integer>}
   */
  getPathFuidsList() {
    return this._pathFuidsList;
  }

  /**
   * @param pathFuidsList{Array<Integer>}
   * @return {PathFuidsList}
   */
  setPathFuidsList(pathFuidsList) {
    this._pathFuidsList = pathFuidsList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = PathFuidsList.CLASS_ID;
      if (this._pathFuidsList && this._pathFuidsList.length > 0) {
    let pathFuidsList_JSON = [];
    /**
     * @type {int}
     */
    this._pathFuidsList.forEach((o115) => {
      if (o115) {
        if (o115.serializeJson && (typeof (o115.serializeJson) === 'function')) {
          pathFuidsList_JSON.push(o115.serializeJson());
        } else {
          pathFuidsList_JSON.push(o115);
        }
      }
    });
    json['pathFuidsList'] = pathFuidsList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type int
		this._pathFuidsList = [];
		let pathFuidsListJSONArray = json.hasOwnProperty("pathFuidsList") ? json["pathFuidsList"] : [];

		pathFuidsListJSONArray.forEach((o116)=>{
			if (o116){
				this._pathFuidsList.push(o116);
			}
		});


  }
}

/**
 * @returns {string}
 */
PathFuidsList.CLASS_ID = "com.zoom.vab.client.autogenerated.PathFuidsList";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ValueList {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._values = null;

  }

    /**
   * @return {Array<String>}
   */
  getValues() {
    return this._values;
  }

  /**
   * @param values{Array<String>}
   * @return {ValueList}
   */
  setValues(values) {
    this._values = values;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ValueList.CLASS_ID;
      if (this._values && this._values.length > 0) {
    let values_JSON = [];
    /**
     * @type {string}
     */
    this._values.forEach((o6) => {
      if (o6) {
        if (o6.serializeJson && (typeof (o6.serializeJson) === 'function')) {
          values_JSON.push(o6.serializeJson());
        } else {
          values_JSON.push(o6);
        }
      }
    });
    json['values'] = values_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._values = [];
		let valuesJSONArray = json.hasOwnProperty("values") ? json["values"] : [];

		valuesJSONArray.forEach((o7)=>{
			if (o7){
				this._values.push(o7);
			}
		});


  }
}

/**
 * @returns {string}
 */
ValueList.CLASS_ID = "com.zoom.vab.client.autogenerated.ValueList";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCommentsUnreadCountMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._fetchOnlyTotalUnreadCount = false;
    /**
     * @type {number}
     * @private
     */
    this._countOfPreviousMessagesToInclude = null;
    /**
     * @type {string}
     * @private
     */
    this._sortCriteria = null;
    /**
     * @type {boolean}
     * @private
     */
    this._fetchUnreadAnnotationThread = false;
    /**
     * @type {boolean}
     * @private
     */
    this._fetchOnlyUnreadCount = false;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidRrnInfoList = null;

  }

    /**
   * @return {boolean}
   */
  isFetchOnlyTotalUnreadCount() {
    return this._fetchOnlyTotalUnreadCount;
  }

  /**
   * @param fetchOnlyTotalUnreadCount{boolean}
   * @return {GetCommentsUnreadCountMessage}
   */
  setFetchOnlyTotalUnreadCount(fetchOnlyTotalUnreadCount) {
    this._fetchOnlyTotalUnreadCount = fetchOnlyTotalUnreadCount;
    return this;
  }
  /**
   * Count of previous replies to include with unread replies. Last entry would always be unread reply.
   * @return {number}
   */
  getCountOfPreviousMessagesToInclude() {
    return this._countOfPreviousMessagesToInclude;
  }

  /**
   * @param countOfPreviousMessagesToInclude{number}
   * @return {GetCommentsUnreadCountMessage}
   */
  setCountOfPreviousMessagesToInclude(countOfPreviousMessagesToInclude) {
    this._countOfPreviousMessagesToInclude = countOfPreviousMessagesToInclude;
    return this;
  }
  /**
   * Enum: MOST_RECENT_FIRST, CHRONOLOGICAL_ORDER. Default value would be Chronological.
   * @return {string}
   */
  getSortCriteria() {
    return this._sortCriteria;
  }

  /**
   * @param sortCriteria{string}
   * @return {GetCommentsUnreadCountMessage}
   */
  setSortCriteria(sortCriteria) {
    this._sortCriteria = sortCriteria;
    return this;
  }
  /**
   * Optional: If true, then fetches the AnnotationThread with unread replies
   * @return {boolean}
   */
  isFetchUnreadAnnotationThread() {
    return this._fetchUnreadAnnotationThread;
  }

  /**
   * @param fetchUnreadAnnotationThread{boolean}
   * @return {GetCommentsUnreadCountMessage}
   */
  setFetchUnreadAnnotationThread(fetchUnreadAnnotationThread) {
    this._fetchUnreadAnnotationThread = fetchUnreadAnnotationThread;
    return this;
  }
  /**
   * If true, then doesn't fetch details of annotations. Just fetch all unread counts, i.e totalUnreadCount, collection specific unread count and fuid specific unread count.
   * @return {boolean}
   */
  isFetchOnlyUnreadCount() {
    return this._fetchOnlyUnreadCount;
  }

  /**
   * @param fetchOnlyUnreadCount{boolean}
   * @return {GetCommentsUnreadCountMessage}
   */
  setFetchOnlyUnreadCount(fetchOnlyUnreadCount) {
    this._fetchOnlyUnreadCount = fetchOnlyUnreadCount;
    return this;
  }
  /**
   * Optional: If collection/sheet id set to -ve then unread count for all collections will be returned including collection id to unread map.                      If it is set to +va then unread count of specific collection/sheet is returned
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {GetCommentsUnreadCountMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comments.
   * @return {Array<FuidRrnInfo>}
   */
  getFuidRrnInfoList() {
    return this._fuidRrnInfoList;
  }

  /**
   * @param fuidRrnInfoList{Array<FuidRrnInfo>}
   * @return {GetCommentsUnreadCountMessage}
   */
  setFuidRrnInfoList(fuidRrnInfoList) {
    this._fuidRrnInfoList = fuidRrnInfoList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCommentsUnreadCountMessage.CLASS_ID;
    
	//Serializing _fetchOnlyTotalUnreadCount
	if (this._fetchOnlyTotalUnreadCount)
		json['fetchOnlyTotalUnreadCount'] = this._fetchOnlyTotalUnreadCount;

	//Serializing _countOfPreviousMessagesToInclude
	if (this._countOfPreviousMessagesToInclude)
		json['countOfPreviousMessagesToInclude'] = this._countOfPreviousMessagesToInclude;

	//Serializing _sortCriteria
	if (this._sortCriteria)
		json['sortCriteria'] = this._sortCriteria;

	//Serializing _fetchUnreadAnnotationThread
	if (this._fetchUnreadAnnotationThread)
		json['fetchUnreadAnnotationThread'] = this._fetchUnreadAnnotationThread;

	//Serializing _fetchOnlyUnreadCount
	if (this._fetchOnlyUnreadCount)
		json['fetchOnlyUnreadCount'] = this._fetchOnlyUnreadCount;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		  if (this._fuidRrnInfoList && this._fuidRrnInfoList.length > 0) {
    let fuidRrnInfoList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidRrnInfoList.forEach((o527) => {
      if (o527) {
        if (o527.serializeJson && (typeof (o527.serializeJson) === 'function')) {
          fuidRrnInfoList_JSON.push(o527.serializeJson());
        } else {
          fuidRrnInfoList_JSON.push(o527);
        }
      }
    });
    json['fuidRrnInfoList'] = fuidRrnInfoList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fetchOnlyTotalUnreadCount = json.hasOwnProperty("fetchOnlyTotalUnreadCount")?json["fetchOnlyTotalUnreadCount"]:false;
		this._countOfPreviousMessagesToInclude = json.hasOwnProperty("countOfPreviousMessagesToInclude")?json["countOfPreviousMessagesToInclude"]:0;
		this._sortCriteria = json.hasOwnProperty("sortCriteria")?json["sortCriteria"]:null;
		this._fetchUnreadAnnotationThread = json.hasOwnProperty("fetchUnreadAnnotationThread")?json["fetchUnreadAnnotationThread"]:false;
		this._fetchOnlyUnreadCount = json.hasOwnProperty("fetchOnlyUnreadCount")?json["fetchOnlyUnreadCount"]:false;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		//set of type FuidRrnInfo
		this._fuidRrnInfoList = [];
		let fuidRrnInfoListJSONArray = json.hasOwnProperty("fuidRrnInfoList") ? json["fuidRrnInfoList"] : [];

		fuidRrnInfoListJSONArray.forEach((o528)=>{
			if (o528){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o528);
				this._fuidRrnInfoList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetCommentsUnreadCountMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCommentsUnreadCountMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetFacetsQuery extends HttpOperation {

  constructor(name = "GetFacets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetFacetsMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetFacetsMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetFacetsRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetFacetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetFacetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetFacetsRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetFacetsRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetFacetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFacets";
/**
 * @returns {string}
 */
GetFacetsQuery.QUERY_NAME = "GetFacets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class UploadFromUrlResponse {

  constructor() {
    
    
  }

  

  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UploadFromUrlResponse.CLASS_ID;
    

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    

  }
}

/**
 * @returns {string}
 */
UploadFromUrlResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.UploadFromUrlResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionProjects {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._permission = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {CollectionProjects}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getPermission() {
    return this._permission;
  }

  /**
   * @param permission{string}
   * @return {CollectionProjects}
   */
  setPermission(permission) {
    this._permission = permission;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionProjects.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _permission
	if (this._permission)
		json['permission'] = this._permission;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._permission = json.hasOwnProperty("permission")?json["permission"]:null;


  }
}

/**
 * @returns {string}
 */
CollectionProjects.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionProjects";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetMetadataHelpQueryMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._prefix = null;
    /**
     * @type {string}
     * @private
     */
    this._metadataProperty = null;

  }

    /**
   * @return {string}
   */
  getPrefix() {
    return this._prefix;
  }

  /**
   * @param prefix{string}
   * @return {GetMetadataHelpQueryMsg}
   */
  setPrefix(prefix) {
    this._prefix = prefix;
    return this;
  }
  /**
   * @return {string}
   */
  getMetadataProperty() {
    return this._metadataProperty;
  }

  /**
   * @param metadataProperty{string}
   * @return {GetMetadataHelpQueryMsg}
   */
  setMetadataProperty(metadataProperty) {
    this._metadataProperty = metadataProperty;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetMetadataHelpQueryMsg.CLASS_ID;
    
	//Serializing _prefix
	if (this._prefix)
		json['prefix'] = this._prefix;

	//Serializing _metadataProperty
	if (this._metadataProperty)
		json['metadataProperty'] = this._metadataProperty;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._prefix = json.hasOwnProperty("prefix")?json["prefix"]:null;
		this._metadataProperty = json.hasOwnProperty("metadataProperty")?json["metadataProperty"]:null;


  }
}

/**
 * @returns {string}
 */
GetMetadataHelpQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadataHelpQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SharingOptions {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._fixedVersion = false;

  }

    /**
   * @return {boolean}
   */
  isFixedVersion() {
    return this._fixedVersion;
  }

  /**
   * @param fixedVersion{boolean}
   * @return {SharingOptions}
   */
  setFixedVersion(fixedVersion) {
    this._fixedVersion = fixedVersion;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SharingOptions.CLASS_ID;
    
	//Serializing _fixedVersion
	if (this._fixedVersion)
		json['fixedVersion'] = this._fixedVersion;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fixedVersion = json.hasOwnProperty("fixedVersion")?json["fixedVersion"]:false;


  }
}

/**
 * @returns {string}
 */
SharingOptions.CLASS_ID = "com.zoom.vab.client.autogenerated.SharingOptions";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionRoles {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._permission = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {CollectionRoles}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getPermission() {
    return this._permission;
  }

  /**
   * @param permission{string}
   * @return {CollectionRoles}
   */
  setPermission(permission) {
    this._permission = permission;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionRoles.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _permission
	if (this._permission)
		json['permission'] = this._permission;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._permission = json.hasOwnProperty("permission")?json["permission"]:null;


  }
}

/**
 * @returns {string}
 */
CollectionRoles.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionRoles";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditOwnerResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {EditOwnerResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditOwnerResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
EditOwnerResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.EditOwnerResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditOwnerMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._newOwner = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {string}
   */
  getNewOwner() {
    return this._newOwner;
  }

  /**
   * @param newOwner{string}
   * @return {EditOwnerMessage}
   */
  setNewOwner(newOwner) {
    this._newOwner = newOwner;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {EditOwnerMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditOwnerMessage.CLASS_ID;
    
	//Serializing _newOwner
	if (this._newOwner)
		json['newOwner'] = this._newOwner;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._newOwner = json.hasOwnProperty("newOwner")?json["newOwner"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
EditOwnerMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EditOwnerMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ListLiveDrawsQuery extends HttpOperation {

  constructor(name = "ListLiveDraws") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {CollectionScope}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CollectionScope}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ListLiveDrawsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ListLiveDrawsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ListLiveDrawsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ListLiveDrawsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ListLiveDrawsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ListLiveDrawsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ListLiveDraws";
/**
 * @returns {string}
 */
ListLiveDrawsQuery.QUERY_NAME = "ListLiveDraws";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class MarkCommentAsReadQuery extends HttpOperation {

  constructor(name = "MarkCommentAsRead") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {MarkCommentAsReadMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{MarkCommentAsReadMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {MarkCommentAsReadResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = MarkCommentAsReadQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (MarkCommentAsReadQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new MarkCommentAsReadResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new MarkCommentAsReadResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
MarkCommentAsReadQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.MarkCommentAsRead";
/**
 * @returns {string}
 */
MarkCommentAsReadQuery.QUERY_NAME = "MarkCommentAsRead";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionSettingsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._nonVcsRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;

  }

    /**
   * @return {number}
   */
  getNonVcsRrn() {
    return this._nonVcsRrn;
  }

  /**
   * @param nonVcsRrn{number}
   * @return {GetCollectionSettingsMessage}
   */
  setNonVcsRrn(nonVcsRrn) {
    this._nonVcsRrn = nonVcsRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetCollectionSettingsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {GetCollectionSettingsMessage}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionSettingsMessage.CLASS_ID;
    
	//Serializing _nonVcsRrn
	if (this._nonVcsRrn)
		json['nonVcsRrn'] = this._nonVcsRrn;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._nonVcsRrn = json.hasOwnProperty("nonVcsRrn")?json["nonVcsRrn"]:0;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;


  }
}

/**
 * @returns {string}
 */
GetCollectionSettingsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionSettingsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CreateCollectionLinkQuery extends HttpOperation {

  constructor(name = "CreateCollectionLink") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CreateCollectionLinkQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CreateCollectionLinkQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CreateCollectionLinkQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateCollectionLink";
/**
 * @returns {string}
 */
CreateCollectionLinkQuery.QUERY_NAME = "CreateCollectionLink";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SpotLightDetail {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {boolean}
     * @private
     */
    this._file = false;
    /**
     * @type {string}
     * @private
     */
    this._prettyTime = null;
    /**
     * @type {number}
     * @private
     */
    this._length = null;
    /**
     * @type {number}
     * @private
     */
    this._spotLightId = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._overlayText = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;
    /**
     * @type {string}
     * @private
     */
    this._assetType = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {SpotLightDetail}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFile() {
    return this._file;
  }

  /**
   * @param file{boolean}
   * @return {SpotLightDetail}
   */
  setFile(file) {
    this._file = file;
    return this;
  }
  /**
   * @return {string}
   */
  getPrettyTime() {
    return this._prettyTime;
  }

  /**
   * @param prettyTime{string}
   * @return {SpotLightDetail}
   */
  setPrettyTime(prettyTime) {
    this._prettyTime = prettyTime;
    return this;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this._length;
  }

  /**
   * @param length{number}
   * @return {SpotLightDetail}
   */
  setLength(length) {
    this._length = length;
    return this;
  }
  /**
   * @return {number}
   */
  getSpotLightId() {
    return this._spotLightId;
  }

  /**
   * @param spotLightId{number}
   * @return {SpotLightDetail}
   */
  setSpotLightId(spotLightId) {
    this._spotLightId = spotLightId;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {SpotLightDetail}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {SpotLightDetail}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getOverlayText() {
    return this._overlayText;
  }

  /**
   * @param overlayText{string}
   * @return {SpotLightDetail}
   */
  setOverlayText(overlayText) {
    this._overlayText = overlayText;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {SpotLightDetail}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {SpotLightDetail}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }
  /**
   * @return {string}
   */
  getAssetType() {
    return this._assetType;
  }

  /**
   * @param assetType{string}
   * @return {SpotLightDetail}
   */
  setAssetType(assetType) {
    this._assetType = assetType;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SpotLightDetail.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _file
	if (this._file)
		json['file'] = this._file;

	//Serializing _prettyTime
	if (this._prettyTime)
		json['prettyTime'] = this._prettyTime;

	//Serializing _length
	if (this._length)
		json['length'] = this._length;

	//Serializing _spotLightId
	if (this._spotLightId)
		json['spotLightId'] = this._spotLightId;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _overlayText
	if (this._overlayText)
		json['overlayText'] = this._overlayText;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;

	//Serializing _assetType
	if (this._assetType)
		json['assetType'] = this._assetType;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._file = json.hasOwnProperty("file")?json["file"]:false;
		this._prettyTime = json.hasOwnProperty("prettyTime")?json["prettyTime"]:null;
		this._length = json.hasOwnProperty("length")?json["length"]:0;
		this._spotLightId = json.hasOwnProperty("spotLightId")?json["spotLightId"]:0;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._overlayText = json.hasOwnProperty("overlayText")?json["overlayText"]:null;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;
		this._assetType = json.hasOwnProperty("assetType")?json["assetType"]:null;


  }
}

/**
 * @returns {string}
 */
SpotLightDetail.CLASS_ID = "com.zoom.vab.client.autogenerated.SpotLightDetail";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class WCStatusQueryResp {

  constructor() {
    
        /**
     * @type {Array<WCStatusRespObject>}
     * @private
     */
    this._items = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2ExtraInfo = null;

  }

    /**
   * @return {Array<WCStatusRespObject>}
   */
  getItems() {
    return this._items;
  }

  /**
   * @param items{Array<WCStatusRespObject>}
   * @return {WCStatusQueryResp}
   */
  setItems(items) {
    this._items = items;
    return this;
  }

  /**
   * @return {java.util.Map<number,ExtraInfo>}
   */
  getFuid2ExtraInfo() {
    return this._fuid2ExtraInfo;
  }

  /**
   * @param fuid2ExtraInfo{java.util.Map<number,ExtraInfo>}
   * @return {WCStatusQueryResp}
   */
  setFuid2ExtraInfo(fuid2ExtraInfo) {
    this._fuid2ExtraInfo = fuid2ExtraInfo;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = WCStatusQueryResp.CLASS_ID;
      if (this._items && this._items.length > 0) {
    let items_JSON = [];
    /**
     * @type {WCStatusRespObject}
     */
    this._items.forEach((o24) => {
      if (o24) {
        if (o24.serializeJson && (typeof (o24.serializeJson) === 'function')) {
          items_JSON.push(o24.serializeJson());
        } else {
          items_JSON.push(o24);
        }
      }
    });
    json['items'] = items_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"fuid2ExtraInfo", this._fuid2ExtraInfo);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type WCStatusRespObject
		this._items = [];
		let itemsJSONArray = json.hasOwnProperty("items") ? json["items"] : [];

		itemsJSONArray.forEach((o25)=>{
			if (o25){
				let classObj = new WCStatusRespObject();
				classObj.deserializeJson(o25);
				this._items.push(classObj);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._fuid2ExtraInfo == null)
			this._fuid2ExtraInfo = new HashMap();
		this._fuid2ExtraInfo.clear();
		let fuid2ExtraInfoJSONArray = json.hasOwnProperty("fuid2ExtraInfo") ? json["fuid2ExtraInfo"] : [];
		this._fuid2ExtraInfo = SerializationUtil.deserializeMap(fuid2ExtraInfoJSONArray);



  }
}

/**
 * @returns {string}
 */
WCStatusQueryResp.CLASS_ID = "com.zoom.vab.client.autogenerated.WCStatusQueryResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SendVerificationLinkToUserMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {UserDetails}
     * @private
     */
    this._userDetails = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SendVerificationLinkToUserMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {UserDetails}
   */
  getUserDetails() {
    return this._userDetails;
  }

  /**
   * @param userDetails{UserDetails}
   * @return {SendVerificationLinkToUserMessage}
   */
  setUserDetails(userDetails) {
    this._userDetails = userDetails;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SendVerificationLinkToUserMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._userDetails)
		json['userDetails'] = this._userDetails.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("userDetails")){
			if (!this._userDetails && this._userDetails == null)
				this._userDetails = new UserDetails();
			this._userDetails.deserializeJson(json.hasOwnProperty("userDetails") ? json["userDetails"] : null);
		}



  }
}

/**
 * @returns {string}
 */
SendVerificationLinkToUserMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SendVerificationLinkToUserMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LoadFiltersQuery extends HttpOperation {

  constructor(name = "LoadFilters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LoadFiltersMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LoadFiltersMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LoadFiltersResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LoadFiltersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LoadFiltersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LoadFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LoadFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LoadFiltersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadFilters";
/**
 * @returns {string}
 */
LoadFiltersQuery.QUERY_NAME = "LoadFilters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionFilters {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._filters = null;

  }

    /**
   * @return {java.util.Map<String,ValueList>}
   */
  getFilters() {
    return this._filters;
  }

  /**
   * @param filters{java.util.Map<String,ValueList>}
   * @return {CollectionFilters}
   */
  setFilters(filters) {
    this._filters = filters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionFilters.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"filters", this._filters);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._filters == null)
			this._filters = new HashMap();
		this._filters.clear();
		let filtersJSONArray = json.hasOwnProperty("filters") ? json["filters"] : [];
		this._filters = SerializationUtil.deserializeMap(filtersJSONArray);



  }
}

/**
 * @returns {string}
 */
CollectionFilters.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionFilters";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Point {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._x = null;
    /**
     * @type {number}
     * @private
     */
    this._y = null;

  }

    /**
   * @return {number}
   */
  getX() {
    return this._x;
  }

  /**
   * @param x{number}
   * @return {Point}
   */
  setX(x) {
    this._x = x;
    return this;
  }
  /**
   * @return {number}
   */
  getY() {
    return this._y;
  }

  /**
   * @param y{number}
   * @return {Point}
   */
  setY(y) {
    this._y = y;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Point.CLASS_ID;
    
	//Serializing _x
	if (this._x)
		json['x'] = this._x;

	//Serializing _y
	if (this._y)
		json['y'] = this._y;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._x = json.hasOwnProperty("x")?json["x"]:0;
		this._y = json.hasOwnProperty("y")?json["y"]:0;


  }
}

/**
 * @returns {string}
 */
Point.CLASS_ID = "com.zoom.vab.client.autogenerated.Point";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MoveAssetsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {MoveAssetsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MoveAssetsResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
MoveAssetsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.MoveAssetsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetMetadataResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {Array<FuidBidRrnWithAssetAiData>}
     * @private
     */
    this._fuidBidRrnToAiDocumentIds = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2keyFrameMetadataEntryList = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2MetadataMap = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetMetadataResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {Array<FuidBidRrnWithAssetAiData>}
   */
  getFuidBidRrnToAiDocumentIds() {
    return this._fuidBidRrnToAiDocumentIds;
  }

  /**
   * @param fuidBidRrnToAiDocumentIds{Array<FuidBidRrnWithAssetAiData>}
   * @return {GetMetadataResp}
   */
  setFuidBidRrnToAiDocumentIds(fuidBidRrnToAiDocumentIds) {
    this._fuidBidRrnToAiDocumentIds = fuidBidRrnToAiDocumentIds;
    return this;
  }

  /**
   * @return {java.util.Map<number,KeyFrameMetadataEntries>}
   */
  getFuid2keyFrameMetadataEntryList() {
    return this._fuid2keyFrameMetadataEntryList;
  }

  /**
   * @param fuid2keyFrameMetadataEntryList{java.util.Map<number,KeyFrameMetadataEntries>}
   * @return {GetMetadataResp}
   */
  setFuid2keyFrameMetadataEntryList(fuid2keyFrameMetadataEntryList) {
    this._fuid2keyFrameMetadataEntryList = fuid2keyFrameMetadataEntryList;
    return this;
  }

  /**
   * @return {java.util.Map<number,MessageMap>}
   */
  getFuid2MetadataMap() {
    return this._fuid2MetadataMap;
  }

  /**
   * @param fuid2MetadataMap{java.util.Map<number,MessageMap>}
   * @return {GetMetadataResp}
   */
  setFuid2MetadataMap(fuid2MetadataMap) {
    this._fuid2MetadataMap = fuid2MetadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetMetadataResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
  if (this._fuidBidRrnToAiDocumentIds && this._fuidBidRrnToAiDocumentIds.length > 0) {
    let fuidBidRrnToAiDocumentIds_JSON = [];
    /**
     * @type {FuidBidRrnWithAssetAiData}
     */
    this._fuidBidRrnToAiDocumentIds.forEach((o1128) => {
      if (o1128) {
        if (o1128.serializeJson && (typeof (o1128.serializeJson) === 'function')) {
          fuidBidRrnToAiDocumentIds_JSON.push(o1128.serializeJson());
        } else {
          fuidBidRrnToAiDocumentIds_JSON.push(o1128);
        }
      }
    });
    json['fuidBidRrnToAiDocumentIds'] = fuidBidRrnToAiDocumentIds_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"fuid2keyFrameMetadataEntryList", this._fuid2keyFrameMetadataEntryList);
		    SerializationUtil.serializeHashMap(json,"fuid2MetadataMap", this._fuid2MetadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		//set of type FuidBidRrnWithAssetAiData
		this._fuidBidRrnToAiDocumentIds = [];
		let fuidBidRrnToAiDocumentIdsJSONArray = json.hasOwnProperty("fuidBidRrnToAiDocumentIds") ? json["fuidBidRrnToAiDocumentIds"] : [];

		fuidBidRrnToAiDocumentIdsJSONArray.forEach((o1129)=>{
			if (o1129){
				let classObj = new FuidBidRrnWithAssetAiData();
				classObj.deserializeJson(o1129);
				this._fuidBidRrnToAiDocumentIds.push(classObj);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._fuid2keyFrameMetadataEntryList == null)
			this._fuid2keyFrameMetadataEntryList = new HashMap();
		this._fuid2keyFrameMetadataEntryList.clear();
		let fuid2keyFrameMetadataEntryListJSONArray = json.hasOwnProperty("fuid2keyFrameMetadataEntryList") ? json["fuid2keyFrameMetadataEntryList"] : [];
		this._fuid2keyFrameMetadataEntryList = SerializationUtil.deserializeMap(fuid2keyFrameMetadataEntryListJSONArray);

//Map of type INT. Decode as tree:false
		if (this._fuid2MetadataMap == null)
			this._fuid2MetadataMap = new HashMap();
		this._fuid2MetadataMap.clear();
		let fuid2MetadataMapJSONArray = json.hasOwnProperty("fuid2MetadataMap") ? json["fuid2MetadataMap"] : [];
		this._fuid2MetadataMap = SerializationUtil.deserializeMap(fuid2MetadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
GetMetadataResp.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadataResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LsZmCollectionAssetsNextPageQuery extends HttpOperation {

  constructor(name = "LsZmCollectionAssetsNextPage") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LsZmCollectionAssetsNextPageMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LsZmCollectionAssetsNextPageMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LsZmCollectionAssetsNextPageResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LsZmCollectionAssetsNextPageQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LsZmCollectionAssetsNextPageQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LsZmCollectionAssetsNextPageResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LsZmCollectionAssetsNextPageResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsNextPageQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssetsNextPage";
/**
 * @returns {string}
 */
LsZmCollectionAssetsNextPageQuery.QUERY_NAME = "LsZmCollectionAssetsNextPage";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetImageAiDataQuery extends HttpOperation {

  constructor(name = "GetImageAiData") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetImageAiDataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetImageAiDataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetImageAiDataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetImageAiDataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetImageAiDataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetImageAiDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetImageAiDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetImageAiDataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetImageAiData";
/**
 * @returns {string}
 */
GetImageAiDataQuery.QUERY_NAME = "GetImageAiData";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteAnnotationsMessage {

  constructor() {
    
        /**
     * @type {Array<CommentId>}
     * @private
     */
    this._deletedComments = null;

  }

    /**
   * @return {Array<CommentId>}
   */
  getDeletedComments() {
    return this._deletedComments;
  }

  /**
   * @param deletedComments{Array<CommentId>}
   * @return {DeleteAnnotationsMessage}
   */
  setDeletedComments(deletedComments) {
    this._deletedComments = deletedComments;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteAnnotationsMessage.CLASS_ID;
      if (this._deletedComments && this._deletedComments.length > 0) {
    let deletedComments_JSON = [];
    /**
     * @type {CommentId}
     */
    this._deletedComments.forEach((o179) => {
      if (o179) {
        if (o179.serializeJson && (typeof (o179.serializeJson) === 'function')) {
          deletedComments_JSON.push(o179.serializeJson());
        } else {
          deletedComments_JSON.push(o179);
        }
      }
    });
    json['deletedComments'] = deletedComments_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type CommentId
		this._deletedComments = [];
		let deletedCommentsJSONArray = json.hasOwnProperty("deletedComments") ? json["deletedComments"] : [];

		deletedCommentsJSONArray.forEach((o180)=>{
			if (o180){
				let classObj = new CommentId();
				classObj.deserializeJson(o180);
				this._deletedComments.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
DeleteAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateUniqueUrlMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._purpose = null;
    /**
     * @type {string}
     * @private
     */
    this._browserUrl = null;
    /**
     * @type {string}
     * @private
     */
    this._domainName = null;
    /**
     * @type {UniqueUrlPurposeConstants}
     * @private
     */
    this._uniqueUrlPurposeConstants = null;

  }

    /**
   * @return {string}
   */
  getPurpose() {
    return this._purpose;
  }

  /**
   * @param purpose{string}
   * @return {CreateUniqueUrlMessage}
   */
  setPurpose(purpose) {
    this._purpose = purpose;
    return this;
  }
  /**
   * @return {string}
   */
  getBrowserUrl() {
    return this._browserUrl;
  }

  /**
   * @param browserUrl{string}
   * @return {CreateUniqueUrlMessage}
   */
  setBrowserUrl(browserUrl) {
    this._browserUrl = browserUrl;
    return this;
  }
  /**
   * @return {string}
   */
  getDomainName() {
    return this._domainName;
  }

  /**
   * @param domainName{string}
   * @return {CreateUniqueUrlMessage}
   */
  setDomainName(domainName) {
    this._domainName = domainName;
    return this;
  }
  /**
   * @return {UniqueUrlPurposeConstants}
   */
  getUniqueUrlPurposeConstants() {
    return this._uniqueUrlPurposeConstants;
  }

  /**
   * @param uniqueUrlPurposeConstants{UniqueUrlPurposeConstants}
   * @return {CreateUniqueUrlMessage}
   */
  setUniqueUrlPurposeConstants(uniqueUrlPurposeConstants) {
    this._uniqueUrlPurposeConstants = uniqueUrlPurposeConstants;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateUniqueUrlMessage.CLASS_ID;
    
	//Serializing _purpose
	if (this._purpose)
		json['purpose'] = this._purpose;

	//Serializing _browserUrl
	if (this._browserUrl)
		json['browserUrl'] = this._browserUrl;

	//Serializing _domainName
	if (this._domainName)
		json['domainName'] = this._domainName;

	//Serializing ComplexType _$arrayName
	if (this._uniqueUrlPurposeConstants)
		json['uniqueUrlPurposeConstants'] = this._uniqueUrlPurposeConstants.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._purpose = json.hasOwnProperty("purpose")?json["purpose"]:null;
		this._browserUrl = json.hasOwnProperty("browserUrl")?json["browserUrl"]:null;
		this._domainName = json.hasOwnProperty("domainName")?json["domainName"]:null;
		if (json.hasOwnProperty("uniqueUrlPurposeConstants")){
			if (!this._uniqueUrlPurposeConstants && this._uniqueUrlPurposeConstants == null)
				this._uniqueUrlPurposeConstants = new UniqueUrlPurposeConstants();
			this._uniqueUrlPurposeConstants.deserializeJson(json.hasOwnProperty("uniqueUrlPurposeConstants") ? json["uniqueUrlPurposeConstants"] : null);
		}



  }
}

/**
 * @returns {string}
 */
CreateUniqueUrlMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateUniqueUrlMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CreateLiveDrawQuery extends HttpOperation {

  constructor(name = "CreateLiveDraw") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {CreateLiveDrawMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CreateLiveDrawMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {CreateLiveDrawResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CreateLiveDrawQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CreateLiveDrawQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new CreateLiveDrawResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new CreateLiveDrawResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CreateLiveDrawQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateLiveDraw";
/**
 * @returns {string}
 */
CreateLiveDrawQuery.QUERY_NAME = "CreateLiveDraw";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ClientExecQuery extends HttpOperation {

  constructor(name = "ClientExec") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ClientExecMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ClientExecMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ClientExecResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ClientExecQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ClientExecQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ClientExecResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ClientExecResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ClientExecQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ClientExec";
/**
 * @returns {string}
 */
ClientExecQuery.QUERY_NAME = "ClientExec";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ArchiveDetailsArgs {

  constructor() {
    
        /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {ArchiveDetailsArgs}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ArchiveDetailsArgs.CLASS_ID;
      if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o790) => {
      if (o790) {
        if (o790.serializeJson && (typeof (o790.serializeJson) === 'function')) {
          fuids_JSON.push(o790.serializeJson());
        } else {
          fuids_JSON.push(o790);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o791)=>{
			if (o791){
				this._fuids.push(o791);
			}
		});


  }
}

/**
 * @returns {string}
 */
ArchiveDetailsArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveDetailsArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetFacetsMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._useCurrentFuidSet = false;
    /**
     * @type {boolean}
     * @private
     */
    this._reset = false;
    /**
     * @type {boolean}
     * @private
     */
    this._useCategoryListForResponse = false;
    /**
     * @type {Array<CategoryQueryVAB>}
     * @private
     */
    this._categoryList = null;

  }

    /**
   * @return {boolean}
   */
  isUseCurrentFuidSet() {
    return this._useCurrentFuidSet;
  }

  /**
   * @param useCurrentFuidSet{boolean}
   * @return {GetFacetsMsg}
   */
  setUseCurrentFuidSet(useCurrentFuidSet) {
    this._useCurrentFuidSet = useCurrentFuidSet;
    return this;
  }
  /**
   * @return {boolean}
   */
  isReset() {
    return this._reset;
  }

  /**
   * @param reset{boolean}
   * @return {GetFacetsMsg}
   */
  setReset(reset) {
    this._reset = reset;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseCategoryListForResponse() {
    return this._useCategoryListForResponse;
  }

  /**
   * @param useCategoryListForResponse{boolean}
   * @return {GetFacetsMsg}
   */
  setUseCategoryListForResponse(useCategoryListForResponse) {
    this._useCategoryListForResponse = useCategoryListForResponse;
    return this;
  }
  /**
   * @return {Array<CategoryQueryVAB>}
   */
  getCategoryList() {
    return this._categoryList;
  }

  /**
   * @param categoryList{Array<CategoryQueryVAB>}
   * @return {GetFacetsMsg}
   */
  setCategoryList(categoryList) {
    this._categoryList = categoryList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetFacetsMsg.CLASS_ID;
    
	//Serializing _useCurrentFuidSet
	if (this._useCurrentFuidSet)
		json['useCurrentFuidSet'] = this._useCurrentFuidSet;

	//Serializing _reset
	if (this._reset)
		json['reset'] = this._reset;

	//Serializing _useCategoryListForResponse
	if (this._useCategoryListForResponse)
		json['useCategoryListForResponse'] = this._useCategoryListForResponse;
  if (this._categoryList && this._categoryList.length > 0) {
    let categoryList_JSON = [];
    /**
     * @type {CategoryQueryVAB}
     */
    this._categoryList.forEach((o592) => {
      if (o592) {
        if (o592.serializeJson && (typeof (o592.serializeJson) === 'function')) {
          categoryList_JSON.push(o592.serializeJson());
        } else {
          categoryList_JSON.push(o592);
        }
      }
    });
    json['categoryList'] = categoryList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._useCurrentFuidSet = json.hasOwnProperty("useCurrentFuidSet")?json["useCurrentFuidSet"]:false;
		this._reset = json.hasOwnProperty("reset")?json["reset"]:false;
		this._useCategoryListForResponse = json.hasOwnProperty("useCategoryListForResponse")?json["useCategoryListForResponse"]:false;
		//set of type CategoryQueryVAB
		this._categoryList = [];
		let categoryListJSONArray = json.hasOwnProperty("categoryList") ? json["categoryList"] : [];

		categoryListJSONArray.forEach((o593)=>{
			if (o593){
				let classObj = new CategoryQueryVAB();
				classObj.deserializeJson(o593);
				this._categoryList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetFacetsMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFacetsMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetExtBrowsingCapsArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._userName = null;

  }

    /**
   * @return {string}
   */
  getUserName() {
    return this._userName;
  }

  /**
   * @param userName{string}
   * @return {GetExtBrowsingCapsArgs}
   */
  setUserName(userName) {
    this._userName = userName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetExtBrowsingCapsArgs.CLASS_ID;
    
	//Serializing _userName
	if (this._userName)
		json['userName'] = this._userName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._userName = json.hasOwnProperty("userName")?json["userName"]:null;


  }
}

/**
 * @returns {string}
 */
GetExtBrowsingCapsArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.GetExtBrowsingCapsArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteZmCollectionQuery extends HttpOperation {

  constructor(name = "DeleteZmCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteZmCollectionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteZmCollectionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SimpleResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteZmCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteZmCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollection";
/**
 * @returns {string}
 */
DeleteZmCollectionQuery.QUERY_NAME = "DeleteZmCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GroupInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._groupName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showInTimeline = false;
    /**
     * @type {string}
     * @private
     */
    this._groupCode = null;

  }

    /**
   * @return {string}
   */
  getGroupName() {
    return this._groupName;
  }

  /**
   * @param groupName{string}
   * @return {GroupInfo}
   */
  setGroupName(groupName) {
    this._groupName = groupName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowInTimeline() {
    return this._showInTimeline;
  }

  /**
   * @param showInTimeline{boolean}
   * @return {GroupInfo}
   */
  setShowInTimeline(showInTimeline) {
    this._showInTimeline = showInTimeline;
    return this;
  }
  /**
   * @return {string}
   */
  getGroupCode() {
    return this._groupCode;
  }

  /**
   * @param groupCode{string}
   * @return {GroupInfo}
   */
  setGroupCode(groupCode) {
    this._groupCode = groupCode;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GroupInfo.CLASS_ID;
    
	//Serializing _groupName
	if (this._groupName)
		json['groupName'] = this._groupName;

	//Serializing _showInTimeline
	if (this._showInTimeline)
		json['showInTimeline'] = this._showInTimeline;

	//Serializing _groupCode
	if (this._groupCode)
		json['groupCode'] = this._groupCode;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._groupName = json.hasOwnProperty("groupName")?json["groupName"]:null;
		this._showInTimeline = json.hasOwnProperty("showInTimeline")?json["showInTimeline"]:false;
		this._groupCode = json.hasOwnProperty("groupCode")?json["groupCode"]:null;


  }
}

/**
 * @returns {string}
 */
GroupInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.GroupInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetExtBrowsingCapsQuery extends HttpOperation {

  constructor(name = "GetExtBrowsingCaps") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetExtBrowsingCapsArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetExtBrowsingCapsArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ExtBrowsingCapabilities}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetExtBrowsingCapsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetExtBrowsingCapsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ExtBrowsingCapabilities();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ExtBrowsingCapabilities();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetExtBrowsingCapsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetExtBrowsingCaps";
/**
 * @returns {string}
 */
GetExtBrowsingCapsQuery.QUERY_NAME = "GetExtBrowsingCaps";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateUserFromWebClientMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._password = null;
    /**
     * @type {string}
     * @private
     */
    this._verificationCode = null;
    /**
     * @type {UserDetails}
     * @private
     */
    this._userDetails = null;

  }

    /**
   * @return {string}
   */
  getPassword() {
    return this._password;
  }

  /**
   * @param password{string}
   * @return {CreateUserFromWebClientMessage}
   */
  setPassword(password) {
    this._password = password;
    return this;
  }
  /**
   * @return {string}
   */
  getVerificationCode() {
    return this._verificationCode;
  }

  /**
   * @param verificationCode{string}
   * @return {CreateUserFromWebClientMessage}
   */
  setVerificationCode(verificationCode) {
    this._verificationCode = verificationCode;
    return this;
  }
  /**
   * @return {UserDetails}
   */
  getUserDetails() {
    return this._userDetails;
  }

  /**
   * @param userDetails{UserDetails}
   * @return {CreateUserFromWebClientMessage}
   */
  setUserDetails(userDetails) {
    this._userDetails = userDetails;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateUserFromWebClientMessage.CLASS_ID;
    
	//Serializing _password
	if (this._password)
		json['password'] = this._password;

	//Serializing _verificationCode
	if (this._verificationCode)
		json['verificationCode'] = this._verificationCode;

	//Serializing ComplexType _$arrayName
	if (this._userDetails)
		json['userDetails'] = this._userDetails.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._password = json.hasOwnProperty("password")?json["password"]:null;
		this._verificationCode = json.hasOwnProperty("verificationCode")?json["verificationCode"]:null;
		if (json.hasOwnProperty("userDetails")){
			if (!this._userDetails && this._userDetails == null)
				this._userDetails = new UserDetails();
			this._userDetails.deserializeJson(json.hasOwnProperty("userDetails") ? json["userDetails"] : null);
		}



  }
}

/**
 * @returns {string}
 */
CreateUserFromWebClientMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateUserFromWebClientMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class RequestOTPForLoginQuery extends HttpOperation {

  constructor(name = "RequestOTPForLogin") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {RequestOTPForLoginMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{RequestOTPForLoginMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {RequestOTPForLoginResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = RequestOTPForLoginQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (RequestOTPForLoginQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new RequestOTPForLoginResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new RequestOTPForLoginResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
RequestOTPForLoginQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.RequestOTPForLogin";
/**
 * @returns {string}
 */
RequestOTPForLoginQuery.QUERY_NAME = "RequestOTPForLogin";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCloudCredentialsForTransferQuery extends HttpOperation {

  constructor(name = "GetCloudCredentialsForTransfer") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCloudCredentialsForTransferMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCloudCredentialsForTransferMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCloudCredentialsForTransferResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCloudCredentialsForTransferQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCloudCredentialsForTransferQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCloudCredentialsForTransferResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCloudCredentialsForTransferResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCloudCredentialsForTransferQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCloudCredentialsForTransfer";
/**
 * @returns {string}
 */
GetCloudCredentialsForTransferQuery.QUERY_NAME = "GetCloudCredentialsForTransfer";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DownloadFormatQuery extends HttpOperation {

  constructor(name = "DownloadFormat") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DownloadFormatMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DownloadFormatMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {DownloadFormatResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DownloadFormatQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DownloadFormatQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new DownloadFormatResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new DownloadFormatResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DownloadFormatQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DownloadFormat";
/**
 * @returns {string}
 */
DownloadFormatQuery.QUERY_NAME = "DownloadFormat";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class HelpQuery extends HttpOperation {

  constructor(name = "Help") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {HelpQueryMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{HelpQueryMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {HelpData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = HelpQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (HelpQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new HelpData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new HelpData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
HelpQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.Help";
/**
 * @returns {string}
 */
HelpQuery.QUERY_NAME = "Help";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetAssetsInfoQuery extends HttpOperation {

  constructor(name = "GetAssetsInfo") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetAssetsInfoMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetAssetsInfoMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetAssetsInfoResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetAssetsInfoQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetAssetsInfoQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetAssetsInfoResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetAssetsInfoResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetAssetsInfoQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsInfo";
/**
 * @returns {string}
 */
GetAssetsInfoQuery.QUERY_NAME = "GetAssetsInfo";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetFiltersQuery extends HttpOperation {

  constructor(name = "GetFilters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetFiltersMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetFiltersMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetFiltersResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetFiltersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetFiltersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetFiltersResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetFiltersResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetFiltersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFilters";
/**
 * @returns {string}
 */
GetFiltersQuery.QUERY_NAME = "GetFilters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ClientDelinkQuery extends HttpOperation {

  constructor(name = "ClientDelink") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ClientDelinkMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ClientDelinkMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GenericCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ClientDelinkQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ClientDelinkQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GenericCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GenericCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ClientDelinkQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ClientDelink";
/**
 * @returns {string}
 */
ClientDelinkQuery.QUERY_NAME = "ClientDelink";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetLinkSharingPermissionsQuery extends HttpOperation {

  constructor(name = "GetLinkSharingPermissions") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetLinkSharingPermissionsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetLinkSharingPermissionsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetLinkSharingPermissionsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetLinkSharingPermissionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetLinkSharingPermissionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetLinkSharingPermissionsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetLinkSharingPermissions";
/**
 * @returns {string}
 */
GetLinkSharingPermissionsQuery.QUERY_NAME = "GetLinkSharingPermissions";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Uid2SettingsMap {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._uid2SettingsMap = null;

  }

    /**
   * @return {java.util.Map<String,PropName2ValueMap>}
   */
  getUid2SettingsMap() {
    return this._uid2SettingsMap;
  }

  /**
   * @param uid2SettingsMap{java.util.Map<String,PropName2ValueMap>}
   * @return {Uid2SettingsMap}
   */
  setUid2SettingsMap(uid2SettingsMap) {
    this._uid2SettingsMap = uid2SettingsMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Uid2SettingsMap.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"uid2SettingsMap", this._uid2SettingsMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._uid2SettingsMap == null)
			this._uid2SettingsMap = new HashMap();
		this._uid2SettingsMap.clear();
		let uid2SettingsMapJSONArray = json.hasOwnProperty("uid2SettingsMap") ? json["uid2SettingsMap"] : [];
		this._uid2SettingsMap = SerializationUtil.deserializeMap(uid2SettingsMapJSONArray);



  }
}

/**
 * @returns {string}
 */
Uid2SettingsMap.CLASS_ID = "com.zoom.vab.client.autogenerated.Uid2SettingsMap";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Capability {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._ingestToZoom = false;
    /**
     * @type {string}
     * @private
     */
    this._storageType = null;

  }

    /**
   * @return {boolean}
   */
  isIngestToZoom() {
    return this._ingestToZoom;
  }

  /**
   * @param ingestToZoom{boolean}
   * @return {Capability}
   */
  setIngestToZoom(ingestToZoom) {
    this._ingestToZoom = ingestToZoom;
    return this;
  }
  /**
   * @return {string}
   */
  getStorageType() {
    return this._storageType;
  }

  /**
   * @param storageType{string}
   * @return {Capability}
   */
  setStorageType(storageType) {
    this._storageType = storageType;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Capability.CLASS_ID;
    
	//Serializing _ingestToZoom
	if (this._ingestToZoom)
		json['ingestToZoom'] = this._ingestToZoom;

	//Serializing _storageType
	if (this._storageType)
		json['storageType'] = this._storageType;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._ingestToZoom = json.hasOwnProperty("ingestToZoom")?json["ingestToZoom"]:false;
		this._storageType = json.hasOwnProperty("storageType")?json["storageType"]:null;


  }
}

/**
 * @returns {string}
 */
Capability.CLASS_ID = "com.zoom.vab.client.autogenerated.Capability";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FlexSmartShareArgs {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._abortOnFailure = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isSuffix = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._destDir = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isWritable = false;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isPrefix = false;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._srcFuids = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {boolean}
   */
  isAbortOnFailure() {
    return this._abortOnFailure;
  }

  /**
   * @param abortOnFailure{boolean}
   * @return {FlexSmartShareArgs}
   */
  setAbortOnFailure(abortOnFailure) {
    this._abortOnFailure = abortOnFailure;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsSuffix() {
    return this._isSuffix;
  }

  /**
   * @param isSuffix{boolean}
   * @return {FlexSmartShareArgs}
   */
  setIsSuffix(isSuffix) {
    this._isSuffix = isSuffix;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {FlexSmartShareArgs}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getDestDir() {
    return this._destDir;
  }

  /**
   * @param destDir{string}
   * @return {FlexSmartShareArgs}
   */
  setDestDir(destDir) {
    this._destDir = destDir;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexSmartShareArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsWritable() {
    return this._isWritable;
  }

  /**
   * @param isWritable{boolean}
   * @return {FlexSmartShareArgs}
   */
  setIsWritable(isWritable) {
    this._isWritable = isWritable;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexSmartShareArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsPrefix() {
    return this._isPrefix;
  }

  /**
   * @param isPrefix{boolean}
   * @return {FlexSmartShareArgs}
   */
  setIsPrefix(isPrefix) {
    this._isPrefix = isPrefix;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getSrcFuids() {
    return this._srcFuids;
  }

  /**
   * @param srcFuids{Array<Integer>}
   * @return {FlexSmartShareArgs}
   */
  setSrcFuids(srcFuids) {
    this._srcFuids = srcFuids;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {FlexSmartShareArgs}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexSmartShareArgs.CLASS_ID;
    
	//Serializing _abortOnFailure
	if (this._abortOnFailure)
		json['abortOnFailure'] = this._abortOnFailure;

	//Serializing _isSuffix
	if (this._isSuffix)
		json['isSuffix'] = this._isSuffix;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _destDir
	if (this._destDir)
		json['destDir'] = this._destDir;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _isWritable
	if (this._isWritable)
		json['isWritable'] = this._isWritable;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;

	//Serializing _isPrefix
	if (this._isPrefix)
		json['isPrefix'] = this._isPrefix;
  if (this._srcFuids && this._srcFuids.length > 0) {
    let srcFuids_JSON = [];
    /**
     * @type {int}
     */
    this._srcFuids.forEach((o276) => {
      if (o276) {
        if (o276.serializeJson && (typeof (o276.serializeJson) === 'function')) {
          srcFuids_JSON.push(o276.serializeJson());
        } else {
          srcFuids_JSON.push(o276);
        }
      }
    });
    json['srcFuids'] = srcFuids_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._abortOnFailure = json.hasOwnProperty("abortOnFailure")?json["abortOnFailure"]:false;
		this._isSuffix = json.hasOwnProperty("isSuffix")?json["isSuffix"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._destDir = json.hasOwnProperty("destDir")?json["destDir"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._isWritable = json.hasOwnProperty("isWritable")?json["isWritable"]:false;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		this._isPrefix = json.hasOwnProperty("isPrefix")?json["isPrefix"]:false;
		//set of type int
		this._srcFuids = [];
		let srcFuidsJSONArray = json.hasOwnProperty("srcFuids") ? json["srcFuids"] : [];

		srcFuidsJSONArray.forEach((o277)=>{
			if (o277){
				this._srcFuids.push(o277);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
FlexSmartShareArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartShareArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionAssetsNextPageResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNumber = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._resultFiles = null;

  }

    /**
   * @return {number}
   */
  getPageNumber() {
    return this._pageNumber;
  }

  /**
   * @param pageNumber{number}
   * @return {LsZmCollectionAssetsNextPageResponse}
   */
  setPageNumber(pageNumber) {
    this._pageNumber = pageNumber;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {LsZmCollectionAssetsNextPageResponse}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {Array<RepoItem>}
   */
  getResultFiles() {
    return this._resultFiles;
  }

  /**
   * @param resultFiles{Array<RepoItem>}
   * @return {LsZmCollectionAssetsNextPageResponse}
   */
  setResultFiles(resultFiles) {
    this._resultFiles = resultFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionAssetsNextPageResponse.CLASS_ID;
    
	//Serializing _pageNumber
	if (this._pageNumber)
		json['pageNumber'] = this._pageNumber;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;
  if (this._resultFiles && this._resultFiles.length > 0) {
    let resultFiles_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._resultFiles.forEach((o187) => {
      if (o187) {
        if (o187.serializeJson && (typeof (o187.serializeJson) === 'function')) {
          resultFiles_JSON.push(o187.serializeJson());
        } else {
          resultFiles_JSON.push(o187);
        }
      }
    });
    json['resultFiles'] = resultFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNumber = json.hasOwnProperty("pageNumber")?json["pageNumber"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		//set of type RepoItem
		this._resultFiles = [];
		let resultFilesJSONArray = json.hasOwnProperty("resultFiles") ? json["resultFiles"] : [];

		resultFilesJSONArray.forEach((o188)=>{
			if (o188){
				let classObj = new RepoItem();
				classObj.deserializeJson(o188);
				this._resultFiles.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsNextPageResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssetsNextPageResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Proj2Br2PathExt {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {Proj2Br2PathExt}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {Proj2Br2PathExt}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {Proj2Br2PathExt}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Proj2Br2PathExt.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;


  }
}

/**
 * @returns {string}
 */
Proj2Br2PathExt.CLASS_ID = "com.zoom.vab.client.autogenerated.Proj2Br2PathExt";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AutoCompleteUserResponse {

  constructor() {
    
        /**
     * @type {Array<AutoCompleteEntry>}
     * @private
     */
    this._users = null;

  }

    /**
   * @return {Array<AutoCompleteEntry>}
   */
  getUsers() {
    return this._users;
  }

  /**
   * @param users{Array<AutoCompleteEntry>}
   * @return {AutoCompleteUserResponse}
   */
  setUsers(users) {
    this._users = users;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AutoCompleteUserResponse.CLASS_ID;
      if (this._users && this._users.length > 0) {
    let users_JSON = [];
    /**
     * @type {AutoCompleteEntry}
     */
    this._users.forEach((o1066) => {
      if (o1066) {
        if (o1066.serializeJson && (typeof (o1066.serializeJson) === 'function')) {
          users_JSON.push(o1066.serializeJson());
        } else {
          users_JSON.push(o1066);
        }
      }
    });
    json['users'] = users_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type AutoCompleteEntry
		this._users = [];
		let usersJSONArray = json.hasOwnProperty("users") ? json["users"] : [];

		usersJSONArray.forEach((o1067)=>{
			if (o1067){
				let classObj = new AutoCompleteEntry();
				classObj.deserializeJson(o1067);
				this._users.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
AutoCompleteUserResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.AutoCompleteUserResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetActivityPanelDataQuery extends HttpOperation {

  constructor(name = "GetActivityPanelData") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetActivityPanelDataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetActivityPanelDataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetActivityPanelDataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetActivityPanelDataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetActivityPanelDataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetActivityPanelDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetActivityPanelDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetActivityPanelDataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivityPanelData";
/**
 * @returns {string}
 */
GetActivityPanelDataQuery.QUERY_NAME = "GetActivityPanelData";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FileReferenceArg {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._includeInActiveLinks = false;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FileReferenceArg}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIncludeInActiveLinks() {
    return this._includeInActiveLinks;
  }

  /**
   * @param includeInActiveLinks{boolean}
   * @return {FileReferenceArg}
   */
  setIncludeInActiveLinks(includeInActiveLinks) {
    this._includeInActiveLinks = includeInActiveLinks;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FileReferenceArg}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {FileReferenceArg}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FileReferenceArg.CLASS_ID;
    
	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _includeInActiveLinks
	if (this._includeInActiveLinks)
		json['includeInActiveLinks'] = this._includeInActiveLinks;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._includeInActiveLinks = json.hasOwnProperty("includeInActiveLinks")?json["includeInActiveLinks"]:false;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
FileReferenceArg.CLASS_ID = "com.zoom.vab.client.autogenerated.FileReferenceArg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClearAllDrawingAnnotationsMessage {

  constructor() {
    
        /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {AnnotationLocation}
     * @private
     */
    this._annotationLocation = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;

  }

    /**
   * optional: Collection scope for comment. May be omitted in edits if unchanged.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {ClearAllDrawingAnnotationsMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Location scope to clear annotations from.
   * @return {AnnotationLocation}
   */
  getAnnotationLocation() {
    return this._annotationLocation;
  }

  /**
   * @param annotationLocation{AnnotationLocation}
   * @return {ClearAllDrawingAnnotationsMessage}
   */
  setAnnotationLocation(annotationLocation) {
    this._annotationLocation = annotationLocation;
    return this;
  }
  /**
   * optional: Asset scope for comment. May be omitted in edits if unchanged.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {ClearAllDrawingAnnotationsMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClearAllDrawingAnnotationsMessage.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._annotationLocation)
		json['annotationLocation'] = this._annotationLocation.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("annotationLocation")){
			if (!this._annotationLocation && this._annotationLocation == null)
				this._annotationLocation = new AnnotationLocation();
			this._annotationLocation.deserializeJson(json.hasOwnProperty("annotationLocation") ? json["annotationLocation"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
ClearAllDrawingAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ClearAllDrawingAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionUnreadCountEntry {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._unreadCount = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {string}
     * @private
     */
    this._collectionName = null;
    /**
     * @type {Array<FuidToUnreadComments>}
     * @private
     */
    this._fuidUnreadComments = null;

  }

    /**
   * @return {number}
   */
  getUnreadCount() {
    return this._unreadCount;
  }

  /**
   * @param unreadCount{number}
   * @return {CollectionUnreadCountEntry}
   */
  setUnreadCount(unreadCount) {
    this._unreadCount = unreadCount;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {CollectionUnreadCountEntry}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {string}
   */
  getCollectionName() {
    return this._collectionName;
  }

  /**
   * @param collectionName{string}
   * @return {CollectionUnreadCountEntry}
   */
  setCollectionName(collectionName) {
    this._collectionName = collectionName;
    return this;
  }
  /**
   * @return {Array<FuidToUnreadComments>}
   */
  getFuidUnreadComments() {
    return this._fuidUnreadComments;
  }

  /**
   * @param fuidUnreadComments{Array<FuidToUnreadComments>}
   * @return {CollectionUnreadCountEntry}
   */
  setFuidUnreadComments(fuidUnreadComments) {
    this._fuidUnreadComments = fuidUnreadComments;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionUnreadCountEntry.CLASS_ID;
    
	//Serializing _unreadCount
	if (this._unreadCount)
		json['unreadCount'] = this._unreadCount;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _collectionName
	if (this._collectionName)
		json['collectionName'] = this._collectionName;
  if (this._fuidUnreadComments && this._fuidUnreadComments.length > 0) {
    let fuidUnreadComments_JSON = [];
    /**
     * @type {FuidToUnreadComments}
     */
    this._fuidUnreadComments.forEach((o570) => {
      if (o570) {
        if (o570.serializeJson && (typeof (o570.serializeJson) === 'function')) {
          fuidUnreadComments_JSON.push(o570.serializeJson());
        } else {
          fuidUnreadComments_JSON.push(o570);
        }
      }
    });
    json['fuidUnreadComments'] = fuidUnreadComments_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._unreadCount = json.hasOwnProperty("unreadCount")?json["unreadCount"]:0;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._collectionName = json.hasOwnProperty("collectionName")?json["collectionName"]:null;
		//set of type FuidToUnreadComments
		this._fuidUnreadComments = [];
		let fuidUnreadCommentsJSONArray = json.hasOwnProperty("fuidUnreadComments") ? json["fuidUnreadComments"] : [];

		fuidUnreadCommentsJSONArray.forEach((o571)=>{
			if (o571){
				let classObj = new FuidToUnreadComments();
				classObj.deserializeJson(o571);
				this._fuidUnreadComments.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
CollectionUnreadCountEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionUnreadCountEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MyProjectsResponse {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._projectList = null;

  }

    /**
   * @return {Array<String>}
   */
  getProjectList() {
    return this._projectList;
  }

  /**
   * @param projectList{Array<String>}
   * @return {MyProjectsResponse}
   */
  setProjectList(projectList) {
    this._projectList = projectList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MyProjectsResponse.CLASS_ID;
      if (this._projectList && this._projectList.length > 0) {
    let projectList_JSON = [];
    /**
     * @type {string}
     */
    this._projectList.forEach((o910) => {
      if (o910) {
        if (o910.serializeJson && (typeof (o910.serializeJson) === 'function')) {
          projectList_JSON.push(o910.serializeJson());
        } else {
          projectList_JSON.push(o910);
        }
      }
    });
    json['projectList'] = projectList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._projectList = [];
		let projectListJSONArray = json.hasOwnProperty("projectList") ? json["projectList"] : [];

		projectListJSONArray.forEach((o911)=>{
			if (o911){
				this._projectList.push(o911);
			}
		});


  }
}

/**
 * @returns {string}
 */
MyProjectsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.MyProjectsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionMetadataValueObj {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isNot = false;
    /**
     * @type {number}
     * @private
     */
    this._searchType = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {number}
     * @private
     */
    this._operator = null;

  }

    /**
   * @return {boolean}
   */
  isIsNot() {
    return this._isNot;
  }

  /**
   * @param isNot{boolean}
   * @return {CollectionMetadataValueObj}
   */
  setIsNot(isNot) {
    this._isNot = isNot;
    return this;
  }
  /**
   * @return {number}
   */
  getSearchType() {
    return this._searchType;
  }

  /**
   * @param searchType{number}
   * @return {CollectionMetadataValueObj}
   */
  setSearchType(searchType) {
    this._searchType = searchType;
    return this;
  }
  /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {CollectionMetadataValueObj}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {number}
   */
  getOperator() {
    return this._operator;
  }

  /**
   * @param operator{number}
   * @return {CollectionMetadataValueObj}
   */
  setOperator(operator) {
    this._operator = operator;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionMetadataValueObj.CLASS_ID;
    
	//Serializing _isNot
	if (this._isNot)
		json['isNot'] = this._isNot;

	//Serializing _searchType
	if (this._searchType)
		json['searchType'] = this._searchType;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing _operator
	if (this._operator)
		json['operator'] = this._operator;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isNot = json.hasOwnProperty("isNot")?json["isNot"]:false;
		this._searchType = json.hasOwnProperty("searchType")?json["searchType"]:0;
		this._value = json.hasOwnProperty("value")?json["value"]:null;
		this._operator = json.hasOwnProperty("operator")?json["operator"]:0;


  }
}

/**
 * @returns {string}
 */
CollectionMetadataValueObj.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionMetadataValueObj";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class WCStatusQueryQuery extends HttpOperation {

  constructor(name = "WCStatusQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {WCStatusQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{WCStatusQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {WCStatusQueryResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = WCStatusQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (WCStatusQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new WCStatusQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new WCStatusQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
WCStatusQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.WCStatusQuery";
/**
 * @returns {string}
 */
WCStatusQueryQuery.QUERY_NAME = "WCStatusQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetNodesQuery extends HttpOperation {

  constructor(name = "GetNodes") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {NodeArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{NodeArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Node}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetNodesQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetNodesQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Node();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Node();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetNodesQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetNodes";
/**
 * @returns {string}
 */
GetNodesQuery.QUERY_NAME = "GetNodes";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ExtBrowsingCapabilities {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._targetToOps = null;

  }

    /**
   * @return {java.util.Map<String,Capability>}
   */
  getTargetToOps() {
    return this._targetToOps;
  }

  /**
   * @param targetToOps{java.util.Map<String,Capability>}
   * @return {ExtBrowsingCapabilities}
   */
  setTargetToOps(targetToOps) {
    this._targetToOps = targetToOps;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ExtBrowsingCapabilities.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"targetToOps", this._targetToOps);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._targetToOps == null)
			this._targetToOps = new HashMap();
		this._targetToOps.clear();
		let targetToOpsJSONArray = json.hasOwnProperty("targetToOps") ? json["targetToOps"] : [];
		this._targetToOps = SerializationUtil.deserializeMap(targetToOpsJSONArray);



  }
}

/**
 * @returns {string}
 */
ExtBrowsingCapabilities.CLASS_ID = "com.zoom.vab.client.autogenerated.ExtBrowsingCapabilities";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetMetadataHelpQueryQuery extends HttpOperation {

  constructor(name = "GetMetadataHelpQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetMetadataHelpQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetMetadataHelpQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetMetadataHelpQueryRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetMetadataHelpQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetMetadataHelpQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetMetadataHelpQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetMetadataHelpQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetMetadataHelpQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadataHelpQuery";
/**
 * @returns {string}
 */
GetMetadataHelpQueryQuery.QUERY_NAME = "GetMetadataHelpQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LoadFiltersMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._sortBy = null;

  }

    /**
   * @return {string}
   */
  getSortBy() {
    return this._sortBy;
  }

  /**
   * @param sortBy{string}
   * @return {LoadFiltersMsg}
   */
  setSortBy(sortBy) {
    this._sortBy = sortBy;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LoadFiltersMsg.CLASS_ID;
    
	//Serializing _SortBy
	if (this._SortBy)
		json['SortBy'] = this._SortBy;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._SortBy = json.hasOwnProperty("SortBy")?json["SortBy"]:null;


  }
}

/**
 * @returns {string}
 */
LoadFiltersMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadFiltersMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionMetadataMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._specificMetadata = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetCollectionMetadataMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getSpecificMetadata() {
    return this._specificMetadata;
  }

  /**
   * @param specificMetadata{Array<String>}
   * @return {GetCollectionMetadataMessage}
   */
  setSpecificMetadata(specificMetadata) {
    this._specificMetadata = specificMetadata;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionMetadataMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._specificMetadata && this._specificMetadata.length > 0) {
    let specificMetadata_JSON = [];
    /**
     * @type {string}
     */
    this._specificMetadata.forEach((o517) => {
      if (o517) {
        if (o517.serializeJson && (typeof (o517.serializeJson) === 'function')) {
          specificMetadata_JSON.push(o517.serializeJson());
        } else {
          specificMetadata_JSON.push(o517);
        }
      }
    });
    json['specificMetadata'] = specificMetadata_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type string
		this._specificMetadata = [];
		let specificMetadataJSONArray = json.hasOwnProperty("specificMetadata") ? json["specificMetadata"] : [];

		specificMetadataJSONArray.forEach((o518)=>{
			if (o518){
				this._specificMetadata.push(o518);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetCollectionMetadataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionMetadataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteCollectionMetadataMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._deleteAll = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._collectionMetadata = null;
    /**
     * @type {HashSet}
     * @private
     */
    this._mdPropName = null;

  }

    /**
   * @return {boolean}
   */
  isDeleteAll() {
    return this._deleteAll;
  }

  /**
   * @param deleteAll{boolean}
   * @return {DeleteCollectionMetadataMessage}
   */
  setDeleteAll(deleteAll) {
    this._deleteAll = deleteAll;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {DeleteCollectionMetadataMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {java.util.Map<String,ValueList>}
   */
  getCollectionMetadata() {
    return this._collectionMetadata;
  }

  /**
   * @param collectionMetadata{java.util.Map<String,ValueList>}
   * @return {DeleteCollectionMetadataMessage}
   */
  setCollectionMetadata(collectionMetadata) {
    this._collectionMetadata = collectionMetadata;
    return this;
  }

  /**
   * @return {HashSet}
   */
  getMdPropName() {
    return this._mdPropName;
  }

  /**
   * @param mdPropName{HashSet}
   * @return {DeleteCollectionMetadataMessage}
   */
  setMdPropName(mdPropName) {
    this._mdPropName = mdPropName;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteCollectionMetadataMessage.CLASS_ID;
    
	//Serializing _deleteAll
	if (this._deleteAll)
		json['deleteAll'] = this._deleteAll;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
    SerializationUtil.serializeHashMap(json,"collectionMetadata", this._collectionMetadata);
		SerializationUtil.serializeSet(json, "mdPropName", this._mdPropName, true);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._deleteAll = json.hasOwnProperty("deleteAll")?json["deleteAll"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
//Map of type STRING. Decode as tree:false
		if (this._collectionMetadata == null)
			this._collectionMetadata = new HashMap();
		this._collectionMetadata.clear();
		let collectionMetadataJSONArray = json.hasOwnProperty("collectionMetadata") ? json["collectionMetadata"] : [];
		this._collectionMetadata = SerializationUtil.deserializeMap(collectionMetadataJSONArray);

//set of type STRING
		if (!this._mdPropName)
			this._mdPropName = new HashSet();
		this._mdPropName.clear();
		let mdPropNameJSONArray = json.hasOwnProperty("mdPropName") ? json["mdPropName"] : [];
		this._mdPropName = SerializationUtil.deserializeSet(mdPropNameJSONArray);

  }
}

/**
 * @returns {string}
 */
DeleteCollectionMetadataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteCollectionMetadataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class KeyFrameMetadataEntry {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._startTime = null;
    /**
     * @type {number}
     * @private
     */
    this._id = null;
    /**
     * @type {number}
     * @private
     */
    this._endTime = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {number}
   */
  getStartTime() {
    return this._startTime;
  }

  /**
   * @param startTime{number}
   * @return {KeyFrameMetadataEntry}
   */
  setStartTime(startTime) {
    this._startTime = startTime;
    return this;
  }
  /**
   * @return {number}
   */
  getId() {
    return this._id;
  }

  /**
   * @param id{number}
   * @return {KeyFrameMetadataEntry}
   */
  setId(id) {
    this._id = id;
    return this;
  }
  /**
   * @return {number}
   */
  getEndTime() {
    return this._endTime;
  }

  /**
   * @param endTime{number}
   * @return {KeyFrameMetadataEntry}
   */
  setEndTime(endTime) {
    this._endTime = endTime;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {KeyFrameMetadataEntry}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = KeyFrameMetadataEntry.CLASS_ID;
    
	//Serializing _startTime
	if (this._startTime)
		json['startTime'] = this._startTime;

	//Serializing _id
	if (this._id)
		json['id'] = this._id;

	//Serializing _endTime
	if (this._endTime)
		json['endTime'] = this._endTime;
    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._startTime = json.hasOwnProperty("startTime")?json["startTime"]:0;
		this._id = json.hasOwnProperty("id")?json["id"]:0;
		this._endTime = json.hasOwnProperty("endTime")?json["endTime"]:0;
//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
KeyFrameMetadataEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.KeyFrameMetadataEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class AssignUsersToCollectionQuery extends HttpOperation {

  constructor(name = "AssignUsersToCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {AssignCollectionUsersData}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{AssignCollectionUsersData}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = AssignUsersToCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (AssignUsersToCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
AssignUsersToCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.AssignUsersToCollection";
/**
 * @returns {string}
 */
AssignUsersToCollectionQuery.QUERY_NAME = "AssignUsersToCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionAssetsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNumber = null;
    /**
     * @type {number}
     * @private
     */
    this._totalEntries = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;
    /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._resultFiles = null;

  }

    /**
   * @return {number}
   */
  getPageNumber() {
    return this._pageNumber;
  }

  /**
   * @param pageNumber{number}
   * @return {LsZmCollectionAssetsResponse}
   */
  setPageNumber(pageNumber) {
    this._pageNumber = pageNumber;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalEntries() {
    return this._totalEntries;
  }

  /**
   * @param totalEntries{number}
   * @return {LsZmCollectionAssetsResponse}
   */
  setTotalEntries(totalEntries) {
    this._totalEntries = totalEntries;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {LsZmCollectionAssetsResponse}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {LsZmCollectionAssetsResponse}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }
  /**
   * @return {Array<RepoItem>}
   */
  getResultFiles() {
    return this._resultFiles;
  }

  /**
   * @param resultFiles{Array<RepoItem>}
   * @return {LsZmCollectionAssetsResponse}
   */
  setResultFiles(resultFiles) {
    this._resultFiles = resultFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionAssetsResponse.CLASS_ID;
    
	//Serializing _pageNumber
	if (this._pageNumber)
		json['pageNumber'] = this._pageNumber;

	//Serializing _totalEntries
	if (this._totalEntries)
		json['totalEntries'] = this._totalEntries;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;

	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		  if (this._resultFiles && this._resultFiles.length > 0) {
    let resultFiles_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._resultFiles.forEach((o226) => {
      if (o226) {
        if (o226.serializeJson && (typeof (o226.serializeJson) === 'function')) {
          resultFiles_JSON.push(o226.serializeJson());
        } else {
          resultFiles_JSON.push(o226);
        }
      }
    });
    json['resultFiles'] = resultFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNumber = json.hasOwnProperty("pageNumber")?json["pageNumber"]:0;
		this._totalEntries = json.hasOwnProperty("totalEntries")?json["totalEntries"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}

		//set of type RepoItem
		this._resultFiles = [];
		let resultFilesJSONArray = json.hasOwnProperty("resultFiles") ? json["resultFiles"] : [];

		resultFilesJSONArray.forEach((o227)=>{
			if (o227){
				let classObj = new RepoItem();
				classObj.deserializeJson(o227);
				this._resultFiles.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssetsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ApplyFilterQuery extends HttpOperation {

  constructor(name = "ApplyFilter") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ApplyFilterMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ApplyFilterMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ApplyFilterResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ApplyFilterQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ApplyFilterQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ApplyFilterResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ApplyFilterResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ApplyFilterQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ApplyFilter";
/**
 * @returns {string}
 */
ApplyFilterQuery.QUERY_NAME = "ApplyFilter";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {DeleteAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;


  }
}

/**
 * @returns {string}
 */
DeleteAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetSettingsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._fetchGlobalSettings = false;
    /**
     * @type {number}
     * @private
     */
    this._fetchGlobalSettingsMaxRrn = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resetAll = false;

  }

    /**
   * @return {boolean}
   */
  isFetchGlobalSettings() {
    return this._fetchGlobalSettings;
  }

  /**
   * @param fetchGlobalSettings{boolean}
   * @return {GetSettingsMessage}
   */
  setFetchGlobalSettings(fetchGlobalSettings) {
    this._fetchGlobalSettings = fetchGlobalSettings;
    return this;
  }
  /**
   * @return {number}
   */
  getFetchGlobalSettingsMaxRrn() {
    return this._fetchGlobalSettingsMaxRrn;
  }

  /**
   * @param fetchGlobalSettingsMaxRrn{number}
   * @return {GetSettingsMessage}
   */
  setFetchGlobalSettingsMaxRrn(fetchGlobalSettingsMaxRrn) {
    this._fetchGlobalSettingsMaxRrn = fetchGlobalSettingsMaxRrn;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResetAll() {
    return this._resetAll;
  }

  /**
   * @param resetAll{boolean}
   * @return {GetSettingsMessage}
   */
  setResetAll(resetAll) {
    this._resetAll = resetAll;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetSettingsMessage.CLASS_ID;
    
	//Serializing _fetchGlobalSettings
	if (this._fetchGlobalSettings)
		json['fetchGlobalSettings'] = this._fetchGlobalSettings;

	//Serializing _fetchGlobalSettingsMaxRrn
	if (this._fetchGlobalSettingsMaxRrn)
		json['fetchGlobalSettingsMaxRrn'] = this._fetchGlobalSettingsMaxRrn;

	//Serializing _resetAll
	if (this._resetAll)
		json['resetAll'] = this._resetAll;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fetchGlobalSettings = json.hasOwnProperty("fetchGlobalSettings")?json["fetchGlobalSettings"]:false;
		this._fetchGlobalSettingsMaxRrn = json.hasOwnProperty("fetchGlobalSettingsMaxRrn")?json["fetchGlobalSettingsMaxRrn"]:0;
		this._resetAll = json.hasOwnProperty("resetAll")?json["resetAll"]:false;


  }
}

/**
 * @returns {string}
 */
GetSettingsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSettingsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ReadFavItemsMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._sortBy = null;

  }

    /**
   * @return {string}
   */
  getSortBy() {
    return this._sortBy;
  }

  /**
   * @param sortBy{string}
   * @return {ReadFavItemsMsg}
   */
  setSortBy(sortBy) {
    this._sortBy = sortBy;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ReadFavItemsMsg.CLASS_ID;
    
	//Serializing _sortBy
	if (this._sortBy)
		json['sortBy'] = this._sortBy;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._sortBy = json.hasOwnProperty("sortBy")?json["sortBy"]:null;


  }
}

/**
 * @returns {string}
 */
ReadFavItemsMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ReadFavItemsMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DownloadFormatMsg {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._filenames = null;

  }

    /**
   * @return {Array<String>}
   */
  getFilenames() {
    return this._filenames;
  }

  /**
   * @param filenames{Array<String>}
   * @return {DownloadFormatMsg}
   */
  setFilenames(filenames) {
    this._filenames = filenames;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DownloadFormatMsg.CLASS_ID;
      if (this._filenames && this._filenames.length > 0) {
    let filenames_JSON = [];
    /**
     * @type {string}
     */
    this._filenames.forEach((o662) => {
      if (o662) {
        if (o662.serializeJson && (typeof (o662.serializeJson) === 'function')) {
          filenames_JSON.push(o662.serializeJson());
        } else {
          filenames_JSON.push(o662);
        }
      }
    });
    json['filenames'] = filenames_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._filenames = [];
		let filenamesJSONArray = json.hasOwnProperty("filenames") ? json["filenames"] : [];

		filenamesJSONArray.forEach((o663)=>{
			if (o663){
				this._filenames.push(o663);
			}
		});


  }
}

/**
 * @returns {string}
 */
DownloadFormatMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.DownloadFormatMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AssetIdJson {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._maxFuid = null;
    /**
     * @type {number}
     * @private
     */
    this._minFuid = null;
    /**
     * @type {string}
     * @private
     */
    this._fuidStr = null;

  }

    /**
   * @return {number}
   */
  getMaxFuid() {
    return this._maxFuid;
  }

  /**
   * @param maxFuid{number}
   * @return {AssetIdJson}
   */
  setMaxFuid(maxFuid) {
    this._maxFuid = maxFuid;
    return this;
  }
  /**
   * @return {number}
   */
  getMinFuid() {
    return this._minFuid;
  }

  /**
   * @param minFuid{number}
   * @return {AssetIdJson}
   */
  setMinFuid(minFuid) {
    this._minFuid = minFuid;
    return this;
  }
  /**
   * @return {string}
   */
  getFuidStr() {
    return this._fuidStr;
  }

  /**
   * @param fuidStr{string}
   * @return {AssetIdJson}
   */
  setFuidStr(fuidStr) {
    this._fuidStr = fuidStr;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AssetIdJson.CLASS_ID;
    
	//Serializing _maxFuid
	if (this._maxFuid)
		json['maxFuid'] = this._maxFuid;

	//Serializing _minFuid
	if (this._minFuid)
		json['minFuid'] = this._minFuid;

	//Serializing _fuidStr
	if (this._fuidStr)
		json['fuidStr'] = this._fuidStr;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._maxFuid = json.hasOwnProperty("maxFuid")?json["maxFuid"]:0;
		this._minFuid = json.hasOwnProperty("minFuid")?json["minFuid"]:0;
		this._fuidStr = json.hasOwnProperty("fuidStr")?json["fuidStr"]:null;


  }
}

/**
 * @returns {string}
 */
AssetIdJson.CLASS_ID = "com.zoom.vab.client.autogenerated.AssetIdJson";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAnnotationsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._includeResolved = false;
    /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {string}
     * @private
     */
    this._annotationKind = null;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<Long>}
     * @private
     */
    this._commentIds = null;

  }

    /**
   * optional: Include Resolved threads in response. By default, resolved comments are hidden.
   * @return {boolean}
   */
  isIncludeResolved() {
    return this._includeResolved;
  }

  /**
   * @param includeResolved{boolean}
   * @return {GetAnnotationsMessage}
   */
  setIncludeResolved(includeResolved) {
    this._includeResolved = includeResolved;
    return this;
  }
  /**
   * optional: only get those threads which have been created/modified after this RRN
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {GetAnnotationsMessage}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * Enum: COMMENT, NOTE, PRIVATE_COMMENT, PRIVATE_NOTE, REVIEW
   * @return {string}
   */
  getAnnotationKind() {
    return this._annotationKind;
  }

  /**
   * @param annotationKind{string}
   * @return {GetAnnotationsMessage}
   */
  setAnnotationKind(annotationKind) {
    this._annotationKind = annotationKind;
    return this;
  }
  /**
   * optional: Collection scope for comments.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {GetAnnotationsMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comments.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {GetAnnotationsMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * optional: can be specified to get specific comment data only; other scope params do not take effect if specified.
   * @return {Array<Long>}
   */
  getCommentIds() {
    return this._commentIds;
  }

  /**
   * @param commentIds{Array<Long>}
   * @return {GetAnnotationsMessage}
   */
  setCommentIds(commentIds) {
    this._commentIds = commentIds;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAnnotationsMessage.CLASS_ID;
    
	//Serializing _includeResolved
	if (this._includeResolved)
		json['includeResolved'] = this._includeResolved;

	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;

	//Serializing _annotationKind
	if (this._annotationKind)
		json['annotationKind'] = this._annotationKind;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._commentIds && this._commentIds.length > 0) {
    let commentIds_JSON = [];
    /**
     * @type {long}
     */
    this._commentIds.forEach((o946) => {
      if (o946) {
        if (o946.serializeJson && (typeof (o946.serializeJson) === 'function')) {
          commentIds_JSON.push(o946.serializeJson());
        } else {
          commentIds_JSON.push(o946);
        }
      }
    });
    json['commentIds'] = commentIds_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._includeResolved = json.hasOwnProperty("includeResolved")?json["includeResolved"]:false;
		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		this._annotationKind = json.hasOwnProperty("annotationKind")?json["annotationKind"]:null;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type long
		this._commentIds = [];
		let commentIdsJSONArray = json.hasOwnProperty("commentIds") ? json["commentIds"] : [];

		commentIdsJSONArray.forEach((o947)=>{
			if (o947){
				this._commentIds.push(o947);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ReadFavItemsResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2FavItemObject = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {ReadFavItemsResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {java.util.Map<number,FavItemDetail>}
   */
  getFuid2FavItemObject() {
    return this._fuid2FavItemObject;
  }

  /**
   * @param fuid2FavItemObject{java.util.Map<number,FavItemDetail>}
   * @return {ReadFavItemsResp}
   */
  setFuid2FavItemObject(fuid2FavItemObject) {
    this._fuid2FavItemObject = fuid2FavItemObject;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ReadFavItemsResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
    SerializationUtil.serializeHashMap(json,"fuid2FavItemObject", this._fuid2FavItemObject);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
//Map of type INT. Decode as tree:false
		if (this._fuid2FavItemObject == null)
			this._fuid2FavItemObject = new HashMap();
		this._fuid2FavItemObject.clear();
		let fuid2FavItemObjectJSONArray = json.hasOwnProperty("fuid2FavItemObject") ? json["fuid2FavItemObject"] : [];
		this._fuid2FavItemObject = SerializationUtil.deserializeMap(fuid2FavItemObjectJSONArray);



  }
}

/**
 * @returns {string}
 */
ReadFavItemsResp.CLASS_ID = "com.zoom.vab.client.autogenerated.ReadFavItemsResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteZmCollectionUsersQuery extends HttpOperation {

  constructor(name = "DeleteZmCollectionUsers") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {DeleteZmCollectionUsersMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteZmCollectionUsersMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteZmCollectionUsersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteZmCollectionUsersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionUsersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollectionUsers";
/**
 * @returns {string}
 */
DeleteZmCollectionUsersQuery.QUERY_NAME = "DeleteZmCollectionUsers";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionFiltersResp {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._filters = null;

  }

    /**
   * @return {java.util.Map<String,ValueList>}
   */
  getFilters() {
    return this._filters;
  }

  /**
   * @param filters{java.util.Map<String,ValueList>}
   * @return {GetCollectionFiltersResp}
   */
  setFilters(filters) {
    this._filters = filters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionFiltersResp.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"filters", this._filters);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._filters == null)
			this._filters = new HashMap();
		this._filters.clear();
		let filtersJSONArray = json.hasOwnProperty("filters") ? json["filters"] : [];
		this._filters = SerializationUtil.deserializeMap(filtersJSONArray);



  }
}

/**
 * @returns {string}
 */
GetCollectionFiltersResp.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionFiltersResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class InviteUsersToCollectionQuery extends HttpOperation {

  constructor(name = "InviteUsersToCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {InviteUsersToCollectionRequestData}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{InviteUsersToCollectionRequestData}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = InviteUsersToCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (InviteUsersToCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
InviteUsersToCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.InviteUsersToCollection";
/**
 * @returns {string}
 */
InviteUsersToCollectionQuery.QUERY_NAME = "InviteUsersToCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ReloadSessionQuery extends HttpOperation {

  constructor(name = "ReloadSession") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ReloadSessionMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ReloadSessionMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesStatData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ReloadSessionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ReloadSessionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesStatData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesStatData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ReloadSessionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ReloadSession";
/**
 * @returns {string}
 */
ReloadSessionQuery.QUERY_NAME = "ReloadSession";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CreateUniqueUrlQuery extends HttpOperation {

  constructor(name = "CreateUniqueUrl") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {CreateUniqueUrlMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CreateUniqueUrlMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {CreateUniqueUrlResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CreateUniqueUrlQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CreateUniqueUrlQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new CreateUniqueUrlResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new CreateUniqueUrlResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CreateUniqueUrlQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateUniqueUrl";
/**
 * @returns {string}
 */
CreateUniqueUrlQuery.QUERY_NAME = "CreateUniqueUrl";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CreateUserFromWebClientQuery extends HttpOperation {

  constructor(name = "CreateUserFromWebClient") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {CreateUserFromWebClientMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CreateUserFromWebClientMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CreateUserFromWebClientQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CreateUserFromWebClientQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CreateUserFromWebClientQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateUserFromWebClient";
/**
 * @returns {string}
 */
CreateUserFromWebClientQuery.QUERY_NAME = "CreateUserFromWebClient";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SetUserStatusQuery extends HttpOperation {

  constructor(name = "SetUserStatus") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {SetUserStatusMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SetUserStatusMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SetUserStatusQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SetUserStatusQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SetUserStatusQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SetUserStatus";
/**
 * @returns {string}
 */
SetUserStatusQuery.QUERY_NAME = "SetUserStatus";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ListFilesQuery extends HttpOperation {

  constructor(name = "ListFiles") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ListFilesMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ListFilesMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ListFilesResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ListFilesQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ListFilesQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ListFilesResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ListFilesResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ListFilesQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ListFiles";
/**
 * @returns {string}
 */
ListFilesQuery.QUERY_NAME = "ListFiles";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CurrentContextInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._sortCriteria = null;
    /**
     * @type {string}
     * @private
     */
    this._mdProp = null;
    /**
     * @type {number}
     * @private
     */
    this._order = null;

  }

    /**
   * @return {string}
   */
  getSortCriteria() {
    return this._sortCriteria;
  }

  /**
   * @param sortCriteria{string}
   * @return {CurrentContextInfo}
   */
  setSortCriteria(sortCriteria) {
    this._sortCriteria = sortCriteria;
    return this;
  }
  /**
   * @return {string}
   */
  getMdProp() {
    return this._mdProp;
  }

  /**
   * @param mdProp{string}
   * @return {CurrentContextInfo}
   */
  setMdProp(mdProp) {
    this._mdProp = mdProp;
    return this;
  }
  /**
   * @return {number}
   */
  getOrder() {
    return this._order;
  }

  /**
   * @param order{number}
   * @return {CurrentContextInfo}
   */
  setOrder(order) {
    this._order = order;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CurrentContextInfo.CLASS_ID;
    
	//Serializing _sortCriteria
	if (this._sortCriteria)
		json['sortCriteria'] = this._sortCriteria;

	//Serializing _mdProp
	if (this._mdProp)
		json['mdProp'] = this._mdProp;

	//Serializing _order
	if (this._order)
		json['order'] = this._order;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._sortCriteria = json.hasOwnProperty("sortCriteria")?json["sortCriteria"]:null;
		this._mdProp = json.hasOwnProperty("mdProp")?json["mdProp"]:null;
		this._order = json.hasOwnProperty("order")?json["order"]:0;


  }
}

/**
 * @returns {string}
 */
CurrentContextInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.CurrentContextInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ApplyFilterMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._filterName = null;

  }

    /**
   * @return {string}
   */
  getFilterName() {
    return this._filterName;
  }

  /**
   * @param filterName{string}
   * @return {ApplyFilterMsg}
   */
  setFilterName(filterName) {
    this._filterName = filterName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ApplyFilterMsg.CLASS_ID;
    
	//Serializing _filterName
	if (this._filterName)
		json['filterName'] = this._filterName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._filterName = json.hasOwnProperty("filterName")?json["filterName"]:null;


  }
}

/**
 * @returns {string}
 */
ApplyFilterMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ApplyFilterMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SetCollectionMetadataForWebClientQuery extends HttpOperation {

  constructor(name = "SetCollectionMetadataForWebClient") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SetCollectionMetadataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SetCollectionMetadataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SetCollectionMetadataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SetCollectionMetadataForWebClientQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SetCollectionMetadataForWebClientQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SetCollectionMetadataForWebClientQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionMetadataForWebClient";
/**
 * @returns {string}
 */
SetCollectionMetadataForWebClientQuery.QUERY_NAME = "SetCollectionMetadataForWebClient";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateLiveDrawMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._tmpSvgId = null;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {LiveDrawEntry}
     * @private
     */
    this._liveDrawEntry = null;

  }

    /**
   * @return {string}
   */
  getTmpSvgId() {
    return this._tmpSvgId;
  }

  /**
   * @param tmpSvgId{string}
   * @return {CreateLiveDrawMessage}
   */
  setTmpSvgId(tmpSvgId) {
    this._tmpSvgId = tmpSvgId;
    return this;
  }
  /**
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {CreateLiveDrawMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * @return {LiveDrawEntry}
   */
  getLiveDrawEntry() {
    return this._liveDrawEntry;
  }

  /**
   * @param liveDrawEntry{LiveDrawEntry}
   * @return {CreateLiveDrawMessage}
   */
  setLiveDrawEntry(liveDrawEntry) {
    this._liveDrawEntry = liveDrawEntry;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateLiveDrawMessage.CLASS_ID;
    
	//Serializing _tmpSvgId
	if (this._tmpSvgId)
		json['tmpSvgId'] = this._tmpSvgId;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._liveDrawEntry)
		json['liveDrawEntry'] = this._liveDrawEntry.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._tmpSvgId = json.hasOwnProperty("tmpSvgId")?json["tmpSvgId"]:null;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("liveDrawEntry")){
			if (!this._liveDrawEntry && this._liveDrawEntry == null)
				this._liveDrawEntry = new LiveDrawEntry();
			this._liveDrawEntry.deserializeJson(json.hasOwnProperty("liveDrawEntry") ? json["liveDrawEntry"] : null);
		}



  }
}

/**
 * @returns {string}
 */
CreateLiveDrawMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateLiveDrawMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class KeyValuePair {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {string}
     * @private
     */
    this._key = null;

  }

    /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {KeyValuePair}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {string}
   */
  getKey() {
    return this._key;
  }

  /**
   * @param key{string}
   * @return {KeyValuePair}
   */
  setKey(key) {
    this._key = key;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = KeyValuePair.CLASS_ID;
    
	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing _key
	if (this._key)
		json['key'] = this._key;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._value = json.hasOwnProperty("value")?json["value"]:null;
		this._key = json.hasOwnProperty("key")?json["key"]:null;


  }
}

/**
 * @returns {string}
 */
KeyValuePair.CLASS_ID = "com.zoom.vab.client.autogenerated.KeyValuePair";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class RequestOTPForLoginResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {RequestOTPForLoginResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = RequestOTPForLoginResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
RequestOTPForLoginResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.RequestOTPForLoginResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ExportAssetMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._action = null;
    /**
     * @type {Array<FuidBidRrnExportInfo>}
     * @private
     */
    this._fuidBidRrnExportInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._properties = null;

  }

    /**
   * @return {string}
   */
  getAction() {
    return this._action;
  }

  /**
   * @param action{string}
   * @return {ExportAssetMessage}
   */
  setAction(action) {
    this._action = action;
    return this;
  }
  /**
   * @return {Array<FuidBidRrnExportInfo>}
   */
  getFuidBidRrnExportInfo() {
    return this._fuidBidRrnExportInfo;
  }

  /**
   * @param fuidBidRrnExportInfo{Array<FuidBidRrnExportInfo>}
   * @return {ExportAssetMessage}
   */
  setFuidBidRrnExportInfo(fuidBidRrnExportInfo) {
    this._fuidBidRrnExportInfo = fuidBidRrnExportInfo;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getProperties() {
    return this._properties;
  }

  /**
   * @param properties{java.util.Map<String,String>}
   * @return {ExportAssetMessage}
   */
  setProperties(properties) {
    this._properties = properties;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ExportAssetMessage.CLASS_ID;
    
	//Serializing _action
	if (this._action)
		json['action'] = this._action;
  if (this._fuidBidRrnExportInfo && this._fuidBidRrnExportInfo.length > 0) {
    let fuidBidRrnExportInfo_JSON = [];
    /**
     * @type {FuidBidRrnExportInfo}
     */
    this._fuidBidRrnExportInfo.forEach((o854) => {
      if (o854) {
        if (o854.serializeJson && (typeof (o854.serializeJson) === 'function')) {
          fuidBidRrnExportInfo_JSON.push(o854.serializeJson());
        } else {
          fuidBidRrnExportInfo_JSON.push(o854);
        }
      }
    });
    json['fuidBidRrnExportInfo'] = fuidBidRrnExportInfo_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"properties", this._properties);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._action = json.hasOwnProperty("action")?json["action"]:null;
		//set of type FuidBidRrnExportInfo
		this._fuidBidRrnExportInfo = [];
		let fuidBidRrnExportInfoJSONArray = json.hasOwnProperty("fuidBidRrnExportInfo") ? json["fuidBidRrnExportInfo"] : [];

		fuidBidRrnExportInfoJSONArray.forEach((o855)=>{
			if (o855){
				let classObj = new FuidBidRrnExportInfo();
				classObj.deserializeJson(o855);
				this._fuidBidRrnExportInfo.push(classObj);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._properties == null)
			this._properties = new HashMap();
		this._properties.clear();
		let propertiesJSONArray = json.hasOwnProperty("properties") ? json["properties"] : [];
		this._properties = SerializationUtil.deserializeMap(propertiesJSONArray);



  }
}

/**
 * @returns {string}
 */
ExportAssetMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ExportAssetMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SimpleResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._message = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {SimpleResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {SimpleResponse}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SimpleResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._message = json.hasOwnProperty("message")?json["message"]:null;


  }
}

/**
 * @returns {string}
 */
SimpleResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SimpleResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FuidBidInfoJson {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._localPath = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;

  }

    /**
   * @return {string}
   */
  getLocalPath() {
    return this._localPath;
  }

  /**
   * @param localPath{string}
   * @return {FuidBidInfoJson}
   */
  setLocalPath(localPath) {
    this._localPath = localPath;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {FuidBidInfoJson}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FuidBidInfoJson}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FuidBidInfoJson}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FuidBidInfoJson.CLASS_ID;
    
	//Serializing _localPath
	if (this._localPath)
		json['localPath'] = this._localPath;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._localPath = json.hasOwnProperty("localPath")?json["localPath"]:null;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;


  }
}

/**
 * @returns {string}
 */
FuidBidInfoJson.CLASS_ID = "com.zoom.vab.client.autogenerated.FuidBidInfoJson";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SaveLinkQuery extends HttpOperation {

  constructor(name = "SaveLink") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SaveLinkMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SaveLinkMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetLinkSharingPermissionsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SaveLinkQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SaveLinkQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetLinkSharingPermissionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetLinkSharingPermissionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SaveLinkQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveLink";
/**
 * @returns {string}
 */
SaveLinkQuery.QUERY_NAME = "SaveLink";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MessageMap {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._hasDefault = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._properties = null;

  }

    /**
   * @return {boolean}
   */
  isHasDefault() {
    return this._hasDefault;
  }

  /**
   * @param hasDefault{boolean}
   * @return {MessageMap}
   */
  setHasDefault(hasDefault) {
    this._hasDefault = hasDefault;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getProperties() {
    return this._properties;
  }

  /**
   * @param properties{java.util.Map<String,String>}
   * @return {MessageMap}
   */
  setProperties(properties) {
    this._properties = properties;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MessageMap.CLASS_ID;
    
	//Serializing _hasDefault
	if (this._hasDefault)
		json['hasDefault'] = this._hasDefault;
    SerializationUtil.serializeHashMap(json,"properties", this._properties);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._hasDefault = json.hasOwnProperty("hasDefault")?json["hasDefault"]:false;
//Map of type STRING. Decode as tree:false
		if (this._properties == null)
			this._properties = new HashMap();
		this._properties.clear();
		let propertiesJSONArray = json.hasOwnProperty("properties") ? json["properties"] : [];
		this._properties = SerializationUtil.deserializeMap(propertiesJSONArray);



  }
}

/**
 * @returns {string}
 */
MessageMap.CLASS_ID = "com.zoom.vab.client.autogenerated.MessageMap";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditOwnerQuery extends HttpOperation {

  constructor(name = "EditOwner") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EditOwnerMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditOwnerMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {EditOwnerResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditOwnerQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditOwnerQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new EditOwnerResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new EditOwnerResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditOwnerQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditOwner";
/**
 * @returns {string}
 */
EditOwnerQuery.QUERY_NAME = "EditOwner";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetFileReferencesQuery extends HttpOperation {

  constructor(name = "GetFileReferences") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FileReferenceArg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FileReferenceArg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetFileReferencesResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetFileReferencesQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetFileReferencesQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetFileReferencesResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetFileReferencesResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetFileReferencesQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFileReferences";
/**
 * @returns {string}
 */
GetFileReferencesQuery.QUERY_NAME = "GetFileReferences";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SaveDrawingAnnotationsQuery extends HttpOperation {

  constructor(name = "SaveDrawingAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SaveDrawingAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SaveDrawingAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SaveDrawingAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SaveDrawingAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SaveDrawingAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SaveDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SaveDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SaveDrawingAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveDrawingAnnotations";
/**
 * @returns {string}
 */
SaveDrawingAnnotationsQuery.QUERY_NAME = "SaveDrawingAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class NodeArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._startAfter = null;
    /**
     * @type {string}
     * @private
     */
    this._storageType = null;
    /**
     * @type {boolean}
     * @private
     */
    this._refresh = false;
    /**
     * @type {string}
     * @private
     */
    this._key = null;
    /**
     * @type {string}
     * @private
     */
    this._storageName = null;

  }

    /**
   * @return {string}
   */
  getStartAfter() {
    return this._startAfter;
  }

  /**
   * @param startAfter{string}
   * @return {NodeArgs}
   */
  setStartAfter(startAfter) {
    this._startAfter = startAfter;
    return this;
  }
  /**
   * @return {string}
   */
  getStorageType() {
    return this._storageType;
  }

  /**
   * @param storageType{string}
   * @return {NodeArgs}
   */
  setStorageType(storageType) {
    this._storageType = storageType;
    return this;
  }
  /**
   * @return {boolean}
   */
  isRefresh() {
    return this._refresh;
  }

  /**
   * @param refresh{boolean}
   * @return {NodeArgs}
   */
  setRefresh(refresh) {
    this._refresh = refresh;
    return this;
  }
  /**
   * @return {string}
   */
  getKey() {
    return this._key;
  }

  /**
   * @param key{string}
   * @return {NodeArgs}
   */
  setKey(key) {
    this._key = key;
    return this;
  }
  /**
   * @return {string}
   */
  getStorageName() {
    return this._storageName;
  }

  /**
   * @param storageName{string}
   * @return {NodeArgs}
   */
  setStorageName(storageName) {
    this._storageName = storageName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = NodeArgs.CLASS_ID;
    
	//Serializing _startAfter
	if (this._startAfter)
		json['startAfter'] = this._startAfter;

	//Serializing _storageType
	if (this._storageType)
		json['storageType'] = this._storageType;

	//Serializing _refresh
	if (this._refresh)
		json['refresh'] = this._refresh;

	//Serializing _key
	if (this._key)
		json['key'] = this._key;

	//Serializing _storageName
	if (this._storageName)
		json['storageName'] = this._storageName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._startAfter = json.hasOwnProperty("startAfter")?json["startAfter"]:null;
		this._storageType = json.hasOwnProperty("storageType")?json["storageType"]:null;
		this._refresh = json.hasOwnProperty("refresh")?json["refresh"]:false;
		this._key = json.hasOwnProperty("key")?json["key"]:null;
		this._storageName = json.hasOwnProperty("storageName")?json["storageName"]:null;


  }
}

/**
 * @returns {string}
 */
NodeArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.NodeArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetRevisionsOfCollectionAssetQuery extends HttpOperation {

  constructor(name = "GetRevisionsOfCollectionAsset") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetRevisionsOfCollectionAssetMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetRevisionsOfCollectionAssetMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetRevisionsOfCollectionAssetResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetRevisionsOfCollectionAssetQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetRevisionsOfCollectionAssetQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetRevisionsOfCollectionAssetResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetRevisionsOfCollectionAssetResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetRevisionsOfCollectionAssetQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetRevisionsOfCollectionAsset";
/**
 * @returns {string}
 */
GetRevisionsOfCollectionAssetQuery.QUERY_NAME = "GetRevisionsOfCollectionAsset";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class BasicFileAttributes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._file = false;
    /**
     * @type {string}
     * @private
     */
    this._fileIcon = null;
    /**
     * @type {number}
     * @private
     */
    this._length = null;
    /**
     * @type {string}
     * @private
     */
    this._mediaType = null;

  }

    /**
   * @return {boolean}
   */
  isFile() {
    return this._file;
  }

  /**
   * @param file{boolean}
   * @return {BasicFileAttributes}
   */
  setFile(file) {
    this._file = file;
    return this;
  }
  /**
   * @return {string}
   */
  getFileIcon() {
    return this._fileIcon;
  }

  /**
   * @param fileIcon{string}
   * @return {BasicFileAttributes}
   */
  setFileIcon(fileIcon) {
    this._fileIcon = fileIcon;
    return this;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this._length;
  }

  /**
   * @param length{number}
   * @return {BasicFileAttributes}
   */
  setLength(length) {
    this._length = length;
    return this;
  }
  /**
   * @return {string}
   */
  getMediaType() {
    return this._mediaType;
  }

  /**
   * @param mediaType{string}
   * @return {BasicFileAttributes}
   */
  setMediaType(mediaType) {
    this._mediaType = mediaType;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = BasicFileAttributes.CLASS_ID;
    
	//Serializing _file
	if (this._file)
		json['file'] = this._file;

	//Serializing _fileIcon
	if (this._fileIcon)
		json['fileIcon'] = this._fileIcon;

	//Serializing _length
	if (this._length)
		json['length'] = this._length;

	//Serializing _mediaType
	if (this._mediaType)
		json['mediaType'] = this._mediaType;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._file = json.hasOwnProperty("file")?json["file"]:false;
		this._fileIcon = json.hasOwnProperty("fileIcon")?json["fileIcon"]:null;
		this._length = json.hasOwnProperty("length")?json["length"]:0;
		this._mediaType = json.hasOwnProperty("mediaType")?json["mediaType"]:null;


  }
}

/**
 * @returns {string}
 */
BasicFileAttributes.CLASS_ID = "com.zoom.vab.client.autogenerated.BasicFileAttributes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetImageAiDataMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._fuid = null;

  }

    /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {GetImageAiDataMessage}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetImageAiDataMessage.CLASS_ID;
    
	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;


  }
}

/**
 * @returns {string}
 */
GetImageAiDataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetImageAiDataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FuidBidRrnExportInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._preset = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._presetProperties = null;

  }

    /**
   * @return {string}
   */
  getPreset() {
    return this._preset;
  }

  /**
   * @param preset{string}
   * @return {FuidBidRrnExportInfo}
   */
  setPreset(preset) {
    this._preset = preset;
    return this;
  }
  /**
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {FuidBidRrnExportInfo}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getPresetProperties() {
    return this._presetProperties;
  }

  /**
   * @param presetProperties{java.util.Map<String,String>}
   * @return {FuidBidRrnExportInfo}
   */
  setPresetProperties(presetProperties) {
    this._presetProperties = presetProperties;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FuidBidRrnExportInfo.CLASS_ID;
    
	//Serializing _preset
	if (this._preset)
		json['preset'] = this._preset;

	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		    SerializationUtil.serializeHashMap(json,"presetProperties", this._presetProperties);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._preset = json.hasOwnProperty("preset")?json["preset"]:null;
		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

//Map of type STRING. Decode as tree:false
		if (this._presetProperties == null)
			this._presetProperties = new HashMap();
		this._presetProperties.clear();
		let presetPropertiesJSONArray = json.hasOwnProperty("presetProperties") ? json["presetProperties"] : [];
		this._presetProperties = SerializationUtil.deserializeMap(presetPropertiesJSONArray);



  }
}

/**
 * @returns {string}
 */
FuidBidRrnExportInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.FuidBidRrnExportInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AssetLinkDetails {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isLinkTo = false;
    /**
     * @type {RepoItem}
     * @private
     */
    this._repoItem = null;

  }

    /**
   * true - means 'Link To' and false- menas 'Link From'
   * @return {boolean}
   */
  isIsLinkTo() {
    return this._isLinkTo;
  }

  /**
   * @param isLinkTo{boolean}
   * @return {AssetLinkDetails}
   */
  setIsLinkTo(isLinkTo) {
    this._isLinkTo = isLinkTo;
    return this;
  }
  /**
   * @return {RepoItem}
   */
  getRepoItem() {
    return this._repoItem;
  }

  /**
   * @param repoItem{RepoItem}
   * @return {AssetLinkDetails}
   */
  setRepoItem(repoItem) {
    this._repoItem = repoItem;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AssetLinkDetails.CLASS_ID;
    
	//Serializing _isLinkTo
	if (this._isLinkTo)
		json['isLinkTo'] = this._isLinkTo;

	//Serializing ComplexType _$arrayName
	if (this._repoItem)
		json['repoItem'] = this._repoItem.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isLinkTo = json.hasOwnProperty("isLinkTo")?json["isLinkTo"]:false;
		if (json.hasOwnProperty("repoItem")){
			if (!this._repoItem && this._repoItem == null)
				this._repoItem = new RepoItem();
			this._repoItem.deserializeJson(json.hasOwnProperty("repoItem") ? json["repoItem"] : null);
		}



  }
}

/**
 * @returns {string}
 */
AssetLinkDetails.CLASS_ID = "com.zoom.vab.client.autogenerated.AssetLinkDetails";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionEntry {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._matchType = null;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {number}
   */
  getMatchType() {
    return this._matchType;
  }

  /**
   * @param matchType{number}
   * @return {CollectionEntry}
   */
  setMatchType(matchType) {
    this._matchType = matchType;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {CollectionEntry}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {CollectionEntry}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionEntry.CLASS_ID;
    
	//Serializing _matchType
	if (this._matchType)
		json['matchType'] = this._matchType;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._matchType = json.hasOwnProperty("matchType")?json["matchType"]:0;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
CollectionEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteDrawingAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {DeleteDrawingAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteDrawingAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;


  }
}

/**
 * @returns {string}
 */
DeleteDrawingAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteDrawingAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AutoCompleteUserRequest {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._onlyInternalUsers = false;
    /**
     * @type {string}
     * @private
     */
    this._prefix = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyEmails = false;

  }

    /**
   * @return {boolean}
   */
  isOnlyInternalUsers() {
    return this._onlyInternalUsers;
  }

  /**
   * @param onlyInternalUsers{boolean}
   * @return {AutoCompleteUserRequest}
   */
  setOnlyInternalUsers(onlyInternalUsers) {
    this._onlyInternalUsers = onlyInternalUsers;
    return this;
  }
  /**
   * @return {string}
   */
  getPrefix() {
    return this._prefix;
  }

  /**
   * @param prefix{string}
   * @return {AutoCompleteUserRequest}
   */
  setPrefix(prefix) {
    this._prefix = prefix;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {AutoCompleteUserRequest}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyEmails() {
    return this._onlyEmails;
  }

  /**
   * @param onlyEmails{boolean}
   * @return {AutoCompleteUserRequest}
   */
  setOnlyEmails(onlyEmails) {
    this._onlyEmails = onlyEmails;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AutoCompleteUserRequest.CLASS_ID;
    
	//Serializing _onlyInternalUsers
	if (this._onlyInternalUsers)
		json['onlyInternalUsers'] = this._onlyInternalUsers;

	//Serializing _prefix
	if (this._prefix)
		json['prefix'] = this._prefix;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _onlyEmails
	if (this._onlyEmails)
		json['onlyEmails'] = this._onlyEmails;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._onlyInternalUsers = json.hasOwnProperty("onlyInternalUsers")?json["onlyInternalUsers"]:false;
		this._prefix = json.hasOwnProperty("prefix")?json["prefix"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._onlyEmails = json.hasOwnProperty("onlyEmails")?json["onlyEmails"]:false;


  }
}

/**
 * @returns {string}
 */
AutoCompleteUserRequest.CLASS_ID = "com.zoom.vab.client.autogenerated.AutoCompleteUserRequest";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetCollectionSettingsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {SetCollectionSettingsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetCollectionSettingsResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
SetCollectionSettingsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionSettingsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveSettingsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._resetAll = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._settings = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._globalSettings = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._tpmPaths = null;

  }

    /**
   * @return {boolean}
   */
  isResetAll() {
    return this._resetAll;
  }

  /**
   * @param resetAll{boolean}
   * @return {SaveSettingsMessage}
   */
  setResetAll(resetAll) {
    this._resetAll = resetAll;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getSettings() {
    return this._settings;
  }

  /**
   * @param settings{java.util.Map<String,String>}
   * @return {SaveSettingsMessage}
   */
  setSettings(settings) {
    this._settings = settings;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getGlobalSettings() {
    return this._globalSettings;
  }

  /**
   * @param globalSettings{java.util.Map<String,String>}
   * @return {SaveSettingsMessage}
   */
  setGlobalSettings(globalSettings) {
    this._globalSettings = globalSettings;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getTpmPaths() {
    return this._tpmPaths;
  }

  /**
   * @param tpmPaths{java.util.Map<String,String>}
   * @return {SaveSettingsMessage}
   */
  setTpmPaths(tpmPaths) {
    this._tpmPaths = tpmPaths;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveSettingsMessage.CLASS_ID;
    
	//Serializing _resetAll
	if (this._resetAll)
		json['resetAll'] = this._resetAll;
    SerializationUtil.serializeHashMap(json,"settings", this._settings);
		    SerializationUtil.serializeHashMap(json,"globalSettings", this._globalSettings);
		    SerializationUtil.serializeHashMap(json,"tpmPaths", this._tpmPaths);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._resetAll = json.hasOwnProperty("resetAll")?json["resetAll"]:false;
//Map of type STRING. Decode as tree:false
		if (this._settings == null)
			this._settings = new HashMap();
		this._settings.clear();
		let settingsJSONArray = json.hasOwnProperty("settings") ? json["settings"] : [];
		this._settings = SerializationUtil.deserializeMap(settingsJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._globalSettings == null)
			this._globalSettings = new HashMap();
		this._globalSettings.clear();
		let globalSettingsJSONArray = json.hasOwnProperty("globalSettings") ? json["globalSettings"] : [];
		this._globalSettings = SerializationUtil.deserializeMap(globalSettingsJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._tpmPaths == null)
			this._tpmPaths = new HashMap();
		this._tpmPaths.clear();
		let tpmPathsJSONArray = json.hasOwnProperty("tpmPaths") ? json["tpmPaths"] : [];
		this._tpmPaths = SerializationUtil.deserializeMap(tpmPathsJSONArray);



  }
}

/**
 * @returns {string}
 */
SaveSettingsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveSettingsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class TimeCode {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._startTime = null;
    /**
     * @type {number}
     * @private
     */
    this._endTime = null;

  }

    /**
   * @return {number}
   */
  getStartTime() {
    return this._startTime;
  }

  /**
   * @param startTime{number}
   * @return {TimeCode}
   */
  setStartTime(startTime) {
    this._startTime = startTime;
    return this;
  }
  /**
   * @return {number}
   */
  getEndTime() {
    return this._endTime;
  }

  /**
   * @param endTime{number}
   * @return {TimeCode}
   */
  setEndTime(endTime) {
    this._endTime = endTime;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TimeCode.CLASS_ID;
    
	//Serializing _startTime
	if (this._startTime)
		json['startTime'] = this._startTime;

	//Serializing _endTime
	if (this._endTime)
		json['endTime'] = this._endTime;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._startTime = json.hasOwnProperty("startTime")?json["startTime"]:0;
		this._endTime = json.hasOwnProperty("endTime")?json["endTime"]:0;


  }
}

/**
 * @returns {string}
 */
TimeCode.CLASS_ID = "com.zoom.vab.client.autogenerated.TimeCode";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AddFavItemsResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2FavItemObject = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {AddFavItemsResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {java.util.Map<number,FavItemDetail>}
   */
  getFuid2FavItemObject() {
    return this._fuid2FavItemObject;
  }

  /**
   * @param fuid2FavItemObject{java.util.Map<number,FavItemDetail>}
   * @return {AddFavItemsResp}
   */
  setFuid2FavItemObject(fuid2FavItemObject) {
    this._fuid2FavItemObject = fuid2FavItemObject;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AddFavItemsResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
    SerializationUtil.serializeHashMap(json,"fuid2FavItemObject", this._fuid2FavItemObject);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
//Map of type INT. Decode as tree:false
		if (this._fuid2FavItemObject == null)
			this._fuid2FavItemObject = new HashMap();
		this._fuid2FavItemObject.clear();
		let fuid2FavItemObjectJSONArray = json.hasOwnProperty("fuid2FavItemObject") ? json["fuid2FavItemObject"] : [];
		this._fuid2FavItemObject = SerializationUtil.deserializeMap(fuid2FavItemObjectJSONArray);



  }
}

/**
 * @returns {string}
 */
AddFavItemsResp.CLASS_ID = "com.zoom.vab.client.autogenerated.AddFavItemsResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ArchiveDetailsQuery extends HttpOperation {

  constructor(name = "ArchiveDetails") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ArchiveDetailsArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ArchiveDetailsArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ArchiveDetailsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ArchiveDetailsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ArchiveDetailsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ArchiveDetailsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ArchiveDetailsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ArchiveDetailsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveDetails";
/**
 * @returns {string}
 */
ArchiveDetailsQuery.QUERY_NAME = "ArchiveDetails";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class UniqueUrlPurposeConstants {

  constructor() {
    
    
  }

  
	/**
	* @type {string}
	*/
	static get ASSETS(){
		return "ASSETS";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION(){
		return "COLLECTION";

	}

	/**
	* @type {string}
	*/
	static get LIGHTBOX(){
		return "LIGHTBOX";

	}


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UniqueUrlPurposeConstants.CLASS_ID;
    

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    

  }
}

/**
 * @returns {string}
 */
UniqueUrlPurposeConstants.CLASS_ID = "com.zoom.vab.client.autogenerated.UniqueUrlPurposeConstants";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditMetadataQuery extends HttpOperation {

  constructor(name = "EditMetadata") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EditMetadataMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditMetadataMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {EditMetadataRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditMetadataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditMetadataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new EditMetadataRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new EditMetadataRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditMetadataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditMetadata";
/**
 * @returns {string}
 */
EditMetadataQuery.QUERY_NAME = "EditMetadata";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class TemporalLocation {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._frameNumber = null;
    /**
     * @type {number}
     * @private
     */
    this._timeOffsetRemPicos = null;
    /**
     * @type {number}
     * @private
     */
    this._timeOffset = null;

  }

    /**
   * page number or animation/video frame number
   * @return {number}
   */
  getFrameNumber() {
    return this._frameNumber;
  }

  /**
   * @param frameNumber{number}
   * @return {TemporalLocation}
   */
  setFrameNumber(frameNumber) {
    this._frameNumber = frameNumber;
    return this;
  }
  /**
   * optional: contains timeOffset remainder in picoseconds, in case of High FPS videos with high time resolution
   * @return {number}
   */
  getTimeOffsetRemPicos() {
    return this._timeOffsetRemPicos;
  }

  /**
   * @param timeOffsetRemPicos{number}
   * @return {TemporalLocation}
   */
  setTimeOffsetRemPicos(timeOffsetRemPicos) {
    this._timeOffsetRemPicos = timeOffsetRemPicos;
    return this;
  }
  /**
   * time in milliseconds, from the start of the video.
   * @return {number}
   */
  getTimeOffset() {
    return this._timeOffset;
  }

  /**
   * @param timeOffset{number}
   * @return {TemporalLocation}
   */
  setTimeOffset(timeOffset) {
    this._timeOffset = timeOffset;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TemporalLocation.CLASS_ID;
    
	//Serializing _frameNumber
	if (this._frameNumber)
		json['frameNumber'] = this._frameNumber;

	//Serializing _timeOffsetRemPicos
	if (this._timeOffsetRemPicos)
		json['timeOffsetRemPicos'] = this._timeOffsetRemPicos;

	//Serializing _timeOffset
	if (this._timeOffset)
		json['timeOffset'] = this._timeOffset;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._frameNumber = json.hasOwnProperty("frameNumber")?json["frameNumber"]:0;
		this._timeOffsetRemPicos = json.hasOwnProperty("timeOffsetRemPicos")?json["timeOffsetRemPicos"]:0;
		this._timeOffset = json.hasOwnProperty("timeOffset")?json["timeOffset"]:0;


  }
}

/**
 * @returns {string}
 */
TemporalLocation.CLASS_ID = "com.zoom.vab.client.autogenerated.TemporalLocation";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetOnlineUsersResponse {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._userIdToLastSeenTime = null;

  }

    /**
   * @return {java.util.Map<String,Long>}
   */
  getUserIdToLastSeenTime() {
    return this._userIdToLastSeenTime;
  }

  /**
   * @param userIdToLastSeenTime{java.util.Map<String,Long>}
   * @return {GetOnlineUsersResponse}
   */
  setUserIdToLastSeenTime(userIdToLastSeenTime) {
    this._userIdToLastSeenTime = userIdToLastSeenTime;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetOnlineUsersResponse.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"userIdToLastSeenTime", this._userIdToLastSeenTime);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._userIdToLastSeenTime == null)
			this._userIdToLastSeenTime = new HashMap();
		this._userIdToLastSeenTime.clear();
		let userIdToLastSeenTimeJSONArray = json.hasOwnProperty("userIdToLastSeenTime") ? json["userIdToLastSeenTime"] : [];
		this._userIdToLastSeenTime = SerializationUtil.deserializeMap(userIdToLastSeenTimeJSONArray);



  }
}

/**
 * @returns {string}
 */
GetOnlineUsersResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetOnlineUsersResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ApproveRejectCollectionQuery extends HttpOperation {

  constructor(name = "ApproveRejectCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ApproveRejectCollectionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ApproveRejectCollectionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SimpleResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ApproveRejectCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ApproveRejectCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ApproveRejectCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ApproveRejectCollection";
/**
 * @returns {string}
 */
ApproveRejectCollectionQuery.QUERY_NAME = "ApproveRejectCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCloudCredentialsForTransferResponse {

  constructor() {
    
        /**
     * @type {Array<CloudCredentialsForTransfer>}
     * @private
     */
    this._cloudCredentials = null;

  }

    /**
   * @return {Array<CloudCredentialsForTransfer>}
   */
  getCloudCredentials() {
    return this._cloudCredentials;
  }

  /**
   * @param cloudCredentials{Array<CloudCredentialsForTransfer>}
   * @return {GetCloudCredentialsForTransferResponse}
   */
  setCloudCredentials(cloudCredentials) {
    this._cloudCredentials = cloudCredentials;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCloudCredentialsForTransferResponse.CLASS_ID;
      if (this._cloudCredentials && this._cloudCredentials.length > 0) {
    let cloudCredentials_JSON = [];
    /**
     * @type {CloudCredentialsForTransfer}
     */
    this._cloudCredentials.forEach((o1000) => {
      if (o1000) {
        if (o1000.serializeJson && (typeof (o1000.serializeJson) === 'function')) {
          cloudCredentials_JSON.push(o1000.serializeJson());
        } else {
          cloudCredentials_JSON.push(o1000);
        }
      }
    });
    json['cloudCredentials'] = cloudCredentials_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type CloudCredentialsForTransfer
		this._cloudCredentials = [];
		let cloudCredentialsJSONArray = json.hasOwnProperty("cloudCredentials") ? json["cloudCredentials"] : [];

		cloudCredentialsJSONArray.forEach((o1001)=>{
			if (o1001){
				let classObj = new CloudCredentialsForTransfer();
				classObj.deserializeJson(o1001);
				this._cloudCredentials.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetCloudCredentialsForTransferResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCloudCredentialsForTransferResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ApplyFilterResp {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._searchString = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {FilesResponseData}
     * @private
     */
    this._filesResponseData = null;

  }

    /**
   * @return {string}
   */
  getSearchString() {
    return this._searchString;
  }

  /**
   * @param searchString{string}
   * @return {ApplyFilterResp}
   */
  setSearchString(searchString) {
    this._searchString = searchString;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {ApplyFilterResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {FilesResponseData}
   */
  getFilesResponseData() {
    return this._filesResponseData;
  }

  /**
   * @param filesResponseData{FilesResponseData}
   * @return {ApplyFilterResp}
   */
  setFilesResponseData(filesResponseData) {
    this._filesResponseData = filesResponseData;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ApplyFilterResp.CLASS_ID;
    
	//Serializing _searchString
	if (this._searchString)
		json['searchString'] = this._searchString;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing ComplexType _$arrayName
	if (this._filesResponseData)
		json['filesResponseData'] = this._filesResponseData.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._searchString = json.hasOwnProperty("searchString")?json["searchString"]:null;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		if (json.hasOwnProperty("filesResponseData")){
			if (!this._filesResponseData && this._filesResponseData == null)
				this._filesResponseData = new FilesResponseData();
			this._filesResponseData.deserializeJson(json.hasOwnProperty("filesResponseData") ? json["filesResponseData"] : null);
		}



  }
}

/**
 * @returns {string}
 */
ApplyFilterResp.CLASS_ID = "com.zoom.vab.client.autogenerated.ApplyFilterResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FlexSmartShareResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._targetFiles = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexSmartShareResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {FlexSmartShareResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getTargetFiles() {
    return this._targetFiles;
  }

  /**
   * @param targetFiles{Array<String>}
   * @return {FlexSmartShareResponse}
   */
  setTargetFiles(targetFiles) {
    this._targetFiles = targetFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexSmartShareResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;
  if (this._targetFiles && this._targetFiles.length > 0) {
    let targetFiles_JSON = [];
    /**
     * @type {string}
     */
    this._targetFiles.forEach((o286) => {
      if (o286) {
        if (o286.serializeJson && (typeof (o286.serializeJson) === 'function')) {
          targetFiles_JSON.push(o286.serializeJson());
        } else {
          targetFiles_JSON.push(o286);
        }
      }
    });
    json['targetFiles'] = targetFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		//set of type string
		this._targetFiles = [];
		let targetFilesJSONArray = json.hasOwnProperty("targetFiles") ? json["targetFiles"] : [];

		targetFilesJSONArray.forEach((o287)=>{
			if (o287){
				this._targetFiles.push(o287);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexSmartShareResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartShareResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionUsersInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._privateLink = null;
    /**
     * @type {Array<CollectionUserEntry>}
     * @private
     */
    this._collectionUsers = null;

  }

    /**
   * @return {string}
   */
  getPrivateLink() {
    return this._privateLink;
  }

  /**
   * @param privateLink{string}
   * @return {CollectionUsersInfo}
   */
  setPrivateLink(privateLink) {
    this._privateLink = privateLink;
    return this;
  }
  /**
   * @return {Array<CollectionUserEntry>}
   */
  getCollectionUsers() {
    return this._collectionUsers;
  }

  /**
   * @param collectionUsers{Array<CollectionUserEntry>}
   * @return {CollectionUsersInfo}
   */
  setCollectionUsers(collectionUsers) {
    this._collectionUsers = collectionUsers;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionUsersInfo.CLASS_ID;
    
	//Serializing _privateLink
	if (this._privateLink)
		json['privateLink'] = this._privateLink;
  if (this._collectionUsers && this._collectionUsers.length > 0) {
    let collectionUsers_JSON = [];
    /**
     * @type {CollectionUserEntry}
     */
    this._collectionUsers.forEach((o688) => {
      if (o688) {
        if (o688.serializeJson && (typeof (o688.serializeJson) === 'function')) {
          collectionUsers_JSON.push(o688.serializeJson());
        } else {
          collectionUsers_JSON.push(o688);
        }
      }
    });
    json['collectionUsers'] = collectionUsers_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._privateLink = json.hasOwnProperty("privateLink")?json["privateLink"]:null;
		//set of type CollectionUserEntry
		this._collectionUsers = [];
		let collectionUsersJSONArray = json.hasOwnProperty("collectionUsers") ? json["collectionUsers"] : [];

		collectionUsersJSONArray.forEach((o689)=>{
			if (o689){
				let classObj = new CollectionUserEntry();
				classObj.deserializeJson(o689);
				this._collectionUsers.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
CollectionUsersInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionUsersInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetAwsRegionsQuery extends HttpOperation {

  constructor(name = "GetAwsRegions") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ArrayType";
  }

  /**
   * @returns {String}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{String}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ArrayCollection}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetAwsRegionsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetAwsRegionsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetAwsRegionsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAwsRegions";
/**
 * @returns {string}
 */
GetAwsRegionsQuery.QUERY_NAME = "GetAwsRegions";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FilesResponseData {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._hasDirtyFilters = false;
    /**
     * @type {boolean}
     * @private
     */
    this._noChange = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._pageNo = null;
    /**
     * @type {boolean}
     * @private
     */
    this._collectiveResponseUpToCurrentPage = false;
    /**
     * @type {number}
     * @private
     */
    this._totalFiles = null;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;
    /**
     * @type {Array<CollectionEntry>}
     * @private
     */
    this._matchedCollection = null;
    /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._resultFiles = null;
    /**
     * @type {Array<AssetEntry>}
     * @private
     */
    this._matchedAssets = null;
    /**
     * @type {Array<MetadataEntry>}
     * @private
     */
    this._matchedMetadata = null;

  }

    /**
   * @return {boolean}
   */
  isHasDirtyFilters() {
    return this._hasDirtyFilters;
  }

  /**
   * @param hasDirtyFilters{boolean}
   * @return {FilesResponseData}
   */
  setHasDirtyFilters(hasDirtyFilters) {
    this._hasDirtyFilters = hasDirtyFilters;
    return this;
  }
  /**
   * @return {boolean}
   */
  isNoChange() {
    return this._noChange;
  }

  /**
   * @param noChange{boolean}
   * @return {FilesResponseData}
   */
  setNoChange(noChange) {
    this._noChange = noChange;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FilesResponseData}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getPageNo() {
    return this._pageNo;
  }

  /**
   * @param pageNo{number}
   * @return {FilesResponseData}
   */
  setPageNo(pageNo) {
    this._pageNo = pageNo;
    return this;
  }
  /**
   * @return {boolean}
   */
  isCollectiveResponseUpToCurrentPage() {
    return this._collectiveResponseUpToCurrentPage;
  }

  /**
   * @param collectiveResponseUpToCurrentPage{boolean}
   * @return {FilesResponseData}
   */
  setCollectiveResponseUpToCurrentPage(collectiveResponseUpToCurrentPage) {
    this._collectiveResponseUpToCurrentPage = collectiveResponseUpToCurrentPage;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalFiles() {
    return this._totalFiles;
  }

  /**
   * @param totalFiles{number}
   * @return {FilesResponseData}
   */
  setTotalFiles(totalFiles) {
    this._totalFiles = totalFiles;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {FilesResponseData}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }
  /**
   * @return {Array<CollectionEntry>}
   */
  getMatchedCollection() {
    return this._matchedCollection;
  }

  /**
   * @param matchedCollection{Array<CollectionEntry>}
   * @return {FilesResponseData}
   */
  setMatchedCollection(matchedCollection) {
    this._matchedCollection = matchedCollection;
    return this;
  }

  /**
   * @return {Array<RepoItem>}
   */
  getResultFiles() {
    return this._resultFiles;
  }

  /**
   * @param resultFiles{Array<RepoItem>}
   * @return {FilesResponseData}
   */
  setResultFiles(resultFiles) {
    this._resultFiles = resultFiles;
    return this;
  }

  /**
   * @return {Array<AssetEntry>}
   */
  getMatchedAssets() {
    return this._matchedAssets;
  }

  /**
   * @param matchedAssets{Array<AssetEntry>}
   * @return {FilesResponseData}
   */
  setMatchedAssets(matchedAssets) {
    this._matchedAssets = matchedAssets;
    return this;
  }

  /**
   * @return {Array<MetadataEntry>}
   */
  getMatchedMetadata() {
    return this._matchedMetadata;
  }

  /**
   * @param matchedMetadata{Array<MetadataEntry>}
   * @return {FilesResponseData}
   */
  setMatchedMetadata(matchedMetadata) {
    this._matchedMetadata = matchedMetadata;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FilesResponseData.CLASS_ID;
    
	//Serializing _hasDirtyFilters
	if (this._hasDirtyFilters)
		json['hasDirtyFilters'] = this._hasDirtyFilters;

	//Serializing _noChange
	if (this._noChange)
		json['noChange'] = this._noChange;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _pageNo
	if (this._pageNo)
		json['pageNo'] = this._pageNo;

	//Serializing _collectiveResponseUpToCurrentPage
	if (this._collectiveResponseUpToCurrentPage)
		json['collectiveResponseUpToCurrentPage'] = this._collectiveResponseUpToCurrentPage;

	//Serializing _totalFiles
	if (this._totalFiles)
		json['totalFiles'] = this._totalFiles;

	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		  if (this._matchedCollection && this._matchedCollection.length > 0) {
    let matchedCollection_JSON = [];
    /**
     * @type {CollectionEntry}
     */
    this._matchedCollection.forEach((o84) => {
      if (o84) {
        if (o84.serializeJson && (typeof (o84.serializeJson) === 'function')) {
          matchedCollection_JSON.push(o84.serializeJson());
        } else {
          matchedCollection_JSON.push(o84);
        }
      }
    });
    json['matchedCollection'] = matchedCollection_JSON;
  }  
  if (this._resultFiles && this._resultFiles.length > 0) {
    let resultFiles_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._resultFiles.forEach((o87) => {
      if (o87) {
        if (o87.serializeJson && (typeof (o87.serializeJson) === 'function')) {
          resultFiles_JSON.push(o87.serializeJson());
        } else {
          resultFiles_JSON.push(o87);
        }
      }
    });
    json['resultFiles'] = resultFiles_JSON;
  }  
  if (this._matchedAssets && this._matchedAssets.length > 0) {
    let matchedAssets_JSON = [];
    /**
     * @type {AssetEntry}
     */
    this._matchedAssets.forEach((o90) => {
      if (o90) {
        if (o90.serializeJson && (typeof (o90.serializeJson) === 'function')) {
          matchedAssets_JSON.push(o90.serializeJson());
        } else {
          matchedAssets_JSON.push(o90);
        }
      }
    });
    json['matchedAssets'] = matchedAssets_JSON;
  }  
  if (this._matchedMetadata && this._matchedMetadata.length > 0) {
    let matchedMetadata_JSON = [];
    /**
     * @type {MetadataEntry}
     */
    this._matchedMetadata.forEach((o93) => {
      if (o93) {
        if (o93.serializeJson && (typeof (o93.serializeJson) === 'function')) {
          matchedMetadata_JSON.push(o93.serializeJson());
        } else {
          matchedMetadata_JSON.push(o93);
        }
      }
    });
    json['matchedMetadata'] = matchedMetadata_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._hasDirtyFilters = json.hasOwnProperty("hasDirtyFilters")?json["hasDirtyFilters"]:false;
		this._noChange = json.hasOwnProperty("noChange")?json["noChange"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._pageNo = json.hasOwnProperty("pageNo")?json["pageNo"]:0;
		this._collectiveResponseUpToCurrentPage = json.hasOwnProperty("collectiveResponseUpToCurrentPage")?json["collectiveResponseUpToCurrentPage"]:false;
		this._totalFiles = json.hasOwnProperty("totalFiles")?json["totalFiles"]:0;
		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}

		//set of type CollectionEntry
		this._matchedCollection = [];
		let matchedCollectionJSONArray = json.hasOwnProperty("matchedCollection") ? json["matchedCollection"] : [];

		matchedCollectionJSONArray.forEach((o85)=>{
			if (o85){
				let classObj = new CollectionEntry();
				classObj.deserializeJson(o85);
				this._matchedCollection.push(classObj);
			}
		});
		//set of type RepoItem
		this._resultFiles = [];
		let resultFilesJSONArray = json.hasOwnProperty("resultFiles") ? json["resultFiles"] : [];

		resultFilesJSONArray.forEach((o88)=>{
			if (o88){
				let classObj = new RepoItem();
				classObj.deserializeJson(o88);
				this._resultFiles.push(classObj);
			}
		});
		//set of type AssetEntry
		this._matchedAssets = [];
		let matchedAssetsJSONArray = json.hasOwnProperty("matchedAssets") ? json["matchedAssets"] : [];

		matchedAssetsJSONArray.forEach((o91)=>{
			if (o91){
				let classObj = new AssetEntry();
				classObj.deserializeJson(o91);
				this._matchedAssets.push(classObj);
			}
		});
		//set of type MetadataEntry
		this._matchedMetadata = [];
		let matchedMetadataJSONArray = json.hasOwnProperty("matchedMetadata") ? json["matchedMetadata"] : [];

		matchedMetadataJSONArray.forEach((o94)=>{
			if (o94){
				let classObj = new MetadataEntry();
				classObj.deserializeJson(o94);
				this._matchedMetadata.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FilesResponseData.CLASS_ID = "com.zoom.vab.client.autogenerated.FilesResponseData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetMetadataHelpQueryRes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {Array<String>}
     * @private
     */
    this._entries = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetMetadataHelpQueryRes}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getEntries() {
    return this._entries;
  }

  /**
   * @param entries{Array<String>}
   * @return {GetMetadataHelpQueryRes}
   */
  setEntries(entries) {
    this._entries = entries;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetMetadataHelpQueryRes.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
  if (this._entries && this._entries.length > 0) {
    let entries_JSON = [];
    /**
     * @type {string}
     */
    this._entries.forEach((o363) => {
      if (o363) {
        if (o363.serializeJson && (typeof (o363.serializeJson) === 'function')) {
          entries_JSON.push(o363.serializeJson());
        } else {
          entries_JSON.push(o363);
        }
      }
    });
    json['entries'] = entries_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		//set of type string
		this._entries = [];
		let entriesJSONArray = json.hasOwnProperty("entries") ? json["entries"] : [];

		entriesJSONArray.forEach((o364)=>{
			if (o364){
				this._entries.push(o364);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetMetadataHelpQueryRes.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadataHelpQueryRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ListFilesMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._useCacheOnly = false;
    /**
     * @type {number}
     * @private
     */
    this._pageLimit = null;
    /**
     * @type {number}
     * @private
     */
    this._maxRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._force = false;
    /**
     * @type {FileFilters}
     * @private
     */
    this._fileFilters = null;
    /**
     * @type {PageRequestData}
     * @private
     */
    this._pageRequestData = null;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;

  }

    /**
   * @return {boolean}
   */
  isUseCacheOnly() {
    return this._useCacheOnly;
  }

  /**
   * @param useCacheOnly{boolean}
   * @return {ListFilesMessage}
   */
  setUseCacheOnly(useCacheOnly) {
    this._useCacheOnly = useCacheOnly;
    return this;
  }
  /**
   * Page size needed.
   * @return {number}
   */
  getPageLimit() {
    return this._pageLimit;
  }

  /**
   * @param pageLimit{number}
   * @return {ListFilesMessage}
   */
  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }
  /**
   * Send response only if higher max rrn is available.
   * @return {number}
   */
  getMaxRrn() {
    return this._maxRrn;
  }

  /**
   * @param maxRrn{number}
   * @return {ListFilesMessage}
   */
  setMaxRrn(maxRrn) {
    this._maxRrn = maxRrn;
    return this;
  }
  /**
   * Folder fuid whole kids have to fetched.
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {ListFilesMessage}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isForce() {
    return this._force;
  }

  /**
   * @param force{boolean}
   * @return {ListFilesMessage}
   */
  setForce(force) {
    this._force = force;
    return this;
  }
  /**
   * For filtering the results
   * @return {FileFilters}
   */
  getFileFilters() {
    return this._fileFilters;
  }

  /**
   * @param fileFilters{FileFilters}
   * @return {ListFilesMessage}
   */
  setFileFilters(fileFilters) {
    this._fileFilters = fileFilters;
    return this;
  }
  /**
   * @return {PageRequestData}
   */
  getPageRequestData() {
    return this._pageRequestData;
  }

  /**
   * @param pageRequestData{PageRequestData}
   * @return {ListFilesMessage}
   */
  setPageRequestData(pageRequestData) {
    this._pageRequestData = pageRequestData;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {ListFilesMessage}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ListFilesMessage.CLASS_ID;
    
	//Serializing _useCacheOnly
	if (this._useCacheOnly)
		json['useCacheOnly'] = this._useCacheOnly;

	//Serializing _pageLimit
	if (this._pageLimit)
		json['pageLimit'] = this._pageLimit;

	//Serializing _maxRrn
	if (this._maxRrn)
		json['maxRrn'] = this._maxRrn;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _force
	if (this._force)
		json['force'] = this._force;

	//Serializing ComplexType _$arrayName
	if (this._fileFilters)
		json['fileFilters'] = this._fileFilters.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._pageRequestData)
		json['pageRequestData'] = this._pageRequestData.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._useCacheOnly = json.hasOwnProperty("useCacheOnly")?json["useCacheOnly"]:false;
		this._pageLimit = json.hasOwnProperty("pageLimit")?json["pageLimit"]:0;
		this._maxRrn = json.hasOwnProperty("maxRrn")?json["maxRrn"]:0;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._force = json.hasOwnProperty("force")?json["force"]:false;
		if (json.hasOwnProperty("fileFilters")){
			if (!this._fileFilters && this._fileFilters == null)
				this._fileFilters = new FileFilters();
			this._fileFilters.deserializeJson(json.hasOwnProperty("fileFilters") ? json["fileFilters"] : null);
		}

		if (json.hasOwnProperty("pageRequestData")){
			if (!this._pageRequestData && this._pageRequestData == null)
				this._pageRequestData = new PageRequestData();
			this._pageRequestData.deserializeJson(json.hasOwnProperty("pageRequestData") ? json["pageRequestData"] : null);
		}

		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
ListFilesMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ListFilesMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CategoryQueryVAB {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._parentIdName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._kidsQuery = false;
    /**
     * @type {number}
     * @private
     */
    this._beginIndex = null;
    /**
     * @type {number}
     * @private
     */
    this._limit = null;
    /**
     * @type {string}
     * @private
     */
    this._matchString = null;
    /**
     * @type {string}
     * @private
     */
    this._categoryId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._recursive = false;
    /**
     * @type {number}
     * @private
     */
    this._parentId = null;

  }

    /**
   * @return {string}
   */
  getParentIdName() {
    return this._parentIdName;
  }

  /**
   * @param parentIdName{string}
   * @return {CategoryQueryVAB}
   */
  setParentIdName(parentIdName) {
    this._parentIdName = parentIdName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isKidsQuery() {
    return this._kidsQuery;
  }

  /**
   * @param kidsQuery{boolean}
   * @return {CategoryQueryVAB}
   */
  setKidsQuery(kidsQuery) {
    this._kidsQuery = kidsQuery;
    return this;
  }
  /**
   * @return {number}
   */
  getBeginIndex() {
    return this._beginIndex;
  }

  /**
   * @param beginIndex{number}
   * @return {CategoryQueryVAB}
   */
  setBeginIndex(beginIndex) {
    this._beginIndex = beginIndex;
    return this;
  }
  /**
   * @return {number}
   */
  getLimit() {
    return this._limit;
  }

  /**
   * @param limit{number}
   * @return {CategoryQueryVAB}
   */
  setLimit(limit) {
    this._limit = limit;
    return this;
  }
  /**
   * @return {string}
   */
  getMatchString() {
    return this._matchString;
  }

  /**
   * @param matchString{string}
   * @return {CategoryQueryVAB}
   */
  setMatchString(matchString) {
    this._matchString = matchString;
    return this;
  }
  /**
   * @return {string}
   */
  getCategoryId() {
    return this._categoryId;
  }

  /**
   * @param categoryId{string}
   * @return {CategoryQueryVAB}
   */
  setCategoryId(categoryId) {
    this._categoryId = categoryId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isRecursive() {
    return this._recursive;
  }

  /**
   * @param recursive{boolean}
   * @return {CategoryQueryVAB}
   */
  setRecursive(recursive) {
    this._recursive = recursive;
    return this;
  }
  /**
   * @return {number}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{number}
   * @return {CategoryQueryVAB}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CategoryQueryVAB.CLASS_ID;
    
	//Serializing _parentIdName
	if (this._parentIdName)
		json['parentIdName'] = this._parentIdName;

	//Serializing _kidsQuery
	if (this._kidsQuery)
		json['kidsQuery'] = this._kidsQuery;

	//Serializing _beginIndex
	if (this._beginIndex)
		json['beginIndex'] = this._beginIndex;

	//Serializing _limit
	if (this._limit)
		json['limit'] = this._limit;

	//Serializing _matchString
	if (this._matchString)
		json['matchString'] = this._matchString;

	//Serializing _categoryId
	if (this._categoryId)
		json['categoryId'] = this._categoryId;

	//Serializing _recursive
	if (this._recursive)
		json['recursive'] = this._recursive;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._parentIdName = json.hasOwnProperty("parentIdName")?json["parentIdName"]:null;
		this._kidsQuery = json.hasOwnProperty("kidsQuery")?json["kidsQuery"]:false;
		this._beginIndex = json.hasOwnProperty("beginIndex")?json["beginIndex"]:0;
		this._limit = json.hasOwnProperty("limit")?json["limit"]:0;
		this._matchString = json.hasOwnProperty("matchString")?json["matchString"]:null;
		this._categoryId = json.hasOwnProperty("categoryId")?json["categoryId"]:null;
		this._recursive = json.hasOwnProperty("recursive")?json["recursive"]:false;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:0;


  }
}

/**
 * @returns {string}
 */
CategoryQueryVAB.CLASS_ID = "com.zoom.vab.client.autogenerated.CategoryQueryVAB";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteDrawingAnnotationsQuery extends HttpOperation {

  constructor(name = "DeleteDrawingAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteDrawingAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteDrawingAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {DeleteDrawingAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteDrawingAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteDrawingAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new DeleteDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new DeleteDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteDrawingAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteDrawingAnnotations";
/**
 * @returns {string}
 */
DeleteDrawingAnnotationsQuery.QUERY_NAME = "DeleteDrawingAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCustomResourceQueryQuery extends HttpOperation {

  constructor(name = "GetCustomResourceQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCustomResourceQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCustomResourceQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCustomResourceQueryResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCustomResourceQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCustomResourceQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCustomResourceQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCustomResourceQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCustomResourceQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCustomResourceQuery";
/**
 * @returns {string}
 */
GetCustomResourceQueryQuery.QUERY_NAME = "GetCustomResourceQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AnnotationLocation {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._commentIndex = null;
    /**
     * @type {SpatialLocation}
     * @private
     */
    this._spatialLocation = null;
    /**
     * @type {TemporalLocationRangeEnd}
     * @private
     */
    this._temporalLocationRangeEnd = null;
    /**
     * @type {TemporalLocation}
     * @private
     */
    this._temporalLocation = null;

  }

    /**
   * order index of comment; for easy display in a key form. It is unique within an AnnotationScope.
   * @return {number}
   */
  getCommentIndex() {
    return this._commentIndex;
  }

  /**
   * @param commentIndex{number}
   * @return {AnnotationLocation}
   */
  setCommentIndex(commentIndex) {
    this._commentIndex = commentIndex;
    return this;
  }
  /**
   * optional: image spatial location
   * @return {SpatialLocation}
   */
  getSpatialLocation() {
    return this._spatialLocation;
  }

  /**
   * @param spatialLocation{SpatialLocation}
   * @return {AnnotationLocation}
   */
  setSpatialLocation(spatialLocation) {
    this._spatialLocation = spatialLocation;
    return this;
  }
  /**
   * optional: end of a temporal location range for video/animation/multi-page
   * @return {TemporalLocationRangeEnd}
   */
  getTemporalLocationRangeEnd() {
    return this._temporalLocationRangeEnd;
  }

  /**
   * @param temporalLocationRangeEnd{TemporalLocationRangeEnd}
   * @return {AnnotationLocation}
   */
  setTemporalLocationRangeEnd(temporalLocationRangeEnd) {
    this._temporalLocationRangeEnd = temporalLocationRangeEnd;
    return this;
  }
  /**
   * optional: video/animation/multi-page temporal location
   * @return {TemporalLocation}
   */
  getTemporalLocation() {
    return this._temporalLocation;
  }

  /**
   * @param temporalLocation{TemporalLocation}
   * @return {AnnotationLocation}
   */
  setTemporalLocation(temporalLocation) {
    this._temporalLocation = temporalLocation;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AnnotationLocation.CLASS_ID;
    
	//Serializing _commentIndex
	if (this._commentIndex)
		json['commentIndex'] = this._commentIndex;

	//Serializing ComplexType _$arrayName
	if (this._spatialLocation)
		json['spatialLocation'] = this._spatialLocation.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._temporalLocationRangeEnd)
		json['temporalLocationRangeEnd'] = this._temporalLocationRangeEnd.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._temporalLocation)
		json['temporalLocation'] = this._temporalLocation.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._commentIndex = json.hasOwnProperty("commentIndex")?json["commentIndex"]:0;
		if (json.hasOwnProperty("spatialLocation")){
			if (!this._spatialLocation && this._spatialLocation == null)
				this._spatialLocation = new SpatialLocation();
			this._spatialLocation.deserializeJson(json.hasOwnProperty("spatialLocation") ? json["spatialLocation"] : null);
		}

		if (json.hasOwnProperty("temporalLocationRangeEnd")){
			if (!this._temporalLocationRangeEnd && this._temporalLocationRangeEnd == null)
				this._temporalLocationRangeEnd = new TemporalLocationRangeEnd();
			this._temporalLocationRangeEnd.deserializeJson(json.hasOwnProperty("temporalLocationRangeEnd") ? json["temporalLocationRangeEnd"] : null);
		}

		if (json.hasOwnProperty("temporalLocation")){
			if (!this._temporalLocation && this._temporalLocation == null)
				this._temporalLocation = new TemporalLocation();
			this._temporalLocation.deserializeJson(json.hasOwnProperty("temporalLocation") ? json["temporalLocation"] : null);
		}



  }
}

/**
 * @returns {string}
 */
AnnotationLocation.CLASS_ID = "com.zoom.vab.client.autogenerated.AnnotationLocation";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ImportQueryMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {string}
     * @private
     */
    this._uniqueKey = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._fileNames = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {ImportQueryMsg}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {string}
   */
  getUniqueKey() {
    return this._uniqueKey;
  }

  /**
   * @param uniqueKey{string}
   * @return {ImportQueryMsg}
   */
  setUniqueKey(uniqueKey) {
    this._uniqueKey = uniqueKey;
    return this;
  }
  /**
   * Optional: When import is done for a collection.?
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {ImportQueryMsg}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getFileNames() {
    return this._fileNames;
  }

  /**
   * @param fileNames{Array<String>}
   * @return {ImportQueryMsg}
   */
  setFileNames(fileNames) {
    this._fileNames = fileNames;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ImportQueryMsg.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _uniqueKey
	if (this._uniqueKey)
		json['uniqueKey'] = this._uniqueKey;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._fileNames && this._fileNames.length > 0) {
    let fileNames_JSON = [];
    /**
     * @type {string}
     */
    this._fileNames.forEach((o238) => {
      if (o238) {
        if (o238.serializeJson && (typeof (o238.serializeJson) === 'function')) {
          fileNames_JSON.push(o238.serializeJson());
        } else {
          fileNames_JSON.push(o238);
        }
      }
    });
    json['fileNames'] = fileNames_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._uniqueKey = json.hasOwnProperty("uniqueKey")?json["uniqueKey"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type string
		this._fileNames = [];
		let fileNamesJSONArray = json.hasOwnProperty("fileNames") ? json["fileNames"] : [];

		fileNamesJSONArray.forEach((o239)=>{
			if (o239){
				this._fileNames.push(o239);
			}
		});


  }
}

/**
 * @returns {string}
 */
ImportQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ImportQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class Annotation {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._editor = null;
    /**
     * @type {string}
     * @private
     */
    this._creator = null;
    /**
     * @type {number}
     * @private
     */
    this._mRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._cRrn = null;
    /**
     * @type {number}
     * @private
     */
    this._commentId = null;
    /**
     * @type {number}
     * @private
     */
    this._parentCommentId = null;
    /**
     * @type {number}
     * @private
     */
    this._cTime = null;
    /**
     * @type {string}
     * @private
     */
    this._textType = null;
    /**
     * @type {string}
     * @private
     */
    this._text = null;
    /**
     * @type {number}
     * @private
     */
    this._mTime = null;
    /**
     * @type {Array<AnnotationAttachment>}
     * @private
     */
    this._attachments = null;
    /**
     * @type {Array<Annotation>}
     * @private
     */
    this._replies = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._peopleMentionedInTheComment = null;

  }

    /**
   * optional: no edits if unspecified.
   * @return {string}
   */
  getEditor() {
    return this._editor;
  }

  /**
   * @param editor{string}
   * @return {Annotation}
   */
  setEditor(editor) {
    this._editor = editor;
    return this;
  }
  /**
   * @return {string}
   */
  getCreator() {
    return this._creator;
  }

  /**
   * @param creator{string}
   * @return {Annotation}
   */
  setCreator(creator) {
    this._creator = creator;
    return this;
  }
  /**
   * optional: no edits if unspecified.
   * @return {number}
   */
  getMRrn() {
    return this._mRrn;
  }

  /**
   * @param mRrn{number}
   * @return {Annotation}
   */
  setMRrn(mRrn) {
    this._mRrn = mRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getCRrn() {
    return this._cRrn;
  }

  /**
   * @param cRrn{number}
   * @return {Annotation}
   */
  setCRrn(cRrn) {
    this._cRrn = cRrn;
    return this;
  }
  /**
   * @return {number}
   */
  getCommentId() {
    return this._commentId;
  }

  /**
   * @param commentId{number}
   * @return {Annotation}
   */
  setCommentId(commentId) {
    this._commentId = commentId;
    return this;
  }
  /**
   * optional: top-level comment if unspecified.
   * @return {number}
   */
  getParentCommentId() {
    return this._parentCommentId;
  }

  /**
   * @param parentCommentId{number}
   * @return {Annotation}
   */
  setParentCommentId(parentCommentId) {
    this._parentCommentId = parentCommentId;
    return this;
  }
  /**
   * @return {number}
   */
  getCTime() {
    return this._cTime;
  }

  /**
   * @param cTime{number}
   * @return {Annotation}
   */
  setCTime(cTime) {
    this._cTime = cTime;
    return this;
  }
  /**
   * Enum: TEXT, REVIEW; default if unspecified: TEXT
   * @return {string}
   */
  getTextType() {
    return this._textType;
  }

  /**
   * @param textType{string}
   * @return {Annotation}
   */
  setTextType(textType) {
    this._textType = textType;
    return this;
  }
  /**
   * @return {string}
   */
  getText() {
    return this._text;
  }

  /**
   * @param text{string}
   * @return {Annotation}
   */
  setText(text) {
    this._text = text;
    return this;
  }
  /**
   * optional: no edits if unspecified.
   * @return {number}
   */
  getMTime() {
    return this._mTime;
  }

  /**
   * @param mTime{number}
   * @return {Annotation}
   */
  setMTime(mTime) {
    this._mTime = mTime;
    return this;
  }
  /**
   * @return {Array<AnnotationAttachment>}
   */
  getAttachments() {
    return this._attachments;
  }

  /**
   * @param attachments{Array<AnnotationAttachment>}
   * @return {Annotation}
   */
  setAttachments(attachments) {
    this._attachments = attachments;
    return this;
  }

  /**
   * @return {Array<Annotation>}
   */
  getReplies() {
    return this._replies;
  }

  /**
   * @param replies{Array<Annotation>}
   * @return {Annotation}
   */
  setReplies(replies) {
    this._replies = replies;
    return this;
  }

  /**
   * User id of the people mentioned in the comments
   * @return {Array<String>}
   */
  getPeopleMentionedInTheComment() {
    return this._peopleMentionedInTheComment;
  }

  /**
   * @param peopleMentionedInTheComment{Array<String>}
   * @return {Annotation}
   */
  setPeopleMentionedInTheComment(peopleMentionedInTheComment) {
    this._peopleMentionedInTheComment = peopleMentionedInTheComment;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = Annotation.CLASS_ID;
    
	//Serializing _editor
	if (this._editor)
		json['editor'] = this._editor;

	//Serializing _creator
	if (this._creator)
		json['creator'] = this._creator;

	//Serializing _mRrn
	if (this._mRrn)
		json['mRrn'] = this._mRrn;

	//Serializing _cRrn
	if (this._cRrn)
		json['cRrn'] = this._cRrn;

	//Serializing _commentId
	if (this._commentId)
		json['commentId'] = this._commentId;

	//Serializing _parentCommentId
	if (this._parentCommentId)
		json['parentCommentId'] = this._parentCommentId;

	//Serializing _cTime
	if (this._cTime)
		json['cTime'] = this._cTime;

	//Serializing _textType
	if (this._textType)
		json['textType'] = this._textType;

	//Serializing _text
	if (this._text)
		json['text'] = this._text;

	//Serializing _mTime
	if (this._mTime)
		json['mTime'] = this._mTime;
  if (this._attachments && this._attachments.length > 0) {
    let attachments_JSON = [];
    /**
     * @type {AnnotationAttachment}
     */
    this._attachments.forEach((o541) => {
      if (o541) {
        if (o541.serializeJson && (typeof (o541.serializeJson) === 'function')) {
          attachments_JSON.push(o541.serializeJson());
        } else {
          attachments_JSON.push(o541);
        }
      }
    });
    json['attachments'] = attachments_JSON;
  }  
  if (this._replies && this._replies.length > 0) {
    let replies_JSON = [];
    /**
     * @type {Annotation}
     */
    this._replies.forEach((o544) => {
      if (o544) {
        if (o544.serializeJson && (typeof (o544.serializeJson) === 'function')) {
          replies_JSON.push(o544.serializeJson());
        } else {
          replies_JSON.push(o544);
        }
      }
    });
    json['replies'] = replies_JSON;
  }  
  if (this._peopleMentionedInTheComment && this._peopleMentionedInTheComment.length > 0) {
    let peopleMentionedInTheComment_JSON = [];
    /**
     * @type {string}
     */
    this._peopleMentionedInTheComment.forEach((o547) => {
      if (o547) {
        if (o547.serializeJson && (typeof (o547.serializeJson) === 'function')) {
          peopleMentionedInTheComment_JSON.push(o547.serializeJson());
        } else {
          peopleMentionedInTheComment_JSON.push(o547);
        }
      }
    });
    json['peopleMentionedInTheComment'] = peopleMentionedInTheComment_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._editor = json.hasOwnProperty("editor")?json["editor"]:null;
		this._creator = json.hasOwnProperty("creator")?json["creator"]:null;
		this._mRrn = json.hasOwnProperty("mRrn")?json["mRrn"]:0;
		this._cRrn = json.hasOwnProperty("cRrn")?json["cRrn"]:0;
		this._commentId = json.hasOwnProperty("commentId")?json["commentId"]:0;
		this._parentCommentId = json.hasOwnProperty("parentCommentId")?json["parentCommentId"]:0;
		this._cTime = json.hasOwnProperty("cTime")?json["cTime"]:0;
		this._textType = json.hasOwnProperty("textType")?json["textType"]:null;
		this._text = json.hasOwnProperty("text")?json["text"]:null;
		this._mTime = json.hasOwnProperty("mTime")?json["mTime"]:0;
		//set of type AnnotationAttachment
		this._attachments = [];
		let attachmentsJSONArray = json.hasOwnProperty("attachments") ? json["attachments"] : [];

		attachmentsJSONArray.forEach((o542)=>{
			if (o542){
				let classObj = new AnnotationAttachment();
				classObj.deserializeJson(o542);
				this._attachments.push(classObj);
			}
		});
		//set of type Annotation
		this._replies = [];
		let repliesJSONArray = json.hasOwnProperty("replies") ? json["replies"] : [];

		repliesJSONArray.forEach((o545)=>{
			if (o545){
				let classObj = new Annotation();
				classObj.deserializeJson(o545);
				this._replies.push(classObj);
			}
		});
		//set of type string
		this._peopleMentionedInTheComment = [];
		let peopleMentionedInTheCommentJSONArray = json.hasOwnProperty("peopleMentionedInTheComment") ? json["peopleMentionedInTheComment"] : [];

		peopleMentionedInTheCommentJSONArray.forEach((o548)=>{
			if (o548){
				this._peopleMentionedInTheComment.push(o548);
			}
		});


  }
}

/**
 * @returns {string}
 */
Annotation.CLASS_ID = "com.zoom.vab.client.autogenerated.Annotation";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MetadataEntry {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._metadataValue = null;
    /**
     * @type {string}
     * @private
     */
    this._metadataName = null;

  }

    /**
   * @return {string}
   */
  getMetadataValue() {
    return this._metadataValue;
  }

  /**
   * @param metadataValue{string}
   * @return {MetadataEntry}
   */
  setMetadataValue(metadataValue) {
    this._metadataValue = metadataValue;
    return this;
  }
  /**
   * @return {string}
   */
  getMetadataName() {
    return this._metadataName;
  }

  /**
   * @param metadataName{string}
   * @return {MetadataEntry}
   */
  setMetadataName(metadataName) {
    this._metadataName = metadataName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MetadataEntry.CLASS_ID;
    
	//Serializing _metadataValue
	if (this._metadataValue)
		json['metadataValue'] = this._metadataValue;

	//Serializing _metadataName
	if (this._metadataName)
		json['metadataName'] = this._metadataName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._metadataValue = json.hasOwnProperty("metadataValue")?json["metadataValue"]:null;
		this._metadataName = json.hasOwnProperty("metadataName")?json["metadataName"]:null;


  }
}

/**
 * @returns {string}
 */
MetadataEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.MetadataEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SearchSortOrderChangeQuery extends HttpOperation {

  constructor(name = "SearchSortOrderChange") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {CurrentContextInfo}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CurrentContextInfo}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesResponseData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SearchSortOrderChangeQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SearchSortOrderChangeQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SearchSortOrderChangeQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SearchSortOrderChange";
/**
 * @returns {string}
 */
SearchSortOrderChangeQuery.QUERY_NAME = "SearchSortOrderChange";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCommentsUnreadCountResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._unreadCount = null;
    /**
     * @type {Array<CollectionUnreadCountEntry>}
     * @private
     */
    this._collectionUnreadCountEntries = null;

  }

    /**
   * Total unread count of collections. Sum of unread counts in CollectionUnreadCountEntry below
   * @return {number}
   */
  getUnreadCount() {
    return this._unreadCount;
  }

  /**
   * @param unreadCount{number}
   * @return {GetCommentsUnreadCountResponse}
   */
  setUnreadCount(unreadCount) {
    this._unreadCount = unreadCount;
    return this;
  }
  /**
   * Unread count per collection.
   * @return {Array<CollectionUnreadCountEntry>}
   */
  getCollectionUnreadCountEntries() {
    return this._collectionUnreadCountEntries;
  }

  /**
   * @param collectionUnreadCountEntries{Array<CollectionUnreadCountEntry>}
   * @return {GetCommentsUnreadCountResponse}
   */
  setCollectionUnreadCountEntries(collectionUnreadCountEntries) {
    this._collectionUnreadCountEntries = collectionUnreadCountEntries;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCommentsUnreadCountResponse.CLASS_ID;
    
	//Serializing _unreadCount
	if (this._unreadCount)
		json['unreadCount'] = this._unreadCount;
  if (this._collectionUnreadCountEntries && this._collectionUnreadCountEntries.length > 0) {
    let collectionUnreadCountEntries_JSON = [];
    /**
     * @type {CollectionUnreadCountEntry}
     */
    this._collectionUnreadCountEntries.forEach((o578) => {
      if (o578) {
        if (o578.serializeJson && (typeof (o578.serializeJson) === 'function')) {
          collectionUnreadCountEntries_JSON.push(o578.serializeJson());
        } else {
          collectionUnreadCountEntries_JSON.push(o578);
        }
      }
    });
    json['collectionUnreadCountEntries'] = collectionUnreadCountEntries_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._unreadCount = json.hasOwnProperty("unreadCount")?json["unreadCount"]:0;
		//set of type CollectionUnreadCountEntry
		this._collectionUnreadCountEntries = [];
		let collectionUnreadCountEntriesJSONArray = json.hasOwnProperty("collectionUnreadCountEntries") ? json["collectionUnreadCountEntries"] : [];

		collectionUnreadCountEntriesJSONArray.forEach((o579)=>{
			if (o579){
				let classObj = new CollectionUnreadCountEntry();
				classObj.deserializeJson(o579);
				this._collectionUnreadCountEntries.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetCommentsUnreadCountResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCommentsUnreadCountResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCustomResourceQueryResp {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._responseMap = null;

  }

    /**
   * @return {java.util.Map<String,String>}
   */
  getResponseMap() {
    return this._responseMap;
  }

  /**
   * @param responseMap{java.util.Map<String,String>}
   * @return {GetCustomResourceQueryResp}
   */
  setResponseMap(responseMap) {
    this._responseMap = responseMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCustomResourceQueryResp.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"responseMap", this._responseMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._responseMap == null)
			this._responseMap = new HashMap();
		this._responseMap.clear();
		let responseMapJSONArray = json.hasOwnProperty("responseMap") ? json["responseMap"] : [];
		this._responseMap = SerializationUtil.deserializeMap(responseMapJSONArray);



  }
}

/**
 * @returns {string}
 */
GetCustomResourceQueryResp.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCustomResourceQueryResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SetActivityPanelDataQuery extends HttpOperation {

  constructor(name = "SetActivityPanelData") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SetActivityPanelDataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SetActivityPanelDataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SetActivityPanelDataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SetActivityPanelDataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SetActivityPanelDataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SetActivityPanelDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SetActivityPanelDataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SetActivityPanelDataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SetActivityPanelData";
/**
 * @returns {string}
 */
SetActivityPanelDataQuery.QUERY_NAME = "SetActivityPanelData";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ReadFavItemsQuery extends HttpOperation {

  constructor(name = "ReadFavItems") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ReadFavItemsMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ReadFavItemsMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ReadFavItemsResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ReadFavItemsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ReadFavItemsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ReadFavItemsResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ReadFavItemsResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ReadFavItemsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ReadFavItems";
/**
 * @returns {string}
 */
ReadFavItemsQuery.QUERY_NAME = "ReadFavItems";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAssetsPathFuidsResponse {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._fuid2PathFuids = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuid2RepoItemList = null;

  }

    /**
   * @return {java.util.Map<number,PathFuidsList>}
   */
  getFuid2PathFuids() {
    return this._fuid2PathFuids;
  }

  /**
   * @param fuid2PathFuids{java.util.Map<number,PathFuidsList>}
   * @return {GetAssetsPathFuidsResponse}
   */
  setFuid2PathFuids(fuid2PathFuids) {
    this._fuid2PathFuids = fuid2PathFuids;
    return this;
  }

  /**
   * @return {java.util.Map<number,RepoItem>}
   */
  getFuid2RepoItemList() {
    return this._fuid2RepoItemList;
  }

  /**
   * @param fuid2RepoItemList{java.util.Map<number,RepoItem>}
   * @return {GetAssetsPathFuidsResponse}
   */
  setFuid2RepoItemList(fuid2RepoItemList) {
    this._fuid2RepoItemList = fuid2RepoItemList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAssetsPathFuidsResponse.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"fuid2PathFuids", this._fuid2PathFuids);
		    SerializationUtil.serializeHashMap(json,"fuid2RepoItemList", this._fuid2RepoItemList);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type INT. Decode as tree:false
		if (this._fuid2PathFuids == null)
			this._fuid2PathFuids = new HashMap();
		this._fuid2PathFuids.clear();
		let fuid2PathFuidsJSONArray = json.hasOwnProperty("fuid2PathFuids") ? json["fuid2PathFuids"] : [];
		this._fuid2PathFuids = SerializationUtil.deserializeMap(fuid2PathFuidsJSONArray);

//Map of type INT. Decode as tree:false
		if (this._fuid2RepoItemList == null)
			this._fuid2RepoItemList = new HashMap();
		this._fuid2RepoItemList.clear();
		let fuid2RepoItemListJSONArray = json.hasOwnProperty("fuid2RepoItemList") ? json["fuid2RepoItemList"] : [];
		this._fuid2RepoItemList = SerializationUtil.deserializeMap(fuid2RepoItemListJSONArray);



  }
}

/**
 * @returns {string}
 */
GetAssetsPathFuidsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsPathFuidsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SetCollectionSettingsQuery extends HttpOperation {

  constructor(name = "SetCollectionSettings") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SetCollectionSettingsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SetCollectionSettingsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SetCollectionSettingsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SetCollectionSettingsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SetCollectionSettingsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SetCollectionSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SetCollectionSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SetCollectionSettingsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionSettings";
/**
 * @returns {string}
 */
SetCollectionSettingsQuery.QUERY_NAME = "SetCollectionSettings";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ShareZmCollectionQuery extends HttpOperation {

  constructor(name = "ShareZmCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {ShareZmCollectionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ShareZmCollectionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ShareZmCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ShareZmCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ShareZmCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ShareZmCollection";
/**
 * @returns {string}
 */
ShareZmCollectionQuery.QUERY_NAME = "ShareZmCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollMetadata {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._collMetadata = null;

  }

    /**
   * @return {java.util.Map<String,ValueList>}
   */
  getCollMetadata() {
    return this._collMetadata;
  }

  /**
   * @param collMetadata{java.util.Map<String,ValueList>}
   * @return {CollMetadata}
   */
  setCollMetadata(collMetadata) {
    this._collMetadata = collMetadata;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollMetadata.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"collMetadata", this._collMetadata);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._collMetadata == null)
			this._collMetadata = new HashMap();
		this._collMetadata.clear();
		let collMetadataJSONArray = json.hasOwnProperty("collMetadata") ? json["collMetadata"] : [];
		this._collMetadata = SerializationUtil.deserializeMap(collMetadataJSONArray);



  }
}

/**
 * @returns {string}
 */
CollMetadata.CLASS_ID = "com.zoom.vab.client.autogenerated.CollMetadata";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteAnnotationsQuery extends HttpOperation {

  constructor(name = "DeleteAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {DeleteAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new DeleteAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new DeleteAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteAnnotations";
/**
 * @returns {string}
 */
DeleteAnnotationsQuery.QUERY_NAME = "DeleteAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class BoundingBoxCoordinates {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._measuringUnits = null;
    /**
     * @type {Array<Point>}
     * @private
     */
    this._points = null;

  }

    /**
   * @return {string}
   */
  getMeasuringUnits() {
    return this._measuringUnits;
  }

  /**
   * @param measuringUnits{string}
   * @return {BoundingBoxCoordinates}
   */
  setMeasuringUnits(measuringUnits) {
    this._measuringUnits = measuringUnits;
    return this;
  }
  /**
   * @return {Array<Point>}
   */
  getPoints() {
    return this._points;
  }

  /**
   * @param points{Array<Point>}
   * @return {BoundingBoxCoordinates}
   */
  setPoints(points) {
    this._points = points;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = BoundingBoxCoordinates.CLASS_ID;
    
	//Serializing _measuringUnits
	if (this._measuringUnits)
		json['measuringUnits'] = this._measuringUnits;
  if (this._points && this._points.length > 0) {
    let points_JSON = [];
    /**
     * @type {Point}
     */
    this._points.forEach((o1090) => {
      if (o1090) {
        if (o1090.serializeJson && (typeof (o1090.serializeJson) === 'function')) {
          points_JSON.push(o1090.serializeJson());
        } else {
          points_JSON.push(o1090);
        }
      }
    });
    json['points'] = points_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._measuringUnits = json.hasOwnProperty("measuringUnits")?json["measuringUnits"]:null;
		//set of type Point
		this._points = [];
		let pointsJSONArray = json.hasOwnProperty("points") ? json["points"] : [];

		pointsJSONArray.forEach((o1091)=>{
			if (o1091){
				let classObj = new Point();
				classObj.deserializeJson(o1091);
				this._points.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
BoundingBoxCoordinates.CLASS_ID = "com.zoom.vab.client.autogenerated.BoundingBoxCoordinates";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class MyProjectsQuery extends HttpOperation {

  constructor(name = "MyProjects") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {MyProjectsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{MyProjectsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {MyProjectsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = MyProjectsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (MyProjectsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new MyProjectsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new MyProjectsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
MyProjectsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.MyProjects";
/**
 * @returns {string}
 */
MyProjectsQuery.QUERY_NAME = "MyProjects";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditSpotLightQueryMsg {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._spotLightId = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._operationType = null;
    /**
     * @type {string}
     * @private
     */
    this._overlayText = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {number}
   */
  getSpotLightId() {
    return this._spotLightId;
  }

  /**
   * @param spotLightId{number}
   * @return {EditSpotLightQueryMsg}
   */
  setSpotLightId(spotLightId) {
    this._spotLightId = spotLightId;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {EditSpotLightQueryMsg}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getOperationType() {
    return this._operationType;
  }

  /**
   * @param operationType{string}
   * @return {EditSpotLightQueryMsg}
   */
  setOperationType(operationType) {
    this._operationType = operationType;
    return this;
  }
  /**
   * @return {string}
   */
  getOverlayText() {
    return this._overlayText;
  }

  /**
   * @param overlayText{string}
   * @return {EditSpotLightQueryMsg}
   */
  setOverlayText(overlayText) {
    this._overlayText = overlayText;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {EditSpotLightQueryMsg}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {EditSpotLightQueryMsg}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditSpotLightQueryMsg.CLASS_ID;
    
	//Serializing _spotLightId
	if (this._spotLightId)
		json['spotLightId'] = this._spotLightId;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _operationType
	if (this._operationType)
		json['operationType'] = this._operationType;

	//Serializing _overlayText
	if (this._overlayText)
		json['overlayText'] = this._overlayText;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._spotLightId = json.hasOwnProperty("spotLightId")?json["spotLightId"]:0;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._operationType = json.hasOwnProperty("operationType")?json["operationType"]:null;
		this._overlayText = json.hasOwnProperty("overlayText")?json["overlayText"]:null;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
EditSpotLightQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.EditSpotLightQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCollectionFilterListQuery extends HttpOperation {

  constructor(name = "GetCollectionFilterList") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {Boolean}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{Boolean}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCollectionFilterListResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCollectionFilterListQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCollectionFilterListQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCollectionFilterListResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCollectionFilterListResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCollectionFilterListQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionFilterList";
/**
 * @returns {string}
 */
GetCollectionFilterListQuery.QUERY_NAME = "GetCollectionFilterList";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ZmCollection {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._totalChildCollections = null;
    /**
     * @type {string}
     * @private
     */
    this._creator = null;
    /**
     * @type {number}
     * @private
     */
    this._totalAssets = null;
    /**
     * @type {string}
     * @private
     */
    this._displayName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._bin = false;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {string}
     * @private
     */
    this._description = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;
    /**
     * @type {string}
     * @private
     */
    this._message = null;
    /**
     * @type {number}
     * @private
     */
    this._createdOn = null;
    /**
     * @type {number}
     * @private
     */
    this._parentId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasDynamicFilters = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._expiresOn = null;
    /**
     * @type {boolean}
     * @private
     */
    this._useLatestRevisionOfAssets = false;
    /**
     * @type {string}
     * @private
     */
    this._modifiedBy = null;
    /**
     * @type {boolean}
     * @private
     */
    this._dynamic = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {string}
     * @private
     */
    this._status = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._childCollections = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._lightboxThumbInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._requestUserPermissionsMap = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadata = null;
    /**
     * @type {HashSet}
     * @private
     */
    this._tags = null;

  }

    /**
   * @return {number}
   */
  getTotalChildCollections() {
    return this._totalChildCollections;
  }

  /**
   * @param totalChildCollections{number}
   * @return {ZmCollection}
   */
  setTotalChildCollections(totalChildCollections) {
    this._totalChildCollections = totalChildCollections;
    return this;
  }
  /**
   * @return {string}
   */
  getCreator() {
    return this._creator;
  }

  /**
   * @param creator{string}
   * @return {ZmCollection}
   */
  setCreator(creator) {
    this._creator = creator;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalAssets() {
    return this._totalAssets;
  }

  /**
   * @param totalAssets{number}
   * @return {ZmCollection}
   */
  setTotalAssets(totalAssets) {
    this._totalAssets = totalAssets;
    return this;
  }
  /**
   * @return {string}
   */
  getDisplayName() {
    return this._displayName;
  }

  /**
   * @param displayName{string}
   * @return {ZmCollection}
   */
  setDisplayName(displayName) {
    this._displayName = displayName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isBin() {
    return this._bin;
  }

  /**
   * @param bin{boolean}
   * @return {ZmCollection}
   */
  setBin(bin) {
    this._bin = bin;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {ZmCollection}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {string}
   */
  getDescription() {
    return this._description;
  }

  /**
   * @param description{string}
   * @return {ZmCollection}
   */
  setDescription(description) {
    this._description = description;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {ZmCollection}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {ZmCollection}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }
  /**
   * @return {number}
   */
  getCreatedOn() {
    return this._createdOn;
  }

  /**
   * @param createdOn{number}
   * @return {ZmCollection}
   */
  setCreatedOn(createdOn) {
    this._createdOn = createdOn;
    return this;
  }
  /**
   * @return {number}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{number}
   * @return {ZmCollection}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasDynamicFilters() {
    return this._hasDynamicFilters;
  }

  /**
   * @param hasDynamicFilters{boolean}
   * @return {ZmCollection}
   */
  setHasDynamicFilters(hasDynamicFilters) {
    this._hasDynamicFilters = hasDynamicFilters;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {ZmCollection}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getExpiresOn() {
    return this._expiresOn;
  }

  /**
   * @param expiresOn{number}
   * @return {ZmCollection}
   */
  setExpiresOn(expiresOn) {
    this._expiresOn = expiresOn;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseLatestRevisionOfAssets() {
    return this._useLatestRevisionOfAssets;
  }

  /**
   * @param useLatestRevisionOfAssets{boolean}
   * @return {ZmCollection}
   */
  setUseLatestRevisionOfAssets(useLatestRevisionOfAssets) {
    this._useLatestRevisionOfAssets = useLatestRevisionOfAssets;
    return this;
  }
  /**
   * @return {string}
   */
  getModifiedBy() {
    return this._modifiedBy;
  }

  /**
   * @param modifiedBy{string}
   * @return {ZmCollection}
   */
  setModifiedBy(modifiedBy) {
    this._modifiedBy = modifiedBy;
    return this;
  }
  /**
   * @return {boolean}
   */
  isDynamic() {
    return this._dynamic;
  }

  /**
   * @param dynamic{boolean}
   * @return {ZmCollection}
   */
  setDynamic(dynamic) {
    this._dynamic = dynamic;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {ZmCollection}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {string}
   */
  getStatus() {
    return this._status;
  }

  /**
   * @param status{string}
   * @return {ZmCollection}
   */
  setStatus(status) {
    this._status = status;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getChildCollections() {
    return this._childCollections;
  }

  /**
   * @param childCollections{Array<Integer>}
   * @return {ZmCollection}
   */
  setChildCollections(childCollections) {
    this._childCollections = childCollections;
    return this;
  }

  /**
   * @return {Array<FuidRrnInfo>}
   */
  getLightboxThumbInfo() {
    return this._lightboxThumbInfo;
  }

  /**
   * @param lightboxThumbInfo{Array<FuidRrnInfo>}
   * @return {ZmCollection}
   */
  setLightboxThumbInfo(lightboxThumbInfo) {
    this._lightboxThumbInfo = lightboxThumbInfo;
    return this;
  }

  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getRequestUserPermissionsMap() {
    return this._requestUserPermissionsMap;
  }

  /**
   * @param requestUserPermissionsMap{java.util.Map<number,Boolean>}
   * @return {ZmCollection}
   */
  setRequestUserPermissionsMap(requestUserPermissionsMap) {
    this._requestUserPermissionsMap = requestUserPermissionsMap;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadata() {
    return this._metadata;
  }

  /**
   * @param metadata{java.util.Map<String,String>}
   * @return {ZmCollection}
   */
  setMetadata(metadata) {
    this._metadata = metadata;
    return this;
  }

  /**
   * @return {HashSet}
   */
  getTags() {
    return this._tags;
  }

  /**
   * @param tags{HashSet}
   * @return {ZmCollection}
   */
  setTags(tags) {
    this._tags = tags;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ZmCollection.CLASS_ID;
    
	//Serializing _totalChildCollections
	if (this._totalChildCollections)
		json['totalChildCollections'] = this._totalChildCollections;

	//Serializing _creator
	if (this._creator)
		json['creator'] = this._creator;

	//Serializing _totalAssets
	if (this._totalAssets)
		json['totalAssets'] = this._totalAssets;

	//Serializing _displayName
	if (this._displayName)
		json['displayName'] = this._displayName;

	//Serializing _bin
	if (this._bin)
		json['bin'] = this._bin;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _description
	if (this._description)
		json['description'] = this._description;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;

	//Serializing _createdOn
	if (this._createdOn)
		json['createdOn'] = this._createdOn;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;

	//Serializing _hasDynamicFilters
	if (this._hasDynamicFilters)
		json['hasDynamicFilters'] = this._hasDynamicFilters;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _expiresOn
	if (this._expiresOn)
		json['expiresOn'] = this._expiresOn;

	//Serializing _useLatestRevisionOfAssets
	if (this._useLatestRevisionOfAssets)
		json['useLatestRevisionOfAssets'] = this._useLatestRevisionOfAssets;

	//Serializing _modifiedBy
	if (this._modifiedBy)
		json['modifiedBy'] = this._modifiedBy;

	//Serializing _dynamic
	if (this._dynamic)
		json['dynamic'] = this._dynamic;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _status
	if (this._status)
		json['status'] = this._status;
  if (this._childCollections && this._childCollections.length > 0) {
    let childCollections_JSON = [];
    /**
     * @type {int}
     */
    this._childCollections.forEach((o329) => {
      if (o329) {
        if (o329.serializeJson && (typeof (o329.serializeJson) === 'function')) {
          childCollections_JSON.push(o329.serializeJson());
        } else {
          childCollections_JSON.push(o329);
        }
      }
    });
    json['childCollections'] = childCollections_JSON;
  }  
  if (this._lightboxThumbInfo && this._lightboxThumbInfo.length > 0) {
    let lightboxThumbInfo_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._lightboxThumbInfo.forEach((o332) => {
      if (o332) {
        if (o332.serializeJson && (typeof (o332.serializeJson) === 'function')) {
          lightboxThumbInfo_JSON.push(o332.serializeJson());
        } else {
          lightboxThumbInfo_JSON.push(o332);
        }
      }
    });
    json['lightboxThumbInfo'] = lightboxThumbInfo_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"requestUserPermissionsMap", this._requestUserPermissionsMap);
		    SerializationUtil.serializeHashMap(json,"metadata", this._metadata);
		SerializationUtil.serializeSet(json, "tags", this._tags, true);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._totalChildCollections = json.hasOwnProperty("totalChildCollections")?json["totalChildCollections"]:0;
		this._creator = json.hasOwnProperty("creator")?json["creator"]:null;
		this._totalAssets = json.hasOwnProperty("totalAssets")?json["totalAssets"]:0;
		this._displayName = json.hasOwnProperty("displayName")?json["displayName"]:null;
		this._bin = json.hasOwnProperty("bin")?json["bin"]:false;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._description = json.hasOwnProperty("description")?json["description"]:null;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;
		this._message = json.hasOwnProperty("message")?json["message"]:null;
		this._createdOn = json.hasOwnProperty("createdOn")?json["createdOn"]:0;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:0;
		this._hasDynamicFilters = json.hasOwnProperty("hasDynamicFilters")?json["hasDynamicFilters"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._expiresOn = json.hasOwnProperty("expiresOn")?json["expiresOn"]:0;
		this._useLatestRevisionOfAssets = json.hasOwnProperty("useLatestRevisionOfAssets")?json["useLatestRevisionOfAssets"]:false;
		this._modifiedBy = json.hasOwnProperty("modifiedBy")?json["modifiedBy"]:null;
		this._dynamic = json.hasOwnProperty("dynamic")?json["dynamic"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._status = json.hasOwnProperty("status")?json["status"]:null;
		//set of type int
		this._childCollections = [];
		let childCollectionsJSONArray = json.hasOwnProperty("childCollections") ? json["childCollections"] : [];

		childCollectionsJSONArray.forEach((o330)=>{
			if (o330){
				this._childCollections.push(o330);
			}
		});
		//set of type FuidRrnInfo
		this._lightboxThumbInfo = [];
		let lightboxThumbInfoJSONArray = json.hasOwnProperty("lightboxThumbInfo") ? json["lightboxThumbInfo"] : [];

		lightboxThumbInfoJSONArray.forEach((o333)=>{
			if (o333){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o333);
				this._lightboxThumbInfo.push(classObj);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._requestUserPermissionsMap == null)
			this._requestUserPermissionsMap = new HashMap();
		this._requestUserPermissionsMap.clear();
		let requestUserPermissionsMapJSONArray = json.hasOwnProperty("requestUserPermissionsMap") ? json["requestUserPermissionsMap"] : [];
		this._requestUserPermissionsMap = SerializationUtil.deserializeMap(requestUserPermissionsMapJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._metadata == null)
			this._metadata = new HashMap();
		this._metadata.clear();
		let metadataJSONArray = json.hasOwnProperty("metadata") ? json["metadata"] : [];
		this._metadata = SerializationUtil.deserializeMap(metadataJSONArray);

//set of type STRING
		if (!this._tags)
			this._tags = new HashSet();
		this._tags.clear();
		let tagsJSONArray = json.hasOwnProperty("tags") ? json["tags"] : [];
		this._tags = SerializationUtil.deserializeSet(tagsJSONArray);

  }
}

/**
 * @returns {string}
 */
ZmCollection.CLASS_ID = "com.zoom.vab.client.autogenerated.ZmCollection";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class KVMap {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._kvMap = null;

  }

    /**
   * @return {java.util.Map<String,String>}
   */
  getKvMap() {
    return this._kvMap;
  }

  /**
   * @param kvMap{java.util.Map<String,String>}
   * @return {KVMap}
   */
  setKvMap(kvMap) {
    this._kvMap = kvMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = KVMap.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"kvMap", this._kvMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._kvMap == null)
			this._kvMap = new HashMap();
		this._kvMap.clear();
		let kvMapJSONArray = json.hasOwnProperty("kvMap") ? json["kvMap"] : [];
		this._kvMap = SerializationUtil.deserializeMap(kvMapJSONArray);



  }
}

/**
 * @returns {string}
 */
KVMap.CLASS_ID = "com.zoom.vab.client.autogenerated.KVMap";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LiveDrawEntry {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._liveDrawId = null;
    /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {string}
     * @private
     */
    this._author = null;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._cTime = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._liveDrawProperties = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._userId2Color = null;

  }

    /**
   * @return {number}
   */
  getLiveDrawId() {
    return this._liveDrawId;
  }

  /**
   * @param liveDrawId{number}
   * @return {LiveDrawEntry}
   */
  setLiveDrawId(liveDrawId) {
    this._liveDrawId = liveDrawId;
    return this;
  }
  /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {LiveDrawEntry}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {string}
   */
  getAuthor() {
    return this._author;
  }

  /**
   * @param author{string}
   * @return {LiveDrawEntry}
   */
  setAuthor(author) {
    this._author = author;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {LiveDrawEntry}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getCTime() {
    return this._cTime;
  }

  /**
   * @param cTime{number}
   * @return {LiveDrawEntry}
   */
  setCTime(cTime) {
    this._cTime = cTime;
    return this;
  }
  /**
   * Any kind of properties can be stored.
   * @return {java.util.Map<String,String>}
   */
  getLiveDrawProperties() {
    return this._liveDrawProperties;
  }

  /**
   * @param liveDrawProperties{java.util.Map<String,String>}
   * @return {LiveDrawEntry}
   */
  setLiveDrawProperties(liveDrawProperties) {
    this._liveDrawProperties = liveDrawProperties;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getUserId2Color() {
    return this._userId2Color;
  }

  /**
   * @param userId2Color{java.util.Map<String,String>}
   * @return {LiveDrawEntry}
   */
  setUserId2Color(userId2Color) {
    this._userId2Color = userId2Color;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LiveDrawEntry.CLASS_ID;
    
	//Serializing _liveDrawId
	if (this._liveDrawId)
		json['liveDrawId'] = this._liveDrawId;

	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _author
	if (this._author)
		json['author'] = this._author;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _cTime
	if (this._cTime)
		json['cTime'] = this._cTime;
    SerializationUtil.serializeHashMap(json,"liveDrawProperties", this._liveDrawProperties);
		    SerializationUtil.serializeHashMap(json,"userId2Color", this._userId2Color);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._liveDrawId = json.hasOwnProperty("liveDrawId")?json["liveDrawId"]:0;
		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._author = json.hasOwnProperty("author")?json["author"]:null;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._cTime = json.hasOwnProperty("cTime")?json["cTime"]:0;
//Map of type STRING. Decode as tree:false
		if (this._liveDrawProperties == null)
			this._liveDrawProperties = new HashMap();
		this._liveDrawProperties.clear();
		let liveDrawPropertiesJSONArray = json.hasOwnProperty("liveDrawProperties") ? json["liveDrawProperties"] : [];
		this._liveDrawProperties = SerializationUtil.deserializeMap(liveDrawPropertiesJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._userId2Color == null)
			this._userId2Color = new HashMap();
		this._userId2Color.clear();
		let userId2ColorJSONArray = json.hasOwnProperty("userId2Color") ? json["userId2Color"] : [];
		this._userId2Color = SerializationUtil.deserializeMap(userId2ColorJSONArray);



  }
}

/**
 * @returns {string}
 */
LiveDrawEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.LiveDrawEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetImageAiDataResponse {

  constructor() {
    
        /**
     * @type {Array<ImageAiData>}
     * @private
     */
    this._imageAiDatas = null;

  }

    /**
   * @return {Array<ImageAiData>}
   */
  getImageAiDatas() {
    return this._imageAiDatas;
  }

  /**
   * @param imageAiDatas{Array<ImageAiData>}
   * @return {GetImageAiDataResponse}
   */
  setImageAiDatas(imageAiDatas) {
    this._imageAiDatas = imageAiDatas;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetImageAiDataResponse.CLASS_ID;
      if (this._imageAiDatas && this._imageAiDatas.length > 0) {
    let imageAiDatas_JSON = [];
    /**
     * @type {ImageAiData}
     */
    this._imageAiDatas.forEach((o387) => {
      if (o387) {
        if (o387.serializeJson && (typeof (o387.serializeJson) === 'function')) {
          imageAiDatas_JSON.push(o387.serializeJson());
        } else {
          imageAiDatas_JSON.push(o387);
        }
      }
    });
    json['imageAiDatas'] = imageAiDatas_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type ImageAiData
		this._imageAiDatas = [];
		let imageAiDatasJSONArray = json.hasOwnProperty("imageAiDatas") ? json["imageAiDatas"] : [];

		imageAiDatasJSONArray.forEach((o388)=>{
			if (o388){
				let classObj = new ImageAiData();
				classObj.deserializeJson(o388);
				this._imageAiDatas.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetImageAiDataResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetImageAiDataResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FacetedItemInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._displayLabel = null;
    /**
     * @type {number}
     * @private
     */
    this._count = null;
    /**
     * @type {string}
     * @private
     */
    this._tooltip = null;
    /**
     * @type {string}
     * @private
     */
    this._label = null;
    /**
     * @type {number}
     * @private
     */
    this._id = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;
    /**
     * @type {boolean}
     * @private
     */
    this._selected = false;
    /**
     * @type {number}
     * @private
     */
    this._parentId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._singleSelect = false;
    /**
     * @type {string}
     * @private
     */
    this._metadataType = null;
    /**
     * @type {string}
     * @private
     */
    this._groupCode = null;
    /**
     * @type {Array<FacetedItemInfo>}
     * @private
     */
    this._children = null;

  }

    /**
   * @return {string}
   */
  getDisplayLabel() {
    return this._displayLabel;
  }

  /**
   * @param displayLabel{string}
   * @return {FacetedItemInfo}
   */
  setDisplayLabel(displayLabel) {
    this._displayLabel = displayLabel;
    return this;
  }
  /**
   * @return {number}
   */
  getCount() {
    return this._count;
  }

  /**
   * @param count{number}
   * @return {FacetedItemInfo}
   */
  setCount(count) {
    this._count = count;
    return this;
  }
  /**
   * @return {string}
   */
  getTooltip() {
    return this._tooltip;
  }

  /**
   * @param tooltip{string}
   * @return {FacetedItemInfo}
   */
  setTooltip(tooltip) {
    this._tooltip = tooltip;
    return this;
  }
  /**
   * @return {string}
   */
  getLabel() {
    return this._label;
  }

  /**
   * @param label{string}
   * @return {FacetedItemInfo}
   */
  setLabel(label) {
    this._label = label;
    return this;
  }
  /**
   * @return {number}
   */
  getId() {
    return this._id;
  }

  /**
   * @param id{number}
   * @return {FacetedItemInfo}
   */
  setId(id) {
    this._id = id;
    return this;
  }
  /**
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {FacetedItemInfo}
   */
  setValue(value) {
    this._value = value;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSelected() {
    return this._selected;
  }

  /**
   * @param selected{boolean}
   * @return {FacetedItemInfo}
   */
  setSelected(selected) {
    this._selected = selected;
    return this;
  }
  /**
   * @return {number}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{number}
   * @return {FacetedItemInfo}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSingleSelect() {
    return this._singleSelect;
  }

  /**
   * @param singleSelect{boolean}
   * @return {FacetedItemInfo}
   */
  setSingleSelect(singleSelect) {
    this._singleSelect = singleSelect;
    return this;
  }
  /**
   * @return {string}
   */
  getMetadataType() {
    return this._metadataType;
  }

  /**
   * @param metadataType{string}
   * @return {FacetedItemInfo}
   */
  setMetadataType(metadataType) {
    this._metadataType = metadataType;
    return this;
  }
  /**
   * @return {string}
   */
  getGroupCode() {
    return this._groupCode;
  }

  /**
   * @param groupCode{string}
   * @return {FacetedItemInfo}
   */
  setGroupCode(groupCode) {
    this._groupCode = groupCode;
    return this;
  }
  /**
   * @return {Array<FacetedItemInfo>}
   */
  getChildren() {
    return this._children;
  }

  /**
   * @param children{Array<FacetedItemInfo>}
   * @return {FacetedItemInfo}
   */
  setChildren(children) {
    this._children = children;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FacetedItemInfo.CLASS_ID;
    
	//Serializing _displayLabel
	if (this._displayLabel)
		json['displayLabel'] = this._displayLabel;

	//Serializing _count
	if (this._count)
		json['count'] = this._count;

	//Serializing _tooltip
	if (this._tooltip)
		json['tooltip'] = this._tooltip;

	//Serializing _label
	if (this._label)
		json['label'] = this._label;

	//Serializing _id
	if (this._id)
		json['id'] = this._id;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;

	//Serializing _selected
	if (this._selected)
		json['selected'] = this._selected;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;

	//Serializing _singleSelect
	if (this._singleSelect)
		json['singleSelect'] = this._singleSelect;

	//Serializing _metadataType
	if (this._metadataType)
		json['metadataType'] = this._metadataType;

	//Serializing _groupCode
	if (this._groupCode)
		json['groupCode'] = this._groupCode;
  if (this._children && this._children.length > 0) {
    let children_JSON = [];
    /**
     * @type {FacetedItemInfo}
     */
    this._children.forEach((o445) => {
      if (o445) {
        if (o445.serializeJson && (typeof (o445.serializeJson) === 'function')) {
          children_JSON.push(o445.serializeJson());
        } else {
          children_JSON.push(o445);
        }
      }
    });
    json['children'] = children_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._displayLabel = json.hasOwnProperty("displayLabel")?json["displayLabel"]:null;
		this._count = json.hasOwnProperty("count")?json["count"]:0;
		this._tooltip = json.hasOwnProperty("tooltip")?json["tooltip"]:null;
		this._label = json.hasOwnProperty("label")?json["label"]:null;
		this._id = json.hasOwnProperty("id")?json["id"]:0;
		this._value = json.hasOwnProperty("value")?json["value"]:null;
		this._selected = json.hasOwnProperty("selected")?json["selected"]:false;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:0;
		this._singleSelect = json.hasOwnProperty("singleSelect")?json["singleSelect"]:false;
		this._metadataType = json.hasOwnProperty("metadataType")?json["metadataType"]:null;
		this._groupCode = json.hasOwnProperty("groupCode")?json["groupCode"]:null;
		//set of type FacetedItemInfo
		this._children = [];
		let childrenJSONArray = json.hasOwnProperty("children") ? json["children"] : [];

		childrenJSONArray.forEach((o446)=>{
			if (o446){
				let classObj = new FacetedItemInfo();
				classObj.deserializeJson(o446);
				this._children.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FacetedItemInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.FacetedItemInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageLimit = null;
    /**
     * @type {number}
     * @private
     */
    this._thumbImageCount = null;
    /**
     * @type {boolean}
     * @private
     */
    this._fetchFullList = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyBins = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {number}
     * @private
     */
    this._begIndex = null;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyCollections = false;
    /**
     * @type {LsCollectionSortCriteria}
     * @private
     */
    this._lsCollectionSortCriteria = null;
    /**
     * @type {CollectionFilters}
     * @private
     */
    this._collectionFilters = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._searchValues = null;

  }

    /**
   * @return {number}
   */
  getPageLimit() {
    return this._pageLimit;
  }

  /**
   * @param pageLimit{number}
   * @return {LsZmCollectionsMessage}
   */
  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }
  /**
   * @return {number}
   */
  getThumbImageCount() {
    return this._thumbImageCount;
  }

  /**
   * @param thumbImageCount{number}
   * @return {LsZmCollectionsMessage}
   */
  setThumbImageCount(thumbImageCount) {
    this._thumbImageCount = thumbImageCount;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFetchFullList() {
    return this._fetchFullList;
  }

  /**
   * @param fetchFullList{boolean}
   * @return {LsZmCollectionsMessage}
   */
  setFetchFullList(fetchFullList) {
    this._fetchFullList = fetchFullList;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyBins() {
    return this._onlyBins;
  }

  /**
   * @param onlyBins{boolean}
   * @return {LsZmCollectionsMessage}
   */
  setOnlyBins(onlyBins) {
    this._onlyBins = onlyBins;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {LsZmCollectionsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {number}
   */
  getBegIndex() {
    return this._begIndex;
  }

  /**
   * @param begIndex{number}
   * @return {LsZmCollectionsMessage}
   */
  setBegIndex(begIndex) {
    this._begIndex = begIndex;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyCollections() {
    return this._onlyCollections;
  }

  /**
   * @param onlyCollections{boolean}
   * @return {LsZmCollectionsMessage}
   */
  setOnlyCollections(onlyCollections) {
    this._onlyCollections = onlyCollections;
    return this;
  }
  /**
   * @return {LsCollectionSortCriteria}
   */
  getLsCollectionSortCriteria() {
    return this._lsCollectionSortCriteria;
  }

  /**
   * @param lsCollectionSortCriteria{LsCollectionSortCriteria}
   * @return {LsZmCollectionsMessage}
   */
  setLsCollectionSortCriteria(lsCollectionSortCriteria) {
    this._lsCollectionSortCriteria = lsCollectionSortCriteria;
    return this;
  }
  /**
   * @return {CollectionFilters}
   */
  getCollectionFilters() {
    return this._collectionFilters;
  }

  /**
   * @param collectionFilters{CollectionFilters}
   * @return {LsZmCollectionsMessage}
   */
  setCollectionFilters(collectionFilters) {
    this._collectionFilters = collectionFilters;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getSearchValues() {
    return this._searchValues;
  }

  /**
   * @param searchValues{Array<String>}
   * @return {LsZmCollectionsMessage}
   */
  setSearchValues(searchValues) {
    this._searchValues = searchValues;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionsMessage.CLASS_ID;
    
	//Serializing _pageLimit
	if (this._pageLimit)
		json['pageLimit'] = this._pageLimit;

	//Serializing _thumbImageCount
	if (this._thumbImageCount)
		json['thumbImageCount'] = this._thumbImageCount;

	//Serializing _fetchFullList
	if (this._fetchFullList)
		json['fetchFullList'] = this._fetchFullList;

	//Serializing _onlyBins
	if (this._onlyBins)
		json['onlyBins'] = this._onlyBins;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _begIndex
	if (this._begIndex)
		json['begIndex'] = this._begIndex;

	//Serializing _onlyCollections
	if (this._onlyCollections)
		json['onlyCollections'] = this._onlyCollections;

	//Serializing ComplexType _$arrayName
	if (this._lsCollectionSortCriteria)
		json['lsCollectionSortCriteria'] = this._lsCollectionSortCriteria.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._collectionFilters)
		json['collectionFilters'] = this._collectionFilters.serializeJson();
		  if (this._searchValues && this._searchValues.length > 0) {
    let searchValues_JSON = [];
    /**
     * @type {string}
     */
    this._searchValues.forEach((o828) => {
      if (o828) {
        if (o828.serializeJson && (typeof (o828.serializeJson) === 'function')) {
          searchValues_JSON.push(o828.serializeJson());
        } else {
          searchValues_JSON.push(o828);
        }
      }
    });
    json['searchValues'] = searchValues_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageLimit = json.hasOwnProperty("pageLimit")?json["pageLimit"]:0;
		this._thumbImageCount = json.hasOwnProperty("thumbImageCount")?json["thumbImageCount"]:0;
		this._fetchFullList = json.hasOwnProperty("fetchFullList")?json["fetchFullList"]:false;
		this._onlyBins = json.hasOwnProperty("onlyBins")?json["onlyBins"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._begIndex = json.hasOwnProperty("begIndex")?json["begIndex"]:0;
		this._onlyCollections = json.hasOwnProperty("onlyCollections")?json["onlyCollections"]:false;
		if (json.hasOwnProperty("lsCollectionSortCriteria")){
			if (!this._lsCollectionSortCriteria && this._lsCollectionSortCriteria == null)
				this._lsCollectionSortCriteria = new LsCollectionSortCriteria();
			this._lsCollectionSortCriteria.deserializeJson(json.hasOwnProperty("lsCollectionSortCriteria") ? json["lsCollectionSortCriteria"] : null);
		}

		if (json.hasOwnProperty("collectionFilters")){
			if (!this._collectionFilters && this._collectionFilters == null)
				this._collectionFilters = new CollectionFilters();
			this._collectionFilters.deserializeJson(json.hasOwnProperty("collectionFilters") ? json["collectionFilters"] : null);
		}

		//set of type string
		this._searchValues = [];
		let searchValuesJSONArray = json.hasOwnProperty("searchValues") ? json["searchValues"] : [];

		searchValuesJSONArray.forEach((o829)=>{
			if (o829){
				this._searchValues.push(o829);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetMetadataMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._updateInCache = false;
    /**
     * @type {string}
     * @private
     */
    this._aiDataSortBy = null;
    /**
     * @type {boolean}
     * @private
     */
    this._fetchAiData = false;
    /**
     * @type {number}
     * @private
     */
    this._aiDataLimit = null;
    /**
     * @type {string}
     * @private
     */
    this._aiDataGroupBy = null;
    /**
     * @type {number}
     * @private
     */
    this._aiDataStartIndex = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidList = null;
    /**
     * @type {Array<KeyValuePair>}
     * @private
     */
    this._metadataFilters = null;

  }

    /**
   * @return {boolean}
   */
  isUpdateInCache() {
    return this._updateInCache;
  }

  /**
   * @param updateInCache{boolean}
   * @return {GetMetadataMsg}
   */
  setUpdateInCache(updateInCache) {
    this._updateInCache = updateInCache;
    return this;
  }
  /**
   * @return {string}
   */
  getAiDataSortBy() {
    return this._aiDataSortBy;
  }

  /**
   * @param aiDataSortBy{string}
   * @return {GetMetadataMsg}
   */
  setAiDataSortBy(aiDataSortBy) {
    this._aiDataSortBy = aiDataSortBy;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFetchAiData() {
    return this._fetchAiData;
  }

  /**
   * @param fetchAiData{boolean}
   * @return {GetMetadataMsg}
   */
  setFetchAiData(fetchAiData) {
    this._fetchAiData = fetchAiData;
    return this;
  }
  /**
   * @return {number}
   */
  getAiDataLimit() {
    return this._aiDataLimit;
  }

  /**
   * @param aiDataLimit{number}
   * @return {GetMetadataMsg}
   */
  setAiDataLimit(aiDataLimit) {
    this._aiDataLimit = aiDataLimit;
    return this;
  }
  /**
   * @return {string}
   */
  getAiDataGroupBy() {
    return this._aiDataGroupBy;
  }

  /**
   * @param aiDataGroupBy{string}
   * @return {GetMetadataMsg}
   */
  setAiDataGroupBy(aiDataGroupBy) {
    this._aiDataGroupBy = aiDataGroupBy;
    return this;
  }
  /**
   * @return {number}
   */
  getAiDataStartIndex() {
    return this._aiDataStartIndex;
  }

  /**
   * @param aiDataStartIndex{number}
   * @return {GetMetadataMsg}
   */
  setAiDataStartIndex(aiDataStartIndex) {
    this._aiDataStartIndex = aiDataStartIndex;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetMetadataMsg}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<FuidRrnInfo>}
   */
  getFuidList() {
    return this._fuidList;
  }

  /**
   * @param fuidList{Array<FuidRrnInfo>}
   * @return {GetMetadataMsg}
   */
  setFuidList(fuidList) {
    this._fuidList = fuidList;
    return this;
  }

  /**
   * @return {Array<KeyValuePair>}
   */
  getMetadataFilters() {
    return this._metadataFilters;
  }

  /**
   * @param metadataFilters{Array<KeyValuePair>}
   * @return {GetMetadataMsg}
   */
  setMetadataFilters(metadataFilters) {
    this._metadataFilters = metadataFilters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetMetadataMsg.CLASS_ID;
    
	//Serializing _updateInCache
	if (this._updateInCache)
		json['updateInCache'] = this._updateInCache;

	//Serializing _aiDataSortBy
	if (this._aiDataSortBy)
		json['aiDataSortBy'] = this._aiDataSortBy;

	//Serializing _fetchAiData
	if (this._fetchAiData)
		json['fetchAiData'] = this._fetchAiData;

	//Serializing _aiDataLimit
	if (this._aiDataLimit)
		json['aiDataLimit'] = this._aiDataLimit;

	//Serializing _aiDataGroupBy
	if (this._aiDataGroupBy)
		json['aiDataGroupBy'] = this._aiDataGroupBy;

	//Serializing _aiDataStartIndex
	if (this._aiDataStartIndex)
		json['aiDataStartIndex'] = this._aiDataStartIndex;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._fuidList && this._fuidList.length > 0) {
    let fuidList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidList.forEach((o1077) => {
      if (o1077) {
        if (o1077.serializeJson && (typeof (o1077.serializeJson) === 'function')) {
          fuidList_JSON.push(o1077.serializeJson());
        } else {
          fuidList_JSON.push(o1077);
        }
      }
    });
    json['fuidList'] = fuidList_JSON;
  }  
  if (this._metadataFilters && this._metadataFilters.length > 0) {
    let metadataFilters_JSON = [];
    /**
     * @type {KeyValuePair}
     */
    this._metadataFilters.forEach((o1080) => {
      if (o1080) {
        if (o1080.serializeJson && (typeof (o1080.serializeJson) === 'function')) {
          metadataFilters_JSON.push(o1080.serializeJson());
        } else {
          metadataFilters_JSON.push(o1080);
        }
      }
    });
    json['metadataFilters'] = metadataFilters_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._updateInCache = json.hasOwnProperty("updateInCache")?json["updateInCache"]:false;
		this._aiDataSortBy = json.hasOwnProperty("aiDataSortBy")?json["aiDataSortBy"]:null;
		this._fetchAiData = json.hasOwnProperty("fetchAiData")?json["fetchAiData"]:false;
		this._aiDataLimit = json.hasOwnProperty("aiDataLimit")?json["aiDataLimit"]:0;
		this._aiDataGroupBy = json.hasOwnProperty("aiDataGroupBy")?json["aiDataGroupBy"]:null;
		this._aiDataStartIndex = json.hasOwnProperty("aiDataStartIndex")?json["aiDataStartIndex"]:0;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type FuidRrnInfo
		this._fuidList = [];
		let fuidListJSONArray = json.hasOwnProperty("fuidList") ? json["fuidList"] : [];

		fuidListJSONArray.forEach((o1078)=>{
			if (o1078){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o1078);
				this._fuidList.push(classObj);
			}
		});
		//set of type KeyValuePair
		this._metadataFilters = [];
		let metadataFiltersJSONArray = json.hasOwnProperty("metadataFilters") ? json["metadataFilters"] : [];

		metadataFiltersJSONArray.forEach((o1081)=>{
			if (o1081){
				let classObj = new KeyValuePair();
				classObj.deserializeJson(o1081);
				this._metadataFilters.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetMetadataMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetMetadataMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ApproveRejectCollectionMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._approve = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {boolean}
   */
  isApprove() {
    return this._approve;
  }

  /**
   * @param approve{boolean}
   * @return {ApproveRejectCollectionMessage}
   */
  setApprove(approve) {
    this._approve = approve;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {ApproveRejectCollectionMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ApproveRejectCollectionMessage.CLASS_ID;
    
	//Serializing _approve
	if (this._approve)
		json['approve'] = this._approve;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._approve = json.hasOwnProperty("approve")?json["approve"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
ApproveRejectCollectionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ApproveRejectCollectionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CategoryChangeMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._categoryId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._selected = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._typeToFacetedItemMap = null;

  }

    /**
   * @return {string}
   */
  getCategoryId() {
    return this._categoryId;
  }

  /**
   * @param categoryId{string}
   * @return {CategoryChangeMsg}
   */
  setCategoryId(categoryId) {
    this._categoryId = categoryId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSelected() {
    return this._selected;
  }

  /**
   * @param selected{boolean}
   * @return {CategoryChangeMsg}
   */
  setSelected(selected) {
    this._selected = selected;
    return this;
  }
  /**
   * @return {java.util.Map<String,FacetedItemInfo>}
   */
  getTypeToFacetedItemMap() {
    return this._typeToFacetedItemMap;
  }

  /**
   * @param typeToFacetedItemMap{java.util.Map<String,FacetedItemInfo>}
   * @return {CategoryChangeMsg}
   */
  setTypeToFacetedItemMap(typeToFacetedItemMap) {
    this._typeToFacetedItemMap = typeToFacetedItemMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CategoryChangeMsg.CLASS_ID;
    
	//Serializing _categoryId
	if (this._categoryId)
		json['categoryId'] = this._categoryId;

	//Serializing _selected
	if (this._selected)
		json['selected'] = this._selected;
    SerializationUtil.serializeHashMap(json,"typeToFacetedItemMap", this._typeToFacetedItemMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._categoryId = json.hasOwnProperty("categoryId")?json["categoryId"]:null;
		this._selected = json.hasOwnProperty("selected")?json["selected"]:false;
//Map of type STRING. Decode as tree:false
		if (this._typeToFacetedItemMap == null)
			this._typeToFacetedItemMap = new HashMap();
		this._typeToFacetedItemMap.clear();
		let typeToFacetedItemMapJSONArray = json.hasOwnProperty("typeToFacetedItemMap") ? json["typeToFacetedItemMap"] : [];
		this._typeToFacetedItemMap = SerializationUtil.deserializeMap(typeToFacetedItemMapJSONArray);



  }
}

/**
 * @returns {string}
 */
CategoryChangeMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.CategoryChangeMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SearchInsideMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._filterText = null;

  }

    /**
   * @return {string}
   */
  getFilterText() {
    return this._filterText;
  }

  /**
   * @param filterText{string}
   * @return {SearchInsideMsg}
   */
  setFilterText(filterText) {
    this._filterText = filterText;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SearchInsideMsg.CLASS_ID;
    
	//Serializing _filterText
	if (this._filterText)
		json['filterText'] = this._filterText;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._filterText = json.hasOwnProperty("filterText")?json["filterText"]:null;


  }
}

/**
 * @returns {string}
 */
SearchInsideMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.SearchInsideMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetExportMetadataQuery extends HttpOperation {

  constructor(name = "GetExportMetadata") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetExportMetadataMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetExportMetadataMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetExportMetadataRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetExportMetadataQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetExportMetadataQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetExportMetadataRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetExportMetadataRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetExportMetadataQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetExportMetadata";
/**
 * @returns {string}
 */
GetExportMetadataQuery.QUERY_NAME = "GetExportMetadata";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteCollectionMetadataForWebClientQuery extends HttpOperation {

  constructor(name = "DeleteCollectionMetadataForWebClient") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteCollectionMetadataMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteCollectionMetadataMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SetCollectionMetadataResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteCollectionMetadataForWebClientQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteCollectionMetadataForWebClientQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SetCollectionMetadataResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteCollectionMetadataForWebClientQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteCollectionMetadataForWebClient";
/**
 * @returns {string}
 */
DeleteCollectionMetadataForWebClientQuery.QUERY_NAME = "DeleteCollectionMetadataForWebClient";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ListLiveDrawsResponse {

  constructor() {
    
        /**
     * @type {Array<LiveDrawEntry>}
     * @private
     */
    this._liveDraws = null;

  }

    /**
   * @return {Array<LiveDrawEntry>}
   */
  getLiveDraws() {
    return this._liveDraws;
  }

  /**
   * @param liveDraws{Array<LiveDrawEntry>}
   * @return {ListLiveDrawsResponse}
   */
  setLiveDraws(liveDraws) {
    this._liveDraws = liveDraws;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ListLiveDrawsResponse.CLASS_ID;
      if (this._liveDraws && this._liveDraws.length > 0) {
    let liveDraws_JSON = [];
    /**
     * @type {LiveDrawEntry}
     */
    this._liveDraws.forEach((o1008) => {
      if (o1008) {
        if (o1008.serializeJson && (typeof (o1008.serializeJson) === 'function')) {
          liveDraws_JSON.push(o1008.serializeJson());
        } else {
          liveDraws_JSON.push(o1008);
        }
      }
    });
    json['liveDraws'] = liveDraws_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type LiveDrawEntry
		this._liveDraws = [];
		let liveDrawsJSONArray = json.hasOwnProperty("liveDraws") ? json["liveDraws"] : [];

		liveDrawsJSONArray.forEach((o1009)=>{
			if (o1009){
				let classObj = new LiveDrawEntry();
				classObj.deserializeJson(o1009);
				this._liveDraws.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
ListLiveDrawsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ListLiveDrawsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FavItemDetail {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._latestRRN = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isFile = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;
    /**
     * @type {string}
     * @private
     */
    this._fqPath = null;
    /**
     * @type {string}
     * @private
     */
    this._assetType = null;

  }

    /**
   * @return {number}
   */
  getLatestRRN() {
    return this._latestRRN;
  }

  /**
   * @param latestRRN{number}
   * @return {FavItemDetail}
   */
  setLatestRRN(latestRRN) {
    this._latestRRN = latestRRN;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsFile() {
    return this._isFile;
  }

  /**
   * @param isFile{boolean}
   * @return {FavItemDetail}
   */
  setIsFile(isFile) {
    this._isFile = isFile;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {FavItemDetail}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FavItemDetail}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FavItemDetail}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {FavItemDetail}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {string}
   */
  getFqPath() {
    return this._fqPath;
  }

  /**
   * @param fqPath{string}
   * @return {FavItemDetail}
   */
  setFqPath(fqPath) {
    this._fqPath = fqPath;
    return this;
  }
  /**
   * @return {string}
   */
  getAssetType() {
    return this._assetType;
  }

  /**
   * @param assetType{string}
   * @return {FavItemDetail}
   */
  setAssetType(assetType) {
    this._assetType = assetType;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FavItemDetail.CLASS_ID;
    
	//Serializing _latestRRN
	if (this._latestRRN)
		json['latestRRN'] = this._latestRRN;

	//Serializing _isFile
	if (this._isFile)
		json['isFile'] = this._isFile;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;

	//Serializing _fqPath
	if (this._fqPath)
		json['fqPath'] = this._fqPath;

	//Serializing _assetType
	if (this._assetType)
		json['assetType'] = this._assetType;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._latestRRN = json.hasOwnProperty("latestRRN")?json["latestRRN"]:0;
		this._isFile = json.hasOwnProperty("isFile")?json["isFile"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;
		this._fqPath = json.hasOwnProperty("fqPath")?json["fqPath"]:null;
		this._assetType = json.hasOwnProperty("assetType")?json["assetType"]:null;


  }
}

/**
 * @returns {string}
 */
FavItemDetail.CLASS_ID = "com.zoom.vab.client.autogenerated.FavItemDetail";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetFiltersMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._useCurrentFuidSet = false;
    /**
     * @type {boolean}
     * @private
     */
    this._reset = false;
    /**
     * @type {boolean}
     * @private
     */
    this._useCategoryListForResponse = false;
    /**
     * @type {Array<CategoryQueryVAB>}
     * @private
     */
    this._categoryList = null;

  }

    /**
   * @return {boolean}
   */
  isUseCurrentFuidSet() {
    return this._useCurrentFuidSet;
  }

  /**
   * @param useCurrentFuidSet{boolean}
   * @return {GetFiltersMessage}
   */
  setUseCurrentFuidSet(useCurrentFuidSet) {
    this._useCurrentFuidSet = useCurrentFuidSet;
    return this;
  }
  /**
   * @return {boolean}
   */
  isReset() {
    return this._reset;
  }

  /**
   * @param reset{boolean}
   * @return {GetFiltersMessage}
   */
  setReset(reset) {
    this._reset = reset;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseCategoryListForResponse() {
    return this._useCategoryListForResponse;
  }

  /**
   * @param useCategoryListForResponse{boolean}
   * @return {GetFiltersMessage}
   */
  setUseCategoryListForResponse(useCategoryListForResponse) {
    this._useCategoryListForResponse = useCategoryListForResponse;
    return this;
  }
  /**
   * @return {Array<CategoryQueryVAB>}
   */
  getCategoryList() {
    return this._categoryList;
  }

  /**
   * @param categoryList{Array<CategoryQueryVAB>}
   * @return {GetFiltersMessage}
   */
  setCategoryList(categoryList) {
    this._categoryList = categoryList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetFiltersMessage.CLASS_ID;
    
	//Serializing _useCurrentFuidSet
	if (this._useCurrentFuidSet)
		json['useCurrentFuidSet'] = this._useCurrentFuidSet;

	//Serializing _reset
	if (this._reset)
		json['reset'] = this._reset;

	//Serializing _useCategoryListForResponse
	if (this._useCategoryListForResponse)
		json['useCategoryListForResponse'] = this._useCategoryListForResponse;
  if (this._categoryList && this._categoryList.length > 0) {
    let categoryList_JSON = [];
    /**
     * @type {CategoryQueryVAB}
     */
    this._categoryList.forEach((o395) => {
      if (o395) {
        if (o395.serializeJson && (typeof (o395.serializeJson) === 'function')) {
          categoryList_JSON.push(o395.serializeJson());
        } else {
          categoryList_JSON.push(o395);
        }
      }
    });
    json['categoryList'] = categoryList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._useCurrentFuidSet = json.hasOwnProperty("useCurrentFuidSet")?json["useCurrentFuidSet"]:false;
		this._reset = json.hasOwnProperty("reset")?json["reset"]:false;
		this._useCategoryListForResponse = json.hasOwnProperty("useCategoryListForResponse")?json["useCategoryListForResponse"]:false;
		//set of type CategoryQueryVAB
		this._categoryList = [];
		let categoryListJSONArray = json.hasOwnProperty("categoryList") ? json["categoryList"] : [];

		categoryListJSONArray.forEach((o396)=>{
			if (o396){
				let classObj = new CategoryQueryVAB();
				classObj.deserializeJson(o396);
				this._categoryList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetFiltersMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFiltersMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SendMailAlertForLightboxQuery extends HttpOperation {

  constructor(name = "SendMailAlertForLightbox") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SendMailAlertForLightboxQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SendMailAlertForLightboxQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SendMailAlertForLightboxQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SendMailAlertForLightbox";
/**
 * @returns {string}
 */
SendMailAlertForLightboxQuery.QUERY_NAME = "SendMailAlertForLightbox";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetOnlineUsersQuery extends HttpOperation {

  constructor(name = "GetOnlineUsers") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "MapType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {HashMap}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{HashMap}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetOnlineUsersResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetOnlineUsersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetOnlineUsersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetOnlineUsersResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetOnlineUsersResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetOnlineUsersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetOnlineUsers";
/**
 * @returns {string}
 */
GetOnlineUsersQuery.QUERY_NAME = "GetOnlineUsers";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionAssetsNextPageMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNumber = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {CurrentContextInfo}
     * @private
     */
    this._currentContextInfo = null;

  }

    /**
   * @return {number}
   */
  getPageNumber() {
    return this._pageNumber;
  }

  /**
   * @param pageNumber{number}
   * @return {LsZmCollectionAssetsNextPageMessage}
   */
  setPageNumber(pageNumber) {
    this._pageNumber = pageNumber;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {LsZmCollectionAssetsNextPageMessage}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {CurrentContextInfo}
   */
  getCurrentContextInfo() {
    return this._currentContextInfo;
  }

  /**
   * @param currentContextInfo{CurrentContextInfo}
   * @return {LsZmCollectionAssetsNextPageMessage}
   */
  setCurrentContextInfo(currentContextInfo) {
    this._currentContextInfo = currentContextInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionAssetsNextPageMessage.CLASS_ID;
    
	//Serializing _pageNumber
	if (this._pageNumber)
		json['pageNumber'] = this._pageNumber;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;

	//Serializing ComplexType _$arrayName
	if (this._currentContextInfo)
		json['currentContextInfo'] = this._currentContextInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNumber = json.hasOwnProperty("pageNumber")?json["pageNumber"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		if (json.hasOwnProperty("currentContextInfo")){
			if (!this._currentContextInfo && this._currentContextInfo == null)
				this._currentContextInfo = new CurrentContextInfo();
			this._currentContextInfo.deserializeJson(json.hasOwnProperty("currentContextInfo") ? json["currentContextInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
LsZmCollectionAssetsNextPageMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionAssetsNextPageMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetCollectionMetadataMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._append = false;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._collectionIds = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SetCollectionMetadataMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isAppend() {
    return this._append;
  }

  /**
   * @param append{boolean}
   * @return {SetCollectionMetadataMessage}
   */
  setAppend(append) {
    this._append = append;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getCollectionIds() {
    return this._collectionIds;
  }

  /**
   * @param collectionIds{Array<Integer>}
   * @return {SetCollectionMetadataMessage}
   */
  setCollectionIds(collectionIds) {
    this._collectionIds = collectionIds;
    return this;
  }

  /**
   * @return {java.util.Map<number,CollMetadata>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<number,CollMetadata>}
   * @return {SetCollectionMetadataMessage}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetCollectionMetadataMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _append
	if (this._append)
		json['append'] = this._append;
  if (this._collectionIds && this._collectionIds.length > 0) {
    let collectionIds_JSON = [];
    /**
     * @type {int}
     */
    this._collectionIds.forEach((o650) => {
      if (o650) {
        if (o650.serializeJson && (typeof (o650.serializeJson) === 'function')) {
          collectionIds_JSON.push(o650.serializeJson());
        } else {
          collectionIds_JSON.push(o650);
        }
      }
    });
    json['collectionIds'] = collectionIds_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._append = json.hasOwnProperty("append")?json["append"]:false;
		//set of type int
		this._collectionIds = [];
		let collectionIdsJSONArray = json.hasOwnProperty("collectionIds") ? json["collectionIds"] : [];

		collectionIdsJSONArray.forEach((o651)=>{
			if (o651){
				this._collectionIds.push(o651);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
SetCollectionMetadataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionMetadataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetExportMetadataMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._fileName = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuidList = null;

  }

    /**
   * @return {string}
   */
  getFileName() {
    return this._fileName;
  }

  /**
   * @param fileName{string}
   * @return {GetExportMetadataMsg}
   */
  setFileName(fileName) {
    this._fileName = fileName;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {GetExportMetadataMsg}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuidList() {
    return this._fuidList;
  }

  /**
   * @param fuidList{Array<Integer>}
   * @return {GetExportMetadataMsg}
   */
  setFuidList(fuidList) {
    this._fuidList = fuidList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetExportMetadataMsg.CLASS_ID;
    
	//Serializing _fileName
	if (this._fileName)
		json['fileName'] = this._fileName;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;
  if (this._fuidList && this._fuidList.length > 0) {
    let fuidList_JSON = [];
    /**
     * @type {int}
     */
    this._fuidList.forEach((o254) => {
      if (o254) {
        if (o254.serializeJson && (typeof (o254.serializeJson) === 'function')) {
          fuidList_JSON.push(o254.serializeJson());
        } else {
          fuidList_JSON.push(o254);
        }
      }
    });
    json['fuidList'] = fuidList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fileName = json.hasOwnProperty("fileName")?json["fileName"]:null;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		//set of type int
		this._fuidList = [];
		let fuidListJSONArray = json.hasOwnProperty("fuidList") ? json["fuidList"] : [];

		fuidListJSONArray.forEach((o255)=>{
			if (o255){
				this._fuidList.push(o255);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetExportMetadataMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetExportMetadataMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class InviteUsersToCollectionRequestData {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._mailMessage = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._emails = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._phoneNumbers = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._permissions = null;

  }

    /**
   * @return {string}
   */
  getMailMessage() {
    return this._mailMessage;
  }

  /**
   * @param mailMessage{string}
   * @return {InviteUsersToCollectionRequestData}
   */
  setMailMessage(mailMessage) {
    this._mailMessage = mailMessage;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {InviteUsersToCollectionRequestData}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getEmails() {
    return this._emails;
  }

  /**
   * @param emails{Array<String>}
   * @return {InviteUsersToCollectionRequestData}
   */
  setEmails(emails) {
    this._emails = emails;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getPhoneNumbers() {
    return this._phoneNumbers;
  }

  /**
   * @param phoneNumbers{Array<String>}
   * @return {InviteUsersToCollectionRequestData}
   */
  setPhoneNumbers(phoneNumbers) {
    this._phoneNumbers = phoneNumbers;
    return this;
  }

  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getPermissions() {
    return this._permissions;
  }

  /**
   * @param permissions{java.util.Map<number,Boolean>}
   * @return {InviteUsersToCollectionRequestData}
   */
  setPermissions(permissions) {
    this._permissions = permissions;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = InviteUsersToCollectionRequestData.CLASS_ID;
    
	//Serializing _mailMessage
	if (this._mailMessage)
		json['mailMessage'] = this._mailMessage;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._emails && this._emails.length > 0) {
    let emails_JSON = [];
    /**
     * @type {string}
     */
    this._emails.forEach((o887) => {
      if (o887) {
        if (o887.serializeJson && (typeof (o887.serializeJson) === 'function')) {
          emails_JSON.push(o887.serializeJson());
        } else {
          emails_JSON.push(o887);
        }
      }
    });
    json['emails'] = emails_JSON;
  }  
  if (this._phoneNumbers && this._phoneNumbers.length > 0) {
    let phoneNumbers_JSON = [];
    /**
     * @type {string}
     */
    this._phoneNumbers.forEach((o890) => {
      if (o890) {
        if (o890.serializeJson && (typeof (o890.serializeJson) === 'function')) {
          phoneNumbers_JSON.push(o890.serializeJson());
        } else {
          phoneNumbers_JSON.push(o890);
        }
      }
    });
    json['phoneNumbers'] = phoneNumbers_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"permissions", this._permissions);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._mailMessage = json.hasOwnProperty("mailMessage")?json["mailMessage"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type string
		this._emails = [];
		let emailsJSONArray = json.hasOwnProperty("emails") ? json["emails"] : [];

		emailsJSONArray.forEach((o888)=>{
			if (o888){
				this._emails.push(o888);
			}
		});
		//set of type string
		this._phoneNumbers = [];
		let phoneNumbersJSONArray = json.hasOwnProperty("phoneNumbers") ? json["phoneNumbers"] : [];

		phoneNumbersJSONArray.forEach((o891)=>{
			if (o891){
				this._phoneNumbers.push(o891);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._permissions == null)
			this._permissions = new HashMap();
		this._permissions.clear();
		let permissionsJSONArray = json.hasOwnProperty("permissions") ? json["permissions"] : [];
		this._permissions = SerializationUtil.deserializeMap(permissionsJSONArray);



  }
}

/**
 * @returns {string}
 */
InviteUsersToCollectionRequestData.CLASS_ID = "com.zoom.vab.client.autogenerated.InviteUsersToCollectionRequestData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveAnnotationsMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._copyComments = false;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {Array<AnnotationThread>}
     * @private
     */
    this._threads = null;

  }

    /**
   * optional: This field is to denote that         this operation is a copy comments operation.
   * @return {boolean}
   */
  isCopyComments() {
    return this._copyComments;
  }

  /**
   * @param copyComments{boolean}
   * @return {SaveAnnotationsMessage}
   */
  setCopyComments(copyComments) {
    this._copyComments = copyComments;
    return this;
  }
  /**
   * optional: Collection scope for comment. May be omitted in edits if unchanged.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {SaveAnnotationsMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: Asset scope for comment. May be omitted in edits if unchanged.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {SaveAnnotationsMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {Array<AnnotationThread>}
   */
  getThreads() {
    return this._threads;
  }

  /**
   * @param threads{Array<AnnotationThread>}
   * @return {SaveAnnotationsMessage}
   */
  setThreads(threads) {
    this._threads = threads;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveAnnotationsMessage.CLASS_ID;
    
	//Serializing _copyComments
	if (this._copyComments)
		json['copyComments'] = this._copyComments;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		  if (this._threads && this._threads.length > 0) {
    let threads_JSON = [];
    /**
     * @type {AnnotationThread}
     */
    this._threads.forEach((o1140) => {
      if (o1140) {
        if (o1140.serializeJson && (typeof (o1140.serializeJson) === 'function')) {
          threads_JSON.push(o1140.serializeJson());
        } else {
          threads_JSON.push(o1140);
        }
      }
    });
    json['threads'] = threads_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._copyComments = json.hasOwnProperty("copyComments")?json["copyComments"]:false;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

		//set of type AnnotationThread
		this._threads = [];
		let threadsJSONArray = json.hasOwnProperty("threads") ? json["threads"] : [];

		threadsJSONArray.forEach((o1141)=>{
			if (o1141){
				let classObj = new AnnotationThread();
				classObj.deserializeJson(o1141);
				this._threads.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SaveAnnotationsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveAnnotationsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GenericCommandResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isRunning = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._progress = null;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {string}
     * @private
     */
    this._progressMessage = null;

  }

    /**
   * @return {boolean}
   */
  isIsRunning() {
    return this._isRunning;
  }

  /**
   * @param isRunning{boolean}
   * @return {GenericCommandResponse}
   */
  setIsRunning(isRunning) {
    this._isRunning = isRunning;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GenericCommandResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getProgress() {
    return this._progress;
  }

  /**
   * @param progress{number}
   * @return {GenericCommandResponse}
   */
  setProgress(progress) {
    this._progress = progress;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {GenericCommandResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {string}
   */
  getProgressMessage() {
    return this._progressMessage;
  }

  /**
   * @param progressMessage{string}
   * @return {GenericCommandResponse}
   */
  setProgressMessage(progressMessage) {
    this._progressMessage = progressMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GenericCommandResponse.CLASS_ID;
    
	//Serializing _isRunning
	if (this._isRunning)
		json['isRunning'] = this._isRunning;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _progress
	if (this._progress)
		json['progress'] = this._progress;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;

	//Serializing _progressMessage
	if (this._progressMessage)
		json['progressMessage'] = this._progressMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isRunning = json.hasOwnProperty("isRunning")?json["isRunning"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._progress = json.hasOwnProperty("progress")?json["progress"]:0;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		this._progressMessage = json.hasOwnProperty("progressMessage")?json["progressMessage"]:null;


  }
}

/**
 * @returns {string}
 */
GenericCommandResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GenericCommandResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class DeleteZmCollectionAssetsQuery extends HttpOperation {

  constructor(name = "DeleteZmCollectionAssets") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {DeleteZmCollectionAssetsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{DeleteZmCollectionAssetsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SimpleResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = DeleteZmCollectionAssetsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (DeleteZmCollectionAssetsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SimpleResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionAssetsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollectionAssets";
/**
 * @returns {string}
 */
DeleteZmCollectionAssetsQuery.QUERY_NAME = "DeleteZmCollectionAssets";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ChildDocument {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._ys = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._xs = null;

  }

    /**
   * @return {Array<String>}
   */
  getYs() {
    return this._ys;
  }

  /**
   * @param ys{Array<String>}
   * @return {ChildDocument}
   */
  setYs(ys) {
    this._ys = ys;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getXs() {
    return this._xs;
  }

  /**
   * @param xs{Array<String>}
   * @return {ChildDocument}
   */
  setXs(xs) {
    this._xs = xs;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ChildDocument.CLASS_ID;
      if (this._ys && this._ys.length > 0) {
    let ys_JSON = [];
    /**
     * @type {string}
     */
    this._ys.forEach((o374) => {
      if (o374) {
        if (o374.serializeJson && (typeof (o374.serializeJson) === 'function')) {
          ys_JSON.push(o374.serializeJson());
        } else {
          ys_JSON.push(o374);
        }
      }
    });
    json['ys'] = ys_JSON;
  }  
  if (this._xs && this._xs.length > 0) {
    let xs_JSON = [];
    /**
     * @type {string}
     */
    this._xs.forEach((o377) => {
      if (o377) {
        if (o377.serializeJson && (typeof (o377.serializeJson) === 'function')) {
          xs_JSON.push(o377.serializeJson());
        } else {
          xs_JSON.push(o377);
        }
      }
    });
    json['xs'] = xs_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._ys = [];
		let ysJSONArray = json.hasOwnProperty("ys") ? json["ys"] : [];

		ysJSONArray.forEach((o375)=>{
			if (o375){
				this._ys.push(o375);
			}
		});
		//set of type string
		this._xs = [];
		let xsJSONArray = json.hasOwnProperty("xs") ? json["xs"] : [];

		xsJSONArray.forEach((o378)=>{
			if (o378){
				this._xs.push(o378);
			}
		});


  }
}

/**
 * @returns {string}
 */
ChildDocument.CLASS_ID = "com.zoom.vab.client.autogenerated.ChildDocument";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class UploadFromUrlQuery extends HttpOperation {

  constructor(name = "UploadFromUrl") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {UploadFromUrlMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{UploadFromUrlMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {UploadFromUrlResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = UploadFromUrlQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (UploadFromUrlQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new UploadFromUrlResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new UploadFromUrlResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
UploadFromUrlQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.UploadFromUrl";
/**
 * @returns {string}
 */
UploadFromUrlQuery.QUERY_NAME = "UploadFromUrl";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FlexSmartCopyResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._targetFiles = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexSmartCopyResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {FlexSmartCopyResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getTargetFiles() {
    return this._targetFiles;
  }

  /**
   * @param targetFiles{Array<String>}
   * @return {FlexSmartCopyResponse}
   */
  setTargetFiles(targetFiles) {
    this._targetFiles = targetFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexSmartCopyResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;
  if (this._targetFiles && this._targetFiles.length > 0) {
    let targetFiles_JSON = [];
    /**
     * @type {string}
     */
    this._targetFiles.forEach((o63) => {
      if (o63) {
        if (o63.serializeJson && (typeof (o63.serializeJson) === 'function')) {
          targetFiles_JSON.push(o63.serializeJson());
        } else {
          targetFiles_JSON.push(o63);
        }
      }
    });
    json['targetFiles'] = targetFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		//set of type string
		this._targetFiles = [];
		let targetFilesJSONArray = json.hasOwnProperty("targetFiles") ? json["targetFiles"] : [];

		targetFilesJSONArray.forEach((o64)=>{
			if (o64){
				this._targetFiles.push(o64);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexSmartCopyResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartCopyResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FolderDetailsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._deletedFilesCount = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._archiveFilesCount = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._folderSize = null;
    /**
     * @type {number}
     * @private
     */
    this._expiredCount = null;
    /**
     * @type {number}
     * @private
     */
    this._totalFiles = null;
    /**
     * @type {number}
     * @private
     */
    this._foldersCount = null;

  }

    /**
   * @return {number}
   */
  getDeletedFilesCount() {
    return this._deletedFilesCount;
  }

  /**
   * @param deletedFilesCount{number}
   * @return {FolderDetailsResponse}
   */
  setDeletedFilesCount(deletedFilesCount) {
    this._deletedFilesCount = deletedFilesCount;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FolderDetailsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getArchiveFilesCount() {
    return this._archiveFilesCount;
  }

  /**
   * @param archiveFilesCount{number}
   * @return {FolderDetailsResponse}
   */
  setArchiveFilesCount(archiveFilesCount) {
    this._archiveFilesCount = archiveFilesCount;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FolderDetailsResponse}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getFolderSize() {
    return this._folderSize;
  }

  /**
   * @param folderSize{string}
   * @return {FolderDetailsResponse}
   */
  setFolderSize(folderSize) {
    this._folderSize = folderSize;
    return this;
  }
  /**
   * @return {number}
   */
  getExpiredCount() {
    return this._expiredCount;
  }

  /**
   * @param expiredCount{number}
   * @return {FolderDetailsResponse}
   */
  setExpiredCount(expiredCount) {
    this._expiredCount = expiredCount;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalFiles() {
    return this._totalFiles;
  }

  /**
   * @param totalFiles{number}
   * @return {FolderDetailsResponse}
   */
  setTotalFiles(totalFiles) {
    this._totalFiles = totalFiles;
    return this;
  }
  /**
   * @return {number}
   */
  getFoldersCount() {
    return this._foldersCount;
  }

  /**
   * @param foldersCount{number}
   * @return {FolderDetailsResponse}
   */
  setFoldersCount(foldersCount) {
    this._foldersCount = foldersCount;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FolderDetailsResponse.CLASS_ID;
    
	//Serializing _deletedFilesCount
	if (this._deletedFilesCount)
		json['deletedFilesCount'] = this._deletedFilesCount;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _archiveFilesCount
	if (this._archiveFilesCount)
		json['archiveFilesCount'] = this._archiveFilesCount;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _folderSize
	if (this._folderSize)
		json['folderSize'] = this._folderSize;

	//Serializing _expiredCount
	if (this._expiredCount)
		json['expiredCount'] = this._expiredCount;

	//Serializing _totalFiles
	if (this._totalFiles)
		json['totalFiles'] = this._totalFiles;

	//Serializing _foldersCount
	if (this._foldersCount)
		json['foldersCount'] = this._foldersCount;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._deletedFilesCount = json.hasOwnProperty("deletedFilesCount")?json["deletedFilesCount"]:0;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._archiveFilesCount = json.hasOwnProperty("archiveFilesCount")?json["archiveFilesCount"]:0;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._folderSize = json.hasOwnProperty("folderSize")?json["folderSize"]:null;
		this._expiredCount = json.hasOwnProperty("expiredCount")?json["expiredCount"]:0;
		this._totalFiles = json.hasOwnProperty("totalFiles")?json["totalFiles"]:0;
		this._foldersCount = json.hasOwnProperty("foldersCount")?json["foldersCount"]:0;


  }
}

/**
 * @returns {string}
 */
FolderDetailsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FolderDetailsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsCollectionSortCriteria {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._sortBy = null;
    /**
     * @type {number}
     * @private
     */
    this._order = null;

  }

  
	/**
	* @type {string}
	*/
	static get COLLECTION_NAME(){
		return "NAME";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_COMMENTS(){
		return "SYST_COLLECTION_ASSET_COMMENT_INFO";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_AUTHOR(){
		return "SYST_AUTHOR_NAME";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_VERSIONS(){
		return "SYST_VERSIONS";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_STATUS(){
		return "SYST_STATUS";

	}
  /**
   * @return {string}
   */
  getSortBy() {
    return this._sortBy;
  }

  /**
   * @param sortBy{string}
   * @return {LsCollectionSortCriteria}
   */
  setSortBy(sortBy) {
    this._sortBy = sortBy;
    return this;
  }

	/**
	* @type {string}
	*/
	static get COLLECTION_CREATED(){
		return "CREATED_TIME";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_UPDATED(){
		return "SYST_UPDATED";

	}

	/**
	* @type {string}
	*/
	static get COLLECTION_LAST_MODIFIED(){
		return "MODIFICATION_TIME";

	}
  /**
   * @return {number}
   */
  getOrder() {
    return this._order;
  }

  /**
   * @param order{number}
   * @return {LsCollectionSortCriteria}
   */
  setOrder(order) {
    this._order = order;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsCollectionSortCriteria.CLASS_ID;
    
	//Serializing _sortBy
	if (this._sortBy)
		json['sortBy'] = this._sortBy;

	//Serializing _order
	if (this._order)
		json['order'] = this._order;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._sortBy = json.hasOwnProperty("sortBy")?json["sortBy"]:null;
		this._order = json.hasOwnProperty("order")?json["order"]:0;


  }
}

/**
 * @returns {string}
 */
LsCollectionSortCriteria.CLASS_ID = "com.zoom.vab.client.autogenerated.LsCollectionSortCriteria";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCommentsUnreadCountQuery extends HttpOperation {

  constructor(name = "GetCommentsUnreadCount") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCommentsUnreadCountMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCommentsUnreadCountMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCommentsUnreadCountResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCommentsUnreadCountQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCommentsUnreadCountQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCommentsUnreadCountResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCommentsUnreadCountResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCommentsUnreadCountQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCommentsUnreadCount";
/**
 * @returns {string}
 */
GetCommentsUnreadCountQuery.QUERY_NAME = "GetCommentsUnreadCount";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EnableDisableLinkSharingMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._transferFeaturesToLoginUser = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._linkPermissions = null;

  }

    /**
   * @return {boolean}
   */
  isTransferFeaturesToLoginUser() {
    return this._transferFeaturesToLoginUser;
  }

  /**
   * @param transferFeaturesToLoginUser{boolean}
   * @return {EnableDisableLinkSharingMessage}
   */
  setTransferFeaturesToLoginUser(transferFeaturesToLoginUser) {
    this._transferFeaturesToLoginUser = transferFeaturesToLoginUser;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {EnableDisableLinkSharingMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getLinkPermissions() {
    return this._linkPermissions;
  }

  /**
   * @param linkPermissions{java.util.Map<number,Boolean>}
   * @return {EnableDisableLinkSharingMessage}
   */
  setLinkPermissions(linkPermissions) {
    this._linkPermissions = linkPermissions;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EnableDisableLinkSharingMessage.CLASS_ID;
    
	//Serializing _transferFeaturesToLoginUser
	if (this._transferFeaturesToLoginUser)
		json['transferFeaturesToLoginUser'] = this._transferFeaturesToLoginUser;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
    SerializationUtil.serializeHashMap(json,"linkPermissions", this._linkPermissions);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._transferFeaturesToLoginUser = json.hasOwnProperty("transferFeaturesToLoginUser")?json["transferFeaturesToLoginUser"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
//Map of type INT. Decode as tree:false
		if (this._linkPermissions == null)
			this._linkPermissions = new HashMap();
		this._linkPermissions.clear();
		let linkPermissionsJSONArray = json.hasOwnProperty("linkPermissions") ? json["linkPermissions"] : [];
		this._linkPermissions = SerializationUtil.deserializeMap(linkPermissionsJSONArray);



  }
}

/**
 * @returns {string}
 */
EnableDisableLinkSharingMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EnableDisableLinkSharingMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionScope {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._contactSheetId = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * optional: If collection being viewed as a series of contact-sheets, annotations etc can be performed on a specific contact-sheet number.
   * @return {number}
   */
  getContactSheetId() {
    return this._contactSheetId;
  }

  /**
   * @param contactSheetId{number}
   * @return {CollectionScope}
   */
  setContactSheetId(contactSheetId) {
    this._contactSheetId = contactSheetId;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {CollectionScope}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionScope.CLASS_ID;
    
	//Serializing _contactSheetId
	if (this._contactSheetId)
		json['contactSheetId'] = this._contactSheetId;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._contactSheetId = json.hasOwnProperty("contactSheetId")?json["contactSheetId"]:0;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
CollectionScope.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionScope";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetRevisionsOfCollectionAssetResponse {

  constructor() {
    
        /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._collectionAssetRevInfoList = null;

  }

    /**
   * @return {Array<RepoItem>}
   */
  getCollectionAssetRevInfoList() {
    return this._collectionAssetRevInfoList;
  }

  /**
   * @param collectionAssetRevInfoList{Array<RepoItem>}
   * @return {GetRevisionsOfCollectionAssetResponse}
   */
  setCollectionAssetRevInfoList(collectionAssetRevInfoList) {
    this._collectionAssetRevInfoList = collectionAssetRevInfoList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetRevisionsOfCollectionAssetResponse.CLASS_ID;
      if (this._collectionAssetRevInfoList && this._collectionAssetRevInfoList.length > 0) {
    let collectionAssetRevInfoList_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._collectionAssetRevInfoList.forEach((o926) => {
      if (o926) {
        if (o926.serializeJson && (typeof (o926.serializeJson) === 'function')) {
          collectionAssetRevInfoList_JSON.push(o926.serializeJson());
        } else {
          collectionAssetRevInfoList_JSON.push(o926);
        }
      }
    });
    json['collectionAssetRevInfoList'] = collectionAssetRevInfoList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type RepoItem
		this._collectionAssetRevInfoList = [];
		let collectionAssetRevInfoListJSONArray = json.hasOwnProperty("collectionAssetRevInfoList") ? json["collectionAssetRevInfoList"] : [];

		collectionAssetRevInfoListJSONArray.forEach((o927)=>{
			if (o927){
				let classObj = new RepoItem();
				classObj.deserializeJson(o927);
				this._collectionAssetRevInfoList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetRevisionsOfCollectionAssetResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetRevisionsOfCollectionAssetResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClearSessionMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._useBrowseSession = false;
    /**
     * @type {boolean}
     * @private
     */
    this._clearAll = false;

  }

    /**
   * @return {boolean}
   */
  isUseBrowseSession() {
    return this._useBrowseSession;
  }

  /**
   * @param useBrowseSession{boolean}
   * @return {ClearSessionMsg}
   */
  setUseBrowseSession(useBrowseSession) {
    this._useBrowseSession = useBrowseSession;
    return this;
  }
  /**
   * @return {boolean}
   */
  isClearAll() {
    return this._clearAll;
  }

  /**
   * @param clearAll{boolean}
   * @return {ClearSessionMsg}
   */
  setClearAll(clearAll) {
    this._clearAll = clearAll;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClearSessionMsg.CLASS_ID;
    
	//Serializing _useBrowseSession
	if (this._useBrowseSession)
		json['useBrowseSession'] = this._useBrowseSession;

	//Serializing _clearAll
	if (this._clearAll)
		json['clearAll'] = this._clearAll;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._useBrowseSession = json.hasOwnProperty("useBrowseSession")?json["useBrowseSession"]:false;
		this._clearAll = json.hasOwnProperty("clearAll")?json["clearAll"]:false;


  }
}

/**
 * @returns {string}
 */
ClearSessionMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ClearSessionMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FuidRrnInfo {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FuidRrnInfo}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FuidRrnInfo}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {FuidRrnInfo}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FuidRrnInfo.CLASS_ID;
    
	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
FuidRrnInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.FuidRrnInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditSpotLightQueryRes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {EditSpotLightQueryRes}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditSpotLightQueryRes.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
EditSpotLightQueryRes.CLASS_ID = "com.zoom.vab.client.autogenerated.EditSpotLightQueryRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {Array<CommentId>}
     * @private
     */
    this._deletedComments = null;
    /**
     * @type {Array<AnnotationThread>}
     * @private
     */
    this._threads = null;

  }

    /**
   * RRN up to which response is valid
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {GetAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * @return {Array<CommentId>}
   */
  getDeletedComments() {
    return this._deletedComments;
  }

  /**
   * @param deletedComments{Array<CommentId>}
   * @return {GetAnnotationsResponse}
   */
  setDeletedComments(deletedComments) {
    this._deletedComments = deletedComments;
    return this;
  }

  /**
   * @return {Array<AnnotationThread>}
   */
  getThreads() {
    return this._threads;
  }

  /**
   * @param threads{Array<AnnotationThread>}
   * @return {GetAnnotationsResponse}
   */
  setThreads(threads) {
    this._threads = threads;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;
  if (this._deletedComments && this._deletedComments.length > 0) {
    let deletedComments_JSON = [];
    /**
     * @type {CommentId}
     */
    this._deletedComments.forEach((o957) => {
      if (o957) {
        if (o957.serializeJson && (typeof (o957.serializeJson) === 'function')) {
          deletedComments_JSON.push(o957.serializeJson());
        } else {
          deletedComments_JSON.push(o957);
        }
      }
    });
    json['deletedComments'] = deletedComments_JSON;
  }  
  if (this._threads && this._threads.length > 0) {
    let threads_JSON = [];
    /**
     * @type {AnnotationThread}
     */
    this._threads.forEach((o960) => {
      if (o960) {
        if (o960.serializeJson && (typeof (o960.serializeJson) === 'function')) {
          threads_JSON.push(o960.serializeJson());
        } else {
          threads_JSON.push(o960);
        }
      }
    });
    json['threads'] = threads_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		//set of type CommentId
		this._deletedComments = [];
		let deletedCommentsJSONArray = json.hasOwnProperty("deletedComments") ? json["deletedComments"] : [];

		deletedCommentsJSONArray.forEach((o958)=>{
			if (o958){
				let classObj = new CommentId();
				classObj.deserializeJson(o958);
				this._deletedComments.push(classObj);
			}
		});
		//set of type AnnotationThread
		this._threads = [];
		let threadsJSONArray = json.hasOwnProperty("threads") ? json["threads"] : [];

		threadsJSONArray.forEach((o961)=>{
			if (o961){
				let classObj = new AnnotationThread();
				classObj.deserializeJson(o961);
				this._threads.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class UserDetails {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._firstName = null;
    /**
     * @type {string}
     * @private
     */
    this._lastName = null;
    /**
     * @type {string}
     * @private
     */
    this._password = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {string}
     * @private
     */
    this._email = null;
    /**
     * @type {string}
     * @private
     */
    this._profileFileId = null;
    /**
     * @type {string}
     * @private
     */
    this._profilePicName = null;

  }

    /**
   * @return {string}
   */
  getFirstName() {
    return this._firstName;
  }

  /**
   * @param firstName{string}
   * @return {UserDetails}
   */
  setFirstName(firstName) {
    this._firstName = firstName;
    return this;
  }
  /**
   * @return {string}
   */
  getLastName() {
    return this._lastName;
  }

  /**
   * @param lastName{string}
   * @return {UserDetails}
   */
  setLastName(lastName) {
    this._lastName = lastName;
    return this;
  }
  /**
   * @return {string}
   */
  getPassword() {
    return this._password;
  }

  /**
   * @param password{string}
   * @return {UserDetails}
   */
  setPassword(password) {
    this._password = password;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {UserDetails}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {string}
   */
  getEmail() {
    return this._email;
  }

  /**
   * @param email{string}
   * @return {UserDetails}
   */
  setEmail(email) {
    this._email = email;
    return this;
  }
  /**
   * @return {string}
   */
  getProfileFileId() {
    return this._profileFileId;
  }

  /**
   * @param profileFileId{string}
   * @return {UserDetails}
   */
  setProfileFileId(profileFileId) {
    this._profileFileId = profileFileId;
    return this;
  }
  /**
   * @return {string}
   */
  getProfilePicName() {
    return this._profilePicName;
  }

  /**
   * @param profilePicName{string}
   * @return {UserDetails}
   */
  setProfilePicName(profilePicName) {
    this._profilePicName = profilePicName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UserDetails.CLASS_ID;
    
	//Serializing _firstName
	if (this._firstName)
		json['firstName'] = this._firstName;

	//Serializing _lastName
	if (this._lastName)
		json['lastName'] = this._lastName;

	//Serializing _password
	if (this._password)
		json['password'] = this._password;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;

	//Serializing _email
	if (this._email)
		json['email'] = this._email;

	//Serializing _profileFileId
	if (this._profileFileId)
		json['profileFileId'] = this._profileFileId;

	//Serializing _profilePicName
	if (this._profilePicName)
		json['profilePicName'] = this._profilePicName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._firstName = json.hasOwnProperty("firstName")?json["firstName"]:null;
		this._lastName = json.hasOwnProperty("lastName")?json["lastName"]:null;
		this._password = json.hasOwnProperty("password")?json["password"]:null;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
		this._email = json.hasOwnProperty("email")?json["email"]:null;
		this._profileFileId = json.hasOwnProperty("profileFileId")?json["profileFileId"]:null;
		this._profilePicName = json.hasOwnProperty("profilePicName")?json["profilePicName"]:null;


  }
}

/**
 * @returns {string}
 */
UserDetails.CLASS_ID = "com.zoom.vab.client.autogenerated.UserDetails";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetCollectionMetadataResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {SetCollectionMetadataResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetCollectionMetadataResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
SetCollectionMetadataResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SetCollectionMetadataResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class AddFavItemsQuery extends HttpOperation {

  constructor(name = "AddFavItems") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {AddFavItemsMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{AddFavItemsMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {AddFavItemsResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = AddFavItemsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (AddFavItemsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new AddFavItemsResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new AddFavItemsResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
AddFavItemsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.AddFavItems";
/**
 * @returns {string}
 */
AddFavItemsQuery.QUERY_NAME = "AddFavItems";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditZmCollectionMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._moveFromParentId = null;
    /**
     * @type {ZmCollection}
     * @private
     */
    this._zmCollection = null;

  }

    /**
   * @return {number}
   */
  getMoveFromParentId() {
    return this._moveFromParentId;
  }

  /**
   * @param moveFromParentId{number}
   * @return {EditZmCollectionMessage}
   */
  setMoveFromParentId(moveFromParentId) {
    this._moveFromParentId = moveFromParentId;
    return this;
  }
  /**
   * @return {ZmCollection}
   */
  getZmCollection() {
    return this._zmCollection;
  }

  /**
   * @param zmCollection{ZmCollection}
   * @return {EditZmCollectionMessage}
   */
  setZmCollection(zmCollection) {
    this._zmCollection = zmCollection;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditZmCollectionMessage.CLASS_ID;
    
	//Serializing _moveFromParentId
	if (this._moveFromParentId)
		json['moveFromParentId'] = this._moveFromParentId;

	//Serializing ComplexType _$arrayName
	if (this._zmCollection)
		json['zmCollection'] = this._zmCollection.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._moveFromParentId = json.hasOwnProperty("moveFromParentId")?json["moveFromParentId"]:0;
		if (json.hasOwnProperty("zmCollection")){
			if (!this._zmCollection && this._zmCollection == null)
				this._zmCollection = new ZmCollection();
			this._zmCollection.deserializeJson(json.hasOwnProperty("zmCollection") ? json["zmCollection"] : null);
		}



  }
}

/**
 * @returns {string}
 */
EditZmCollectionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollectionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCustomResourceQueryMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._bundleName = null;

  }

    /**
   * @return {string}
   */
  getBundleName() {
    return this._bundleName;
  }

  /**
   * @param bundleName{string}
   * @return {GetCustomResourceQueryMsg}
   */
  setBundleName(bundleName) {
    this._bundleName = bundleName;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCustomResourceQueryMsg.CLASS_ID;
    
	//Serializing _bundleName
	if (this._bundleName)
		json['bundleName'] = this._bundleName;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._bundleName = json.hasOwnProperty("bundleName")?json["bundleName"]:null;


  }
}

/**
 * @returns {string}
 */
GetCustomResourceQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCustomResourceQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CategoryWiseDetail {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._maxVal = null;
    /**
     * @type {string}
     * @private
     */
    this._minVal = null;
    /**
     * @type {boolean}
     * @private
     */
    this._recursiveData = false;
    /**
     * @type {boolean}
     * @private
     */
    this._entriesRemaining = false;
    /**
     * @type {string}
     * @private
     */
    this._reactKey = null;
    /**
     * @type {string}
     * @private
     */
    this._matchString = null;
    /**
     * @type {string}
     * @private
     */
    this._label = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasAnySelectedItem = false;
    /**
     * @type {number}
     * @private
     */
    this._totalMatches = null;
    /**
     * @type {string}
     * @private
     */
    this._categoryId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._singleSelect = false;
    /**
     * @type {Array<FacetedItemInfo>}
     * @private
     */
    this._name2count = null;
    /**
     * @type {Array<FacetedItemInfo>}
     * @private
     */
    this._treeData = null;

  }

    /**
   * @return {string}
   */
  getMaxVal() {
    return this._maxVal;
  }

  /**
   * @param maxVal{string}
   * @return {CategoryWiseDetail}
   */
  setMaxVal(maxVal) {
    this._maxVal = maxVal;
    return this;
  }
  /**
   * @return {string}
   */
  getMinVal() {
    return this._minVal;
  }

  /**
   * @param minVal{string}
   * @return {CategoryWiseDetail}
   */
  setMinVal(minVal) {
    this._minVal = minVal;
    return this;
  }
  /**
   * @return {boolean}
   */
  isRecursiveData() {
    return this._recursiveData;
  }

  /**
   * @param recursiveData{boolean}
   * @return {CategoryWiseDetail}
   */
  setRecursiveData(recursiveData) {
    this._recursiveData = recursiveData;
    return this;
  }
  /**
   * @return {boolean}
   */
  isEntriesRemaining() {
    return this._entriesRemaining;
  }

  /**
   * @param entriesRemaining{boolean}
   * @return {CategoryWiseDetail}
   */
  setEntriesRemaining(entriesRemaining) {
    this._entriesRemaining = entriesRemaining;
    return this;
  }
  /**
   * @return {string}
   */
  getReactKey() {
    return this._reactKey;
  }

  /**
   * @param reactKey{string}
   * @return {CategoryWiseDetail}
   */
  setReactKey(reactKey) {
    this._reactKey = reactKey;
    return this;
  }
  /**
   * @return {string}
   */
  getMatchString() {
    return this._matchString;
  }

  /**
   * @param matchString{string}
   * @return {CategoryWiseDetail}
   */
  setMatchString(matchString) {
    this._matchString = matchString;
    return this;
  }
  /**
   * @return {string}
   */
  getLabel() {
    return this._label;
  }

  /**
   * @param label{string}
   * @return {CategoryWiseDetail}
   */
  setLabel(label) {
    this._label = label;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasAnySelectedItem() {
    return this._hasAnySelectedItem;
  }

  /**
   * @param hasAnySelectedItem{boolean}
   * @return {CategoryWiseDetail}
   */
  setHasAnySelectedItem(hasAnySelectedItem) {
    this._hasAnySelectedItem = hasAnySelectedItem;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalMatches() {
    return this._totalMatches;
  }

  /**
   * @param totalMatches{number}
   * @return {CategoryWiseDetail}
   */
  setTotalMatches(totalMatches) {
    this._totalMatches = totalMatches;
    return this;
  }
  /**
   * @return {string}
   */
  getCategoryId() {
    return this._categoryId;
  }

  /**
   * @param categoryId{string}
   * @return {CategoryWiseDetail}
   */
  setCategoryId(categoryId) {
    this._categoryId = categoryId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSingleSelect() {
    return this._singleSelect;
  }

  /**
   * @param singleSelect{boolean}
   * @return {CategoryWiseDetail}
   */
  setSingleSelect(singleSelect) {
    this._singleSelect = singleSelect;
    return this;
  }
  /**
   * @return {Array<FacetedItemInfo>}
   */
  getName2count() {
    return this._name2count;
  }

  /**
   * @param name2count{Array<FacetedItemInfo>}
   * @return {CategoryWiseDetail}
   */
  setName2count(name2count) {
    this._name2count = name2count;
    return this;
  }

  /**
   * @return {Array<FacetedItemInfo>}
   */
  getTreeData() {
    return this._treeData;
  }

  /**
   * @param treeData{Array<FacetedItemInfo>}
   * @return {CategoryWiseDetail}
   */
  setTreeData(treeData) {
    this._treeData = treeData;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CategoryWiseDetail.CLASS_ID;
    
	//Serializing _maxVal
	if (this._maxVal)
		json['maxVal'] = this._maxVal;

	//Serializing _minVal
	if (this._minVal)
		json['minVal'] = this._minVal;

	//Serializing _recursiveData
	if (this._recursiveData)
		json['recursiveData'] = this._recursiveData;

	//Serializing _entriesRemaining
	if (this._entriesRemaining)
		json['entriesRemaining'] = this._entriesRemaining;

	//Serializing _reactKey
	if (this._reactKey)
		json['reactKey'] = this._reactKey;

	//Serializing _matchString
	if (this._matchString)
		json['matchString'] = this._matchString;

	//Serializing _label
	if (this._label)
		json['label'] = this._label;

	//Serializing _hasAnySelectedItem
	if (this._hasAnySelectedItem)
		json['hasAnySelectedItem'] = this._hasAnySelectedItem;

	//Serializing _totalMatches
	if (this._totalMatches)
		json['totalMatches'] = this._totalMatches;

	//Serializing _categoryId
	if (this._categoryId)
		json['categoryId'] = this._categoryId;

	//Serializing _singleSelect
	if (this._singleSelect)
		json['singleSelect'] = this._singleSelect;
  if (this._name2count && this._name2count.length > 0) {
    let name2count_JSON = [];
    /**
     * @type {FacetedItemInfo}
     */
    this._name2count.forEach((o456) => {
      if (o456) {
        if (o456.serializeJson && (typeof (o456.serializeJson) === 'function')) {
          name2count_JSON.push(o456.serializeJson());
        } else {
          name2count_JSON.push(o456);
        }
      }
    });
    json['name2count'] = name2count_JSON;
  }  
  if (this._treeData && this._treeData.length > 0) {
    let treeData_JSON = [];
    /**
     * @type {FacetedItemInfo}
     */
    this._treeData.forEach((o459) => {
      if (o459) {
        if (o459.serializeJson && (typeof (o459.serializeJson) === 'function')) {
          treeData_JSON.push(o459.serializeJson());
        } else {
          treeData_JSON.push(o459);
        }
      }
    });
    json['treeData'] = treeData_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._maxVal = json.hasOwnProperty("maxVal")?json["maxVal"]:null;
		this._minVal = json.hasOwnProperty("minVal")?json["minVal"]:null;
		this._recursiveData = json.hasOwnProperty("recursiveData")?json["recursiveData"]:false;
		this._entriesRemaining = json.hasOwnProperty("entriesRemaining")?json["entriesRemaining"]:false;
		this._reactKey = json.hasOwnProperty("reactKey")?json["reactKey"]:null;
		this._matchString = json.hasOwnProperty("matchString")?json["matchString"]:null;
		this._label = json.hasOwnProperty("label")?json["label"]:null;
		this._hasAnySelectedItem = json.hasOwnProperty("hasAnySelectedItem")?json["hasAnySelectedItem"]:false;
		this._totalMatches = json.hasOwnProperty("totalMatches")?json["totalMatches"]:0;
		this._categoryId = json.hasOwnProperty("categoryId")?json["categoryId"]:null;
		this._singleSelect = json.hasOwnProperty("singleSelect")?json["singleSelect"]:false;
		//set of type FacetedItemInfo
		this._name2count = [];
		let name2countJSONArray = json.hasOwnProperty("name2count") ? json["name2count"] : [];

		name2countJSONArray.forEach((o457)=>{
			if (o457){
				let classObj = new FacetedItemInfo();
				classObj.deserializeJson(o457);
				this._name2count.push(classObj);
			}
		});
		//set of type FacetedItemInfo
		this._treeData = [];
		let treeDataJSONArray = json.hasOwnProperty("treeData") ? json["treeData"] : [];

		treeDataJSONArray.forEach((o460)=>{
			if (o460){
				let classObj = new FacetedItemInfo();
				classObj.deserializeJson(o460);
				this._treeData.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
CategoryWiseDetail.CLASS_ID = "com.zoom.vab.client.autogenerated.CategoryWiseDetail";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionMetadataResponse {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._collectionMetadata = null;

  }

    /**
   * @return {java.util.Map<String,ValueList>}
   */
  getCollectionMetadata() {
    return this._collectionMetadata;
  }

  /**
   * @param collectionMetadata{java.util.Map<String,ValueList>}
   * @return {GetCollectionMetadataResponse}
   */
  setCollectionMetadata(collectionMetadata) {
    this._collectionMetadata = collectionMetadata;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionMetadataResponse.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"collectionMetadata", this._collectionMetadata);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._collectionMetadata == null)
			this._collectionMetadata = new HashMap();
		this._collectionMetadata.clear();
		let collectionMetadataJSONArray = json.hasOwnProperty("collectionMetadata") ? json["collectionMetadata"] : [];
		this._collectionMetadata = SerializationUtil.deserializeMap(collectionMetadataJSONArray);



  }
}

/**
 * @returns {string}
 */
GetCollectionMetadataResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionMetadataResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetFileReferencesResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._totalRefsCount = null;
    /**
     * @type {number}
     * @private
     */
    this._fromRefsCount = null;
    /**
     * @type {number}
     * @private
     */
    this._toRefsCount = null;
    /**
     * @type {Array<AssetLinkDetails>}
     * @private
     */
    this._linkDetails = null;

  }

    /**
   * @return {number}
   */
  getTotalRefsCount() {
    return this._totalRefsCount;
  }

  /**
   * @param totalRefsCount{number}
   * @return {GetFileReferencesResponse}
   */
  setTotalRefsCount(totalRefsCount) {
    this._totalRefsCount = totalRefsCount;
    return this;
  }
  /**
   * @return {number}
   */
  getFromRefsCount() {
    return this._fromRefsCount;
  }

  /**
   * @param fromRefsCount{number}
   * @return {GetFileReferencesResponse}
   */
  setFromRefsCount(fromRefsCount) {
    this._fromRefsCount = fromRefsCount;
    return this;
  }
  /**
   * @return {number}
   */
  getToRefsCount() {
    return this._toRefsCount;
  }

  /**
   * @param toRefsCount{number}
   * @return {GetFileReferencesResponse}
   */
  setToRefsCount(toRefsCount) {
    this._toRefsCount = toRefsCount;
    return this;
  }
  /**
   * @return {Array<AssetLinkDetails>}
   */
  getLinkDetails() {
    return this._linkDetails;
  }

  /**
   * @param linkDetails{Array<AssetLinkDetails>}
   * @return {GetFileReferencesResponse}
   */
  setLinkDetails(linkDetails) {
    this._linkDetails = linkDetails;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetFileReferencesResponse.CLASS_ID;
    
	//Serializing _totalRefsCount
	if (this._totalRefsCount)
		json['totalRefsCount'] = this._totalRefsCount;

	//Serializing _fromRefsCount
	if (this._fromRefsCount)
		json['fromRefsCount'] = this._fromRefsCount;

	//Serializing _toRefsCount
	if (this._toRefsCount)
		json['toRefsCount'] = this._toRefsCount;
  if (this._linkDetails && this._linkDetails.length > 0) {
    let linkDetails_JSON = [];
    /**
     * @type {AssetLinkDetails}
     */
    this._linkDetails.forEach((o1156) => {
      if (o1156) {
        if (o1156.serializeJson && (typeof (o1156.serializeJson) === 'function')) {
          linkDetails_JSON.push(o1156.serializeJson());
        } else {
          linkDetails_JSON.push(o1156);
        }
      }
    });
    json['linkDetails'] = linkDetails_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._totalRefsCount = json.hasOwnProperty("totalRefsCount")?json["totalRefsCount"]:0;
		this._fromRefsCount = json.hasOwnProperty("fromRefsCount")?json["fromRefsCount"]:0;
		this._toRefsCount = json.hasOwnProperty("toRefsCount")?json["toRefsCount"]:0;
		//set of type AssetLinkDetails
		this._linkDetails = [];
		let linkDetailsJSONArray = json.hasOwnProperty("linkDetails") ? json["linkDetails"] : [];

		linkDetailsJSONArray.forEach((o1157)=>{
			if (o1157){
				let classObj = new AssetLinkDetails();
				classObj.deserializeJson(o1157);
				this._linkDetails.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetFileReferencesResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFileReferencesResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteTimelineResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {DeleteTimelineResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteTimelineResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
DeleteTimelineResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteTimelineResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CollectionUserEntry {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._deleted = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isInvited = false;
    /**
     * @type {string}
     * @private
     */
    this._displayName = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {string}
     * @private
     */
    this._email = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._collectionFeatures = null;

  }

    /**
   * @return {boolean}
   */
  isDeleted() {
    return this._deleted;
  }

  /**
   * @param deleted{boolean}
   * @return {CollectionUserEntry}
   */
  setDeleted(deleted) {
    this._deleted = deleted;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsInvited() {
    return this._isInvited;
  }

  /**
   * @param isInvited{boolean}
   * @return {CollectionUserEntry}
   */
  setIsInvited(isInvited) {
    this._isInvited = isInvited;
    return this;
  }
  /**
   * @return {string}
   */
  getDisplayName() {
    return this._displayName;
  }

  /**
   * @param displayName{string}
   * @return {CollectionUserEntry}
   */
  setDisplayName(displayName) {
    this._displayName = displayName;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {CollectionUserEntry}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {string}
   */
  getEmail() {
    return this._email;
  }

  /**
   * @param email{string}
   * @return {CollectionUserEntry}
   */
  setEmail(email) {
    this._email = email;
    return this;
  }
  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getCollectionFeatures() {
    return this._collectionFeatures;
  }

  /**
   * @param collectionFeatures{java.util.Map<number,Boolean>}
   * @return {CollectionUserEntry}
   */
  setCollectionFeatures(collectionFeatures) {
    this._collectionFeatures = collectionFeatures;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CollectionUserEntry.CLASS_ID;
    
	//Serializing _deleted
	if (this._deleted)
		json['deleted'] = this._deleted;

	//Serializing _isInvited
	if (this._isInvited)
		json['isInvited'] = this._isInvited;

	//Serializing _displayName
	if (this._displayName)
		json['displayName'] = this._displayName;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;

	//Serializing _email
	if (this._email)
		json['email'] = this._email;
    SerializationUtil.serializeHashMap(json,"collectionFeatures", this._collectionFeatures);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._deleted = json.hasOwnProperty("deleted")?json["deleted"]:false;
		this._isInvited = json.hasOwnProperty("isInvited")?json["isInvited"]:false;
		this._displayName = json.hasOwnProperty("displayName")?json["displayName"]:null;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
		this._email = json.hasOwnProperty("email")?json["email"]:null;
//Map of type INT. Decode as tree:false
		if (this._collectionFeatures == null)
			this._collectionFeatures = new HashMap();
		this._collectionFeatures.clear();
		let collectionFeaturesJSONArray = json.hasOwnProperty("collectionFeatures") ? json["collectionFeatures"] : [];
		this._collectionFeatures = SerializationUtil.deserializeMap(collectionFeaturesJSONArray);



  }
}

/**
 * @returns {string}
 */
CollectionUserEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.CollectionUserEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetActivityPanelDataResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {SetActivityPanelDataResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetActivityPanelDataResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
SetActivityPanelDataResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SetActivityPanelDataResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetActivityPanelDataMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._date = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {number}
   */
  getDate() {
    return this._date;
  }

  /**
   * @param date{number}
   * @return {GetActivityPanelDataMessage}
   */
  setDate(date) {
    this._date = date;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {GetActivityPanelDataMessage}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {GetActivityPanelDataMessage}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetActivityPanelDataMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetActivityPanelDataMessage.CLASS_ID;
    
	//Serializing _date
	if (this._date)
		json['date'] = this._date;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._date = json.hasOwnProperty("date")?json["date"]:0;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
GetActivityPanelDataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivityPanelDataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class EditZmCollectionUserPermissionMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._muteEmailNotification = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {CollectionUserEntry}
     * @private
     */
    this._collectionUserEntry = null;

  }

    /**
   * @return {boolean}
   */
  isMuteEmailNotification() {
    return this._muteEmailNotification;
  }

  /**
   * @param muteEmailNotification{boolean}
   * @return {EditZmCollectionUserPermissionMessage}
   */
  setMuteEmailNotification(muteEmailNotification) {
    this._muteEmailNotification = muteEmailNotification;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {EditZmCollectionUserPermissionMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {CollectionUserEntry}
   */
  getCollectionUserEntry() {
    return this._collectionUserEntry;
  }

  /**
   * @param collectionUserEntry{CollectionUserEntry}
   * @return {EditZmCollectionUserPermissionMessage}
   */
  setCollectionUserEntry(collectionUserEntry) {
    this._collectionUserEntry = collectionUserEntry;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = EditZmCollectionUserPermissionMessage.CLASS_ID;
    
	//Serializing _muteEmailNotification
	if (this._muteEmailNotification)
		json['muteEmailNotification'] = this._muteEmailNotification;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._collectionUserEntry)
		json['collectionUserEntry'] = this._collectionUserEntry.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._muteEmailNotification = json.hasOwnProperty("muteEmailNotification")?json["muteEmailNotification"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("collectionUserEntry")){
			if (!this._collectionUserEntry && this._collectionUserEntry == null)
				this._collectionUserEntry = new CollectionUserEntry();
			this._collectionUserEntry.deserializeJson(json.hasOwnProperty("collectionUserEntry") ? json["collectionUserEntry"] : null);
		}



  }
}

/**
 * @returns {string}
 */
EditZmCollectionUserPermissionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollectionUserPermissionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class TemporalLocationRangeEnd {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._frameNumber = null;
    /**
     * @type {number}
     * @private
     */
    this._timeOffsetRemPicos = null;
    /**
     * @type {number}
     * @private
     */
    this._timeOffset = null;

  }

    /**
   * page number or animation/video frame number
   * @return {number}
   */
  getFrameNumber() {
    return this._frameNumber;
  }

  /**
   * @param frameNumber{number}
   * @return {TemporalLocationRangeEnd}
   */
  setFrameNumber(frameNumber) {
    this._frameNumber = frameNumber;
    return this;
  }
  /**
   * optional: contains timeOffset remainder in picoseconds, in case of High FPS videos with high time resolution
   * @return {number}
   */
  getTimeOffsetRemPicos() {
    return this._timeOffsetRemPicos;
  }

  /**
   * @param timeOffsetRemPicos{number}
   * @return {TemporalLocationRangeEnd}
   */
  setTimeOffsetRemPicos(timeOffsetRemPicos) {
    this._timeOffsetRemPicos = timeOffsetRemPicos;
    return this;
  }
  /**
   * time in milliseconds, from the start of the video.
   * @return {number}
   */
  getTimeOffset() {
    return this._timeOffset;
  }

  /**
   * @param timeOffset{number}
   * @return {TemporalLocationRangeEnd}
   */
  setTimeOffset(timeOffset) {
    this._timeOffset = timeOffset;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TemporalLocationRangeEnd.CLASS_ID;
    
	//Serializing _frameNumber
	if (this._frameNumber)
		json['frameNumber'] = this._frameNumber;

	//Serializing _timeOffsetRemPicos
	if (this._timeOffsetRemPicos)
		json['timeOffsetRemPicos'] = this._timeOffsetRemPicos;

	//Serializing _timeOffset
	if (this._timeOffset)
		json['timeOffset'] = this._timeOffset;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._frameNumber = json.hasOwnProperty("frameNumber")?json["frameNumber"]:0;
		this._timeOffsetRemPicos = json.hasOwnProperty("timeOffsetRemPicos")?json["timeOffsetRemPicos"]:0;
		this._timeOffset = json.hasOwnProperty("timeOffset")?json["timeOffset"]:0;


  }
}

/**
 * @returns {string}
 */
TemporalLocationRangeEnd.CLASS_ID = "com.zoom.vab.client.autogenerated.TemporalLocationRangeEnd";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetLinkSharingPermissionsResponse {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._password = null;
    /**
     * @type {string}
     * @private
     */
    this._link = null;
    /**
     * @type {boolean}
     * @private
     */
    this._linkSharingEnable = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._transferPermissions = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._linkFeatures = null;

  }

    /**
   * @return {string}
   */
  getPassword() {
    return this._password;
  }

  /**
   * @param password{string}
   * @return {GetLinkSharingPermissionsResponse}
   */
  setPassword(password) {
    this._password = password;
    return this;
  }
  /**
   * @return {string}
   */
  getLink() {
    return this._link;
  }

  /**
   * @param link{string}
   * @return {GetLinkSharingPermissionsResponse}
   */
  setLink(link) {
    this._link = link;
    return this;
  }
  /**
   * @return {boolean}
   */
  isLinkSharingEnable() {
    return this._linkSharingEnable;
  }

  /**
   * @param linkSharingEnable{boolean}
   * @return {GetLinkSharingPermissionsResponse}
   */
  setLinkSharingEnable(linkSharingEnable) {
    this._linkSharingEnable = linkSharingEnable;
    return this;
  }
  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getTransferPermissions() {
    return this._transferPermissions;
  }

  /**
   * @param transferPermissions{java.util.Map<number,Boolean>}
   * @return {GetLinkSharingPermissionsResponse}
   */
  setTransferPermissions(transferPermissions) {
    this._transferPermissions = transferPermissions;
    return this;
  }

  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getLinkFeatures() {
    return this._linkFeatures;
  }

  /**
   * @param linkFeatures{java.util.Map<number,Boolean>}
   * @return {GetLinkSharingPermissionsResponse}
   */
  setLinkFeatures(linkFeatures) {
    this._linkFeatures = linkFeatures;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetLinkSharingPermissionsResponse.CLASS_ID;
    
	//Serializing _password
	if (this._password)
		json['password'] = this._password;

	//Serializing _link
	if (this._link)
		json['link'] = this._link;

	//Serializing _linkSharingEnable
	if (this._linkSharingEnable)
		json['linkSharingEnable'] = this._linkSharingEnable;
    SerializationUtil.serializeHashMap(json,"transferPermissions", this._transferPermissions);
		    SerializationUtil.serializeHashMap(json,"linkFeatures", this._linkFeatures);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._password = json.hasOwnProperty("password")?json["password"]:null;
		this._link = json.hasOwnProperty("link")?json["link"]:null;
		this._linkSharingEnable = json.hasOwnProperty("linkSharingEnable")?json["linkSharingEnable"]:false;
//Map of type INT. Decode as tree:false
		if (this._transferPermissions == null)
			this._transferPermissions = new HashMap();
		this._transferPermissions.clear();
		let transferPermissionsJSONArray = json.hasOwnProperty("transferPermissions") ? json["transferPermissions"] : [];
		this._transferPermissions = SerializationUtil.deserializeMap(transferPermissionsJSONArray);

//Map of type INT. Decode as tree:false
		if (this._linkFeatures == null)
			this._linkFeatures = new HashMap();
		this._linkFeatures.clear();
		let linkFeaturesJSONArray = json.hasOwnProperty("linkFeatures") ? json["linkFeatures"] : [];
		this._linkFeatures = SerializationUtil.deserializeMap(linkFeaturesJSONArray);



  }
}

/**
 * @returns {string}
 */
GetLinkSharingPermissionsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetLinkSharingPermissionsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AnnotationThread {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._threadId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._archived = false;
    /**
     * @type {string}
     * @private
     */
    this._annotationKind = null;
    /**
     * @type {boolean}
     * @private
     */
    this._resolved = false;
    /**
     * @type {AnnotationScope}
     * @private
     */
    this._annotationScope = null;
    /**
     * @type {AnnotationLocation}
     * @private
     */
    this._annotationLocation = null;
    /**
     * @type {Annotation}
     * @private
     */
    this._annotation = null;

  }

    /**
   * @return {number}
   */
  getThreadId() {
    return this._threadId;
  }

  /**
   * @param threadId{number}
   * @return {AnnotationThread}
   */
  setThreadId(threadId) {
    this._threadId = threadId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isArchived() {
    return this._archived;
  }

  /**
   * @param archived{boolean}
   * @return {AnnotationThread}
   */
  setArchived(archived) {
    this._archived = archived;
    return this;
  }
  /**
   * Enum: COMMENT, NOTE, PRIVATE_COMMENT, PRIVATE_NOTE, REVIEW
   * @return {string}
   */
  getAnnotationKind() {
    return this._annotationKind;
  }

  /**
   * @param annotationKind{string}
   * @return {AnnotationThread}
   */
  setAnnotationKind(annotationKind) {
    this._annotationKind = annotationKind;
    return this;
  }
  /**
   * @return {boolean}
   */
  isResolved() {
    return this._resolved;
  }

  /**
   * @param resolved{boolean}
   * @return {AnnotationThread}
   */
  setResolved(resolved) {
    this._resolved = resolved;
    return this;
  }
  /**
   * Consists of {scope, sub-scope}. Optional in edits, if unchanged; ignored in Save (as Message contains Scope).
   * @return {AnnotationScope}
   */
  getAnnotationScope() {
    return this._annotationScope;
  }

  /**
   * @param annotationScope{AnnotationScope}
   * @return {AnnotationThread}
   */
  setAnnotationScope(annotationScope) {
    this._annotationScope = annotationScope;
    return this;
  }
  /**
   * Location (within Scope). Optional in edits, if unchanged.
   * @return {AnnotationLocation}
   */
  getAnnotationLocation() {
    return this._annotationLocation;
  }

  /**
   * @param annotationLocation{AnnotationLocation}
   * @return {AnnotationThread}
   */
  setAnnotationLocation(annotationLocation) {
    this._annotationLocation = annotationLocation;
    return this;
  }
  /**
   * @return {Annotation}
   */
  getAnnotation() {
    return this._annotation;
  }

  /**
   * @param annotation{Annotation}
   * @return {AnnotationThread}
   */
  setAnnotation(annotation) {
    this._annotation = annotation;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AnnotationThread.CLASS_ID;
    
	//Serializing _threadId
	if (this._threadId)
		json['threadId'] = this._threadId;

	//Serializing _archived
	if (this._archived)
		json['archived'] = this._archived;

	//Serializing _annotationKind
	if (this._annotationKind)
		json['annotationKind'] = this._annotationKind;

	//Serializing _resolved
	if (this._resolved)
		json['resolved'] = this._resolved;

	//Serializing ComplexType _$arrayName
	if (this._annotationScope)
		json['annotationScope'] = this._annotationScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._annotationLocation)
		json['annotationLocation'] = this._annotationLocation.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._annotation)
		json['annotation'] = this._annotation.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._threadId = json.hasOwnProperty("threadId")?json["threadId"]:0;
		this._archived = json.hasOwnProperty("archived")?json["archived"]:false;
		this._annotationKind = json.hasOwnProperty("annotationKind")?json["annotationKind"]:null;
		this._resolved = json.hasOwnProperty("resolved")?json["resolved"]:false;
		if (json.hasOwnProperty("annotationScope")){
			if (!this._annotationScope && this._annotationScope == null)
				this._annotationScope = new AnnotationScope();
			this._annotationScope.deserializeJson(json.hasOwnProperty("annotationScope") ? json["annotationScope"] : null);
		}

		if (json.hasOwnProperty("annotationLocation")){
			if (!this._annotationLocation && this._annotationLocation == null)
				this._annotationLocation = new AnnotationLocation();
			this._annotationLocation.deserializeJson(json.hasOwnProperty("annotationLocation") ? json["annotationLocation"] : null);
		}

		if (json.hasOwnProperty("annotation")){
			if (!this._annotation && this._annotation == null)
				this._annotation = new Annotation();
			this._annotation.deserializeJson(json.hasOwnProperty("annotation") ? json["annotation"] : null);
		}



  }
}

/**
 * @returns {string}
 */
AnnotationThread.CLASS_ID = "com.zoom.vab.client.autogenerated.AnnotationThread";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SpatialLocation {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._width = null;
    /**
     * @type {number}
     * @private
     */
    this._heightOffset = null;
    /**
     * @type {number}
     * @private
     */
    this._widthOffset = null;
    /**
     * @type {number}
     * @private
     */
    this._height = null;

  }

    /**
   * width of the image at which annotation was created
   * @return {number}
   */
  getWidth() {
    return this._width;
  }

  /**
   * @param width{number}
   * @return {SpatialLocation}
   */
  setWidth(width) {
    this._width = width;
    return this;
  }
  /**
   * height offset for location; between 0 - height.
   * @return {number}
   */
  getHeightOffset() {
    return this._heightOffset;
  }

  /**
   * @param heightOffset{number}
   * @return {SpatialLocation}
   */
  setHeightOffset(heightOffset) {
    this._heightOffset = heightOffset;
    return this;
  }
  /**
   * width offset for location; between 0 - width.
   * @return {number}
   */
  getWidthOffset() {
    return this._widthOffset;
  }

  /**
   * @param widthOffset{number}
   * @return {SpatialLocation}
   */
  setWidthOffset(widthOffset) {
    this._widthOffset = widthOffset;
    return this;
  }
  /**
   * height of the image at which annotation was created
   * @return {number}
   */
  getHeight() {
    return this._height;
  }

  /**
   * @param height{number}
   * @return {SpatialLocation}
   */
  setHeight(height) {
    this._height = height;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SpatialLocation.CLASS_ID;
    
	//Serializing _width
	if (this._width)
		json['width'] = this._width;

	//Serializing _heightOffset
	if (this._heightOffset)
		json['heightOffset'] = this._heightOffset;

	//Serializing _widthOffset
	if (this._widthOffset)
		json['widthOffset'] = this._widthOffset;

	//Serializing _height
	if (this._height)
		json['height'] = this._height;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._width = json.hasOwnProperty("width")?json["width"]:0;
		this._heightOffset = json.hasOwnProperty("heightOffset")?json["heightOffset"]:0;
		this._widthOffset = json.hasOwnProperty("widthOffset")?json["widthOffset"]:0;
		this._height = json.hasOwnProperty("height")?json["height"]:0;


  }
}

/**
 * @returns {string}
 */
SpatialLocation.CLASS_ID = "com.zoom.vab.client.autogenerated.SpatialLocation";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ReloadSessionMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._force = false;

  }

    /**
   * @return {boolean}
   */
  isForce() {
    return this._force;
  }

  /**
   * @param force{boolean}
   * @return {ReloadSessionMsg}
   */
  setForce(force) {
    this._force = force;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ReloadSessionMsg.CLASS_ID;
    
	//Serializing _force
	if (this._force)
		json['force'] = this._force;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._force = json.hasOwnProperty("force")?json["force"]:false;


  }
}

/**
 * @returns {string}
 */
ReloadSessionMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ReloadSessionMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AssetEntry {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._fqPath = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {AssetEntry}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {AssetEntry}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {AssetEntry}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getFqPath() {
    return this._fqPath;
  }

  /**
   * @param fqPath{string}
   * @return {AssetEntry}
   */
  setFqPath(fqPath) {
    this._fqPath = fqPath;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {AssetEntry}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AssetEntry.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _fqPath
	if (this._fqPath)
		json['fqPath'] = this._fqPath;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._fqPath = json.hasOwnProperty("fqPath")?json["fqPath"]:null;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
AssetEntry.CLASS_ID = "com.zoom.vab.client.autogenerated.AssetEntry";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DrawingAnnotation {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._editor = null;
    /**
     * @type {number}
     * @private
     */
    this._shapeId = null;
    /**
     * @type {string}
     * @private
     */
    this._data = null;
    /**
     * @type {string}
     * @private
     */
    this._dataType = null;
    /**
     * @type {number}
     * @private
     */
    this._mTime = null;
    /**
     * @type {AnnotationScope}
     * @private
     */
    this._annotationScope = null;
    /**
     * @type {AnnotationLocation}
     * @private
     */
    this._annotationLocation = null;

  }

    /**
   * @return {string}
   */
  getEditor() {
    return this._editor;
  }

  /**
   * @param editor{string}
   * @return {DrawingAnnotation}
   */
  setEditor(editor) {
    this._editor = editor;
    return this;
  }
  /**
   * @return {number}
   */
  getShapeId() {
    return this._shapeId;
  }

  /**
   * @param shapeId{number}
   * @return {DrawingAnnotation}
   */
  setShapeId(shapeId) {
    this._shapeId = shapeId;
    return this;
  }
  /**
   * @return {string}
   */
  getData() {
    return this._data;
  }

  /**
   * @param data{string}
   * @return {DrawingAnnotation}
   */
  setData(data) {
    this._data = data;
    return this;
  }
  /**
   * Enum: SVG
   * @return {string}
   */
  getDataType() {
    return this._dataType;
  }

  /**
   * @param dataType{string}
   * @return {DrawingAnnotation}
   */
  setDataType(dataType) {
    this._dataType = dataType;
    return this;
  }
  /**
   * @return {number}
   */
  getMTime() {
    return this._mTime;
  }

  /**
   * @param mTime{number}
   * @return {DrawingAnnotation}
   */
  setMTime(mTime) {
    this._mTime = mTime;
    return this;
  }
  /**
   * @return {AnnotationScope}
   */
  getAnnotationScope() {
    return this._annotationScope;
  }

  /**
   * @param annotationScope{AnnotationScope}
   * @return {DrawingAnnotation}
   */
  setAnnotationScope(annotationScope) {
    this._annotationScope = annotationScope;
    return this;
  }
  /**
   * @return {AnnotationLocation}
   */
  getAnnotationLocation() {
    return this._annotationLocation;
  }

  /**
   * @param annotationLocation{AnnotationLocation}
   * @return {DrawingAnnotation}
   */
  setAnnotationLocation(annotationLocation) {
    this._annotationLocation = annotationLocation;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DrawingAnnotation.CLASS_ID;
    
	//Serializing _editor
	if (this._editor)
		json['editor'] = this._editor;

	//Serializing _shapeId
	if (this._shapeId)
		json['shapeId'] = this._shapeId;

	//Serializing _data
	if (this._data)
		json['data'] = this._data;

	//Serializing _dataType
	if (this._dataType)
		json['dataType'] = this._dataType;

	//Serializing _mTime
	if (this._mTime)
		json['mTime'] = this._mTime;

	//Serializing ComplexType _$arrayName
	if (this._annotationScope)
		json['annotationScope'] = this._annotationScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._annotationLocation)
		json['annotationLocation'] = this._annotationLocation.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._editor = json.hasOwnProperty("editor")?json["editor"]:null;
		this._shapeId = json.hasOwnProperty("shapeId")?json["shapeId"]:0;
		this._data = json.hasOwnProperty("data")?json["data"]:null;
		this._dataType = json.hasOwnProperty("dataType")?json["dataType"]:null;
		this._mTime = json.hasOwnProperty("mTime")?json["mTime"]:0;
		if (json.hasOwnProperty("annotationScope")){
			if (!this._annotationScope && this._annotationScope == null)
				this._annotationScope = new AnnotationScope();
			this._annotationScope.deserializeJson(json.hasOwnProperty("annotationScope") ? json["annotationScope"] : null);
		}

		if (json.hasOwnProperty("annotationLocation")){
			if (!this._annotationLocation && this._annotationLocation == null)
				this._annotationLocation = new AnnotationLocation();
			this._annotationLocation.deserializeJson(json.hasOwnProperty("annotationLocation") ? json["annotationLocation"] : null);
		}



  }
}

/**
 * @returns {string}
 */
DrawingAnnotation.CLASS_ID = "com.zoom.vab.client.autogenerated.DrawingAnnotation";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditFiltersQuery extends HttpOperation {

  constructor(name = "EditFilters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EditFiltersMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditFiltersMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {EditFiltersResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditFiltersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditFiltersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new EditFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new EditFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditFiltersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditFilters";
/**
 * @returns {string}
 */
EditFiltersQuery.QUERY_NAME = "EditFilters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SaveSettingsQuery extends HttpOperation {

  constructor(name = "SaveSettings") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SaveSettingsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SaveSettingsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {SaveSettingsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SaveSettingsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SaveSettingsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new SaveSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new SaveSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SaveSettingsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveSettings";
/**
 * @returns {string}
 */
SaveSettingsQuery.QUERY_NAME = "SaveSettings";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LoadMetadataSpecQuery extends HttpOperation {

  constructor(name = "LoadMetadataSpec") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LoadMetadataSpecMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LoadMetadataSpecMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LoadMetadataSpecResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LoadMetadataSpecQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LoadMetadataSpecQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LoadMetadataSpecResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LoadMetadataSpecResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LoadMetadataSpecQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadMetadataSpec";
/**
 * @returns {string}
 */
LoadMetadataSpecQuery.QUERY_NAME = "LoadMetadataSpec";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class HelpInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._helpHeader = null;
    /**
     * @type {string}
     * @private
     */
    this._helpType = null;
    /**
     * @type {string}
     * @private
     */
    this._iconType = null;
    /**
     * @type {number}
     * @private
     */
    this._totalPages = null;
    /**
     * @type {string}
     * @private
     */
    this._helpContent = null;
    /**
     * @type {number}
     * @private
     */
    this._currentPage = null;
    /**
     * @type {Array<HelpLinkInfo>}
     * @private
     */
    this._helpLinks = null;

  }

    /**
   * @return {string}
   */
  getHelpHeader() {
    return this._helpHeader;
  }

  /**
   * @param helpHeader{string}
   * @return {HelpInfo}
   */
  setHelpHeader(helpHeader) {
    this._helpHeader = helpHeader;
    return this;
  }
  /**
   * @return {string}
   */
  getHelpType() {
    return this._helpType;
  }

  /**
   * @param helpType{string}
   * @return {HelpInfo}
   */
  setHelpType(helpType) {
    this._helpType = helpType;
    return this;
  }
  /**
   * @return {string}
   */
  getIconType() {
    return this._iconType;
  }

  /**
   * @param iconType{string}
   * @return {HelpInfo}
   */
  setIconType(iconType) {
    this._iconType = iconType;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalPages() {
    return this._totalPages;
  }

  /**
   * @param totalPages{number}
   * @return {HelpInfo}
   */
  setTotalPages(totalPages) {
    this._totalPages = totalPages;
    return this;
  }
  /**
   * @return {string}
   */
  getHelpContent() {
    return this._helpContent;
  }

  /**
   * @param helpContent{string}
   * @return {HelpInfo}
   */
  setHelpContent(helpContent) {
    this._helpContent = helpContent;
    return this;
  }
  /**
   * @return {number}
   */
  getCurrentPage() {
    return this._currentPage;
  }

  /**
   * @param currentPage{number}
   * @return {HelpInfo}
   */
  setCurrentPage(currentPage) {
    this._currentPage = currentPage;
    return this;
  }
  /**
   * @return {Array<HelpLinkInfo>}
   */
  getHelpLinks() {
    return this._helpLinks;
  }

  /**
   * @param helpLinks{Array<HelpLinkInfo>}
   * @return {HelpInfo}
   */
  setHelpLinks(helpLinks) {
    this._helpLinks = helpLinks;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = HelpInfo.CLASS_ID;
    
	//Serializing _helpHeader
	if (this._helpHeader)
		json['helpHeader'] = this._helpHeader;

	//Serializing _helpType
	if (this._helpType)
		json['helpType'] = this._helpType;

	//Serializing _iconType
	if (this._iconType)
		json['iconType'] = this._iconType;

	//Serializing _totalPages
	if (this._totalPages)
		json['totalPages'] = this._totalPages;

	//Serializing _helpContent
	if (this._helpContent)
		json['helpContent'] = this._helpContent;

	//Serializing _currentPage
	if (this._currentPage)
		json['currentPage'] = this._currentPage;
  if (this._helpLinks && this._helpLinks.length > 0) {
    let helpLinks_JSON = [];
    /**
     * @type {HelpLinkInfo}
     */
    this._helpLinks.forEach((o347) => {
      if (o347) {
        if (o347.serializeJson && (typeof (o347.serializeJson) === 'function')) {
          helpLinks_JSON.push(o347.serializeJson());
        } else {
          helpLinks_JSON.push(o347);
        }
      }
    });
    json['helpLinks'] = helpLinks_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._helpHeader = json.hasOwnProperty("helpHeader")?json["helpHeader"]:null;
		this._helpType = json.hasOwnProperty("helpType")?json["helpType"]:null;
		this._iconType = json.hasOwnProperty("iconType")?json["iconType"]:null;
		this._totalPages = json.hasOwnProperty("totalPages")?json["totalPages"]:0;
		this._helpContent = json.hasOwnProperty("helpContent")?json["helpContent"]:null;
		this._currentPage = json.hasOwnProperty("currentPage")?json["currentPage"]:0;
		//set of type HelpLinkInfo
		this._helpLinks = [];
		let helpLinksJSONArray = json.hasOwnProperty("helpLinks") ? json["helpLinks"] : [];

		helpLinksJSONArray.forEach((o348)=>{
			if (o348){
				let classObj = new HelpLinkInfo();
				classObj.deserializeJson(o348);
				this._helpLinks.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
HelpInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.HelpInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class MultiFormatDownloadsServerResp {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._outputFormats = null;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._id = null;
    /**
     * @type {Array<SimpleArgsClassServer>}
     * @private
     */
    this._argTokenDetailsIdList = null;

  }

    /**
   * @return {string}
   */
  getOutputFormats() {
    return this._outputFormats;
  }

  /**
   * @param outputFormats{string}
   * @return {MultiFormatDownloadsServerResp}
   */
  setOutputFormats(outputFormats) {
    this._outputFormats = outputFormats;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {MultiFormatDownloadsServerResp}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getId() {
    return this._id;
  }

  /**
   * @param id{number}
   * @return {MultiFormatDownloadsServerResp}
   */
  setId(id) {
    this._id = id;
    return this;
  }
  /**
   * @return {Array<SimpleArgsClassServer>}
   */
  getArgTokenDetailsIdList() {
    return this._argTokenDetailsIdList;
  }

  /**
   * @param argTokenDetailsIdList{Array<SimpleArgsClassServer>}
   * @return {MultiFormatDownloadsServerResp}
   */
  setArgTokenDetailsIdList(argTokenDetailsIdList) {
    this._argTokenDetailsIdList = argTokenDetailsIdList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = MultiFormatDownloadsServerResp.CLASS_ID;
    
	//Serializing _outputFormats
	if (this._outputFormats)
		json['outputFormats'] = this._outputFormats;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _id
	if (this._id)
		json['id'] = this._id;
  if (this._argTokenDetailsIdList && this._argTokenDetailsIdList.length > 0) {
    let argTokenDetailsIdList_JSON = [];
    /**
     * @type {SimpleArgsClassServer}
     */
    this._argTokenDetailsIdList.forEach((o678) => {
      if (o678) {
        if (o678.serializeJson && (typeof (o678.serializeJson) === 'function')) {
          argTokenDetailsIdList_JSON.push(o678.serializeJson());
        } else {
          argTokenDetailsIdList_JSON.push(o678);
        }
      }
    });
    json['argTokenDetailsIdList'] = argTokenDetailsIdList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._outputFormats = json.hasOwnProperty("outputFormats")?json["outputFormats"]:null;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._id = json.hasOwnProperty("id")?json["id"]:0;
		//set of type SimpleArgsClassServer
		this._argTokenDetailsIdList = [];
		let argTokenDetailsIdListJSONArray = json.hasOwnProperty("argTokenDetailsIdList") ? json["argTokenDetailsIdList"] : [];

		argTokenDetailsIdListJSONArray.forEach((o679)=>{
			if (o679){
				let classObj = new SimpleArgsClassServer();
				classObj.deserializeJson(o679);
				this._argTokenDetailsIdList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
MultiFormatDownloadsServerResp.CLASS_ID = "com.zoom.vab.client.autogenerated.MultiFormatDownloadsServerResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCollectionSettingsQuery extends HttpOperation {

  constructor(name = "GetCollectionSettings") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCollectionSettingsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCollectionSettingsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCollectionSettingsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCollectionSettingsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCollectionSettingsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCollectionSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCollectionSettingsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCollectionSettingsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionSettings";
/**
 * @returns {string}
 */
GetCollectionSettingsQuery.QUERY_NAME = "GetCollectionSettings";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class UploadFromUrlMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._action = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._paths = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._properties = null;

  }

    /**
   * @return {string}
   */
  getAction() {
    return this._action;
  }

  /**
   * @param action{string}
   * @return {UploadFromUrlMessage}
   */
  setAction(action) {
    this._action = action;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getPaths() {
    return this._paths;
  }

  /**
   * @param paths{Array<String>}
   * @return {UploadFromUrlMessage}
   */
  setPaths(paths) {
    this._paths = paths;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getProperties() {
    return this._properties;
  }

  /**
   * @param properties{java.util.Map<String,String>}
   * @return {UploadFromUrlMessage}
   */
  setProperties(properties) {
    this._properties = properties;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UploadFromUrlMessage.CLASS_ID;
    
	//Serializing _action
	if (this._action)
		json['action'] = this._action;
  if (this._paths && this._paths.length > 0) {
    let paths_JSON = [];
    /**
     * @type {string}
     */
    this._paths.forEach((o266) => {
      if (o266) {
        if (o266.serializeJson && (typeof (o266.serializeJson) === 'function')) {
          paths_JSON.push(o266.serializeJson());
        } else {
          paths_JSON.push(o266);
        }
      }
    });
    json['paths'] = paths_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"properties", this._properties);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._action = json.hasOwnProperty("action")?json["action"]:null;
		//set of type string
		this._paths = [];
		let pathsJSONArray = json.hasOwnProperty("paths") ? json["paths"] : [];

		pathsJSONArray.forEach((o267)=>{
			if (o267){
				this._paths.push(o267);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._properties == null)
			this._properties = new HashMap();
		this._properties.clear();
		let propertiesJSONArray = json.hasOwnProperty("properties") ? json["properties"] : [];
		this._properties = SerializationUtil.deserializeMap(propertiesJSONArray);



  }
}

/**
 * @returns {string}
 */
UploadFromUrlMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.UploadFromUrlMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FilterDetail {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._label = null;
    /**
     * @type {Array<FilterDetail>}
     * @private
     */
    this._children = null;

  }

    /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {FilterDetail}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getLabel() {
    return this._label;
  }

  /**
   * @param label{string}
   * @return {FilterDetail}
   */
  setLabel(label) {
    this._label = label;
    return this;
  }
  /**
   * @return {Array<FilterDetail>}
   */
  getChildren() {
    return this._children;
  }

  /**
   * @param children{Array<FilterDetail>}
   * @return {FilterDetail}
   */
  setChildren(children) {
    this._children = children;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FilterDetail.CLASS_ID;
    
	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _label
	if (this._label)
		json['label'] = this._label;
  if (this._children && this._children.length > 0) {
    let children_JSON = [];
    /**
     * @type {FilterDetail}
     */
    this._children.forEach((o403) => {
      if (o403) {
        if (o403.serializeJson && (typeof (o403.serializeJson) === 'function')) {
          children_JSON.push(o403.serializeJson());
        } else {
          children_JSON.push(o403);
        }
      }
    });
    json['children'] = children_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._label = json.hasOwnProperty("label")?json["label"]:null;
		//set of type FilterDetail
		this._children = [];
		let childrenJSONArray = json.hasOwnProperty("children") ? json["children"] : [];

		childrenJSONArray.forEach((o404)=>{
			if (o404){
				let classObj = new FilterDetail();
				classObj.deserializeJson(o404);
				this._children.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FilterDetail.CLASS_ID = "com.zoom.vab.client.autogenerated.FilterDetail";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ExtraInfo {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isConnected = false;
    /**
     * @type {string}
     * @private
     */
    this._dragPath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isProxy = false;
    /**
     * @type {string}
     * @private
     */
    this._expectedTPMPath = null;

  }

    /**
   * @return {boolean}
   */
  isIsConnected() {
    return this._isConnected;
  }

  /**
   * @param isConnected{boolean}
   * @return {ExtraInfo}
   */
  setIsConnected(isConnected) {
    this._isConnected = isConnected;
    return this;
  }
  /**
   * @return {string}
   */
  getDragPath() {
    return this._dragPath;
  }

  /**
   * @param dragPath{string}
   * @return {ExtraInfo}
   */
  setDragPath(dragPath) {
    this._dragPath = dragPath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsProxy() {
    return this._isProxy;
  }

  /**
   * @param isProxy{boolean}
   * @return {ExtraInfo}
   */
  setIsProxy(isProxy) {
    this._isProxy = isProxy;
    return this;
  }
  /**
   * @return {string}
   */
  getExpectedTPMPath() {
    return this._expectedTPMPath;
  }

  /**
   * @param expectedTPMPath{string}
   * @return {ExtraInfo}
   */
  setExpectedTPMPath(expectedTPMPath) {
    this._expectedTPMPath = expectedTPMPath;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ExtraInfo.CLASS_ID;
    
	//Serializing _isConnected
	if (this._isConnected)
		json['isConnected'] = this._isConnected;

	//Serializing _dragPath
	if (this._dragPath)
		json['dragPath'] = this._dragPath;

	//Serializing _isProxy
	if (this._isProxy)
		json['isProxy'] = this._isProxy;

	//Serializing _expectedTPMPath
	if (this._expectedTPMPath)
		json['expectedTPMPath'] = this._expectedTPMPath;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isConnected = json.hasOwnProperty("isConnected")?json["isConnected"]:false;
		this._dragPath = json.hasOwnProperty("dragPath")?json["dragPath"]:null;
		this._isProxy = json.hasOwnProperty("isProxy")?json["isProxy"]:false;
		this._expectedTPMPath = json.hasOwnProperty("expectedTPMPath")?json["expectedTPMPath"]:null;


  }
}

/**
 * @returns {string}
 */
ExtraInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.ExtraInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetActivityPanelDataMessage {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isMarkedResolved = false;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isNewComment = false;
    /**
     * @type {string}
     * @private
     */
    this._userId = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {number}
     * @private
     */
    this._parentId = null;
    /**
     * @type {string}
     * @private
     */
    this._status = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasReplied = false;

  }

    /**
   * @return {boolean}
   */
  isIsMarkedResolved() {
    return this._isMarkedResolved;
  }

  /**
   * @param isMarkedResolved{boolean}
   * @return {SetActivityPanelDataMessage}
   */
  setIsMarkedResolved(isMarkedResolved) {
    this._isMarkedResolved = isMarkedResolved;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {SetActivityPanelDataMessage}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsNewComment() {
    return this._isNewComment;
  }

  /**
   * @param isNewComment{boolean}
   * @return {SetActivityPanelDataMessage}
   */
  setIsNewComment(isNewComment) {
    this._isNewComment = isNewComment;
    return this;
  }
  /**
   * @return {string}
   */
  getUserId() {
    return this._userId;
  }

  /**
   * @param userId{string}
   * @return {SetActivityPanelDataMessage}
   */
  setUserId(userId) {
    this._userId = userId;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {SetActivityPanelDataMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {number}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{number}
   * @return {SetActivityPanelDataMessage}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }
  /**
   * @return {string}
   */
  getStatus() {
    return this._status;
  }

  /**
   * @param status{string}
   * @return {SetActivityPanelDataMessage}
   */
  setStatus(status) {
    this._status = status;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasReplied() {
    return this._hasReplied;
  }

  /**
   * @param hasReplied{boolean}
   * @return {SetActivityPanelDataMessage}
   */
  setHasReplied(hasReplied) {
    this._hasReplied = hasReplied;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetActivityPanelDataMessage.CLASS_ID;
    
	//Serializing _isMarkedResolved
	if (this._isMarkedResolved)
		json['isMarkedResolved'] = this._isMarkedResolved;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _isNewComment
	if (this._isNewComment)
		json['isNewComment'] = this._isNewComment;

	//Serializing _userId
	if (this._userId)
		json['userId'] = this._userId;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;

	//Serializing _status
	if (this._status)
		json['status'] = this._status;

	//Serializing _hasReplied
	if (this._hasReplied)
		json['hasReplied'] = this._hasReplied;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isMarkedResolved = json.hasOwnProperty("isMarkedResolved")?json["isMarkedResolved"]:false;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._isNewComment = json.hasOwnProperty("isNewComment")?json["isNewComment"]:false;
		this._userId = json.hasOwnProperty("userId")?json["userId"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:0;
		this._status = json.hasOwnProperty("status")?json["status"]:null;
		this._hasReplied = json.hasOwnProperty("hasReplied")?json["hasReplied"]:false;


  }
}

/**
 * @returns {string}
 */
SetActivityPanelDataMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SetActivityPanelDataMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditSpotLightQuery extends HttpOperation {

  constructor(name = "EditSpotLight") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {EditSpotLightQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditSpotLightQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {EditSpotLightQueryRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditSpotLightQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditSpotLightQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new EditSpotLightQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new EditSpotLightQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditSpotLightQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditSpotLight";
/**
 * @returns {string}
 */
EditSpotLightQuery.QUERY_NAME = "EditSpotLight";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetDrawingAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {Array<ShapeId>}
     * @private
     */
    this._deletedShapes = null;
    /**
     * @type {Array<DrawingAnnotation>}
     * @private
     */
    this._shapes = null;

  }

    /**
   * RRN up to which response is valid
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {GetDrawingAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * Shapes deleted since lastReceivedRrn.
   * @return {Array<ShapeId>}
   */
  getDeletedShapes() {
    return this._deletedShapes;
  }

  /**
   * @param deletedShapes{Array<ShapeId>}
   * @return {GetDrawingAnnotationsResponse}
   */
  setDeletedShapes(deletedShapes) {
    this._deletedShapes = deletedShapes;
    return this;
  }

  /**
   * @return {Array<DrawingAnnotation>}
   */
  getShapes() {
    return this._shapes;
  }

  /**
   * @param shapes{Array<DrawingAnnotation>}
   * @return {GetDrawingAnnotationsResponse}
   */
  setShapes(shapes) {
    this._shapes = shapes;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetDrawingAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;
  if (this._deletedShapes && this._deletedShapes.length > 0) {
    let deletedShapes_JSON = [];
    /**
     * @type {ShapeId}
     */
    this._deletedShapes.forEach((o130) => {
      if (o130) {
        if (o130.serializeJson && (typeof (o130.serializeJson) === 'function')) {
          deletedShapes_JSON.push(o130.serializeJson());
        } else {
          deletedShapes_JSON.push(o130);
        }
      }
    });
    json['deletedShapes'] = deletedShapes_JSON;
  }  
  if (this._shapes && this._shapes.length > 0) {
    let shapes_JSON = [];
    /**
     * @type {DrawingAnnotation}
     */
    this._shapes.forEach((o133) => {
      if (o133) {
        if (o133.serializeJson && (typeof (o133.serializeJson) === 'function')) {
          shapes_JSON.push(o133.serializeJson());
        } else {
          shapes_JSON.push(o133);
        }
      }
    });
    json['shapes'] = shapes_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		//set of type ShapeId
		this._deletedShapes = [];
		let deletedShapesJSONArray = json.hasOwnProperty("deletedShapes") ? json["deletedShapes"] : [];

		deletedShapesJSONArray.forEach((o131)=>{
			if (o131){
				let classObj = new ShapeId();
				classObj.deserializeJson(o131);
				this._deletedShapes.push(classObj);
			}
		});
		//set of type DrawingAnnotation
		this._shapes = [];
		let shapesJSONArray = json.hasOwnProperty("shapes") ? json["shapes"] : [];

		shapesJSONArray.forEach((o134)=>{
			if (o134){
				let classObj = new DrawingAnnotation();
				classObj.deserializeJson(o134);
				this._shapes.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetDrawingAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetDrawingAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LiveDrawSpecResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isLiveDrawEnabled = false;

  }

    /**
   * @return {boolean}
   */
  isIsLiveDrawEnabled() {
    return this._isLiveDrawEnabled;
  }

  /**
   * @param isLiveDrawEnabled{boolean}
   * @return {LiveDrawSpecResponse}
   */
  setIsLiveDrawEnabled(isLiveDrawEnabled) {
    this._isLiveDrawEnabled = isLiveDrawEnabled;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LiveDrawSpecResponse.CLASS_ID;
    
	//Serializing _isLiveDrawEnabled
	if (this._isLiveDrawEnabled)
		json['isLiveDrawEnabled'] = this._isLiveDrawEnabled;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isLiveDrawEnabled = json.hasOwnProperty("isLiveDrawEnabled")?json["isLiveDrawEnabled"]:false;


  }
}

/**
 * @returns {string}
 */
LiveDrawSpecResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LiveDrawSpecResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetDrawingAnnotationsQuery extends HttpOperation {

  constructor(name = "GetDrawingAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetDrawingAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetDrawingAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetDrawingAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetDrawingAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetDrawingAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetDrawingAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetDrawingAnnotations";
/**
 * @returns {string}
 */
GetDrawingAnnotationsQuery.QUERY_NAME = "GetDrawingAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SendVerificationLinkToUserQuery extends HttpOperation {

  constructor(name = "SendVerificationLinkToUser") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {SendVerificationLinkToUserMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SendVerificationLinkToUserMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SendVerificationLinkToUserQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SendVerificationLinkToUserQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SendVerificationLinkToUserQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SendVerificationLinkToUser";
/**
 * @returns {string}
 */
SendVerificationLinkToUserQuery.QUERY_NAME = "SendVerificationLinkToUser";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ClearAllDrawingAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {ClearAllDrawingAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ClearAllDrawingAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;


  }
}

/**
 * @returns {string}
 */
ClearAllDrawingAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.ClearAllDrawingAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class FolderDetailsQuery extends HttpOperation {

  constructor(name = "FolderDetails") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FolderDetailsArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FolderDetailsArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FolderDetailsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FolderDetailsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FolderDetailsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FolderDetailsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FolderDetailsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FolderDetailsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FolderDetails";
/**
 * @returns {string}
 */
FolderDetailsQuery.QUERY_NAME = "FolderDetails";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class CreateLiveDrawResponse {

  constructor() {
    
        /**
     * @type {LiveDrawEntry}
     * @private
     */
    this._liveDrawEntry = null;

  }

    /**
   * @return {LiveDrawEntry}
   */
  getLiveDrawEntry() {
    return this._liveDrawEntry;
  }

  /**
   * @param liveDrawEntry{LiveDrawEntry}
   * @return {CreateLiveDrawResponse}
   */
  setLiveDrawEntry(liveDrawEntry) {
    this._liveDrawEntry = liveDrawEntry;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = CreateLiveDrawResponse.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._liveDrawEntry)
		json['liveDrawEntry'] = this._liveDrawEntry.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("liveDrawEntry")){
			if (!this._liveDrawEntry && this._liveDrawEntry == null)
				this._liveDrawEntry = new LiveDrawEntry();
			this._liveDrawEntry.deserializeJson(json.hasOwnProperty("liveDrawEntry") ? json["liveDrawEntry"] : null);
		}



  }
}

/**
 * @returns {string}
 */
CreateLiveDrawResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateLiveDrawResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionFilterListResp {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._collectionFilterNames = null;

  }

    /**
   * @return {Array<String>}
   */
  getCollectionFilterNames() {
    return this._collectionFilterNames;
  }

  /**
   * @param collectionFilterNames{Array<String>}
   * @return {GetCollectionFilterListResp}
   */
  setCollectionFilterNames(collectionFilterNames) {
    this._collectionFilterNames = collectionFilterNames;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionFilterListResp.CLASS_ID;
      if (this._collectionFilterNames && this._collectionFilterNames.length > 0) {
    let collectionFilterNames_JSON = [];
    /**
     * @type {string}
     */
    this._collectionFilterNames.forEach((o918) => {
      if (o918) {
        if (o918.serializeJson && (typeof (o918.serializeJson) === 'function')) {
          collectionFilterNames_JSON.push(o918.serializeJson());
        } else {
          collectionFilterNames_JSON.push(o918);
        }
      }
    });
    json['collectionFilterNames'] = collectionFilterNames_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._collectionFilterNames = [];
		let collectionFilterNamesJSONArray = json.hasOwnProperty("collectionFilterNames") ? json["collectionFilterNames"] : [];

		collectionFilterNamesJSONArray.forEach((o919)=>{
			if (o919){
				this._collectionFilterNames.push(o919);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetCollectionFilterListResp.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionFilterListResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetZmCollectionRolesQuery extends HttpOperation {

  constructor(name = "GetZmCollectionRoles") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ArrayType";
  }

  /**
   * @returns {int}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{int}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ArrayCollection}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetZmCollectionRolesQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetZmCollectionRolesQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ArrayCollection();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetZmCollectionRolesQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetZmCollectionRoles";
/**
 * @returns {string}
 */
GetZmCollectionRolesQuery.QUERY_NAME = "GetZmCollectionRoles";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FlexSmartCopyArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._destDir = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {boolean}
     * @private
     */
    this._useSameDestFolder = false;
    /**
     * @type {Array<String>}
     * @private
     */
    this._srcRrn = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._srcFuids = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._dest = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * Used for confirmation message in VAB
   * @return {string}
   */
  getDestDir() {
    return this._destDir;
  }

  /**
   * @param destDir{string}
   * @return {FlexSmartCopyArgs}
   */
  setDestDir(destDir) {
    this._destDir = destDir;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexSmartCopyArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexSmartCopyArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseSameDestFolder() {
    return this._useSameDestFolder;
  }

  /**
   * @param useSameDestFolder{boolean}
   * @return {FlexSmartCopyArgs}
   */
  setUseSameDestFolder(useSameDestFolder) {
    this._useSameDestFolder = useSameDestFolder;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getSrcRrn() {
    return this._srcRrn;
  }

  /**
   * @param srcRrn{Array<String>}
   * @return {FlexSmartCopyArgs}
   */
  setSrcRrn(srcRrn) {
    this._srcRrn = srcRrn;
    return this;
  }

  /**
   * @return {Array<Integer>}
   */
  getSrcFuids() {
    return this._srcFuids;
  }

  /**
   * @param srcFuids{Array<Integer>}
   * @return {FlexSmartCopyArgs}
   */
  setSrcFuids(srcFuids) {
    this._srcFuids = srcFuids;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getDest() {
    return this._dest;
  }

  /**
   * @param dest{Array<String>}
   * @return {FlexSmartCopyArgs}
   */
  setDest(dest) {
    this._dest = dest;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {FlexSmartCopyArgs}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexSmartCopyArgs.CLASS_ID;
    
	//Serializing _destDir
	if (this._destDir)
		json['destDir'] = this._destDir;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;

	//Serializing _useSameDestFolder
	if (this._useSameDestFolder)
		json['useSameDestFolder'] = this._useSameDestFolder;
  if (this._srcRrn && this._srcRrn.length > 0) {
    let srcRrn_JSON = [];
    /**
     * @type {string}
     */
    this._srcRrn.forEach((o43) => {
      if (o43) {
        if (o43.serializeJson && (typeof (o43.serializeJson) === 'function')) {
          srcRrn_JSON.push(o43.serializeJson());
        } else {
          srcRrn_JSON.push(o43);
        }
      }
    });
    json['srcRrn'] = srcRrn_JSON;
  }  
  if (this._srcFuids && this._srcFuids.length > 0) {
    let srcFuids_JSON = [];
    /**
     * @type {int}
     */
    this._srcFuids.forEach((o46) => {
      if (o46) {
        if (o46.serializeJson && (typeof (o46.serializeJson) === 'function')) {
          srcFuids_JSON.push(o46.serializeJson());
        } else {
          srcFuids_JSON.push(o46);
        }
      }
    });
    json['srcFuids'] = srcFuids_JSON;
  }  
  if (this._dest && this._dest.length > 0) {
    let dest_JSON = [];
    /**
     * @type {string}
     */
    this._dest.forEach((o49) => {
      if (o49) {
        if (o49.serializeJson && (typeof (o49.serializeJson) === 'function')) {
          dest_JSON.push(o49.serializeJson());
        } else {
          dest_JSON.push(o49);
        }
      }
    });
    json['dest'] = dest_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._destDir = json.hasOwnProperty("destDir")?json["destDir"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		this._useSameDestFolder = json.hasOwnProperty("useSameDestFolder")?json["useSameDestFolder"]:false;
		//set of type string
		this._srcRrn = [];
		let srcRrnJSONArray = json.hasOwnProperty("srcRrn") ? json["srcRrn"] : [];

		srcRrnJSONArray.forEach((o44)=>{
			if (o44){
				this._srcRrn.push(o44);
			}
		});
		//set of type int
		this._srcFuids = [];
		let srcFuidsJSONArray = json.hasOwnProperty("srcFuids") ? json["srcFuids"] : [];

		srcFuidsJSONArray.forEach((o47)=>{
			if (o47){
				this._srcFuids.push(o47);
			}
		});
		//set of type string
		this._dest = [];
		let destJSONArray = json.hasOwnProperty("dest") ? json["dest"] : [];

		destJSONArray.forEach((o50)=>{
			if (o50){
				this._dest.push(o50);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
FlexSmartCopyArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartCopyArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LoadMetadataSpecMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._skipId2PropMap = false;
    /**
     * @type {boolean}
     * @private
     */
    this._includeEditablePropsList = false;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;

  }

    /**
   * @return {boolean}
   */
  isSkipId2PropMap() {
    return this._skipId2PropMap;
  }

  /**
   * @param skipId2PropMap{boolean}
   * @return {LoadMetadataSpecMsg}
   */
  setSkipId2PropMap(skipId2PropMap) {
    this._skipId2PropMap = skipId2PropMap;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIncludeEditablePropsList() {
    return this._includeEditablePropsList;
  }

  /**
   * @param includeEditablePropsList{boolean}
   * @return {LoadMetadataSpecMsg}
   */
  setIncludeEditablePropsList(includeEditablePropsList) {
    this._includeEditablePropsList = includeEditablePropsList;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {LoadMetadataSpecMsg}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LoadMetadataSpecMsg.CLASS_ID;
    
	//Serializing _skipId2PropMap
	if (this._skipId2PropMap)
		json['skipId2PropMap'] = this._skipId2PropMap;

	//Serializing _includeEditablePropsList
	if (this._includeEditablePropsList)
		json['includeEditablePropsList'] = this._includeEditablePropsList;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._skipId2PropMap = json.hasOwnProperty("skipId2PropMap")?json["skipId2PropMap"]:false;
		this._includeEditablePropsList = json.hasOwnProperty("includeEditablePropsList")?json["includeEditablePropsList"]:false;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;


  }
}

/**
 * @returns {string}
 */
LoadMetadataSpecMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.LoadMetadataSpecMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveAnnotationsResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._lastReceivedRrn = null;
    /**
     * @type {Array<AnnotationThread>}
     * @private
     */
    this._threads = null;

  }

    /**
   * RRN of successful save; 0 if unsuccessful.
   * @return {number}
   */
  getLastReceivedRrn() {
    return this._lastReceivedRrn;
  }

  /**
   * @param lastReceivedRrn{number}
   * @return {SaveAnnotationsResponse}
   */
  setLastReceivedRrn(lastReceivedRrn) {
    this._lastReceivedRrn = lastReceivedRrn;
    return this;
  }
  /**
   * saved thread data; not returned in case of deletes.
   * @return {Array<AnnotationThread>}
   */
  getThreads() {
    return this._threads;
  }

  /**
   * @param threads{Array<AnnotationThread>}
   * @return {SaveAnnotationsResponse}
   */
  setThreads(threads) {
    this._threads = threads;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveAnnotationsResponse.CLASS_ID;
    
	//Serializing _lastReceivedRrn
	if (this._lastReceivedRrn)
		json['lastReceivedRrn'] = this._lastReceivedRrn;
  if (this._threads && this._threads.length > 0) {
    let threads_JSON = [];
    /**
     * @type {AnnotationThread}
     */
    this._threads.forEach((o1148) => {
      if (o1148) {
        if (o1148.serializeJson && (typeof (o1148.serializeJson) === 'function')) {
          threads_JSON.push(o1148.serializeJson());
        } else {
          threads_JSON.push(o1148);
        }
      }
    });
    json['threads'] = threads_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lastReceivedRrn = json.hasOwnProperty("lastReceivedRrn")?json["lastReceivedRrn"]:0;
		//set of type AnnotationThread
		this._threads = [];
		let threadsJSONArray = json.hasOwnProperty("threads") ? json["threads"] : [];

		threadsJSONArray.forEach((o1149)=>{
			if (o1149){
				let classObj = new AnnotationThread();
				classObj.deserializeJson(o1149);
				this._threads.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
SaveAnnotationsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveAnnotationsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionsNextPageResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isLastPage = false;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {Array<ZmCollection>}
     * @private
     */
    this._collections = null;

  }

    /**
   * @return {boolean}
   */
  isIsLastPage() {
    return this._isLastPage;
  }

  /**
   * @param isLastPage{boolean}
   * @return {LsZmCollectionsNextPageResponse}
   */
  setIsLastPage(isLastPage) {
    this._isLastPage = isLastPage;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {LsZmCollectionsNextPageResponse}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {Array<ZmCollection>}
   */
  getCollections() {
    return this._collections;
  }

  /**
   * @param collections{Array<ZmCollection>}
   * @return {LsZmCollectionsNextPageResponse}
   */
  setCollections(collections) {
    this._collections = collections;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionsNextPageResponse.CLASS_ID;
    
	//Serializing _isLastPage
	if (this._isLastPage)
		json['isLastPage'] = this._isLastPage;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;
  if (this._collections && this._collections.length > 0) {
    let collections_JSON = [];
    /**
     * @type {ZmCollection}
     */
    this._collections.forEach((o608) => {
      if (o608) {
        if (o608.serializeJson && (typeof (o608.serializeJson) === 'function')) {
          collections_JSON.push(o608.serializeJson());
        } else {
          collections_JSON.push(o608);
        }
      }
    });
    json['collections'] = collections_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isLastPage = json.hasOwnProperty("isLastPage")?json["isLastPage"]:false;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		//set of type ZmCollection
		this._collections = [];
		let collectionsJSONArray = json.hasOwnProperty("collections") ? json["collections"] : [];

		collectionsJSONArray.forEach((o609)=>{
			if (o609){
				let classObj = new ZmCollection();
				classObj.deserializeJson(o609);
				this._collections.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionsNextPageResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionsNextPageResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CreateZmCollectionQuery extends HttpOperation {

  constructor(name = "CreateZmCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {CreateZmCollectionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CreateZmCollectionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {int}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CreateZmCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CreateZmCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new int();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new int();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CreateZmCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CreateZmCollection";
/**
 * @returns {string}
 */
CreateZmCollectionQuery.QUERY_NAME = "CreateZmCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class FlexSmartShareQuery extends HttpOperation {

  constructor(name = "FlexSmartShare") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexSmartShareArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexSmartShareArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexSmartShareResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexSmartShareQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexSmartShareQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexSmartShareResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexSmartShareResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexSmartShareQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexSmartShare";
/**
 * @returns {string}
 */
FlexSmartShareQuery.QUERY_NAME = "FlexSmartShare";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetSpotLightQuery extends HttpOperation {

  constructor(name = "GetSpotLight") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetSpotLightQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetSpotLightQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetSpotLightQueryRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetSpotLightQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetSpotLightQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetSpotLightQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetSpotLightQueryRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetSpotLightQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSpotLight";
/**
 * @returns {string}
 */
GetSpotLightQuery.QUERY_NAME = "GetSpotLight";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetFacetsRes {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._responseForAllCategories = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {Array<CategoryWiseDetail>}
     * @private
     */
    this._categoryList = null;

  }

    /**
   * @return {boolean}
   */
  isResponseForAllCategories() {
    return this._responseForAllCategories;
  }

  /**
   * @param responseForAllCategories{boolean}
   * @return {GetFacetsRes}
   */
  setResponseForAllCategories(responseForAllCategories) {
    this._responseForAllCategories = responseForAllCategories;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetFacetsRes}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {GetFacetsRes}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {Array<CategoryWiseDetail>}
   */
  getCategoryList() {
    return this._categoryList;
  }

  /**
   * @param categoryList{Array<CategoryWiseDetail>}
   * @return {GetFacetsRes}
   */
  setCategoryList(categoryList) {
    this._categoryList = categoryList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetFacetsRes.CLASS_ID;
    
	//Serializing _responseForAllCategories
	if (this._responseForAllCategories)
		json['responseForAllCategories'] = this._responseForAllCategories;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;
  if (this._categoryList && this._categoryList.length > 0) {
    let categoryList_JSON = [];
    /**
     * @type {CategoryWiseDetail}
     */
    this._categoryList.forEach((o600) => {
      if (o600) {
        if (o600.serializeJson && (typeof (o600.serializeJson) === 'function')) {
          categoryList_JSON.push(o600.serializeJson());
        } else {
          categoryList_JSON.push(o600);
        }
      }
    });
    json['categoryList'] = categoryList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._responseForAllCategories = json.hasOwnProperty("responseForAllCategories")?json["responseForAllCategories"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		//set of type CategoryWiseDetail
		this._categoryList = [];
		let categoryListJSONArray = json.hasOwnProperty("categoryList") ? json["categoryList"] : [];

		categoryListJSONArray.forEach((o601)=>{
			if (o601){
				let classObj = new CategoryWiseDetail();
				classObj.deserializeJson(o601);
				this._categoryList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetFacetsRes.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFacetsRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetSettingsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._globalSettingsMaxRrn = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._collectionProps = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._generalProps = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._globalProperties = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._tpmPathsMapping = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._notificationProps = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetSettingsResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getGlobalSettingsMaxRrn() {
    return this._globalSettingsMaxRrn;
  }

  /**
   * @param globalSettingsMaxRrn{number}
   * @return {GetSettingsResponse}
   */
  setGlobalSettingsMaxRrn(globalSettingsMaxRrn) {
    this._globalSettingsMaxRrn = globalSettingsMaxRrn;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getCollectionProps() {
    return this._collectionProps;
  }

  /**
   * @param collectionProps{java.util.Map<String,String>}
   * @return {GetSettingsResponse}
   */
  setCollectionProps(collectionProps) {
    this._collectionProps = collectionProps;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getGeneralProps() {
    return this._generalProps;
  }

  /**
   * @param generalProps{java.util.Map<String,String>}
   * @return {GetSettingsResponse}
   */
  setGeneralProps(generalProps) {
    this._generalProps = generalProps;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getGlobalProperties() {
    return this._globalProperties;
  }

  /**
   * @param globalProperties{java.util.Map<String,String>}
   * @return {GetSettingsResponse}
   */
  setGlobalProperties(globalProperties) {
    this._globalProperties = globalProperties;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getTpmPathsMapping() {
    return this._tpmPathsMapping;
  }

  /**
   * @param tpmPathsMapping{java.util.Map<String,String>}
   * @return {GetSettingsResponse}
   */
  setTpmPathsMapping(tpmPathsMapping) {
    this._tpmPathsMapping = tpmPathsMapping;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getNotificationProps() {
    return this._notificationProps;
  }

  /**
   * @param notificationProps{java.util.Map<String,String>}
   * @return {GetSettingsResponse}
   */
  setNotificationProps(notificationProps) {
    this._notificationProps = notificationProps;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetSettingsResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _globalSettingsMaxRrn
	if (this._globalSettingsMaxRrn)
		json['globalSettingsMaxRrn'] = this._globalSettingsMaxRrn;
    SerializationUtil.serializeHashMap(json,"collectionProps", this._collectionProps);
		    SerializationUtil.serializeHashMap(json,"generalProps", this._generalProps);
		    SerializationUtil.serializeHashMap(json,"globalProperties", this._globalProperties);
		    SerializationUtil.serializeHashMap(json,"tpmPathsMapping", this._tpmPathsMapping);
		    SerializationUtil.serializeHashMap(json,"notificationProps", this._notificationProps);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._globalSettingsMaxRrn = json.hasOwnProperty("globalSettingsMaxRrn")?json["globalSettingsMaxRrn"]:0;
//Map of type STRING. Decode as tree:false
		if (this._collectionProps == null)
			this._collectionProps = new HashMap();
		this._collectionProps.clear();
		let collectionPropsJSONArray = json.hasOwnProperty("collectionProps") ? json["collectionProps"] : [];
		this._collectionProps = SerializationUtil.deserializeMap(collectionPropsJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._generalProps == null)
			this._generalProps = new HashMap();
		this._generalProps.clear();
		let generalPropsJSONArray = json.hasOwnProperty("generalProps") ? json["generalProps"] : [];
		this._generalProps = SerializationUtil.deserializeMap(generalPropsJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._globalProperties == null)
			this._globalProperties = new HashMap();
		this._globalProperties.clear();
		let globalPropertiesJSONArray = json.hasOwnProperty("globalProperties") ? json["globalProperties"] : [];
		this._globalProperties = SerializationUtil.deserializeMap(globalPropertiesJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._tpmPathsMapping == null)
			this._tpmPathsMapping = new HashMap();
		this._tpmPathsMapping.clear();
		let tpmPathsMappingJSONArray = json.hasOwnProperty("tpmPathsMapping") ? json["tpmPathsMapping"] : [];
		this._tpmPathsMapping = SerializationUtil.deserializeMap(tpmPathsMappingJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._notificationProps == null)
			this._notificationProps = new HashMap();
		this._notificationProps.clear();
		let notificationPropsJSONArray = json.hasOwnProperty("notificationProps") ? json["notificationProps"] : [];
		this._notificationProps = SerializationUtil.deserializeMap(notificationPropsJSONArray);



  }
}

/**
 * @returns {string}
 */
GetSettingsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetSettingsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetCollectionFiltersQuery extends HttpOperation {

  constructor(name = "GetCollectionFilters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetCollectionFiltersMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetCollectionFiltersMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetCollectionFiltersResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCollectionFiltersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCollectionFiltersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetCollectionFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetCollectionFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCollectionFiltersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionFilters";
/**
 * @returns {string}
 */
GetCollectionFiltersQuery.QUERY_NAME = "GetCollectionFilters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetExportMetadataRes {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._exportedFilePath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {string}
   */
  getExportedFilePath() {
    return this._exportedFilePath;
  }

  /**
   * @param exportedFilePath{string}
   * @return {GetExportMetadataRes}
   */
  setExportedFilePath(exportedFilePath) {
    this._exportedFilePath = exportedFilePath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetExportMetadataRes}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetExportMetadataRes.CLASS_ID;
    
	//Serializing _exportedFilePath
	if (this._exportedFilePath)
		json['exportedFilePath'] = this._exportedFilePath;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._exportedFilePath = json.hasOwnProperty("exportedFilePath")?json["exportedFilePath"]:null;
		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
GetExportMetadataRes.CLASS_ID = "com.zoom.vab.client.autogenerated.GetExportMetadataRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ShareZmCollectionMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._shareMessage = null;
    /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._emailsList = null;

  }

    /**
   * @return {string}
   */
  getShareMessage() {
    return this._shareMessage;
  }

  /**
   * @param shareMessage{string}
   * @return {ShareZmCollectionMessage}
   */
  setShareMessage(shareMessage) {
    this._shareMessage = shareMessage;
    return this;
  }
  /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {ShareZmCollectionMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getEmailsList() {
    return this._emailsList;
  }

  /**
   * @param emailsList{Array<String>}
   * @return {ShareZmCollectionMessage}
   */
  setEmailsList(emailsList) {
    this._emailsList = emailsList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ShareZmCollectionMessage.CLASS_ID;
    
	//Serializing _shareMessage
	if (this._shareMessage)
		json['shareMessage'] = this._shareMessage;

	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._emailsList && this._emailsList.length > 0) {
    let emailsList_JSON = [];
    /**
     * @type {string}
     */
    this._emailsList.forEach((o509) => {
      if (o509) {
        if (o509.serializeJson && (typeof (o509.serializeJson) === 'function')) {
          emailsList_JSON.push(o509.serializeJson());
        } else {
          emailsList_JSON.push(o509);
        }
      }
    });
    json['emailsList'] = emailsList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._shareMessage = json.hasOwnProperty("shareMessage")?json["shareMessage"]:null;
		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type string
		this._emailsList = [];
		let emailsListJSONArray = json.hasOwnProperty("emailsList") ? json["emailsList"] : [];

		emailsListJSONArray.forEach((o510)=>{
			if (o510){
				this._emailsList.push(o510);
			}
		});


  }
}

/**
 * @returns {string}
 */
ShareZmCollectionMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.ShareZmCollectionMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class WebclientAddFolderResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {boolean}
     * @private
     */
    this._pathCreated = false;
    /**
     * @type {string}
     * @private
     */
    this._destDir = null;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {WebclientAddFolderResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {boolean}
   */
  isPathCreated() {
    return this._pathCreated;
  }

  /**
   * @param pathCreated{boolean}
   * @return {WebclientAddFolderResponse}
   */
  setPathCreated(pathCreated) {
    this._pathCreated = pathCreated;
    return this;
  }
  /**
   * @return {string}
   */
  getDestDir() {
    return this._destDir;
  }

  /**
   * @param destDir{string}
   * @return {WebclientAddFolderResponse}
   */
  setDestDir(destDir) {
    this._destDir = destDir;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {WebclientAddFolderResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = WebclientAddFolderResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _pathCreated
	if (this._pathCreated)
		json['pathCreated'] = this._pathCreated;

	//Serializing _destDir
	if (this._destDir)
		json['destDir'] = this._destDir;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._pathCreated = json.hasOwnProperty("pathCreated")?json["pathCreated"]:false;
		this._destDir = json.hasOwnProperty("destDir")?json["destDir"]:null;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;


  }
}

/**
 * @returns {string}
 */
WebclientAddFolderResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.WebclientAddFolderResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class LsZmCollectionsQuery extends HttpOperation {

  constructor(name = "LsZmCollections") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {LsZmCollectionsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{LsZmCollectionsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {LsZmCollectionsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = LsZmCollectionsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (LsZmCollectionsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new LsZmCollectionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new LsZmCollectionsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
LsZmCollectionsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollections";
/**
 * @returns {string}
 */
LsZmCollectionsQuery.QUERY_NAME = "LsZmCollections";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class ClearAllDrawingAnnotationsQuery extends HttpOperation {

  constructor(name = "ClearAllDrawingAnnotations") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ClearAllDrawingAnnotationsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ClearAllDrawingAnnotationsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ClearAllDrawingAnnotationsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ClearAllDrawingAnnotationsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ClearAllDrawingAnnotationsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ClearAllDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ClearAllDrawingAnnotationsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ClearAllDrawingAnnotationsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ClearAllDrawingAnnotations";
/**
 * @returns {string}
 */
ClearAllDrawingAnnotationsQuery.QUERY_NAME = "ClearAllDrawingAnnotations";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SaveLinkMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._password = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isDelete = false;
    /**
     * @type {string}
     * @private
     */
    this._link = null;
    /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._transferPermissions = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._linkFeatures = null;

  }

    /**
   * @return {string}
   */
  getPassword() {
    return this._password;
  }

  /**
   * @param password{string}
   * @return {SaveLinkMessage}
   */
  setPassword(password) {
    this._password = password;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsDelete() {
    return this._isDelete;
  }

  /**
   * @param isDelete{boolean}
   * @return {SaveLinkMessage}
   */
  setIsDelete(isDelete) {
    this._isDelete = isDelete;
    return this;
  }
  /**
   * @return {string}
   */
  getLink() {
    return this._link;
  }

  /**
   * @param link{string}
   * @return {SaveLinkMessage}
   */
  setLink(link) {
    this._link = link;
    return this;
  }
  /**
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {SaveLinkMessage}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {SaveLinkMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }
  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getTransferPermissions() {
    return this._transferPermissions;
  }

  /**
   * @param transferPermissions{java.util.Map<number,Boolean>}
   * @return {SaveLinkMessage}
   */
  setTransferPermissions(transferPermissions) {
    this._transferPermissions = transferPermissions;
    return this;
  }

  /**
   * @return {java.util.Map<number,Boolean>}
   */
  getLinkFeatures() {
    return this._linkFeatures;
  }

  /**
   * @param linkFeatures{java.util.Map<number,Boolean>}
   * @return {SaveLinkMessage}
   */
  setLinkFeatures(linkFeatures) {
    this._linkFeatures = linkFeatures;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SaveLinkMessage.CLASS_ID;
    
	//Serializing _password
	if (this._password)
		json['password'] = this._password;

	//Serializing _isDelete
	if (this._isDelete)
		json['isDelete'] = this._isDelete;

	//Serializing _link
	if (this._link)
		json['link'] = this._link;

	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		    SerializationUtil.serializeHashMap(json,"transferPermissions", this._transferPermissions);
		    SerializationUtil.serializeHashMap(json,"linkFeatures", this._linkFeatures);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._password = json.hasOwnProperty("password")?json["password"]:null;
		this._isDelete = json.hasOwnProperty("isDelete")?json["isDelete"]:false;
		this._link = json.hasOwnProperty("link")?json["link"]:null;
		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}

//Map of type INT. Decode as tree:false
		if (this._transferPermissions == null)
			this._transferPermissions = new HashMap();
		this._transferPermissions.clear();
		let transferPermissionsJSONArray = json.hasOwnProperty("transferPermissions") ? json["transferPermissions"] : [];
		this._transferPermissions = SerializationUtil.deserializeMap(transferPermissionsJSONArray);

//Map of type INT. Decode as tree:false
		if (this._linkFeatures == null)
			this._linkFeatures = new HashMap();
		this._linkFeatures.clear();
		let linkFeaturesJSONArray = json.hasOwnProperty("linkFeatures") ? json["linkFeatures"] : [];
		this._linkFeatures = SerializationUtil.deserializeMap(linkFeaturesJSONArray);



  }
}

/**
 * @returns {string}
 */
SaveLinkMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SaveLinkMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionsResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isLastPage = false;
    /**
     * @type {number}
     * @private
     */
    this._totalEntries = null;
    /**
     * @type {Array<CollectionPathEntry>}
     * @private
     */
    this._rootAncestors = null;
    /**
     * @type {Array<ZmCollection>}
     * @private
     */
    this._collections = null;

  }

    /**
   * @return {boolean}
   */
  isIsLastPage() {
    return this._isLastPage;
  }

  /**
   * @param isLastPage{boolean}
   * @return {LsZmCollectionsResponse}
   */
  setIsLastPage(isLastPage) {
    this._isLastPage = isLastPage;
    return this;
  }
  /**
   * @return {number}
   */
  getTotalEntries() {
    return this._totalEntries;
  }

  /**
   * @param totalEntries{number}
   * @return {LsZmCollectionsResponse}
   */
  setTotalEntries(totalEntries) {
    this._totalEntries = totalEntries;
    return this;
  }
  /**
   * @return {Array<CollectionPathEntry>}
   */
  getRootAncestors() {
    return this._rootAncestors;
  }

  /**
   * @param rootAncestors{Array<CollectionPathEntry>}
   * @return {LsZmCollectionsResponse}
   */
  setRootAncestors(rootAncestors) {
    this._rootAncestors = rootAncestors;
    return this;
  }

  /**
   * @return {Array<ZmCollection>}
   */
  getCollections() {
    return this._collections;
  }

  /**
   * @param collections{Array<ZmCollection>}
   * @return {LsZmCollectionsResponse}
   */
  setCollections(collections) {
    this._collections = collections;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionsResponse.CLASS_ID;
    
	//Serializing _isLastPage
	if (this._isLastPage)
		json['isLastPage'] = this._isLastPage;

	//Serializing _totalEntries
	if (this._totalEntries)
		json['totalEntries'] = this._totalEntries;
  if (this._rootAncestors && this._rootAncestors.length > 0) {
    let rootAncestors_JSON = [];
    /**
     * @type {CollectionPathEntry}
     */
    this._rootAncestors.forEach((o839) => {
      if (o839) {
        if (o839.serializeJson && (typeof (o839.serializeJson) === 'function')) {
          rootAncestors_JSON.push(o839.serializeJson());
        } else {
          rootAncestors_JSON.push(o839);
        }
      }
    });
    json['rootAncestors'] = rootAncestors_JSON;
  }  
  if (this._collections && this._collections.length > 0) {
    let collections_JSON = [];
    /**
     * @type {ZmCollection}
     */
    this._collections.forEach((o842) => {
      if (o842) {
        if (o842.serializeJson && (typeof (o842.serializeJson) === 'function')) {
          collections_JSON.push(o842.serializeJson());
        } else {
          collections_JSON.push(o842);
        }
      }
    });
    json['collections'] = collections_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isLastPage = json.hasOwnProperty("isLastPage")?json["isLastPage"]:false;
		this._totalEntries = json.hasOwnProperty("totalEntries")?json["totalEntries"]:0;
		//set of type CollectionPathEntry
		this._rootAncestors = [];
		let rootAncestorsJSONArray = json.hasOwnProperty("rootAncestors") ? json["rootAncestors"] : [];

		rootAncestorsJSONArray.forEach((o840)=>{
			if (o840){
				let classObj = new CollectionPathEntry();
				classObj.deserializeJson(o840);
				this._rootAncestors.push(classObj);
			}
		});
		//set of type ZmCollection
		this._collections = [];
		let collectionsJSONArray = json.hasOwnProperty("collections") ? json["collections"] : [];

		collectionsJSONArray.forEach((o843)=>{
			if (o843){
				let classObj = new ZmCollection();
				classObj.deserializeJson(o843);
				this._collections.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
LsZmCollectionsResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionsResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class WCStatusQueryMsg {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._pageNumber = null;
    /**
     * @type {boolean}
     * @private
     */
    this._forceUpdate = false;
    /**
     * @type {number}
     * @private
     */
    this._rootFuid = null;
    /**
     * @type {string}
     * @private
     */
    this._pageId = null;
    /**
     * @type {Array<RemoteStatusEntry>}
     * @private
     */
    this._assetEntries = null;

  }

    /**
   * @return {number}
   */
  getPageNumber() {
    return this._pageNumber;
  }

  /**
   * @param pageNumber{number}
   * @return {WCStatusQueryMsg}
   */
  setPageNumber(pageNumber) {
    this._pageNumber = pageNumber;
    return this;
  }
  /**
   * @return {boolean}
   */
  isForceUpdate() {
    return this._forceUpdate;
  }

  /**
   * @param forceUpdate{boolean}
   * @return {WCStatusQueryMsg}
   */
  setForceUpdate(forceUpdate) {
    this._forceUpdate = forceUpdate;
    return this;
  }
  /**
   * @return {number}
   */
  getRootFuid() {
    return this._rootFuid;
  }

  /**
   * @param rootFuid{number}
   * @return {WCStatusQueryMsg}
   */
  setRootFuid(rootFuid) {
    this._rootFuid = rootFuid;
    return this;
  }
  /**
   * @return {string}
   */
  getPageId() {
    return this._pageId;
  }

  /**
   * @param pageId{string}
   * @return {WCStatusQueryMsg}
   */
  setPageId(pageId) {
    this._pageId = pageId;
    return this;
  }
  /**
   * @return {Array<RemoteStatusEntry>}
   */
  getAssetEntries() {
    return this._assetEntries;
  }

  /**
   * @param assetEntries{Array<RemoteStatusEntry>}
   * @return {WCStatusQueryMsg}
   */
  setAssetEntries(assetEntries) {
    this._assetEntries = assetEntries;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = WCStatusQueryMsg.CLASS_ID;
    
	//Serializing _pageNumber
	if (this._pageNumber)
		json['pageNumber'] = this._pageNumber;

	//Serializing _forceUpdate
	if (this._forceUpdate)
		json['forceUpdate'] = this._forceUpdate;

	//Serializing _rootFuid
	if (this._rootFuid)
		json['rootFuid'] = this._rootFuid;

	//Serializing _pageId
	if (this._pageId)
		json['pageId'] = this._pageId;
  if (this._assetEntries && this._assetEntries.length > 0) {
    let assetEntries_JSON = [];
    /**
     * @type {RemoteStatusEntry}
     */
    this._assetEntries.forEach((o16) => {
      if (o16) {
        if (o16.serializeJson && (typeof (o16.serializeJson) === 'function')) {
          assetEntries_JSON.push(o16.serializeJson());
        } else {
          assetEntries_JSON.push(o16);
        }
      }
    });
    json['assetEntries'] = assetEntries_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._pageNumber = json.hasOwnProperty("pageNumber")?json["pageNumber"]:0;
		this._forceUpdate = json.hasOwnProperty("forceUpdate")?json["forceUpdate"]:false;
		this._rootFuid = json.hasOwnProperty("rootFuid")?json["rootFuid"]:0;
		this._pageId = json.hasOwnProperty("pageId")?json["pageId"]:null;
		//set of type RemoteStatusEntry
		this._assetEntries = [];
		let assetEntriesJSONArray = json.hasOwnProperty("assetEntries") ? json["assetEntries"] : [];

		assetEntriesJSONArray.forEach((o17)=>{
			if (o17){
				let classObj = new RemoteStatusEntry();
				classObj.deserializeJson(o17);
				this._assetEntries.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
WCStatusQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.WCStatusQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class FolderDetailsArgs {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FolderDetailsArgs}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FolderDetailsArgs}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {FolderDetailsArgs}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FolderDetailsArgs.CLASS_ID;
    
	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
FolderDetailsArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FolderDetailsArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetRevisionsOfCollectionAssetMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {GetRevisionsOfCollectionAssetMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * Denotes the fuid rrn info for which the assets revisions need to arrive
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {GetRevisionsOfCollectionAssetMessage}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetRevisionsOfCollectionAssetMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;

	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
GetRevisionsOfCollectionAssetMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetRevisionsOfCollectionAssetMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class CategoryChangeQuery extends HttpOperation {

  constructor(name = "CategoryChange") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {CategoryChangeMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{CategoryChangeMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesStatData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = CategoryChangeQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (CategoryChangeQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesStatData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesStatData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
CategoryChangeQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.CategoryChange";
/**
 * @returns {string}
 */
CategoryChangeQuery.QUERY_NAME = "CategoryChange";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetFiltersResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {Array<FilterDetail>}
     * @private
     */
    this._filters = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetFiltersResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {GetFiltersResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {Array<FilterDetail>}
   */
  getFilters() {
    return this._filters;
  }

  /**
   * @param filters{Array<FilterDetail>}
   * @return {GetFiltersResponse}
   */
  setFilters(filters) {
    this._filters = filters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetFiltersResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;
  if (this._filters && this._filters.length > 0) {
    let filters_JSON = [];
    /**
     * @type {FilterDetail}
     */
    this._filters.forEach((o411) => {
      if (o411) {
        if (o411.serializeJson && (typeof (o411.serializeJson) === 'function')) {
          filters_JSON.push(o411.serializeJson());
        } else {
          filters_JSON.push(o411);
        }
      }
    });
    json['filters'] = filters_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		//set of type FilterDetail
		this._filters = [];
		let filtersJSONArray = json.hasOwnProperty("filters") ? json["filters"] : [];

		filtersJSONArray.forEach((o412)=>{
			if (o412){
				let classObj = new FilterDetail();
				classObj.deserializeJson(o412);
				this._filters.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetFiltersResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFiltersResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LiveDrawSpecMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._ignore = null;

  }

    /**
   * @return {string}
   */
  getIgnore() {
    return this._ignore;
  }

  /**
   * @param ignore{string}
   * @return {LiveDrawSpecMessage}
   */
  setIgnore(ignore) {
    this._ignore = ignore;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LiveDrawSpecMessage.CLASS_ID;
    
	//Serializing _ignore
	if (this._ignore)
		json['ignore'] = this._ignore;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._ignore = json.hasOwnProperty("ignore")?json["ignore"]:null;


  }
}

/**
 * @returns {string}
 */
LiveDrawSpecMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.LiveDrawSpecMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SetUserLinkDefaultPermissionsQuery extends HttpOperation {

  constructor(name = "SetUserLinkDefaultPermissions") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {SetUserLinkDefaultPermissionsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SetUserLinkDefaultPermissionsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SetUserLinkDefaultPermissionsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SetUserLinkDefaultPermissionsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SetUserLinkDefaultPermissionsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SetUserLinkDefaultPermissions";
/**
 * @returns {string}
 */
SetUserLinkDefaultPermissionsQuery.QUERY_NAME = "SetUserLinkDefaultPermissions";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class DeleteZmCollectionAssetsMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._collectionId = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidRrnList = null;

  }

    /**
   * @return {number}
   */
  getCollectionId() {
    return this._collectionId;
  }

  /**
   * @param collectionId{number}
   * @return {DeleteZmCollectionAssetsMessage}
   */
  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }
  /**
   * @return {Array<FuidRrnInfo>}
   */
  getFuidRrnList() {
    return this._fuidRrnList;
  }

  /**
   * @param fuidRrnList{Array<FuidRrnInfo>}
   * @return {DeleteZmCollectionAssetsMessage}
   */
  setFuidRrnList(fuidRrnList) {
    this._fuidRrnList = fuidRrnList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DeleteZmCollectionAssetsMessage.CLASS_ID;
    
	//Serializing _collectionId
	if (this._collectionId)
		json['collectionId'] = this._collectionId;
  if (this._fuidRrnList && this._fuidRrnList.length > 0) {
    let fuidRrnList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidRrnList.forEach((o984) => {
      if (o984) {
        if (o984.serializeJson && (typeof (o984.serializeJson) === 'function')) {
          fuidRrnList_JSON.push(o984.serializeJson());
        } else {
          fuidRrnList_JSON.push(o984);
        }
      }
    });
    json['fuidRrnList'] = fuidRrnList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._collectionId = json.hasOwnProperty("collectionId")?json["collectionId"]:0;
		//set of type FuidRrnInfo
		this._fuidRrnList = [];
		let fuidRrnListJSONArray = json.hasOwnProperty("fuidRrnList") ? json["fuidRrnList"] : [];

		fuidRrnListJSONArray.forEach((o985)=>{
			if (o985){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o985);
				this._fuidRrnList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
DeleteZmCollectionAssetsMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.DeleteZmCollectionAssetsMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetCollectionFiltersMsg {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._filters = null;

  }

    /**
   * @return {java.util.Map<String,String>}
   */
  getFilters() {
    return this._filters;
  }

  /**
   * @param filters{java.util.Map<String,String>}
   * @return {GetCollectionFiltersMsg}
   */
  setFilters(filters) {
    this._filters = filters;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetCollectionFiltersMsg.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"filters", this._filters);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._filters == null)
			this._filters = new HashMap();
		this._filters.clear();
		let filtersJSONArray = json.hasOwnProperty("filters") ? json["filters"] : [];
		this._filters = SerializationUtil.deserializeMap(filtersJSONArray);



  }
}

/**
 * @returns {string}
 */
GetCollectionFiltersMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCollectionFiltersMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class PropName2ValueMap {

  constructor() {
    
        /**
     * @type {HashMap}
     * @private
     */
    this._propName2ValueMap = null;

  }

    /**
   * @return {java.util.Map<String,String>}
   */
  getPropName2ValueMap() {
    return this._propName2ValueMap;
  }

  /**
   * @param propName2ValueMap{java.util.Map<String,String>}
   * @return {PropName2ValueMap}
   */
  setPropName2ValueMap(propName2ValueMap) {
    this._propName2ValueMap = propName2ValueMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = PropName2ValueMap.CLASS_ID;
        SerializationUtil.serializeHashMap(json,"propName2ValueMap", this._propName2ValueMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    //Map of type STRING. Decode as tree:false
		if (this._propName2ValueMap == null)
			this._propName2ValueMap = new HashMap();
		this._propName2ValueMap.clear();
		let propName2ValueMapJSONArray = json.hasOwnProperty("propName2ValueMap") ? json["propName2ValueMap"] : [];
		this._propName2ValueMap = SerializationUtil.deserializeMap(propName2ValueMapJSONArray);



  }
}

/**
 * @returns {string}
 */
PropName2ValueMap.CLASS_ID = "com.zoom.vab.client.autogenerated.PropName2ValueMap";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class LsZmCollectionsNextPageMessage {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._begIndex = null;
    /**
     * @type {LsCollectionSortCriteria}
     * @private
     */
    this._lsCollectionSortCriteria = null;

  }

    /**
   * @return {number}
   */
  getBegIndex() {
    return this._begIndex;
  }

  /**
   * @param begIndex{number}
   * @return {LsZmCollectionsNextPageMessage}
   */
  setBegIndex(begIndex) {
    this._begIndex = begIndex;
    return this;
  }
  /**
   * @return {LsCollectionSortCriteria}
   */
  getLsCollectionSortCriteria() {
    return this._lsCollectionSortCriteria;
  }

  /**
   * @param lsCollectionSortCriteria{LsCollectionSortCriteria}
   * @return {LsZmCollectionsNextPageMessage}
   */
  setLsCollectionSortCriteria(lsCollectionSortCriteria) {
    this._lsCollectionSortCriteria = lsCollectionSortCriteria;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LsZmCollectionsNextPageMessage.CLASS_ID;
    
	//Serializing _begIndex
	if (this._begIndex)
		json['begIndex'] = this._begIndex;

	//Serializing ComplexType _$arrayName
	if (this._lsCollectionSortCriteria)
		json['lsCollectionSortCriteria'] = this._lsCollectionSortCriteria.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._begIndex = json.hasOwnProperty("begIndex")?json["begIndex"]:0;
		if (json.hasOwnProperty("lsCollectionSortCriteria")){
			if (!this._lsCollectionSortCriteria && this._lsCollectionSortCriteria == null)
				this._lsCollectionSortCriteria = new LsCollectionSortCriteria();
			this._lsCollectionSortCriteria.deserializeJson(json.hasOwnProperty("lsCollectionSortCriteria") ? json["lsCollectionSortCriteria"] : null);
		}



  }
}

/**
 * @returns {string}
 */
LsZmCollectionsNextPageMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.LsZmCollectionsNextPageMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class GetAssetsPathFuidsQuery extends HttpOperation {

  constructor(name = "GetAssetsPathFuids") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetAssetsPathFuidsMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetAssetsPathFuidsMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetAssetsPathFuidsResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetAssetsPathFuidsQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetAssetsPathFuidsQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetAssetsPathFuidsResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetAssetsPathFuidsResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetAssetsPathFuidsQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsPathFuids";
/**
 * @returns {string}
 */
GetAssetsPathFuidsQuery.QUERY_NAME = "GetAssetsPathFuids";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class GetAssetsInfoResponse {

  constructor() {
    
        /**
     * @type {Array<RepoItem>}
     * @private
     */
    this._resultFiles = null;

  }

    /**
   * @return {Array<RepoItem>}
   */
  getResultFiles() {
    return this._resultFiles;
  }

  /**
   * @param resultFiles{Array<RepoItem>}
   * @return {GetAssetsInfoResponse}
   */
  setResultFiles(resultFiles) {
    this._resultFiles = resultFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetAssetsInfoResponse.CLASS_ID;
      if (this._resultFiles && this._resultFiles.length > 0) {
    let resultFiles_JSON = [];
    /**
     * @type {RepoItem}
     */
    this._resultFiles.forEach((o624) => {
      if (o624) {
        if (o624.serializeJson && (typeof (o624.serializeJson) === 'function')) {
          resultFiles_JSON.push(o624.serializeJson());
        } else {
          resultFiles_JSON.push(o624);
        }
      }
    });
    json['resultFiles'] = resultFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type RepoItem
		this._resultFiles = [];
		let resultFilesJSONArray = json.hasOwnProperty("resultFiles") ? json["resultFiles"] : [];

		resultFilesJSONArray.forEach((o625)=>{
			if (o625){
				let classObj = new RepoItem();
				classObj.deserializeJson(o625);
				this._resultFiles.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetAssetsInfoResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetAssetsInfoResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class AnnotationScope {

  constructor() {
    
        /**
     * @type {CollectionScope}
     * @private
     */
    this._collectionScope = null;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this._fuidRrnInfo = null;

  }

    /**
   * optional: collection scope; global scope if absent.
   * @return {CollectionScope}
   */
  getCollectionScope() {
    return this._collectionScope;
  }

  /**
   * @param collectionScope{CollectionScope}
   * @return {AnnotationScope}
   */
  setCollectionScope(collectionScope) {
    this._collectionScope = collectionScope;
    return this;
  }
  /**
   * optional: asset sub-scope; global sub-scope if absent.
   * @return {FuidRrnInfo}
   */
  getFuidRrnInfo() {
    return this._fuidRrnInfo;
  }

  /**
   * @param fuidRrnInfo{FuidRrnInfo}
   * @return {AnnotationScope}
   */
  setFuidRrnInfo(fuidRrnInfo) {
    this._fuidRrnInfo = fuidRrnInfo;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = AnnotationScope.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._collectionScope)
		json['collectionScope'] = this._collectionScope.serializeJson();
		
	//Serializing ComplexType _$arrayName
	if (this._fuidRrnInfo)
		json['fuidRrnInfo'] = this._fuidRrnInfo.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("collectionScope")){
			if (!this._collectionScope && this._collectionScope == null)
				this._collectionScope = new CollectionScope();
			this._collectionScope.deserializeJson(json.hasOwnProperty("collectionScope") ? json["collectionScope"] : null);
		}

		if (json.hasOwnProperty("fuidRrnInfo")){
			if (!this._fuidRrnInfo && this._fuidRrnInfo == null)
				this._fuidRrnInfo = new FuidRrnInfo();
			this._fuidRrnInfo.deserializeJson(json.hasOwnProperty("fuidRrnInfo") ? json["fuidRrnInfo"] : null);
		}



  }
}

/**
 * @returns {string}
 */
AnnotationScope.CLASS_ID = "com.zoom.vab.client.autogenerated.AnnotationScope";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class WebclientAddFolderMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {string}
     * @private
     */
    this._destPath = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {WebclientAddFolderMessage}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {string}
   */
  getDestPath() {
    return this._destPath;
  }

  /**
   * @param destPath{string}
   * @return {WebclientAddFolderMessage}
   */
  setDestPath(destPath) {
    this._destPath = destPath;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {WebclientAddFolderMessage}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {WebclientAddFolderMessage}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = WebclientAddFolderMessage.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _destPath
	if (this._destPath)
		json['destPath'] = this._destPath;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._destPath = json.hasOwnProperty("destPath")?json["destPath"]:null;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;


  }
}

/**
 * @returns {string}
 */
WebclientAddFolderMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.WebclientAddFolderMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class SearchInsideQuery extends HttpOperation {

  constructor(name = "SearchInside") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {SearchInsideMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{SearchInsideMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FilesResponseData}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = SearchInsideQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (SearchInsideQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FilesResponseData();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
SearchInsideQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.SearchInside";
/**
 * @returns {string}
 */
SearchInsideQuery.QUERY_NAME = "SearchInside";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class ShareAssetsRequestData {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._currentTime = null;
    /**
     * @type {string}
     * @private
     */
    this._mailMessage = null;
    /**
     * @type {string}
     * @private
     */
    this._privateLink = null;
    /**
     * @type {SharingOptions}
     * @private
     */
    this._sharingOptions = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._emails = null;
    /**
     * @type {Array<FuidRrnInfo>}
     * @private
     */
    this._fuidList = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._phoneNumbers = null;

  }

    /**
   * @return {number}
   */
  getCurrentTime() {
    return this._currentTime;
  }

  /**
   * @param currentTime{number}
   * @return {ShareAssetsRequestData}
   */
  setCurrentTime(currentTime) {
    this._currentTime = currentTime;
    return this;
  }
  /**
   * @return {string}
   */
  getMailMessage() {
    return this._mailMessage;
  }

  /**
   * @param mailMessage{string}
   * @return {ShareAssetsRequestData}
   */
  setMailMessage(mailMessage) {
    this._mailMessage = mailMessage;
    return this;
  }
  /**
   * @return {string}
   */
  getPrivateLink() {
    return this._privateLink;
  }

  /**
   * @param privateLink{string}
   * @return {ShareAssetsRequestData}
   */
  setPrivateLink(privateLink) {
    this._privateLink = privateLink;
    return this;
  }
  /**
   * @return {SharingOptions}
   */
  getSharingOptions() {
    return this._sharingOptions;
  }

  /**
   * @param sharingOptions{SharingOptions}
   * @return {ShareAssetsRequestData}
   */
  setSharingOptions(sharingOptions) {
    this._sharingOptions = sharingOptions;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getEmails() {
    return this._emails;
  }

  /**
   * @param emails{Array<String>}
   * @return {ShareAssetsRequestData}
   */
  setEmails(emails) {
    this._emails = emails;
    return this;
  }

  /**
   * @return {Array<FuidRrnInfo>}
   */
  getFuidList() {
    return this._fuidList;
  }

  /**
   * @param fuidList{Array<FuidRrnInfo>}
   * @return {ShareAssetsRequestData}
   */
  setFuidList(fuidList) {
    this._fuidList = fuidList;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getPhoneNumbers() {
    return this._phoneNumbers;
  }

  /**
   * @param phoneNumbers{Array<String>}
   * @return {ShareAssetsRequestData}
   */
  setPhoneNumbers(phoneNumbers) {
    this._phoneNumbers = phoneNumbers;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ShareAssetsRequestData.CLASS_ID;
    
	//Serializing _currentTime
	if (this._currentTime)
		json['currentTime'] = this._currentTime;

	//Serializing _mailMessage
	if (this._mailMessage)
		json['mailMessage'] = this._mailMessage;

	//Serializing _privateLink
	if (this._privateLink)
		json['privateLink'] = this._privateLink;

	//Serializing ComplexType _$arrayName
	if (this._sharingOptions)
		json['sharingOptions'] = this._sharingOptions.serializeJson();
		  if (this._emails && this._emails.length > 0) {
    let emails_JSON = [];
    /**
     * @type {string}
     */
    this._emails.forEach((o491) => {
      if (o491) {
        if (o491.serializeJson && (typeof (o491.serializeJson) === 'function')) {
          emails_JSON.push(o491.serializeJson());
        } else {
          emails_JSON.push(o491);
        }
      }
    });
    json['emails'] = emails_JSON;
  }  
  if (this._fuidList && this._fuidList.length > 0) {
    let fuidList_JSON = [];
    /**
     * @type {FuidRrnInfo}
     */
    this._fuidList.forEach((o494) => {
      if (o494) {
        if (o494.serializeJson && (typeof (o494.serializeJson) === 'function')) {
          fuidList_JSON.push(o494.serializeJson());
        } else {
          fuidList_JSON.push(o494);
        }
      }
    });
    json['fuidList'] = fuidList_JSON;
  }  
  if (this._phoneNumbers && this._phoneNumbers.length > 0) {
    let phoneNumbers_JSON = [];
    /**
     * @type {string}
     */
    this._phoneNumbers.forEach((o497) => {
      if (o497) {
        if (o497.serializeJson && (typeof (o497.serializeJson) === 'function')) {
          phoneNumbers_JSON.push(o497.serializeJson());
        } else {
          phoneNumbers_JSON.push(o497);
        }
      }
    });
    json['phoneNumbers'] = phoneNumbers_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._currentTime = json.hasOwnProperty("currentTime")?json["currentTime"]:0;
		this._mailMessage = json.hasOwnProperty("mailMessage")?json["mailMessage"]:null;
		this._privateLink = json.hasOwnProperty("privateLink")?json["privateLink"]:null;
		if (json.hasOwnProperty("sharingOptions")){
			if (!this._sharingOptions && this._sharingOptions == null)
				this._sharingOptions = new SharingOptions();
			this._sharingOptions.deserializeJson(json.hasOwnProperty("sharingOptions") ? json["sharingOptions"] : null);
		}

		//set of type string
		this._emails = [];
		let emailsJSONArray = json.hasOwnProperty("emails") ? json["emails"] : [];

		emailsJSONArray.forEach((o492)=>{
			if (o492){
				this._emails.push(o492);
			}
		});
		//set of type FuidRrnInfo
		this._fuidList = [];
		let fuidListJSONArray = json.hasOwnProperty("fuidList") ? json["fuidList"] : [];

		fuidListJSONArray.forEach((o495)=>{
			if (o495){
				let classObj = new FuidRrnInfo();
				classObj.deserializeJson(o495);
				this._fuidList.push(classObj);
			}
		});
		//set of type string
		this._phoneNumbers = [];
		let phoneNumbersJSONArray = json.hasOwnProperty("phoneNumbers") ? json["phoneNumbers"] : [];

		phoneNumbersJSONArray.forEach((o498)=>{
			if (o498){
				this._phoneNumbers.push(o498);
			}
		});


  }
}

/**
 * @returns {string}
 */
ShareAssetsRequestData.CLASS_ID = "com.zoom.vab.client.autogenerated.ShareAssetsRequestData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class RequestOTPForLoginMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._username = null;

  }

    /**
   * @return {string}
   */
  getUsername() {
    return this._username;
  }

  /**
   * @param username{string}
   * @return {RequestOTPForLoginMessage}
   */
  setUsername(username) {
    this._username = username;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = RequestOTPForLoginMessage.CLASS_ID;
    
	//Serializing _username
	if (this._username)
		json['username'] = this._username;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._username = json.hasOwnProperty("username")?json["username"]:null;


  }
}

/**
 * @returns {string}
 */
RequestOTPForLoginMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.RequestOTPForLoginMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class EditZmCollectionQuery extends HttpOperation {

  constructor(name = "EditZmCollection") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "SimpleType";
  }

  /**
   * @returns {EditZmCollectionMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{EditZmCollectionMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {Boolean}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = EditZmCollectionQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (EditZmCollectionQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new Boolean();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
EditZmCollectionQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.EditZmCollection";
/**
 * @returns {string}
 */
EditZmCollectionQuery.QUERY_NAME = "EditZmCollection";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class SetUserStatusMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._status = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._scopeMap = null;

  }

    /**
   * ACTIVE, AWAY, IDLE. Set null to delete the entry.
   * @return {string}
   */
  getStatus() {
    return this._status;
  }

  /**
   * @param status{string}
   * @return {SetUserStatusMessage}
   */
  setStatus(status) {
    this._status = status;
    return this;
  }
  /**
   * @return {java.util.Map<String,String>}
   */
  getScopeMap() {
    return this._scopeMap;
  }

  /**
   * @param scopeMap{java.util.Map<String,String>}
   * @return {SetUserStatusMessage}
   */
  setScopeMap(scopeMap) {
    this._scopeMap = scopeMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = SetUserStatusMessage.CLASS_ID;
    
	//Serializing _status
	if (this._status)
		json['status'] = this._status;
    SerializationUtil.serializeHashMap(json,"scopeMap", this._scopeMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._status = json.hasOwnProperty("status")?json["status"]:null;
//Map of type STRING. Decode as tree:false
		if (this._scopeMap == null)
			this._scopeMap = new HashMap();
		this._scopeMap.clear();
		let scopeMapJSONArray = json.hasOwnProperty("scopeMap") ? json["scopeMap"] : [];
		this._scopeMap = SerializationUtil.deserializeMap(scopeMapJSONArray);



  }
}

/**
 * @returns {string}
 */
SetUserStatusMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.SetUserStatusMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

//Register Package


export class HelpLinkInfo {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._linkLabel = null;
    /**
     * @type {string}
     * @private
     */
    this._linkUrl = null;
    /**
     * @type {string}
     * @private
     */
    this._iconPosition = null;
    /**
     * @type {string}
     * @private
     */
    this._linkIcon = null;

  }

    /**
   * @return {string}
   */
  getLinkLabel() {
    return this._linkLabel;
  }

  /**
   * @param linkLabel{string}
   * @return {HelpLinkInfo}
   */
  setLinkLabel(linkLabel) {
    this._linkLabel = linkLabel;
    return this;
  }
  /**
   * @return {string}
   */
  getLinkUrl() {
    return this._linkUrl;
  }

  /**
   * @param linkUrl{string}
   * @return {HelpLinkInfo}
   */
  setLinkUrl(linkUrl) {
    this._linkUrl = linkUrl;
    return this;
  }
  /**
   * @return {string}
   */
  getIconPosition() {
    return this._iconPosition;
  }

  /**
   * @param iconPosition{string}
   * @return {HelpLinkInfo}
   */
  setIconPosition(iconPosition) {
    this._iconPosition = iconPosition;
    return this;
  }
  /**
   * @return {string}
   */
  getLinkIcon() {
    return this._linkIcon;
  }

  /**
   * @param linkIcon{string}
   * @return {HelpLinkInfo}
   */
  setLinkIcon(linkIcon) {
    this._linkIcon = linkIcon;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = HelpLinkInfo.CLASS_ID;
    
	//Serializing _linkLabel
	if (this._linkLabel)
		json['linkLabel'] = this._linkLabel;

	//Serializing _linkUrl
	if (this._linkUrl)
		json['linkUrl'] = this._linkUrl;

	//Serializing _iconPosition
	if (this._iconPosition)
		json['iconPosition'] = this._iconPosition;

	//Serializing _linkIcon
	if (this._linkIcon)
		json['linkIcon'] = this._linkIcon;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._linkLabel = json.hasOwnProperty("linkLabel")?json["linkLabel"]:null;
		this._linkUrl = json.hasOwnProperty("linkUrl")?json["linkUrl"]:null;
		this._iconPosition = json.hasOwnProperty("iconPosition")?json["iconPosition"]:null;
		this._linkIcon = json.hasOwnProperty("linkIcon")?json["linkIcon"]:null;


  }
}

/**
 * @returns {string}
 */
HelpLinkInfo.CLASS_ID = "com.zoom.vab.client.autogenerated.HelpLinkInfo";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:06 AM
 */

export class AutoCompleteUserQuery extends HttpOperation {

  constructor(name = "AutoCompleteUser") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {AutoCompleteUserRequest}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{AutoCompleteUserRequest}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {AutoCompleteUserResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = AutoCompleteUserQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (AutoCompleteUserQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new AutoCompleteUserResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new AutoCompleteUserResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
AutoCompleteUserQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.AutoCompleteUser";
/**
 * @returns {string}
 */
AutoCompleteUserQuery.QUERY_NAME = "AutoCompleteUser";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class GetLayerResponse {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._rootId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {HashMap}
     * @private
     */
    this._layerPropMap = null;

  }

    /**
   * @return {number}
   */
  getRootId() {
    return this._rootId;
  }

  /**
   * @param rootId{number}
   * @return {GetLayerResponse}
   */
  setRootId(rootId) {
    this._rootId = rootId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {GetLayerResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {java.util.Map<number,LayerPropVal>}
   */
  getLayerPropMap() {
    return this._layerPropMap;
  }

  /**
   * @param layerPropMap{java.util.Map<number,LayerPropVal>}
   * @return {GetLayerResponse}
   */
  setLayerPropMap(layerPropMap) {
    this._layerPropMap = layerPropMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetLayerResponse.CLASS_ID;
    
	//Serializing _rootId
	if (this._rootId)
		json['rootId'] = this._rootId;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;
    SerializationUtil.serializeHashMap(json,"layerPropMap", this._layerPropMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._rootId = json.hasOwnProperty("rootId")?json["rootId"]:0;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
//Map of type INT. Decode as tree:false
		if (this._layerPropMap == null)
			this._layerPropMap = new HashMap();
		this._layerPropMap.clear();
		let layerPropMapJSONArray = json.hasOwnProperty("layerPropMap") ? json["layerPropMap"] : [];
		this._layerPropMap = SerializationUtil.deserializeMap(layerPropMapJSONArray);



  }
}

/**
 * @returns {string}
 */
GetLayerResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.GetLayerResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class OAuthLoginQuery extends HttpOperation {

  constructor(name = "OAuthLogin") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {OAuthLoginMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{OAuthLoginMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {OAuthLoginResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = OAuthLoginQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (OAuthLoginQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new OAuthLoginResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new OAuthLoginResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
OAuthLoginQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.OAuthLogin";
/**
 * @returns {string}
 */
OAuthLoginQuery.QUERY_NAME = "OAuthLogin";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABGetFileTypeFiltersMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._mtime = null;

  }

    /**
   * @return {string}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{string}
   * @return {VABGetFileTypeFiltersMsg}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABGetFileTypeFiltersMsg.CLASS_ID;
    
	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:null;


  }
}

/**
 * @returns {string}
 */
VABGetFileTypeFiltersMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.VABGetFileTypeFiltersMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexRemoteMoveArgs {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._destFuid = null;
    /**
     * @type {string}
     * @private
     */
    this._sourceBranch = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {VABTabId}
     * @private
     */
    this._vABTabId = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._inFuids = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._fuidToPath = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._metadataMap = null;

  }

    /**
   * @return {number}
   */
  getDestFuid() {
    return this._destFuid;
  }

  /**
   * @param destFuid{number}
   * @return {FlexRemoteMoveArgs}
   */
  setDestFuid(destFuid) {
    this._destFuid = destFuid;
    return this;
  }
  /**
   * @return {string}
   */
  getSourceBranch() {
    return this._sourceBranch;
  }

  /**
   * @param sourceBranch{string}
   * @return {FlexRemoteMoveArgs}
   */
  setSourceBranch(sourceBranch) {
    this._sourceBranch = sourceBranch;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexRemoteMoveArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {FlexRemoteMoveArgs}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {VABTabId}
   */
  getVABTabId() {
    return this._vABTabId;
  }

  /**
   * @param vABTabId{VABTabId}
   * @return {FlexRemoteMoveArgs}
   */
  setVABTabId(vABTabId) {
    this._vABTabId = vABTabId;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getInFuids() {
    return this._inFuids;
  }

  /**
   * @param inFuids{Array<Integer>}
   * @return {FlexRemoteMoveArgs}
   */
  setInFuids(inFuids) {
    this._inFuids = inFuids;
    return this;
  }

  /**
   * @return {java.util.Map<number,String>}
   */
  getFuidToPath() {
    return this._fuidToPath;
  }

  /**
   * @param fuidToPath{java.util.Map<number,String>}
   * @return {FlexRemoteMoveArgs}
   */
  setFuidToPath(fuidToPath) {
    this._fuidToPath = fuidToPath;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getMetadataMap() {
    return this._metadataMap;
  }

  /**
   * @param metadataMap{java.util.Map<String,String>}
   * @return {FlexRemoteMoveArgs}
   */
  setMetadataMap(metadataMap) {
    this._metadataMap = metadataMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexRemoteMoveArgs.CLASS_ID;
    
	//Serializing _destFuid
	if (this._destFuid)
		json['destFuid'] = this._destFuid;

	//Serializing _sourceBranch
	if (this._sourceBranch)
		json['sourceBranch'] = this._sourceBranch;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing ComplexType _$arrayName
	if (this._vABTabId)
		json['vABTabId'] = this._vABTabId.serializeJson();
		  if (this._inFuids && this._inFuids.length > 0) {
    let inFuids_JSON = [];
    /**
     * @type {int}
     */
    this._inFuids.forEach((o44) => {
      if (o44) {
        if (o44.serializeJson && (typeof (o44.serializeJson) === 'function')) {
          inFuids_JSON.push(o44.serializeJson());
        } else {
          inFuids_JSON.push(o44);
        }
      }
    });
    json['inFuids'] = inFuids_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"fuidToPath", this._fuidToPath);
		    SerializationUtil.serializeHashMap(json,"metadataMap", this._metadataMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._destFuid = json.hasOwnProperty("destFuid")?json["destFuid"]:0;
		this._sourceBranch = json.hasOwnProperty("sourceBranch")?json["sourceBranch"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		if (json.hasOwnProperty("vABTabId")){
			if (!this._vABTabId && this._vABTabId == null)
				this._vABTabId = new VABTabId();
			this._vABTabId.deserializeJson(json.hasOwnProperty("vABTabId") ? json["vABTabId"] : null);
		}

		//set of type int
		this._inFuids = [];
		let inFuidsJSONArray = json.hasOwnProperty("inFuids") ? json["inFuids"] : [];

		inFuidsJSONArray.forEach((o45)=>{
			if (o45){
				this._inFuids.push(o45);
			}
		});
//Map of type INT. Decode as tree:false
		if (this._fuidToPath == null)
			this._fuidToPath = new HashMap();
		this._fuidToPath.clear();
		let fuidToPathJSONArray = json.hasOwnProperty("fuidToPath") ? json["fuidToPath"] : [];
		this._fuidToPath = SerializationUtil.deserializeMap(fuidToPathJSONArray);

//Map of type STRING. Decode as tree:false
		if (this._metadataMap == null)
			this._metadataMap = new HashMap();
		this._metadataMap.clear();
		let metadataMapJSONArray = json.hasOwnProperty("metadataMap") ? json["metadataMap"] : [];
		this._metadataMap = SerializationUtil.deserializeMap(metadataMapJSONArray);



  }
}

/**
 * @returns {string}
 */
FlexRemoteMoveArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteMoveArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexCheckoutArgs {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._lockFiles = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyAdditionalPathCO = false;
    /**
     * @type {number}
     * @private
     */
    this._inFuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._useDestForAddtionalPathCo = false;
    /**
     * @type {number}
     * @private
     */
    this._fuid2Lock = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {boolean}
     * @private
     */
    this._noKids = false;
    /**
     * @type {string}
     * @private
     */
    this._path2Lock = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {string}
     * @private
     */
    this._checkoutDestination = null;
    /**
     * @type {string}
     * @private
     */
    this._extraDirPathToAddAndCo = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._infiles = null;

  }

    /**
   * @return {boolean}
   */
  isLockFiles() {
    return this._lockFiles;
  }

  /**
   * @param lockFiles{boolean}
   * @return {FlexCheckoutArgs}
   */
  setLockFiles(lockFiles) {
    this._lockFiles = lockFiles;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyAdditionalPathCO() {
    return this._onlyAdditionalPathCO;
  }

  /**
   * @param onlyAdditionalPathCO{boolean}
   * @return {FlexCheckoutArgs}
   */
  setOnlyAdditionalPathCO(onlyAdditionalPathCO) {
    this._onlyAdditionalPathCO = onlyAdditionalPathCO;
    return this;
  }
  /**
   * @return {number}
   */
  getInFuid() {
    return this._inFuid;
  }

  /**
   * @param inFuid{number}
   * @return {FlexCheckoutArgs}
   */
  setInFuid(inFuid) {
    this._inFuid = inFuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUseDestForAddtionalPathCo() {
    return this._useDestForAddtionalPathCo;
  }

  /**
   * @param useDestForAddtionalPathCo{boolean}
   * @return {FlexCheckoutArgs}
   */
  setUseDestForAddtionalPathCo(useDestForAddtionalPathCo) {
    this._useDestForAddtionalPathCo = useDestForAddtionalPathCo;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid2Lock() {
    return this._fuid2Lock;
  }

  /**
   * @param fuid2Lock{number}
   * @return {FlexCheckoutArgs}
   */
  setFuid2Lock(fuid2Lock) {
    this._fuid2Lock = fuid2Lock;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {FlexCheckoutArgs}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {boolean}
   */
  isNoKids() {
    return this._noKids;
  }

  /**
   * @param noKids{boolean}
   * @return {FlexCheckoutArgs}
   */
  setNoKids(noKids) {
    this._noKids = noKids;
    return this;
  }
  /**
   * @return {string}
   */
  getPath2Lock() {
    return this._path2Lock;
  }

  /**
   * @param path2Lock{string}
   * @return {FlexCheckoutArgs}
   */
  setPath2Lock(path2Lock) {
    this._path2Lock = path2Lock;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexCheckoutArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {string}
   */
  getCheckoutDestination() {
    return this._checkoutDestination;
  }

  /**
   * @param checkoutDestination{string}
   * @return {FlexCheckoutArgs}
   */
  setCheckoutDestination(checkoutDestination) {
    this._checkoutDestination = checkoutDestination;
    return this;
  }
  /**
   * @return {string}
   */
  getExtraDirPathToAddAndCo() {
    return this._extraDirPathToAddAndCo;
  }

  /**
   * @param extraDirPathToAddAndCo{string}
   * @return {FlexCheckoutArgs}
   */
  setExtraDirPathToAddAndCo(extraDirPathToAddAndCo) {
    this._extraDirPathToAddAndCo = extraDirPathToAddAndCo;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {FlexCheckoutArgs}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getInfiles() {
    return this._infiles;
  }

  /**
   * @param infiles{Array<String>}
   * @return {FlexCheckoutArgs}
   */
  setInfiles(infiles) {
    this._infiles = infiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexCheckoutArgs.CLASS_ID;
    
	//Serializing _lockFiles
	if (this._lockFiles)
		json['lockFiles'] = this._lockFiles;

	//Serializing _onlyAdditionalPathCO
	if (this._onlyAdditionalPathCO)
		json['onlyAdditionalPathCO'] = this._onlyAdditionalPathCO;

	//Serializing _inFuid
	if (this._inFuid)
		json['inFuid'] = this._inFuid;

	//Serializing _useDestForAddtionalPathCo
	if (this._useDestForAddtionalPathCo)
		json['useDestForAddtionalPathCo'] = this._useDestForAddtionalPathCo;

	//Serializing _fuid2Lock
	if (this._fuid2Lock)
		json['fuid2Lock'] = this._fuid2Lock;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _noKids
	if (this._noKids)
		json['noKids'] = this._noKids;

	//Serializing _path2Lock
	if (this._path2Lock)
		json['path2Lock'] = this._path2Lock;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;

	//Serializing _checkoutDestination
	if (this._checkoutDestination)
		json['checkoutDestination'] = this._checkoutDestination;

	//Serializing _extraDirPathToAddAndCo
	if (this._extraDirPathToAddAndCo)
		json['extraDirPathToAddAndCo'] = this._extraDirPathToAddAndCo;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;
  if (this._infiles && this._infiles.length > 0) {
    let infiles_JSON = [];
    /**
     * @type {string}
     */
    this._infiles.forEach((o124) => {
      if (o124) {
        if (o124.serializeJson && (typeof (o124.serializeJson) === 'function')) {
          infiles_JSON.push(o124.serializeJson());
        } else {
          infiles_JSON.push(o124);
        }
      }
    });
    json['infiles'] = infiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lockFiles = json.hasOwnProperty("lockFiles")?json["lockFiles"]:false;
		this._onlyAdditionalPathCO = json.hasOwnProperty("onlyAdditionalPathCO")?json["onlyAdditionalPathCO"]:false;
		this._inFuid = json.hasOwnProperty("inFuid")?json["inFuid"]:0;
		this._useDestForAddtionalPathCo = json.hasOwnProperty("useDestForAddtionalPathCo")?json["useDestForAddtionalPathCo"]:false;
		this._fuid2Lock = json.hasOwnProperty("fuid2Lock")?json["fuid2Lock"]:0;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._noKids = json.hasOwnProperty("noKids")?json["noKids"]:false;
		this._path2Lock = json.hasOwnProperty("path2Lock")?json["path2Lock"]:null;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		this._checkoutDestination = json.hasOwnProperty("checkoutDestination")?json["checkoutDestination"]:null;
		this._extraDirPathToAddAndCo = json.hasOwnProperty("extraDirPathToAddAndCo")?json["extraDirPathToAddAndCo"]:null;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;
		//set of type string
		this._infiles = [];
		let infilesJSONArray = json.hasOwnProperty("infiles") ? json["infiles"] : [];

		infilesJSONArray.forEach((o125)=>{
			if (o125){
				this._infiles.push(o125);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexCheckoutArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexCheckoutArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class TimeAndDatePrettyFormatMsg {

  constructor() {
    
        /**
     * @type {Array<Long>}
     * @private
     */
    this._mTimeArray = null;

  }

    /**
   * @return {Array<Long>}
   */
  getMTimeArray() {
    return this._mTimeArray;
  }

  /**
   * @param mTimeArray{Array<Long>}
   * @return {TimeAndDatePrettyFormatMsg}
   */
  setMTimeArray(mTimeArray) {
    this._mTimeArray = mTimeArray;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TimeAndDatePrettyFormatMsg.CLASS_ID;
      if (this._mTimeArray && this._mTimeArray.length > 0) {
    let mTimeArray_JSON = [];
    /**
     * @type {long}
     */
    this._mTimeArray.forEach((o208) => {
      if (o208) {
        if (o208.serializeJson && (typeof (o208.serializeJson) === 'function')) {
          mTimeArray_JSON.push(o208.serializeJson());
        } else {
          mTimeArray_JSON.push(o208);
        }
      }
    });
    json['mTimeArray'] = mTimeArray_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type long
		this._mTimeArray = [];
		let mTimeArrayJSONArray = json.hasOwnProperty("mTimeArray") ? json["mTimeArray"] : [];

		mTimeArrayJSONArray.forEach((o209)=>{
			if (o209){
				this._mTimeArray.push(o209);
			}
		});


  }
}

/**
 * @returns {string}
 */
TimeAndDatePrettyFormatMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.TimeAndDatePrettyFormatMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class UpdateTPMQueryMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {UpdateTPMQueryMsg}
   */
  setPath(path) {
    this._path = path;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UpdateTPMQueryMsg.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;


  }
}

/**
 * @returns {string}
 */
UpdateTPMQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.UpdateTPMQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexDeleteCommandArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {boolean}
     * @private
     */
    this._includeSmartShare = false;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {boolean}
     * @private
     */
    this._local = false;
    /**
     * @type {Array<String>}
     * @private
     */
    this._infiles = null;
    /**
     * @type {Array<FilePathAndStatus>}
     * @private
     */
    this._statusFiles = null;

  }

    /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexDeleteCommandArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIncludeSmartShare() {
    return this._includeSmartShare;
  }

  /**
   * @param includeSmartShare{boolean}
   * @return {FlexDeleteCommandArgs}
   */
  setIncludeSmartShare(includeSmartShare) {
    this._includeSmartShare = includeSmartShare;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexDeleteCommandArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {boolean}
   */
  isLocal() {
    return this._local;
  }

  /**
   * @param local{boolean}
   * @return {FlexDeleteCommandArgs}
   */
  setLocal(local) {
    this._local = local;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getInfiles() {
    return this._infiles;
  }

  /**
   * @param infiles{Array<String>}
   * @return {FlexDeleteCommandArgs}
   */
  setInfiles(infiles) {
    this._infiles = infiles;
    return this;
  }

  /**
   * @return {Array<FilePathAndStatus>}
   */
  getStatusFiles() {
    return this._statusFiles;
  }

  /**
   * @param statusFiles{Array<FilePathAndStatus>}
   * @return {FlexDeleteCommandArgs}
   */
  setStatusFiles(statusFiles) {
    this._statusFiles = statusFiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexDeleteCommandArgs.CLASS_ID;
    
	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _includeSmartShare
	if (this._includeSmartShare)
		json['includeSmartShare'] = this._includeSmartShare;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;

	//Serializing _local
	if (this._local)
		json['local'] = this._local;
  if (this._infiles && this._infiles.length > 0) {
    let infiles_JSON = [];
    /**
     * @type {string}
     */
    this._infiles.forEach((o31) => {
      if (o31) {
        if (o31.serializeJson && (typeof (o31.serializeJson) === 'function')) {
          infiles_JSON.push(o31.serializeJson());
        } else {
          infiles_JSON.push(o31);
        }
      }
    });
    json['infiles'] = infiles_JSON;
  }  
  if (this._statusFiles && this._statusFiles.length > 0) {
    let statusFiles_JSON = [];
    /**
     * @type {FilePathAndStatus}
     */
    this._statusFiles.forEach((o34) => {
      if (o34) {
        if (o34.serializeJson && (typeof (o34.serializeJson) === 'function')) {
          statusFiles_JSON.push(o34.serializeJson());
        } else {
          statusFiles_JSON.push(o34);
        }
      }
    });
    json['statusFiles'] = statusFiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._includeSmartShare = json.hasOwnProperty("includeSmartShare")?json["includeSmartShare"]:false;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		this._local = json.hasOwnProperty("local")?json["local"]:false;
		//set of type string
		this._infiles = [];
		let infilesJSONArray = json.hasOwnProperty("infiles") ? json["infiles"] : [];

		infilesJSONArray.forEach((o32)=>{
			if (o32){
				this._infiles.push(o32);
			}
		});
		//set of type FilePathAndStatus
		this._statusFiles = [];
		let statusFilesJSONArray = json.hasOwnProperty("statusFiles") ? json["statusFiles"] : [];

		statusFilesJSONArray.forEach((o35)=>{
			if (o35){
				let classObj = new FilePathAndStatus();
				classObj.deserializeJson(o35);
				this._statusFiles.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexDeleteCommandArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexDeleteCommandArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class GetListResponseDataObj {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {number}
     * @private
     */
    this._frn = null;
    /**
     * @type {string}
     * @private
     */
    this._pathStatus = null;
    /**
     * @type {boolean}
     * @private
     */
    this._smartCopySource = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._project = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._smartCopy = false;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {GetListResponseDataObj}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {number}
   */
  getFrn() {
    return this._frn;
  }

  /**
   * @param frn{number}
   * @return {GetListResponseDataObj}
   */
  setFrn(frn) {
    this._frn = frn;
    return this;
  }
  /**
   * @return {string}
   */
  getPathStatus() {
    return this._pathStatus;
  }

  /**
   * @param pathStatus{string}
   * @return {GetListResponseDataObj}
   */
  setPathStatus(pathStatus) {
    this._pathStatus = pathStatus;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSmartCopySource() {
    return this._smartCopySource;
  }

  /**
   * @param smartCopySource{boolean}
   * @return {GetListResponseDataObj}
   */
  setSmartCopySource(smartCopySource) {
    this._smartCopySource = smartCopySource;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {GetListResponseDataObj}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getProject() {
    return this._project;
  }

  /**
   * @param project{string}
   * @return {GetListResponseDataObj}
   */
  setProject(project) {
    this._project = project;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {GetListResponseDataObj}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSmartCopy() {
    return this._smartCopy;
  }

  /**
   * @param smartCopy{boolean}
   * @return {GetListResponseDataObj}
   */
  setSmartCopy(smartCopy) {
    this._smartCopy = smartCopy;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {GetListResponseDataObj}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetListResponseDataObj.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _frn
	if (this._frn)
		json['frn'] = this._frn;

	//Serializing _pathStatus
	if (this._pathStatus)
		json['pathStatus'] = this._pathStatus;

	//Serializing _smartCopySource
	if (this._smartCopySource)
		json['smartCopySource'] = this._smartCopySource;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _project
	if (this._project)
		json['project'] = this._project;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _smartCopy
	if (this._smartCopy)
		json['smartCopy'] = this._smartCopy;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._frn = json.hasOwnProperty("frn")?json["frn"]:0;
		this._pathStatus = json.hasOwnProperty("pathStatus")?json["pathStatus"]:null;
		this._smartCopySource = json.hasOwnProperty("smartCopySource")?json["smartCopySource"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._project = json.hasOwnProperty("project")?json["project"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._smartCopy = json.hasOwnProperty("smartCopy")?json["smartCopy"]:false;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
GetListResponseDataObj.CLASS_ID = "com.zoom.vab.client.autogenerated.GetListResponseDataObj";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexRemoteResurrectQuery extends HttpOperation {

  constructor(name = "FlexRemoteResurrect") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexRemoteResurrectArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexRemoteResurrectArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexZoomCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexRemoteResurrectQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexRemoteResurrectQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexRemoteResurrectQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteResurrect";
/**
 * @returns {string}
 */
FlexRemoteResurrectQuery.QUERY_NAME = "FlexRemoteResurrect";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABTabId {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._tabId = null;

  }

    /**
   * @return {string}
   */
  getTabId() {
    return this._tabId;
  }

  /**
   * @param tabId{string}
   * @return {VABTabId}
   */
  setTabId(tabId) {
    this._tabId = tabId;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABTabId.CLASS_ID;
    
	//Serializing _tabId
	if (this._tabId)
		json['tabId'] = this._tabId;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._tabId = json.hasOwnProperty("tabId")?json["tabId"]:null;


  }
}

/**
 * @returns {string}
 */
VABTabId.CLASS_ID = "com.zoom.vab.client.autogenerated.VABTabId";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABMakeCurrentMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._path = null;
    /**
     * @type {number}
     * @private
     */
    this._frn = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {boolean}
     * @private
     */
    this._frnFlag = false;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {string}
   */
  getPath() {
    return this._path;
  }

  /**
   * @param path{string}
   * @return {VABMakeCurrentMsg}
   */
  setPath(path) {
    this._path = path;
    return this;
  }
  /**
   * @return {number}
   */
  getFrn() {
    return this._frn;
  }

  /**
   * @param frn{number}
   * @return {VABMakeCurrentMsg}
   */
  setFrn(frn) {
    this._frn = frn;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {VABMakeCurrentMsg}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {VABMakeCurrentMsg}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {VABMakeCurrentMsg}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFrnFlag() {
    return this._frnFlag;
  }

  /**
   * @param frnFlag{boolean}
   * @return {VABMakeCurrentMsg}
   */
  setFrnFlag(frnFlag) {
    this._frnFlag = frnFlag;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {VABMakeCurrentMsg}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABMakeCurrentMsg.CLASS_ID;
    
	//Serializing _path
	if (this._path)
		json['path'] = this._path;

	//Serializing _frn
	if (this._frn)
		json['frn'] = this._frn;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;

	//Serializing _frnFlag
	if (this._frnFlag)
		json['frnFlag'] = this._frnFlag;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._path = json.hasOwnProperty("path")?json["path"]:null;
		this._frn = json.hasOwnProperty("frn")?json["frn"]:0;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		this._frnFlag = json.hasOwnProperty("frnFlag")?json["frnFlag"]:false;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
VABMakeCurrentMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.VABMakeCurrentMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexLockCommandArgs {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._remote = false;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._infiles = null;

  }

    /**
   * @return {boolean}
   */
  isRemote() {
    return this._remote;
  }

  /**
   * @param remote{boolean}
   * @return {FlexLockCommandArgs}
   */
  setRemote(remote) {
    this._remote = remote;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexLockCommandArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getInfiles() {
    return this._infiles;
  }

  /**
   * @param infiles{Array<String>}
   * @return {FlexLockCommandArgs}
   */
  setInfiles(infiles) {
    this._infiles = infiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexLockCommandArgs.CLASS_ID;
    
	//Serializing _remote
	if (this._remote)
		json['remote'] = this._remote;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;
  if (this._infiles && this._infiles.length > 0) {
    let infiles_JSON = [];
    /**
     * @type {string}
     */
    this._infiles.forEach((o200) => {
      if (o200) {
        if (o200.serializeJson && (typeof (o200.serializeJson) === 'function')) {
          infiles_JSON.push(o200.serializeJson());
        } else {
          infiles_JSON.push(o200);
        }
      }
    });
    json['infiles'] = infiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._remote = json.hasOwnProperty("remote")?json["remote"]:false;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		//set of type string
		this._infiles = [];
		let infilesJSONArray = json.hasOwnProperty("infiles") ? json["infiles"] : [];

		infilesJSONArray.forEach((o201)=>{
			if (o201){
				this._infiles.push(o201);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexLockCommandArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexLockCommandArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class GetActivityResp {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._oldestTime = null;
    /**
     * @type {boolean}
     * @private
     */
    this._hasMoreEntries = false;
    /**
     * @type {string}
     * @private
     */
    this._latestTimeDateLabel = null;
    /**
     * @type {string}
     * @private
     */
    this._oldestTimeDateLabel = null;
    /**
     * @type {number}
     * @private
     */
    this._latestTime = null;
    /**
     * @type {Array<ActivityResponseObject>}
     * @private
     */
    this._activityList = null;

  }

    /**
   * @return {number}
   */
  getOldestTime() {
    return this._oldestTime;
  }

  /**
   * @param oldestTime{number}
   * @return {GetActivityResp}
   */
  setOldestTime(oldestTime) {
    this._oldestTime = oldestTime;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHasMoreEntries() {
    return this._hasMoreEntries;
  }

  /**
   * @param hasMoreEntries{boolean}
   * @return {GetActivityResp}
   */
  setHasMoreEntries(hasMoreEntries) {
    this._hasMoreEntries = hasMoreEntries;
    return this;
  }
  /**
   * @return {string}
   */
  getLatestTimeDateLabel() {
    return this._latestTimeDateLabel;
  }

  /**
   * @param latestTimeDateLabel{string}
   * @return {GetActivityResp}
   */
  setLatestTimeDateLabel(latestTimeDateLabel) {
    this._latestTimeDateLabel = latestTimeDateLabel;
    return this;
  }
  /**
   * @return {string}
   */
  getOldestTimeDateLabel() {
    return this._oldestTimeDateLabel;
  }

  /**
   * @param oldestTimeDateLabel{string}
   * @return {GetActivityResp}
   */
  setOldestTimeDateLabel(oldestTimeDateLabel) {
    this._oldestTimeDateLabel = oldestTimeDateLabel;
    return this;
  }
  /**
   * @return {number}
   */
  getLatestTime() {
    return this._latestTime;
  }

  /**
   * @param latestTime{number}
   * @return {GetActivityResp}
   */
  setLatestTime(latestTime) {
    this._latestTime = latestTime;
    return this;
  }
  /**
   * @return {Array<ActivityResponseObject>}
   */
  getActivityList() {
    return this._activityList;
  }

  /**
   * @param activityList{Array<ActivityResponseObject>}
   * @return {GetActivityResp}
   */
  setActivityList(activityList) {
    this._activityList = activityList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetActivityResp.CLASS_ID;
    
	//Serializing _oldestTime
	if (this._oldestTime)
		json['oldestTime'] = this._oldestTime;

	//Serializing _hasMoreEntries
	if (this._hasMoreEntries)
		json['hasMoreEntries'] = this._hasMoreEntries;

	//Serializing _latestTimeDateLabel
	if (this._latestTimeDateLabel)
		json['latestTimeDateLabel'] = this._latestTimeDateLabel;

	//Serializing _oldestTimeDateLabel
	if (this._oldestTimeDateLabel)
		json['oldestTimeDateLabel'] = this._oldestTimeDateLabel;

	//Serializing _latestTime
	if (this._latestTime)
		json['latestTime'] = this._latestTime;
  if (this._activityList && this._activityList.length > 0) {
    let activityList_JSON = [];
    /**
     * @type {ActivityResponseObject}
     */
    this._activityList.forEach((o66) => {
      if (o66) {
        if (o66.serializeJson && (typeof (o66.serializeJson) === 'function')) {
          activityList_JSON.push(o66.serializeJson());
        } else {
          activityList_JSON.push(o66);
        }
      }
    });
    json['activityList'] = activityList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._oldestTime = json.hasOwnProperty("oldestTime")?json["oldestTime"]:0;
		this._hasMoreEntries = json.hasOwnProperty("hasMoreEntries")?json["hasMoreEntries"]:false;
		this._latestTimeDateLabel = json.hasOwnProperty("latestTimeDateLabel")?json["latestTimeDateLabel"]:null;
		this._oldestTimeDateLabel = json.hasOwnProperty("oldestTimeDateLabel")?json["oldestTimeDateLabel"]:null;
		this._latestTime = json.hasOwnProperty("latestTime")?json["latestTime"]:0;
		//set of type ActivityResponseObject
		this._activityList = [];
		let activityListJSONArray = json.hasOwnProperty("activityList") ? json["activityList"] : [];

		activityListJSONArray.forEach((o67)=>{
			if (o67){
				let classObj = new ActivityResponseObject();
				classObj.deserializeJson(o67);
				this._activityList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
GetActivityResp.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivityResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexRemoteRenameArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._newName = null;
    /**
     * @type {string}
     * @private
     */
    this._remotePath = null;
    /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;

  }

    /**
   * @return {string}
   */
  getNewName() {
    return this._newName;
  }

  /**
   * @param newName{string}
   * @return {FlexRemoteRenameArgs}
   */
  setNewName(newName) {
    this._newName = newName;
    return this;
  }
  /**
   * @return {string}
   */
  getRemotePath() {
    return this._remotePath;
  }

  /**
   * @param remotePath{string}
   * @return {FlexRemoteRenameArgs}
   */
  setRemotePath(remotePath) {
    this._remotePath = remotePath;
    return this;
  }
  /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexRemoteRenameArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexRemoteRenameArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexRemoteRenameArgs.CLASS_ID;
    
	//Serializing _newName
	if (this._newName)
		json['newName'] = this._newName;

	//Serializing _remotePath
	if (this._remotePath)
		json['remotePath'] = this._remotePath;

	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._newName = json.hasOwnProperty("newName")?json["newName"]:null;
		this._remotePath = json.hasOwnProperty("remotePath")?json["remotePath"]:null;
		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;


  }
}

/**
 * @returns {string}
 */
FlexRemoteRenameArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteRenameArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABFileFilterData {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._deleted = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._index = null;
    /**
     * @type {boolean}
     * @private
     */
    this._checked = false;
    /**
     * @type {string}
     * @private
     */
    this._propName = null;
    /**
     * @type {string}
     * @private
     */
    this._value = null;

  }

    /**
   * @return {boolean}
   */
  isDeleted() {
    return this._deleted;
  }

  /**
   * @param deleted{boolean}
   * @return {VABFileFilterData}
   */
  setDeleted(deleted) {
    this._deleted = deleted;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {VABFileFilterData}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getIndex() {
    return this._index;
  }

  /**
   * @param index{number}
   * @return {VABFileFilterData}
   */
  setIndex(index) {
    this._index = index;
    return this;
  }
  /**
   * @return {boolean}
   */
  isChecked() {
    return this._checked;
  }

  /**
   * @param checked{boolean}
   * @return {VABFileFilterData}
   */
  setChecked(checked) {
    this._checked = checked;
    return this;
  }
  /**
   * @return {string}
   */
  getPropName() {
    return this._propName;
  }

  /**
   * @param propName{string}
   * @return {VABFileFilterData}
   */
  setPropName(propName) {
    this._propName = propName;
    return this;
  }
  /**
   * values separated with pipes so that we can accept all kind of values
   * @return {string}
   */
  getValue() {
    return this._value;
  }

  /**
   * @param value{string}
   * @return {VABFileFilterData}
   */
  setValue(value) {
    this._value = value;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABFileFilterData.CLASS_ID;
    
	//Serializing _deleted
	if (this._deleted)
		json['deleted'] = this._deleted;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _index
	if (this._index)
		json['index'] = this._index;

	//Serializing _checked
	if (this._checked)
		json['checked'] = this._checked;

	//Serializing _propName
	if (this._propName)
		json['propName'] = this._propName;

	//Serializing _value
	if (this._value)
		json['value'] = this._value;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._deleted = json.hasOwnProperty("deleted")?json["deleted"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._index = json.hasOwnProperty("index")?json["index"]:0;
		this._checked = json.hasOwnProperty("checked")?json["checked"]:false;
		this._propName = json.hasOwnProperty("propName")?json["propName"]:null;
		this._value = json.hasOwnProperty("value")?json["value"]:null;


  }
}

/**
 * @returns {string}
 */
VABFileFilterData.CLASS_ID = "com.zoom.vab.client.autogenerated.VABFileFilterData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class UpdateTPMQueryResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {UpdateTPMQueryResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = UpdateTPMQueryResp.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;


  }
}

/**
 * @returns {string}
 */
UpdateTPMQueryResp.CLASS_ID = "com.zoom.vab.client.autogenerated.UpdateTPMQueryResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class VABLogoutQuery extends HttpOperation {

  constructor(name = "VABLogout") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {String}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{String}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {VABLogoutResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = VABLogoutQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (VABLogoutQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new VABLogoutResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new VABLogoutResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
VABLogoutQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.VABLogout";
/**
 * @returns {string}
 */
VABLogoutQuery.QUERY_NAME = "VABLogout";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexLockStatusResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._fileLockedByOtherUsers = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {string}
     * @private
     */
    this._currentLoggedInUser = null;
    /**
     * @type {Array<LockDetail>}
     * @private
     */
    this._lockInfos = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._otherUsersName = null;

  }

    /**
   * @return {boolean}
   */
  isFileLockedByOtherUsers() {
    return this._fileLockedByOtherUsers;
  }

  /**
   * @param fileLockedByOtherUsers{boolean}
   * @return {FlexLockStatusResponse}
   */
  setFileLockedByOtherUsers(fileLockedByOtherUsers) {
    this._fileLockedByOtherUsers = fileLockedByOtherUsers;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexLockStatusResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {FlexLockStatusResponse}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {string}
   */
  getCurrentLoggedInUser() {
    return this._currentLoggedInUser;
  }

  /**
   * @param currentLoggedInUser{string}
   * @return {FlexLockStatusResponse}
   */
  setCurrentLoggedInUser(currentLoggedInUser) {
    this._currentLoggedInUser = currentLoggedInUser;
    return this;
  }
  /**
   * @return {Array<LockDetail>}
   */
  getLockInfos() {
    return this._lockInfos;
  }

  /**
   * @param lockInfos{Array<LockDetail>}
   * @return {FlexLockStatusResponse}
   */
  setLockInfos(lockInfos) {
    this._lockInfos = lockInfos;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getOtherUsersName() {
    return this._otherUsersName;
  }

  /**
   * @param otherUsersName{Array<String>}
   * @return {FlexLockStatusResponse}
   */
  setOtherUsersName(otherUsersName) {
    this._otherUsersName = otherUsersName;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexLockStatusResponse.CLASS_ID;
    
	//Serializing _fileLockedByOtherUsers
	if (this._fileLockedByOtherUsers)
		json['fileLockedByOtherUsers'] = this._fileLockedByOtherUsers;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _currentLoggedInUser
	if (this._currentLoggedInUser)
		json['currentLoggedInUser'] = this._currentLoggedInUser;
  if (this._LockInfos && this._LockInfos.length > 0) {
    let LockInfos_JSON = [];
    /**
     * @type {LockDetail}
     */
    this._LockInfos.forEach((o93) => {
      if (o93) {
        if (o93.serializeJson && (typeof (o93.serializeJson) === 'function')) {
          LockInfos_JSON.push(o93.serializeJson());
        } else {
          LockInfos_JSON.push(o93);
        }
      }
    });
    json['LockInfos'] = LockInfos_JSON;
  }  
  if (this._otherUsersName && this._otherUsersName.length > 0) {
    let otherUsersName_JSON = [];
    /**
     * @type {string}
     */
    this._otherUsersName.forEach((o96) => {
      if (o96) {
        if (o96.serializeJson && (typeof (o96.serializeJson) === 'function')) {
          otherUsersName_JSON.push(o96.serializeJson());
        } else {
          otherUsersName_JSON.push(o96);
        }
      }
    });
    json['otherUsersName'] = otherUsersName_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fileLockedByOtherUsers = json.hasOwnProperty("fileLockedByOtherUsers")?json["fileLockedByOtherUsers"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._currentLoggedInUser = json.hasOwnProperty("currentLoggedInUser")?json["currentLoggedInUser"]:null;
		//set of type LockDetail
		this._LockInfos = [];
		let LockInfosJSONArray = json.hasOwnProperty("LockInfos") ? json["LockInfos"] : [];

		LockInfosJSONArray.forEach((o94)=>{
			if (o94){
				let classObj = new LockDetail();
				classObj.deserializeJson(o94);
				this._LockInfos.push(classObj);
			}
		});
		//set of type string
		this._otherUsersName = [];
		let otherUsersNameJSONArray = json.hasOwnProperty("otherUsersName") ? json["otherUsersName"] : [];

		otherUsersNameJSONArray.forEach((o97)=>{
			if (o97){
				this._otherUsersName.push(o97);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexLockStatusResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexLockStatusResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABGetFileTypeFiltersResp {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._mtime = null;
    /**
     * @type {Array<VABFileFilterData>}
     * @private
     */
    this._filterItems = null;

  }

    /**
   * @return {string}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{string}
   * @return {VABGetFileTypeFiltersResp}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {Array<VABFileFilterData>}
   */
  getFilterItems() {
    return this._filterItems;
  }

  /**
   * @param filterItems{Array<VABFileFilterData>}
   * @return {VABGetFileTypeFiltersResp}
   */
  setFilterItems(filterItems) {
    this._filterItems = filterItems;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABGetFileTypeFiltersResp.CLASS_ID;
    
	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;
  if (this._filterItems && this._filterItems.length > 0) {
    let filterItems_JSON = [];
    /**
     * @type {VABFileFilterData}
     */
    this._filterItems.forEach((o224) => {
      if (o224) {
        if (o224.serializeJson && (typeof (o224.serializeJson) === 'function')) {
          filterItems_JSON.push(o224.serializeJson());
        } else {
          filterItems_JSON.push(o224);
        }
      }
    });
    json['filterItems'] = filterItems_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:null;
		//set of type VABFileFilterData
		this._filterItems = [];
		let filterItemsJSONArray = json.hasOwnProperty("filterItems") ? json["filterItems"] : [];

		filterItemsJSONArray.forEach((o225)=>{
			if (o225){
				let classObj = new VABFileFilterData();
				classObj.deserializeJson(o225);
				this._filterItems.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
VABGetFileTypeFiltersResp.CLASS_ID = "com.zoom.vab.client.autogenerated.VABGetFileTypeFiltersResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class LayerPropVal {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._frn = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isFile = false;
    /**
     * @type {string}
     * @private
     */
    this._pathStatus = null;
    /**
     * @type {number}
     * @private
     */
    this._pid = null;
    /**
     * @type {string}
     * @private
     */
    this._compName = null;
    /**
     * @type {string}
     * @private
     */
    this._parentId = null;
    /**
     * @type {number}
     * @private
     */
    this._parentFuid = null;
    /**
     * @type {number}
     * @private
     */
    this._isLinked = null;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._id = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._fqPath = null;
    /**
     * @type {Array<LayerProperty>}
     * @private
     */
    this._layerProperties = null;
    /**
     * @type {Array<LayerPropVal>}
     * @private
     */
    this._children = null;

  }

    /**
   * @return {number}
   */
  getFrn() {
    return this._frn;
  }

  /**
   * @param frn{number}
   * @return {LayerPropVal}
   */
  setFrn(frn) {
    this._frn = frn;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsFile() {
    return this._isFile;
  }

  /**
   * @param isFile{boolean}
   * @return {LayerPropVal}
   */
  setIsFile(isFile) {
    this._isFile = isFile;
    return this;
  }
  /**
   * @return {string}
   */
  getPathStatus() {
    return this._pathStatus;
  }

  /**
   * @param pathStatus{string}
   * @return {LayerPropVal}
   */
  setPathStatus(pathStatus) {
    this._pathStatus = pathStatus;
    return this;
  }
  /**
   * @return {number}
   */
  getPid() {
    return this._pid;
  }

  /**
   * @param pid{number}
   * @return {LayerPropVal}
   */
  setPid(pid) {
    this._pid = pid;
    return this;
  }
  /**
   * @return {string}
   */
  getCompName() {
    return this._compName;
  }

  /**
   * @param compName{string}
   * @return {LayerPropVal}
   */
  setCompName(compName) {
    this._compName = compName;
    return this;
  }
  /**
   * @return {string}
   */
  getParentId() {
    return this._parentId;
  }

  /**
   * @param parentId{string}
   * @return {LayerPropVal}
   */
  setParentId(parentId) {
    this._parentId = parentId;
    return this;
  }
  /**
   * @return {number}
   */
  getParentFuid() {
    return this._parentFuid;
  }

  /**
   * @param parentFuid{number}
   * @return {LayerPropVal}
   */
  setParentFuid(parentFuid) {
    this._parentFuid = parentFuid;
    return this;
  }
  /**
   * @return {number}
   */
  getIsLinked() {
    return this._isLinked;
  }

  /**
   * @param isLinked{number}
   * @return {LayerPropVal}
   */
  setIsLinked(isLinked) {
    this._isLinked = isLinked;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {LayerPropVal}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {LayerPropVal}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getId() {
    return this._id;
  }

  /**
   * @param id{number}
   * @return {LayerPropVal}
   */
  setId(id) {
    this._id = id;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {LayerPropVal}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getFqPath() {
    return this._fqPath;
  }

  /**
   * @param fqPath{string}
   * @return {LayerPropVal}
   */
  setFqPath(fqPath) {
    this._fqPath = fqPath;
    return this;
  }
  /**
   * @return {Array<LayerProperty>}
   */
  getLayerProperties() {
    return this._layerProperties;
  }

  /**
   * @param layerProperties{Array<LayerProperty>}
   * @return {LayerPropVal}
   */
  setLayerProperties(layerProperties) {
    this._layerProperties = layerProperties;
    return this;
  }

  /**
   * @return {Array<LayerPropVal>}
   */
  getChildren() {
    return this._children;
  }

  /**
   * @param children{Array<LayerPropVal>}
   * @return {LayerPropVal}
   */
  setChildren(children) {
    this._children = children;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LayerPropVal.CLASS_ID;
    
	//Serializing _frn
	if (this._frn)
		json['frn'] = this._frn;

	//Serializing _isFile
	if (this._isFile)
		json['isFile'] = this._isFile;

	//Serializing _pathStatus
	if (this._pathStatus)
		json['pathStatus'] = this._pathStatus;

	//Serializing _pid
	if (this._pid)
		json['pid'] = this._pid;

	//Serializing _compName
	if (this._compName)
		json['compName'] = this._compName;

	//Serializing _parentId
	if (this._parentId)
		json['parentId'] = this._parentId;

	//Serializing _parentFuid
	if (this._parentFuid)
		json['parentFuid'] = this._parentFuid;

	//Serializing _isLinked
	if (this._isLinked)
		json['isLinked'] = this._isLinked;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _id
	if (this._id)
		json['id'] = this._id;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _fqPath
	if (this._fqPath)
		json['fqPath'] = this._fqPath;
  if (this._layerProperties && this._layerProperties.length > 0) {
    let layerProperties_JSON = [];
    /**
     * @type {LayerProperty}
     */
    this._layerProperties.forEach((o109) => {
      if (o109) {
        if (o109.serializeJson && (typeof (o109.serializeJson) === 'function')) {
          layerProperties_JSON.push(o109.serializeJson());
        } else {
          layerProperties_JSON.push(o109);
        }
      }
    });
    json['layerProperties'] = layerProperties_JSON;
  }  
  if (this._children && this._children.length > 0) {
    let children_JSON = [];
    /**
     * @type {LayerPropVal}
     */
    this._children.forEach((o112) => {
      if (o112) {
        if (o112.serializeJson && (typeof (o112.serializeJson) === 'function')) {
          children_JSON.push(o112.serializeJson());
        } else {
          children_JSON.push(o112);
        }
      }
    });
    json['children'] = children_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._frn = json.hasOwnProperty("frn")?json["frn"]:0;
		this._isFile = json.hasOwnProperty("isFile")?json["isFile"]:false;
		this._pathStatus = json.hasOwnProperty("pathStatus")?json["pathStatus"]:null;
		this._pid = json.hasOwnProperty("pid")?json["pid"]:0;
		this._compName = json.hasOwnProperty("compName")?json["compName"]:null;
		this._parentId = json.hasOwnProperty("parentId")?json["parentId"]:null;
		this._parentFuid = json.hasOwnProperty("parentFuid")?json["parentFuid"]:0;
		this._isLinked = json.hasOwnProperty("isLinked")?json["isLinked"]:0;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._id = json.hasOwnProperty("id")?json["id"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._fqPath = json.hasOwnProperty("fqPath")?json["fqPath"]:null;
		//set of type LayerProperty
		this._layerProperties = [];
		let layerPropertiesJSONArray = json.hasOwnProperty("layerProperties") ? json["layerProperties"] : [];

		layerPropertiesJSONArray.forEach((o110)=>{
			if (o110){
				let classObj = new LayerProperty();
				classObj.deserializeJson(o110);
				this._layerProperties.push(classObj);
			}
		});
		//set of type LayerPropVal
		this._children = [];
		let childrenJSONArray = json.hasOwnProperty("children") ? json["children"] : [];

		childrenJSONArray.forEach((o113)=>{
			if (o113){
				let classObj = new LayerPropVal();
				classObj.deserializeJson(o113);
				this._children.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
LayerPropVal.CLASS_ID = "com.zoom.vab.client.autogenerated.LayerPropVal";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexVABGetLockStatusQuery extends HttpOperation {

  constructor(name = "FlexVABGetLockStatus") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexLockStatusRequest}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexLockStatusRequest}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexLockStatusResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexVABGetLockStatusQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexVABGetLockStatusQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexLockStatusResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexLockStatusResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexVABGetLockStatusQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexVABGetLockStatus";
/**
 * @returns {string}
 */
FlexVABGetLockStatusQuery.QUERY_NAME = "FlexVABGetLockStatus";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexMultiAssetCheckoutArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._userAction = null;
    /**
     * @type {boolean}
     * @private
     */
    this._cancelExistingJob = false;
    /**
     * @type {boolean}
     * @private
     */
    this._checkoutWithLinks = false;
    /**
     * @type {boolean}
     * @private
     */
    this._noFileOpen = false;
    /**
     * @type {boolean}
     * @private
     */
    this._ignoreProxy = false;
    /**
     * @type {string}
     * @private
     */
    this._checkoutDestination = null;
    /**
     * @type {number}
     * @private
     */
    this._taskId = null;
    /**
     * @type {Array<FlexCheckoutArgs>}
     * @private
     */
    this._assetDetails = null;

  }

    /**
   * @return {string}
   */
  getUserAction() {
    return this._userAction;
  }

  /**
   * @param userAction{string}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setUserAction(userAction) {
    this._userAction = userAction;
    return this;
  }
  /**
   * @return {boolean}
   */
  isCancelExistingJob() {
    return this._cancelExistingJob;
  }

  /**
   * @param cancelExistingJob{boolean}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setCancelExistingJob(cancelExistingJob) {
    this._cancelExistingJob = cancelExistingJob;
    return this;
  }
  /**
   * @return {boolean}
   */
  isCheckoutWithLinks() {
    return this._checkoutWithLinks;
  }

  /**
   * @param checkoutWithLinks{boolean}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setCheckoutWithLinks(checkoutWithLinks) {
    this._checkoutWithLinks = checkoutWithLinks;
    return this;
  }
  /**
   * @return {boolean}
   */
  isNoFileOpen() {
    return this._noFileOpen;
  }

  /**
   * @param noFileOpen{boolean}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setNoFileOpen(noFileOpen) {
    this._noFileOpen = noFileOpen;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIgnoreProxy() {
    return this._ignoreProxy;
  }

  /**
   * @param ignoreProxy{boolean}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setIgnoreProxy(ignoreProxy) {
    this._ignoreProxy = ignoreProxy;
    return this;
  }
  /**
   * @return {string}
   */
  getCheckoutDestination() {
    return this._checkoutDestination;
  }

  /**
   * @param checkoutDestination{string}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setCheckoutDestination(checkoutDestination) {
    this._checkoutDestination = checkoutDestination;
    return this;
  }
  /**
   * @return {number}
   */
  getTaskId() {
    return this._taskId;
  }

  /**
   * @param taskId{number}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setTaskId(taskId) {
    this._taskId = taskId;
    return this;
  }
  /**
   * @return {Array<FlexCheckoutArgs>}
   */
  getAssetDetails() {
    return this._assetDetails;
  }

  /**
   * @param assetDetails{Array<FlexCheckoutArgs>}
   * @return {FlexMultiAssetCheckoutArgs}
   */
  setAssetDetails(assetDetails) {
    this._assetDetails = assetDetails;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexMultiAssetCheckoutArgs.CLASS_ID;
    
	//Serializing _userAction
	if (this._userAction)
		json['userAction'] = this._userAction;

	//Serializing _cancelExistingJob
	if (this._cancelExistingJob)
		json['cancelExistingJob'] = this._cancelExistingJob;

	//Serializing _checkoutWithLinks
	if (this._checkoutWithLinks)
		json['checkoutWithLinks'] = this._checkoutWithLinks;

	//Serializing _noFileOpen
	if (this._noFileOpen)
		json['noFileOpen'] = this._noFileOpen;

	//Serializing _ignoreProxy
	if (this._ignoreProxy)
		json['ignoreProxy'] = this._ignoreProxy;

	//Serializing _checkoutDestination
	if (this._checkoutDestination)
		json['checkoutDestination'] = this._checkoutDestination;

	//Serializing _taskId
	if (this._taskId)
		json['taskId'] = this._taskId;
  if (this._assetDetails && this._assetDetails.length > 0) {
    let assetDetails_JSON = [];
    /**
     * @type {FlexCheckoutArgs}
     */
    this._assetDetails.forEach((o132) => {
      if (o132) {
        if (o132.serializeJson && (typeof (o132.serializeJson) === 'function')) {
          assetDetails_JSON.push(o132.serializeJson());
        } else {
          assetDetails_JSON.push(o132);
        }
      }
    });
    json['assetDetails'] = assetDetails_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._userAction = json.hasOwnProperty("userAction")?json["userAction"]:null;
		this._cancelExistingJob = json.hasOwnProperty("cancelExistingJob")?json["cancelExistingJob"]:false;
		this._checkoutWithLinks = json.hasOwnProperty("checkoutWithLinks")?json["checkoutWithLinks"]:false;
		this._noFileOpen = json.hasOwnProperty("noFileOpen")?json["noFileOpen"]:false;
		this._ignoreProxy = json.hasOwnProperty("ignoreProxy")?json["ignoreProxy"]:false;
		this._checkoutDestination = json.hasOwnProperty("checkoutDestination")?json["checkoutDestination"]:null;
		this._taskId = json.hasOwnProperty("taskId")?json["taskId"]:0;
		//set of type FlexCheckoutArgs
		this._assetDetails = [];
		let assetDetailsJSONArray = json.hasOwnProperty("assetDetails") ? json["assetDetails"] : [];

		assetDetailsJSONArray.forEach((o133)=>{
			if (o133){
				let classObj = new FlexCheckoutArgs();
				classObj.deserializeJson(o133);
				this._assetDetails.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexMultiAssetCheckoutArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexMultiAssetCheckoutArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class GetFileTypeFiltersQuery extends HttpOperation {

  constructor(name = "GetFileTypeFilters") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {VABGetFileTypeFiltersMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{VABGetFileTypeFiltersMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {VABGetFileTypeFiltersResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetFileTypeFiltersQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetFileTypeFiltersQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new VABGetFileTypeFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new VABGetFileTypeFiltersResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetFileTypeFiltersQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetFileTypeFilters";
/**
 * @returns {string}
 */
GetFileTypeFiltersQuery.QUERY_NAME = "GetFileTypeFilters";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ActivityResponseObject {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._frn = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isAnnotation = false;
    /**
     * @type {string}
     * @private
     */
    this._profilePic = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isLightBox = false;
    /**
     * @type {string}
     * @private
     */
    this._message = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;
    /**
     * @type {string}
     * @private
     */
    this._dateLabel = null;
    /**
     * @type {boolean}
     * @private
     */
    this._notClickable = false;
    /**
     * @type {boolean}
     * @private
     */
    this._file = false;
    /**
     * @type {string}
     * @private
     */
    this._name = null;
    /**
     * @type {string}
     * @private
     */
    this._thumbnailPath = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showThumbnail = false;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._timeLabel = null;
    /**
     * @type {number}
     * @private
     */
    this._taskId = null;
    /**
     * @type {number}
     * @private
     */
    this._workflowId = null;
    /**
     * @type {string}
     * @private
     */
    this._username = null;

  }

    /**
   * @return {number}
   */
  getFrn() {
    return this._frn;
  }

  /**
   * @param frn{number}
   * @return {ActivityResponseObject}
   */
  setFrn(frn) {
    this._frn = frn;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsAnnotation() {
    return this._isAnnotation;
  }

  /**
   * @param isAnnotation{boolean}
   * @return {ActivityResponseObject}
   */
  setIsAnnotation(isAnnotation) {
    this._isAnnotation = isAnnotation;
    return this;
  }
  /**
   * @return {string}
   */
  getProfilePic() {
    return this._profilePic;
  }

  /**
   * @param profilePic{string}
   * @return {ActivityResponseObject}
   */
  setProfilePic(profilePic) {
    this._profilePic = profilePic;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsLightBox() {
    return this._isLightBox;
  }

  /**
   * @param isLightBox{boolean}
   * @return {ActivityResponseObject}
   */
  setIsLightBox(isLightBox) {
    this._isLightBox = isLightBox;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {ActivityResponseObject}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {ActivityResponseObject}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }
  /**
   * @return {string}
   */
  getDateLabel() {
    return this._dateLabel;
  }

  /**
   * @param dateLabel{string}
   * @return {ActivityResponseObject}
   */
  setDateLabel(dateLabel) {
    this._dateLabel = dateLabel;
    return this;
  }
  /**
   * @return {boolean}
   */
  isNotClickable() {
    return this._notClickable;
  }

  /**
   * @param notClickable{boolean}
   * @return {ActivityResponseObject}
   */
  setNotClickable(notClickable) {
    this._notClickable = notClickable;
    return this;
  }
  /**
   * @return {boolean}
   */
  isFile() {
    return this._file;
  }

  /**
   * @param file{boolean}
   * @return {ActivityResponseObject}
   */
  setFile(file) {
    this._file = file;
    return this;
  }
  /**
   * @return {string}
   */
  getName() {
    return this._name;
  }

  /**
   * @param name{string}
   * @return {ActivityResponseObject}
   */
  setName(name) {
    this._name = name;
    return this;
  }
  /**
   * @return {string}
   */
  getThumbnailPath() {
    return this._thumbnailPath;
  }

  /**
   * @param thumbnailPath{string}
   * @return {ActivityResponseObject}
   */
  setThumbnailPath(thumbnailPath) {
    this._thumbnailPath = thumbnailPath;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {ActivityResponseObject}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowThumbnail() {
    return this._showThumbnail;
  }

  /**
   * @param showThumbnail{boolean}
   * @return {ActivityResponseObject}
   */
  setShowThumbnail(showThumbnail) {
    this._showThumbnail = showThumbnail;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {ActivityResponseObject}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getTimeLabel() {
    return this._timeLabel;
  }

  /**
   * @param timeLabel{string}
   * @return {ActivityResponseObject}
   */
  setTimeLabel(timeLabel) {
    this._timeLabel = timeLabel;
    return this;
  }
  /**
   * @return {number}
   */
  getTaskId() {
    return this._taskId;
  }

  /**
   * @param taskId{number}
   * @return {ActivityResponseObject}
   */
  setTaskId(taskId) {
    this._taskId = taskId;
    return this;
  }
  /**
   * @return {number}
   */
  getWorkflowId() {
    return this._workflowId;
  }

  /**
   * @param workflowId{number}
   * @return {ActivityResponseObject}
   */
  setWorkflowId(workflowId) {
    this._workflowId = workflowId;
    return this;
  }
  /**
   * @return {string}
   */
  getUsername() {
    return this._username;
  }

  /**
   * @param username{string}
   * @return {ActivityResponseObject}
   */
  setUsername(username) {
    this._username = username;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ActivityResponseObject.CLASS_ID;
    
	//Serializing _frn
	if (this._frn)
		json['frn'] = this._frn;

	//Serializing _isAnnotation
	if (this._isAnnotation)
		json['isAnnotation'] = this._isAnnotation;

	//Serializing _profilePic
	if (this._profilePic)
		json['profilePic'] = this._profilePic;

	//Serializing _isLightBox
	if (this._isLightBox)
		json['isLightBox'] = this._isLightBox;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;

	//Serializing _dateLabel
	if (this._dateLabel)
		json['dateLabel'] = this._dateLabel;

	//Serializing _notClickable
	if (this._notClickable)
		json['notClickable'] = this._notClickable;

	//Serializing _file
	if (this._file)
		json['file'] = this._file;

	//Serializing _name
	if (this._name)
		json['name'] = this._name;

	//Serializing _thumbnailPath
	if (this._thumbnailPath)
		json['thumbnailPath'] = this._thumbnailPath;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _showThumbnail
	if (this._showThumbnail)
		json['showThumbnail'] = this._showThumbnail;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _timeLabel
	if (this._timeLabel)
		json['timeLabel'] = this._timeLabel;

	//Serializing _taskId
	if (this._taskId)
		json['taskId'] = this._taskId;

	//Serializing _workflowId
	if (this._workflowId)
		json['workflowId'] = this._workflowId;

	//Serializing _username
	if (this._username)
		json['username'] = this._username;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._frn = json.hasOwnProperty("frn")?json["frn"]:0;
		this._isAnnotation = json.hasOwnProperty("isAnnotation")?json["isAnnotation"]:false;
		this._profilePic = json.hasOwnProperty("profilePic")?json["profilePic"]:null;
		this._isLightBox = json.hasOwnProperty("isLightBox")?json["isLightBox"]:false;
		this._message = json.hasOwnProperty("message")?json["message"]:null;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;
		this._dateLabel = json.hasOwnProperty("dateLabel")?json["dateLabel"]:null;
		this._notClickable = json.hasOwnProperty("notClickable")?json["notClickable"]:false;
		this._file = json.hasOwnProperty("file")?json["file"]:false;
		this._name = json.hasOwnProperty("name")?json["name"]:null;
		this._thumbnailPath = json.hasOwnProperty("thumbnailPath")?json["thumbnailPath"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._showThumbnail = json.hasOwnProperty("showThumbnail")?json["showThumbnail"]:false;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._timeLabel = json.hasOwnProperty("timeLabel")?json["timeLabel"]:null;
		this._taskId = json.hasOwnProperty("taskId")?json["taskId"]:0;
		this._workflowId = json.hasOwnProperty("workflowId")?json["workflowId"]:0;
		this._username = json.hasOwnProperty("username")?json["username"]:null;


  }
}

/**
 * @returns {string}
 */
ActivityResponseObject.CLASS_ID = "com.zoom.vab.client.autogenerated.ActivityResponseObject";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexRemoteMoveQuery extends HttpOperation {

  constructor(name = "FlexRemoteMove") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexRemoteMoveArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexRemoteMoveArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexZoomCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexRemoteMoveQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexRemoteMoveQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexRemoteMoveQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteMove";
/**
 * @returns {string}
 */
FlexRemoteMoveQuery.QUERY_NAME = "FlexRemoteMove";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABMakeCurrentResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._message = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {VABMakeCurrentResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {VABMakeCurrentResponse}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABMakeCurrentResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._message = json.hasOwnProperty("message")?json["message"]:null;


  }
}

/**
 * @returns {string}
 */
VABMakeCurrentResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.VABMakeCurrentResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class DisabledItemsData {

  constructor() {
    
        /**
     * @type {Array<String>}
     * @private
     */
    this._settings = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._collectionActions = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._assetActions = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._metadataProps = null;

  }

    /**
   * @return {Array<String>}
   */
  getSettings() {
    return this._settings;
  }

  /**
   * @param settings{Array<String>}
   * @return {DisabledItemsData}
   */
  setSettings(settings) {
    this._settings = settings;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getCollectionActions() {
    return this._collectionActions;
  }

  /**
   * @param collectionActions{Array<String>}
   * @return {DisabledItemsData}
   */
  setCollectionActions(collectionActions) {
    this._collectionActions = collectionActions;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getAssetActions() {
    return this._assetActions;
  }

  /**
   * @param assetActions{Array<String>}
   * @return {DisabledItemsData}
   */
  setAssetActions(assetActions) {
    this._assetActions = assetActions;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getMetadataProps() {
    return this._metadataProps;
  }

  /**
   * @param metadataProps{Array<String>}
   * @return {DisabledItemsData}
   */
  setMetadataProps(metadataProps) {
    this._metadataProps = metadataProps;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = DisabledItemsData.CLASS_ID;
      if (this._settings && this._settings.length > 0) {
    let settings_JSON = [];
    /**
     * @type {string}
     */
    this._settings.forEach((o149) => {
      if (o149) {
        if (o149.serializeJson && (typeof (o149.serializeJson) === 'function')) {
          settings_JSON.push(o149.serializeJson());
        } else {
          settings_JSON.push(o149);
        }
      }
    });
    json['settings'] = settings_JSON;
  }  
  if (this._collectionActions && this._collectionActions.length > 0) {
    let collectionActions_JSON = [];
    /**
     * @type {string}
     */
    this._collectionActions.forEach((o152) => {
      if (o152) {
        if (o152.serializeJson && (typeof (o152.serializeJson) === 'function')) {
          collectionActions_JSON.push(o152.serializeJson());
        } else {
          collectionActions_JSON.push(o152);
        }
      }
    });
    json['collectionActions'] = collectionActions_JSON;
  }  
  if (this._assetActions && this._assetActions.length > 0) {
    let assetActions_JSON = [];
    /**
     * @type {string}
     */
    this._assetActions.forEach((o155) => {
      if (o155) {
        if (o155.serializeJson && (typeof (o155.serializeJson) === 'function')) {
          assetActions_JSON.push(o155.serializeJson());
        } else {
          assetActions_JSON.push(o155);
        }
      }
    });
    json['assetActions'] = assetActions_JSON;
  }  
  if (this._metadataProps && this._metadataProps.length > 0) {
    let metadataProps_JSON = [];
    /**
     * @type {string}
     */
    this._metadataProps.forEach((o158) => {
      if (o158) {
        if (o158.serializeJson && (typeof (o158.serializeJson) === 'function')) {
          metadataProps_JSON.push(o158.serializeJson());
        } else {
          metadataProps_JSON.push(o158);
        }
      }
    });
    json['metadataProps'] = metadataProps_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type string
		this._settings = [];
		let settingsJSONArray = json.hasOwnProperty("settings") ? json["settings"] : [];

		settingsJSONArray.forEach((o150)=>{
			if (o150){
				this._settings.push(o150);
			}
		});
		//set of type string
		this._collectionActions = [];
		let collectionActionsJSONArray = json.hasOwnProperty("collectionActions") ? json["collectionActions"] : [];

		collectionActionsJSONArray.forEach((o153)=>{
			if (o153){
				this._collectionActions.push(o153);
			}
		});
		//set of type string
		this._assetActions = [];
		let assetActionsJSONArray = json.hasOwnProperty("assetActions") ? json["assetActions"] : [];

		assetActionsJSONArray.forEach((o156)=>{
			if (o156){
				this._assetActions.push(o156);
			}
		});
		//set of type string
		this._metadataProps = [];
		let metadataPropsJSONArray = json.hasOwnProperty("metadataProps") ? json["metadataProps"] : [];

		metadataPropsJSONArray.forEach((o159)=>{
			if (o159){
				this._metadataProps.push(o159);
			}
		});


  }
}

/**
 * @returns {string}
 */
DisabledItemsData.CLASS_ID = "com.zoom.vab.client.autogenerated.DisabledItemsData";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ForkInfoQueryMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._checkBothLinkAndCopy = false;
    /**
     * @type {boolean}
     * @private
     */
    this._excludeInActive = false;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isSmartLink = false;

  }

    /**
   * @return {boolean}
   */
  isCheckBothLinkAndCopy() {
    return this._checkBothLinkAndCopy;
  }

  /**
   * @param checkBothLinkAndCopy{boolean}
   * @return {ForkInfoQueryMsg}
   */
  setCheckBothLinkAndCopy(checkBothLinkAndCopy) {
    this._checkBothLinkAndCopy = checkBothLinkAndCopy;
    return this;
  }
  /**
   * @return {boolean}
   */
  isExcludeInActive() {
    return this._excludeInActive;
  }

  /**
   * @param excludeInActive{boolean}
   * @return {ForkInfoQueryMsg}
   */
  setExcludeInActive(excludeInActive) {
    this._excludeInActive = excludeInActive;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {ForkInfoQueryMsg}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsSmartLink() {
    return this._isSmartLink;
  }

  /**
   * @param isSmartLink{boolean}
   * @return {ForkInfoQueryMsg}
   */
  setIsSmartLink(isSmartLink) {
    this._isSmartLink = isSmartLink;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ForkInfoQueryMsg.CLASS_ID;
    
	//Serializing _checkBothLinkAndCopy
	if (this._checkBothLinkAndCopy)
		json['checkBothLinkAndCopy'] = this._checkBothLinkAndCopy;

	//Serializing _excludeInActive
	if (this._excludeInActive)
		json['excludeInActive'] = this._excludeInActive;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _isSmartLink
	if (this._isSmartLink)
		json['isSmartLink'] = this._isSmartLink;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._checkBothLinkAndCopy = json.hasOwnProperty("checkBothLinkAndCopy")?json["checkBothLinkAndCopy"]:false;
		this._excludeInActive = json.hasOwnProperty("excludeInActive")?json["excludeInActive"]:false;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._isSmartLink = json.hasOwnProperty("isSmartLink")?json["isSmartLink"]:false;


  }
}

/**
 * @returns {string}
 */
ForkInfoQueryMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ForkInfoQueryMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class GetActivityQuery extends HttpOperation {

  constructor(name = "GetActivity") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetActivityMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetActivityMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetActivityResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetActivityQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetActivityQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetActivityResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetActivityResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetActivityQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivity";
/**
 * @returns {string}
 */
GetActivityQuery.QUERY_NAME = "GetActivity";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FilePathAndStatus {

  constructor() {
    
        /**
     * @type {number}
     * @private
     */
    this._fileStatus = null;
    /**
     * @type {string}
     * @private
     */
    this._filePath = null;

  }

    /**
   * @return {number}
   */
  getFileStatus() {
    return this._fileStatus;
  }

  /**
   * @param fileStatus{number}
   * @return {FilePathAndStatus}
   */
  setFileStatus(fileStatus) {
    this._fileStatus = fileStatus;
    return this;
  }
  /**
   * @return {string}
   */
  getFilePath() {
    return this._filePath;
  }

  /**
   * @param filePath{string}
   * @return {FilePathAndStatus}
   */
  setFilePath(filePath) {
    this._filePath = filePath;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FilePathAndStatus.CLASS_ID;
    
	//Serializing _fileStatus
	if (this._fileStatus)
		json['fileStatus'] = this._fileStatus;

	//Serializing _filePath
	if (this._filePath)
		json['filePath'] = this._filePath;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._fileStatus = json.hasOwnProperty("fileStatus")?json["fileStatus"]:0;
		this._filePath = json.hasOwnProperty("filePath")?json["filePath"]:null;


  }
}

/**
 * @returns {string}
 */
FilePathAndStatus.CLASS_ID = "com.zoom.vab.client.autogenerated.FilePathAndStatus";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexUnLockQuery extends HttpOperation {

  constructor(name = "FlexUnLock") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexUnLockCommandArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexUnLockCommandArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexUnlockResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexUnLockQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexUnLockQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexUnlockResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexUnlockResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexUnLockQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexUnLock";
/**
 * @returns {string}
 */
FlexUnLockQuery.QUERY_NAME = "FlexUnLock";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ServerRepoId {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._repoId = null;
    /**
     * @type {string}
     * @private
     */
    this._server = null;
    /**
     * @type {boolean}
     * @private
     */
    this._enableDecluttering = false;

  }

    /**
   * @return {string}
   */
  getRepoId() {
    return this._repoId;
  }

  /**
   * @param repoId{string}
   * @return {ServerRepoId}
   */
  setRepoId(repoId) {
    this._repoId = repoId;
    return this;
  }
  /**
   * @return {string}
   */
  getServer() {
    return this._server;
  }

  /**
   * @param server{string}
   * @return {ServerRepoId}
   */
  setServer(server) {
    this._server = server;
    return this;
  }
  /**
   * @return {boolean}
   */
  isEnableDecluttering() {
    return this._enableDecluttering;
  }

  /**
   * @param enableDecluttering{boolean}
   * @return {ServerRepoId}
   */
  setEnableDecluttering(enableDecluttering) {
    this._enableDecluttering = enableDecluttering;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ServerRepoId.CLASS_ID;
    
	//Serializing _repoId
	if (this._repoId)
		json['repoId'] = this._repoId;

	//Serializing _server
	if (this._server)
		json['server'] = this._server;

	//Serializing _enableDecluttering
	if (this._enableDecluttering)
		json['enableDecluttering'] = this._enableDecluttering;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._repoId = json.hasOwnProperty("repoId")?json["repoId"]:null;
		this._server = json.hasOwnProperty("server")?json["server"]:null;
		this._enableDecluttering = json.hasOwnProperty("enableDecluttering")?json["enableDecluttering"]:false;


  }
}

/**
 * @returns {string}
 */
ServerRepoId.CLASS_ID = "com.zoom.vab.client.autogenerated.ServerRepoId";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexPurgeCommandArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._logMsg = null;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyDelete = false;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._infiles = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._infuids = null;

  }

    /**
   * @return {string}
   */
  getLogMsg() {
    return this._logMsg;
  }

  /**
   * @param logMsg{string}
   * @return {FlexPurgeCommandArgs}
   */
  setLogMsg(logMsg) {
    this._logMsg = logMsg;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyDelete() {
    return this._onlyDelete;
  }

  /**
   * @param onlyDelete{boolean}
   * @return {FlexPurgeCommandArgs}
   */
  setOnlyDelete(onlyDelete) {
    this._onlyDelete = onlyDelete;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexPurgeCommandArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getInfiles() {
    return this._infiles;
  }

  /**
   * @param infiles{Array<String>}
   * @return {FlexPurgeCommandArgs}
   */
  setInfiles(infiles) {
    this._infiles = infiles;
    return this;
  }

  /**
   * @return {Array<Integer>}
   */
  getInfuids() {
    return this._infuids;
  }

  /**
   * @param infuids{Array<Integer>}
   * @return {FlexPurgeCommandArgs}
   */
  setInfuids(infuids) {
    this._infuids = infuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexPurgeCommandArgs.CLASS_ID;
    
	//Serializing _logMsg
	if (this._logMsg)
		json['logMsg'] = this._logMsg;

	//Serializing _onlyDelete
	if (this._onlyDelete)
		json['onlyDelete'] = this._onlyDelete;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;
  if (this._infiles && this._infiles.length > 0) {
    let infiles_JSON = [];
    /**
     * @type {string}
     */
    this._infiles.forEach((o235) => {
      if (o235) {
        if (o235.serializeJson && (typeof (o235.serializeJson) === 'function')) {
          infiles_JSON.push(o235.serializeJson());
        } else {
          infiles_JSON.push(o235);
        }
      }
    });
    json['infiles'] = infiles_JSON;
  }  
  if (this._infuids && this._infuids.length > 0) {
    let infuids_JSON = [];
    /**
     * @type {int}
     */
    this._infuids.forEach((o238) => {
      if (o238) {
        if (o238.serializeJson && (typeof (o238.serializeJson) === 'function')) {
          infuids_JSON.push(o238.serializeJson());
        } else {
          infuids_JSON.push(o238);
        }
      }
    });
    json['infuids'] = infuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._logMsg = json.hasOwnProperty("logMsg")?json["logMsg"]:null;
		this._onlyDelete = json.hasOwnProperty("onlyDelete")?json["onlyDelete"]:false;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		//set of type string
		this._infiles = [];
		let infilesJSONArray = json.hasOwnProperty("infiles") ? json["infiles"] : [];

		infilesJSONArray.forEach((o236)=>{
			if (o236){
				this._infiles.push(o236);
			}
		});
		//set of type int
		this._infuids = [];
		let infuidsJSONArray = json.hasOwnProperty("infuids") ? json["infuids"] : [];

		infuidsJSONArray.forEach((o239)=>{
			if (o239){
				this._infuids.push(o239);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexPurgeCommandArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexPurgeCommandArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class VABLogoutResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {Array<String>}
     * @private
     */
    this._globalLogoutURLs = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {VABLogoutResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getGlobalLogoutURLs() {
    return this._globalLogoutURLs;
  }

  /**
   * @param globalLogoutURLs{Array<String>}
   * @return {VABLogoutResponse}
   */
  setGlobalLogoutURLs(globalLogoutURLs) {
    this._globalLogoutURLs = globalLogoutURLs;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = VABLogoutResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;
  if (this._globalLogoutURLs && this._globalLogoutURLs.length > 0) {
    let globalLogoutURLs_JSON = [];
    /**
     * @type {string}
     */
    this._globalLogoutURLs.forEach((o4) => {
      if (o4) {
        if (o4.serializeJson && (typeof (o4.serializeJson) === 'function')) {
          globalLogoutURLs_JSON.push(o4.serializeJson());
        } else {
          globalLogoutURLs_JSON.push(o4);
        }
      }
    });
    json['globalLogoutURLs'] = globalLogoutURLs_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		//set of type string
		this._globalLogoutURLs = [];
		let globalLogoutURLsJSONArray = json.hasOwnProperty("globalLogoutURLs") ? json["globalLogoutURLs"] : [];

		globalLogoutURLsJSONArray.forEach((o5)=>{
			if (o5){
				this._globalLogoutURLs.push(o5);
			}
		});


  }
}

/**
 * @returns {string}
 */
VABLogoutResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.VABLogoutResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class OAuthLoginResp {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._isRunning = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {number}
     * @private
     */
    this._progress = null;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {string}
     * @private
     */
    this._url = null;
    /**
     * @type {string}
     * @private
     */
    this._progressMessage = null;
    /**
     * @type {ZoomServerSpec}
     * @private
     */
    this._zoomServerSpec = null;

  }

    /**
   * @return {boolean}
   */
  isIsRunning() {
    return this._isRunning;
  }

  /**
   * @param isRunning{boolean}
   * @return {OAuthLoginResp}
   */
  setIsRunning(isRunning) {
    this._isRunning = isRunning;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {OAuthLoginResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {number}
   */
  getProgress() {
    return this._progress;
  }

  /**
   * @param progress{number}
   * @return {OAuthLoginResp}
   */
  setProgress(progress) {
    this._progress = progress;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {OAuthLoginResp}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {string}
   */
  getUrl() {
    return this._url;
  }

  /**
   * @param url{string}
   * @return {OAuthLoginResp}
   */
  setUrl(url) {
    this._url = url;
    return this;
  }
  /**
   * @return {string}
   */
  getProgressMessage() {
    return this._progressMessage;
  }

  /**
   * @param progressMessage{string}
   * @return {OAuthLoginResp}
   */
  setProgressMessage(progressMessage) {
    this._progressMessage = progressMessage;
    return this;
  }
  /**
   * @return {ZoomServerSpec}
   */
  getZoomServerSpec() {
    return this._zoomServerSpec;
  }

  /**
   * @param zoomServerSpec{ZoomServerSpec}
   * @return {OAuthLoginResp}
   */
  setZoomServerSpec(zoomServerSpec) {
    this._zoomServerSpec = zoomServerSpec;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = OAuthLoginResp.CLASS_ID;
    
	//Serializing _isRunning
	if (this._isRunning)
		json['isRunning'] = this._isRunning;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _progress
	if (this._progress)
		json['progress'] = this._progress;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;

	//Serializing _url
	if (this._url)
		json['url'] = this._url;

	//Serializing _progressMessage
	if (this._progressMessage)
		json['progressMessage'] = this._progressMessage;

	//Serializing ComplexType _$arrayName
	if (this._zoomServerSpec)
		json['zoomServerSpec'] = this._zoomServerSpec.serializeJson();
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._isRunning = json.hasOwnProperty("isRunning")?json["isRunning"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._progress = json.hasOwnProperty("progress")?json["progress"]:0;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		this._url = json.hasOwnProperty("url")?json["url"]:null;
		this._progressMessage = json.hasOwnProperty("progressMessage")?json["progressMessage"]:null;
		if (json.hasOwnProperty("zoomServerSpec")){
			if (!this._zoomServerSpec && this._zoomServerSpec == null)
				this._zoomServerSpec = new ZoomServerSpec();
			this._zoomServerSpec.deserializeJson(json.hasOwnProperty("zoomServerSpec") ? json["zoomServerSpec"] : null);
		}



  }
}

/**
 * @returns {string}
 */
OAuthLoginResp.CLASS_ID = "com.zoom.vab.client.autogenerated.OAuthLoginResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexRemoteRenameQuery extends HttpOperation {

  constructor(name = "FlexRemoteRename") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexRemoteRenameArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexRemoteRenameArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexRemoteRenameResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexRemoteRenameQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexRemoteRenameQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexRemoteRenameResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexRemoteRenameResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexRemoteRenameQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteRename";
/**
 * @returns {string}
 */
FlexRemoteRenameQuery.QUERY_NAME = "FlexRemoteRename";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ZoomServerSpec {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._webminRealm = null;
    /**
     * @type {string}
     * @private
     */
    this._hostName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._skipMDBasedIngestPathEnabled = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isExternalUser = false;
    /**
     * @type {string}
     * @private
     */
    this._serverRealm = null;
    /**
     * @type {string}
     * @private
     */
    this._zmServerAlias = null;
    /**
     * @type {string}
     * @private
     */
    this._companyName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isHadrEnabled = false;
    /**
     * @type {string}
     * @private
     */
    this._autoCOPathList = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isSuperAdmin = false;
    /**
     * @type {string}
     * @private
     */
    this._zmCookie = null;
    /**
     * @type {string}
     * @private
     */
    this._workstationProp = null;
    /**
     * @type {string}
     * @private
     */
    this._zmDisplayName = null;
    /**
     * @type {string}
     * @private
     */
    this._zmUserName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._vlxEnabled = false;
    /**
     * @type {boolean}
     * @private
     */
    this._sslWebmin = false;
    /**
     * @type {string}
     * @private
     */
    this._defaultCheckoutPath = null;
    /**
     * @type {string}
     * @private
     */
    this._webminSslServer = null;
    /**
     * @type {string}
     * @private
     */
    this._huid = null;
    /**
     * @type {string}
     * @private
     */
    this._storageTypes = null;
    /**
     * @type {string}
     * @private
     */
    this._zmEmail = null;
    /**
     * @type {string}
     * @private
     */
    this._webminServer = null;
    /**
     * @type {boolean}
     * @private
     */
    this._showOnlyCollection = false;
    /**
     * @type {string}
     * @private
     */
    this._companyTagLine = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isAutoCOEnabled = false;
    /**
     * @type {string}
     * @private
     */
    this._repoId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._uploadOnPreviewServer = false;
    /**
     * @type {boolean}
     * @private
     */
    this._vantageEnabled = false;
    /**
     * @type {boolean}
     * @private
     */
    this._imgSeqEnabled = false;
    /**
     * @type {string}
     * @private
     */
    this._mdBasedPathProp = null;
    /**
     * @type {number}
     * @private
     */
    this._zmCookieMaxAge = null;
    /**
     * @type {string}
     * @private
     */
    this._zmPassword = null;
    /**
     * @type {boolean}
     * @private
     */
    this._vfxEnabled = false;
    /**
     * @type {string}
     * @private
     */
    this._zmServer = null;
    /**
     * @type {string}
     * @private
     */
    this._sessionId = null;
    /**
     * @type {number}
     * @private
     */
    this._zmCookieServerTime = null;
    /**
     * @type {boolean}
     * @private
     */
    this._skipMDBasedIngestPathVal = false;
    /**
     * @type {string}
     * @private
     */
    this._version = null;
    /**
     * @type {string}
     * @private
     */
    this._projectsList = null;
    /**
     * @type {string}
     * @private
     */
    this._rolesList = null;
    /**
     * @type {string}
     * @private
     */
    this._externalUserId = null;
    /**
     * @type {boolean}
     * @private
     */
    this._mandatoryMDEnabled = false;
    /**
     * @type {boolean}
     * @private
     */
    this._sslRv = false;
    /**
     * @type {string}
     * @private
     */
    this._location = null;
    /**
     * @type {boolean}
     * @private
     */
    this._userHasAdminPerm = false;
    /**
     * @type {ServerPermissionsData}
     * @private
     */
    this._serverPermissionsData = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._reviewServerHostPortList = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._reviewServerHostPortSSLList = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._extraProps = null;

  }

    /**
   * @return {string}
   */
  getWebminRealm() {
    return this._webminRealm;
  }

  /**
   * @param webminRealm{string}
   * @return {ZoomServerSpec}
   */
  setWebminRealm(webminRealm) {
    this._webminRealm = webminRealm;
    return this;
  }
  /**
   * Fetches the host name of client machine. If not present then will fetch the IP
   * @return {string}
   */
  getHostName() {
    return this._hostName;
  }

  /**
   * @param hostName{string}
   * @return {ZoomServerSpec}
   */
  setHostName(hostName) {
    this._hostName = hostName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSkipMDBasedIngestPathEnabled() {
    return this._skipMDBasedIngestPathEnabled;
  }

  /**
   * @param skipMDBasedIngestPathEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setSkipMDBasedIngestPathEnabled(skipMDBasedIngestPathEnabled) {
    this._skipMDBasedIngestPathEnabled = skipMDBasedIngestPathEnabled;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsExternalUser() {
    return this._isExternalUser;
  }

  /**
   * @param isExternalUser{boolean}
   * @return {ZoomServerSpec}
   */
  setIsExternalUser(isExternalUser) {
    this._isExternalUser = isExternalUser;
    return this;
  }
  /**
   * @return {string}
   */
  getServerRealm() {
    return this._serverRealm;
  }

  /**
   * @param serverRealm{string}
   * @return {ZoomServerSpec}
   */
  setServerRealm(serverRealm) {
    this._serverRealm = serverRealm;
    return this;
  }
  /**
   * @return {string}
   */
  getZmServerAlias() {
    return this._zmServerAlias;
  }

  /**
   * @param zmServerAlias{string}
   * @return {ZoomServerSpec}
   */
  setZmServerAlias(zmServerAlias) {
    this._zmServerAlias = zmServerAlias;
    return this;
  }
  /**
   * @return {string}
   */
  getCompanyName() {
    return this._companyName;
  }

  /**
   * @param companyName{string}
   * @return {ZoomServerSpec}
   */
  setCompanyName(companyName) {
    this._companyName = companyName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsHadrEnabled() {
    return this._isHadrEnabled;
  }

  /**
   * @param isHadrEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setIsHadrEnabled(isHadrEnabled) {
    this._isHadrEnabled = isHadrEnabled;
    return this;
  }
  /**
   * auto checkout remote paths (comma separated) for which auto checkout is enabled.
   * @return {string}
   */
  getAutoCOPathList() {
    return this._autoCOPathList;
  }

  /**
   * @param autoCOPathList{string}
   * @return {ZoomServerSpec}
   */
  setAutoCOPathList(autoCOPathList) {
    this._autoCOPathList = autoCOPathList;
    return this;
  }
  /**
   * user is superadmin or not
   * @return {boolean}
   */
  isIsSuperAdmin() {
    return this._isSuperAdmin;
  }

  /**
   * @param isSuperAdmin{boolean}
   * @return {ZoomServerSpec}
   */
  setIsSuperAdmin(isSuperAdmin) {
    this._isSuperAdmin = isSuperAdmin;
    return this;
  }
  /**
   * @return {string}
   */
  getZmCookie() {
    return this._zmCookie;
  }

  /**
   * @param zmCookie{string}
   * @return {ZoomServerSpec}
   */
  setZmCookie(zmCookie) {
    this._zmCookie = zmCookie;
    return this;
  }
  /**
   * Workstation prop name specified in zoom properties
   * @return {string}
   */
  getWorkstationProp() {
    return this._workstationProp;
  }

  /**
   * @param workstationProp{string}
   * @return {ZoomServerSpec}
   */
  setWorkstationProp(workstationProp) {
    this._workstationProp = workstationProp;
    return this;
  }
  /**
   * @return {string}
   */
  getZmDisplayName() {
    return this._zmDisplayName;
  }

  /**
   * @param zmDisplayName{string}
   * @return {ZoomServerSpec}
   */
  setZmDisplayName(zmDisplayName) {
    this._zmDisplayName = zmDisplayName;
    return this;
  }
  /**
   * @return {string}
   */
  getZmUserName() {
    return this._zmUserName;
  }

  /**
   * @param zmUserName{string}
   * @return {ZoomServerSpec}
   */
  setZmUserName(zmUserName) {
    this._zmUserName = zmUserName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isVlxEnabled() {
    return this._vlxEnabled;
  }

  /**
   * @param vlxEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setVlxEnabled(vlxEnabled) {
    this._vlxEnabled = vlxEnabled;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSslWebmin() {
    return this._sslWebmin;
  }

  /**
   * @param sslWebmin{boolean}
   * @return {ZoomServerSpec}
   */
  setSslWebmin(sslWebmin) {
    this._sslWebmin = sslWebmin;
    return this;
  }
  /**
   * @return {string}
   */
  getDefaultCheckoutPath() {
    return this._defaultCheckoutPath;
  }

  /**
   * @param defaultCheckoutPath{string}
   * @return {ZoomServerSpec}
   */
  setDefaultCheckoutPath(defaultCheckoutPath) {
    this._defaultCheckoutPath = defaultCheckoutPath;
    return this;
  }
  /**
   * @return {string}
   */
  getWebminSslServer() {
    return this._webminSslServer;
  }

  /**
   * @param webminSslServer{string}
   * @return {ZoomServerSpec}
   */
  setWebminSslServer(webminSslServer) {
    this._webminSslServer = webminSslServer;
    return this;
  }
  /**
   * Hub unique identifier
   * @return {string}
   */
  getHuid() {
    return this._huid;
  }

  /**
   * @param huid{string}
   * @return {ZoomServerSpec}
   */
  setHuid(huid) {
    this._huid = huid;
    return this;
  }
  /**
   * @return {string}
   */
  getStorageTypes() {
    return this._storageTypes;
  }

  /**
   * @param storageTypes{string}
   * @return {ZoomServerSpec}
   */
  setStorageTypes(storageTypes) {
    this._storageTypes = storageTypes;
    return this;
  }
  /**
   * @return {string}
   */
  getZmEmail() {
    return this._zmEmail;
  }

  /**
   * @param zmEmail{string}
   * @return {ZoomServerSpec}
   */
  setZmEmail(zmEmail) {
    this._zmEmail = zmEmail;
    return this;
  }
  /**
   * @return {string}
   */
  getWebminServer() {
    return this._webminServer;
  }

  /**
   * @param webminServer{string}
   * @return {ZoomServerSpec}
   */
  setWebminServer(webminServer) {
    this._webminServer = webminServer;
    return this;
  }
  /**
   * @return {boolean}
   */
  isShowOnlyCollection() {
    return this._showOnlyCollection;
  }

  /**
   * @param showOnlyCollection{boolean}
   * @return {ZoomServerSpec}
   */
  setShowOnlyCollection(showOnlyCollection) {
    this._showOnlyCollection = showOnlyCollection;
    return this;
  }
  /**
   * @return {string}
   */
  getCompanyTagLine() {
    return this._companyTagLine;
  }

  /**
   * @param companyTagLine{string}
   * @return {ZoomServerSpec}
   */
  setCompanyTagLine(companyTagLine) {
    this._companyTagLine = companyTagLine;
    return this;
  }
  /**
   * boolean tag to check if auto checkout is enabled.
   * @return {boolean}
   */
  isIsAutoCOEnabled() {
    return this._isAutoCOEnabled;
  }

  /**
   * @param isAutoCOEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setIsAutoCOEnabled(isAutoCOEnabled) {
    this._isAutoCOEnabled = isAutoCOEnabled;
    return this;
  }
  /**
   * @return {string}
   */
  getRepoId() {
    return this._repoId;
  }

  /**
   * @param repoId{string}
   * @return {ZoomServerSpec}
   */
  setRepoId(repoId) {
    this._repoId = repoId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUploadOnPreviewServer() {
    return this._uploadOnPreviewServer;
  }

  /**
   * @param uploadOnPreviewServer{boolean}
   * @return {ZoomServerSpec}
   */
  setUploadOnPreviewServer(uploadOnPreviewServer) {
    this._uploadOnPreviewServer = uploadOnPreviewServer;
    return this;
  }
  /**
   * @return {boolean}
   */
  isVantageEnabled() {
    return this._vantageEnabled;
  }

  /**
   * @param vantageEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setVantageEnabled(vantageEnabled) {
    this._vantageEnabled = vantageEnabled;
    return this;
  }
  /**
   * @return {boolean}
   */
  isImgSeqEnabled() {
    return this._imgSeqEnabled;
  }

  /**
   * @param imgSeqEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setImgSeqEnabled(imgSeqEnabled) {
    this._imgSeqEnabled = imgSeqEnabled;
    return this;
  }
  /**
   * @return {string}
   */
  getMdBasedPathProp() {
    return this._mdBasedPathProp;
  }

  /**
   * @param mdBasedPathProp{string}
   * @return {ZoomServerSpec}
   */
  setMdBasedPathProp(mdBasedPathProp) {
    this._mdBasedPathProp = mdBasedPathProp;
    return this;
  }
  /**
   * @return {number}
   */
  getZmCookieMaxAge() {
    return this._zmCookieMaxAge;
  }

  /**
   * @param zmCookieMaxAge{number}
   * @return {ZoomServerSpec}
   */
  setZmCookieMaxAge(zmCookieMaxAge) {
    this._zmCookieMaxAge = zmCookieMaxAge;
    return this;
  }
  /**
   * @return {string}
   */
  getZmPassword() {
    return this._zmPassword;
  }

  /**
   * @param zmPassword{string}
   * @return {ZoomServerSpec}
   */
  setZmPassword(zmPassword) {
    this._zmPassword = zmPassword;
    return this;
  }
  /**
   * @return {boolean}
   */
  isVfxEnabled() {
    return this._vfxEnabled;
  }

  /**
   * @param vfxEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setVfxEnabled(vfxEnabled) {
    this._vfxEnabled = vfxEnabled;
    return this;
  }
  /**
   * @return {string}
   */
  getZmServer() {
    return this._zmServer;
  }

  /**
   * @param zmServer{string}
   * @return {ZoomServerSpec}
   */
  setZmServer(zmServer) {
    this._zmServer = zmServer;
    return this;
  }
  /**
   * @return {string}
   */
  getSessionId() {
    return this._sessionId;
  }

  /**
   * @param sessionId{string}
   * @return {ZoomServerSpec}
   */
  setSessionId(sessionId) {
    this._sessionId = sessionId;
    return this;
  }
  /**
   * @return {number}
   */
  getZmCookieServerTime() {
    return this._zmCookieServerTime;
  }

  /**
   * @param zmCookieServerTime{number}
   * @return {ZoomServerSpec}
   */
  setZmCookieServerTime(zmCookieServerTime) {
    this._zmCookieServerTime = zmCookieServerTime;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSkipMDBasedIngestPathVal() {
    return this._skipMDBasedIngestPathVal;
  }

  /**
   * @param skipMDBasedIngestPathVal{boolean}
   * @return {ZoomServerSpec}
   */
  setSkipMDBasedIngestPathVal(skipMDBasedIngestPathVal) {
    this._skipMDBasedIngestPathVal = skipMDBasedIngestPathVal;
    return this;
  }
  /**
   * @return {string}
   */
  getVersion() {
    return this._version;
  }

  /**
   * @param version{string}
   * @return {ZoomServerSpec}
   */
  setVersion(version) {
    this._version = version;
    return this;
  }
  /**
   * @return {string}
   */
  getProjectsList() {
    return this._projectsList;
  }

  /**
   * @param projectsList{string}
   * @return {ZoomServerSpec}
   */
  setProjectsList(projectsList) {
    this._projectsList = projectsList;
    return this;
  }
  /**
   * @return {string}
   */
  getRolesList() {
    return this._rolesList;
  }

  /**
   * @param rolesList{string}
   * @return {ZoomServerSpec}
   */
  setRolesList(rolesList) {
    this._rolesList = rolesList;
    return this;
  }
  /**
   * @return {string}
   */
  getExternalUserId() {
    return this._externalUserId;
  }

  /**
   * @param externalUserId{string}
   * @return {ZoomServerSpec}
   */
  setExternalUserId(externalUserId) {
    this._externalUserId = externalUserId;
    return this;
  }
  /**
   * @return {boolean}
   */
  isMandatoryMDEnabled() {
    return this._mandatoryMDEnabled;
  }

  /**
   * @param mandatoryMDEnabled{boolean}
   * @return {ZoomServerSpec}
   */
  setMandatoryMDEnabled(mandatoryMDEnabled) {
    this._mandatoryMDEnabled = mandatoryMDEnabled;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSslRv() {
    return this._sslRv;
  }

  /**
   * @param sslRv{boolean}
   * @return {ZoomServerSpec}
   */
  setSslRv(sslRv) {
    this._sslRv = sslRv;
    return this;
  }
  /**
   * @return {string}
   */
  getLocation() {
    return this._location;
  }

  /**
   * @param location{string}
   * @return {ZoomServerSpec}
   */
  setLocation(location) {
    this._location = location;
    return this;
  }
  /**
   * @return {boolean}
   */
  isUserHasAdminPerm() {
    return this._userHasAdminPerm;
  }

  /**
   * @param userHasAdminPerm{boolean}
   * @return {ZoomServerSpec}
   */
  setUserHasAdminPerm(userHasAdminPerm) {
    this._userHasAdminPerm = userHasAdminPerm;
    return this;
  }
  /**
   * @return {ServerPermissionsData}
   */
  getServerPermissionsData() {
    return this._serverPermissionsData;
  }

  /**
   * @param serverPermissionsData{ServerPermissionsData}
   * @return {ZoomServerSpec}
   */
  setServerPermissionsData(serverPermissionsData) {
    this._serverPermissionsData = serverPermissionsData;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getReviewServerHostPortList() {
    return this._reviewServerHostPortList;
  }

  /**
   * @param reviewServerHostPortList{Array<String>}
   * @return {ZoomServerSpec}
   */
  setReviewServerHostPortList(reviewServerHostPortList) {
    this._reviewServerHostPortList = reviewServerHostPortList;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getReviewServerHostPortSSLList() {
    return this._reviewServerHostPortSSLList;
  }

  /**
   * @param reviewServerHostPortSSLList{Array<String>}
   * @return {ZoomServerSpec}
   */
  setReviewServerHostPortSSLList(reviewServerHostPortSSLList) {
    this._reviewServerHostPortSSLList = reviewServerHostPortSSLList;
    return this;
  }

  /**
   * @return {java.util.Map<String,String>}
   */
  getExtraProps() {
    return this._extraProps;
  }

  /**
   * @param extraProps{java.util.Map<String,String>}
   * @return {ZoomServerSpec}
   */
  setExtraProps(extraProps) {
    this._extraProps = extraProps;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ZoomServerSpec.CLASS_ID;
    
	//Serializing _webminRealm
	if (this._webminRealm)
		json['webminRealm'] = this._webminRealm;

	//Serializing _hostName
	if (this._hostName)
		json['hostName'] = this._hostName;

	//Serializing _skipMDBasedIngestPathEnabled
	if (this._skipMDBasedIngestPathEnabled)
		json['skipMDBasedIngestPathEnabled'] = this._skipMDBasedIngestPathEnabled;

	//Serializing _isExternalUser
	if (this._isExternalUser)
		json['isExternalUser'] = this._isExternalUser;

	//Serializing _serverRealm
	if (this._serverRealm)
		json['serverRealm'] = this._serverRealm;

	//Serializing _zmServerAlias
	if (this._zmServerAlias)
		json['zmServerAlias'] = this._zmServerAlias;

	//Serializing _companyName
	if (this._companyName)
		json['companyName'] = this._companyName;

	//Serializing _isHadrEnabled
	if (this._isHadrEnabled)
		json['isHadrEnabled'] = this._isHadrEnabled;

	//Serializing _autoCOPathList
	if (this._autoCOPathList)
		json['autoCOPathList'] = this._autoCOPathList;

	//Serializing _isSuperAdmin
	if (this._isSuperAdmin)
		json['isSuperAdmin'] = this._isSuperAdmin;

	//Serializing _zmCookie
	if (this._zmCookie)
		json['zmCookie'] = this._zmCookie;

	//Serializing _workstationProp
	if (this._workstationProp)
		json['workstationProp'] = this._workstationProp;

	//Serializing _zmDisplayName
	if (this._zmDisplayName)
		json['zmDisplayName'] = this._zmDisplayName;

	//Serializing _zmUserName
	if (this._zmUserName)
		json['zmUserName'] = this._zmUserName;

	//Serializing _vlxEnabled
	if (this._vlxEnabled)
		json['vlxEnabled'] = this._vlxEnabled;

	//Serializing _sslWebmin
	if (this._sslWebmin)
		json['sslWebmin'] = this._sslWebmin;

	//Serializing _defaultCheckoutPath
	if (this._defaultCheckoutPath)
		json['defaultCheckoutPath'] = this._defaultCheckoutPath;

	//Serializing _webminSslServer
	if (this._webminSslServer)
		json['webminSslServer'] = this._webminSslServer;

	//Serializing _huid
	if (this._huid)
		json['huid'] = this._huid;

	//Serializing _storageTypes
	if (this._storageTypes)
		json['storageTypes'] = this._storageTypes;

	//Serializing _zmEmail
	if (this._zmEmail)
		json['zmEmail'] = this._zmEmail;

	//Serializing _webminServer
	if (this._webminServer)
		json['webminServer'] = this._webminServer;

	//Serializing _showOnlyCollection
	if (this._showOnlyCollection)
		json['showOnlyCollection'] = this._showOnlyCollection;

	//Serializing _companyTagLine
	if (this._companyTagLine)
		json['companyTagLine'] = this._companyTagLine;

	//Serializing _isAutoCOEnabled
	if (this._isAutoCOEnabled)
		json['isAutoCOEnabled'] = this._isAutoCOEnabled;

	//Serializing _repoId
	if (this._repoId)
		json['repoId'] = this._repoId;

	//Serializing _uploadOnPreviewServer
	if (this._uploadOnPreviewServer)
		json['uploadOnPreviewServer'] = this._uploadOnPreviewServer;

	//Serializing _vantageEnabled
	if (this._vantageEnabled)
		json['vantageEnabled'] = this._vantageEnabled;

	//Serializing _imgSeqEnabled
	if (this._imgSeqEnabled)
		json['imgSeqEnabled'] = this._imgSeqEnabled;

	//Serializing _mdBasedPathProp
	if (this._mdBasedPathProp)
		json['mdBasedPathProp'] = this._mdBasedPathProp;

	//Serializing _zmCookieMaxAge
	if (this._zmCookieMaxAge)
		json['zmCookieMaxAge'] = this._zmCookieMaxAge;

	//Serializing _zmPassword
	if (this._zmPassword)
		json['zmPassword'] = this._zmPassword;

	//Serializing _vfxEnabled
	if (this._vfxEnabled)
		json['vfxEnabled'] = this._vfxEnabled;

	//Serializing _zmServer
	if (this._zmServer)
		json['zmServer'] = this._zmServer;

	//Serializing _sessionId
	if (this._sessionId)
		json['sessionId'] = this._sessionId;

	//Serializing _zmCookieServerTime
	if (this._zmCookieServerTime)
		json['zmCookieServerTime'] = this._zmCookieServerTime;

	//Serializing _skipMDBasedIngestPathVal
	if (this._skipMDBasedIngestPathVal)
		json['skipMDBasedIngestPathVal'] = this._skipMDBasedIngestPathVal;

	//Serializing _version
	if (this._version)
		json['version'] = this._version;

	//Serializing _projectsList
	if (this._projectsList)
		json['projectsList'] = this._projectsList;

	//Serializing _rolesList
	if (this._rolesList)
		json['rolesList'] = this._rolesList;

	//Serializing _externalUserId
	if (this._externalUserId)
		json['externalUserId'] = this._externalUserId;

	//Serializing _mandatoryMDEnabled
	if (this._mandatoryMDEnabled)
		json['mandatoryMDEnabled'] = this._mandatoryMDEnabled;

	//Serializing _sslRv
	if (this._sslRv)
		json['sslRv'] = this._sslRv;

	//Serializing _location
	if (this._location)
		json['location'] = this._location;

	//Serializing _userHasAdminPerm
	if (this._userHasAdminPerm)
		json['userHasAdminPerm'] = this._userHasAdminPerm;

	//Serializing ComplexType _$arrayName
	if (this._serverPermissionsData)
		json['serverPermissionsData'] = this._serverPermissionsData.serializeJson();
		  if (this._reviewServerHostPortList && this._reviewServerHostPortList.length > 0) {
    let reviewServerHostPortList_JSON = [];
    /**
     * @type {string}
     */
    this._reviewServerHostPortList.forEach((o177) => {
      if (o177) {
        if (o177.serializeJson && (typeof (o177.serializeJson) === 'function')) {
          reviewServerHostPortList_JSON.push(o177.serializeJson());
        } else {
          reviewServerHostPortList_JSON.push(o177);
        }
      }
    });
    json['reviewServerHostPortList'] = reviewServerHostPortList_JSON;
  }  
  if (this._reviewServerHostPortSSLList && this._reviewServerHostPortSSLList.length > 0) {
    let reviewServerHostPortSSLList_JSON = [];
    /**
     * @type {string}
     */
    this._reviewServerHostPortSSLList.forEach((o180) => {
      if (o180) {
        if (o180.serializeJson && (typeof (o180.serializeJson) === 'function')) {
          reviewServerHostPortSSLList_JSON.push(o180.serializeJson());
        } else {
          reviewServerHostPortSSLList_JSON.push(o180);
        }
      }
    });
    json['reviewServerHostPortSSLList'] = reviewServerHostPortSSLList_JSON;
  }  
    SerializationUtil.serializeHashMap(json,"extraProps", this._extraProps);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._webminRealm = json.hasOwnProperty("webminRealm")?json["webminRealm"]:null;
		this._hostName = json.hasOwnProperty("hostName")?json["hostName"]:null;
		this._skipMDBasedIngestPathEnabled = json.hasOwnProperty("skipMDBasedIngestPathEnabled")?json["skipMDBasedIngestPathEnabled"]:false;
		this._isExternalUser = json.hasOwnProperty("isExternalUser")?json["isExternalUser"]:false;
		this._serverRealm = json.hasOwnProperty("serverRealm")?json["serverRealm"]:null;
		this._zmServerAlias = json.hasOwnProperty("zmServerAlias")?json["zmServerAlias"]:null;
		this._companyName = json.hasOwnProperty("companyName")?json["companyName"]:null;
		this._isHadrEnabled = json.hasOwnProperty("isHadrEnabled")?json["isHadrEnabled"]:false;
		this._autoCOPathList = json.hasOwnProperty("autoCOPathList")?json["autoCOPathList"]:null;
		this._isSuperAdmin = json.hasOwnProperty("isSuperAdmin")?json["isSuperAdmin"]:false;
		this._zmCookie = json.hasOwnProperty("zmCookie")?json["zmCookie"]:null;
		this._workstationProp = json.hasOwnProperty("workstationProp")?json["workstationProp"]:null;
		this._zmDisplayName = json.hasOwnProperty("zmDisplayName")?json["zmDisplayName"]:null;
		this._zmUserName = json.hasOwnProperty("zmUserName")?json["zmUserName"]:null;
		this._vlxEnabled = json.hasOwnProperty("vlxEnabled")?json["vlxEnabled"]:false;
		this._sslWebmin = json.hasOwnProperty("sslWebmin")?json["sslWebmin"]:false;
		this._defaultCheckoutPath = json.hasOwnProperty("defaultCheckoutPath")?json["defaultCheckoutPath"]:null;
		this._webminSslServer = json.hasOwnProperty("webminSslServer")?json["webminSslServer"]:null;
		this._huid = json.hasOwnProperty("huid")?json["huid"]:null;
		this._storageTypes = json.hasOwnProperty("storageTypes")?json["storageTypes"]:null;
		this._zmEmail = json.hasOwnProperty("zmEmail")?json["zmEmail"]:null;
		this._webminServer = json.hasOwnProperty("webminServer")?json["webminServer"]:null;
		this._showOnlyCollection = json.hasOwnProperty("showOnlyCollection")?json["showOnlyCollection"]:false;
		this._companyTagLine = json.hasOwnProperty("companyTagLine")?json["companyTagLine"]:null;
		this._isAutoCOEnabled = json.hasOwnProperty("isAutoCOEnabled")?json["isAutoCOEnabled"]:false;
		this._repoId = json.hasOwnProperty("repoId")?json["repoId"]:null;
		this._uploadOnPreviewServer = json.hasOwnProperty("uploadOnPreviewServer")?json["uploadOnPreviewServer"]:false;
		this._vantageEnabled = json.hasOwnProperty("vantageEnabled")?json["vantageEnabled"]:false;
		this._imgSeqEnabled = json.hasOwnProperty("imgSeqEnabled")?json["imgSeqEnabled"]:false;
		this._mdBasedPathProp = json.hasOwnProperty("mdBasedPathProp")?json["mdBasedPathProp"]:null;
		this._zmCookieMaxAge = json.hasOwnProperty("zmCookieMaxAge")?json["zmCookieMaxAge"]:0;
		this._zmPassword = json.hasOwnProperty("zmPassword")?json["zmPassword"]:null;
		this._vfxEnabled = json.hasOwnProperty("vfxEnabled")?json["vfxEnabled"]:false;
		this._zmServer = json.hasOwnProperty("zmServer")?json["zmServer"]:null;
		this._sessionId = json.hasOwnProperty("sessionId")?json["sessionId"]:null;
		this._zmCookieServerTime = json.hasOwnProperty("zmCookieServerTime")?json["zmCookieServerTime"]:0;
		this._skipMDBasedIngestPathVal = json.hasOwnProperty("skipMDBasedIngestPathVal")?json["skipMDBasedIngestPathVal"]:false;
		this._version = json.hasOwnProperty("version")?json["version"]:null;
		this._projectsList = json.hasOwnProperty("projectsList")?json["projectsList"]:null;
		this._rolesList = json.hasOwnProperty("rolesList")?json["rolesList"]:null;
		this._externalUserId = json.hasOwnProperty("externalUserId")?json["externalUserId"]:null;
		this._mandatoryMDEnabled = json.hasOwnProperty("mandatoryMDEnabled")?json["mandatoryMDEnabled"]:false;
		this._sslRv = json.hasOwnProperty("sslRv")?json["sslRv"]:false;
		this._location = json.hasOwnProperty("location")?json["location"]:null;
		this._userHasAdminPerm = json.hasOwnProperty("userHasAdminPerm")?json["userHasAdminPerm"]:false;
		if (json.hasOwnProperty("serverPermissionsData")){
			if (!this._serverPermissionsData && this._serverPermissionsData == null)
				this._serverPermissionsData = new ServerPermissionsData();
			this._serverPermissionsData.deserializeJson(json.hasOwnProperty("serverPermissionsData") ? json["serverPermissionsData"] : null);
		}

		//set of type string
		this._reviewServerHostPortList = [];
		let reviewServerHostPortListJSONArray = json.hasOwnProperty("reviewServerHostPortList") ? json["reviewServerHostPortList"] : [];

		reviewServerHostPortListJSONArray.forEach((o178)=>{
			if (o178){
				this._reviewServerHostPortList.push(o178);
			}
		});
		//set of type string
		this._reviewServerHostPortSSLList = [];
		let reviewServerHostPortSSLListJSONArray = json.hasOwnProperty("reviewServerHostPortSSLList") ? json["reviewServerHostPortSSLList"] : [];

		reviewServerHostPortSSLListJSONArray.forEach((o181)=>{
			if (o181){
				this._reviewServerHostPortSSLList.push(o181);
			}
		});
//Map of type STRING. Decode as tree:false
		if (this._extraProps == null)
			this._extraProps = new HashMap();
		this._extraProps.clear();
		let extraPropsJSONArray = json.hasOwnProperty("extraProps") ? json["extraProps"] : [];
		this._extraProps = SerializationUtil.deserializeMap(extraPropsJSONArray);



  }
}

/**
 * @returns {string}
 */
ZoomServerSpec.CLASS_ID = "com.zoom.vab.client.autogenerated.ZoomServerSpec";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexVABMakeCurrentQuery extends HttpOperation {

  constructor(name = "FlexVABMakeCurrent") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {VABMakeCurrentMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{VABMakeCurrentMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {VABMakeCurrentResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexVABMakeCurrentQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexVABMakeCurrentQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new VABMakeCurrentResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new VABMakeCurrentResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexVABMakeCurrentQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexVABMakeCurrent";
/**
 * @returns {string}
 */
FlexVABMakeCurrentQuery.QUERY_NAME = "FlexVABMakeCurrent";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexPurgeQuery extends HttpOperation {

  constructor(name = "FlexPurge") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexPurgeCommandArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexPurgeCommandArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexZoomCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexPurgeQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexPurgeQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexPurgeQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexPurge";
/**
 * @returns {string}
 */
FlexPurgeQuery.QUERY_NAME = "FlexPurge";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class ForkInfoQueryQuery extends HttpOperation {

  constructor(name = "ForkInfoQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ForkInfoQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ForkInfoQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ForkInfoQueryResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ForkInfoQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ForkInfoQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ForkInfoQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ForkInfoQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ForkInfoQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ForkInfoQuery";
/**
 * @returns {string}
 */
ForkInfoQueryQuery.QUERY_NAME = "ForkInfoQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class LockDetail {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._lockStatus = false;
    /**
     * @type {number}
     * @private
     */
    this._lockTime = null;
    /**
     * @type {string}
     * @private
     */
    this._lockOwner = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;

  }

    /**
   * @return {boolean}
   */
  isLockStatus() {
    return this._lockStatus;
  }

  /**
   * @param lockStatus{boolean}
   * @return {LockDetail}
   */
  setLockStatus(lockStatus) {
    this._lockStatus = lockStatus;
    return this;
  }
  /**
   * @return {number}
   */
  getLockTime() {
    return this._lockTime;
  }

  /**
   * @param lockTime{number}
   * @return {LockDetail}
   */
  setLockTime(lockTime) {
    this._lockTime = lockTime;
    return this;
  }
  /**
   * @return {string}
   */
  getLockOwner() {
    return this._lockOwner;
  }

  /**
   * @param lockOwner{string}
   * @return {LockDetail}
   */
  setLockOwner(lockOwner) {
    this._lockOwner = lockOwner;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {LockDetail}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LockDetail.CLASS_ID;
    
	//Serializing _lockStatus
	if (this._lockStatus)
		json['lockStatus'] = this._lockStatus;

	//Serializing _lockTime
	if (this._lockTime)
		json['lockTime'] = this._lockTime;

	//Serializing _lockOwner
	if (this._lockOwner)
		json['lockOwner'] = this._lockOwner;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lockStatus = json.hasOwnProperty("lockStatus")?json["lockStatus"]:false;
		this._lockTime = json.hasOwnProperty("lockTime")?json["lockTime"]:0;
		this._lockOwner = json.hasOwnProperty("lockOwner")?json["lockOwner"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;


  }
}

/**
 * @returns {string}
 */
LockDetail.CLASS_ID = "com.zoom.vab.client.autogenerated.LockDetail";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class VABLoginQuery extends HttpOperation {

  constructor(name = "VABLogin") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "SimpleType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {String}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{String}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ZoomServerSpec}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = VABLoginQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (VABLoginQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ZoomServerSpec();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ZoomServerSpec();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
VABLoginQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.VABLogin";
/**
 * @returns {string}
 */
VABLoginQuery.QUERY_NAME = "VABLogin";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class GetActivityMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._onlyComments = false;
    /**
     * @type {boolean}
     * @private
     */
    this._skipActivityFromCurrentUser = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyNotifications = false;
    /**
     * @type {boolean}
     * @private
     */
    this._onlyTasks = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isMaxTime = false;
    /**
     * @type {string}
     * @private
     */
    this._oldestTimeDateLabel = null;
    /**
     * @type {number}
     * @private
     */
    this._mtime = null;

  }

    /**
   * @return {boolean}
   */
  isOnlyComments() {
    return this._onlyComments;
  }

  /**
   * @param onlyComments{boolean}
   * @return {GetActivityMsg}
   */
  setOnlyComments(onlyComments) {
    this._onlyComments = onlyComments;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSkipActivityFromCurrentUser() {
    return this._skipActivityFromCurrentUser;
  }

  /**
   * @param skipActivityFromCurrentUser{boolean}
   * @return {GetActivityMsg}
   */
  setSkipActivityFromCurrentUser(skipActivityFromCurrentUser) {
    this._skipActivityFromCurrentUser = skipActivityFromCurrentUser;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyNotifications() {
    return this._onlyNotifications;
  }

  /**
   * @param onlyNotifications{boolean}
   * @return {GetActivityMsg}
   */
  setOnlyNotifications(onlyNotifications) {
    this._onlyNotifications = onlyNotifications;
    return this;
  }
  /**
   * @return {boolean}
   */
  isOnlyTasks() {
    return this._onlyTasks;
  }

  /**
   * @param onlyTasks{boolean}
   * @return {GetActivityMsg}
   */
  setOnlyTasks(onlyTasks) {
    this._onlyTasks = onlyTasks;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsMaxTime() {
    return this._isMaxTime;
  }

  /**
   * @param isMaxTime{boolean}
   * @return {GetActivityMsg}
   */
  setIsMaxTime(isMaxTime) {
    this._isMaxTime = isMaxTime;
    return this;
  }
  /**
   * @return {string}
   */
  getOldestTimeDateLabel() {
    return this._oldestTimeDateLabel;
  }

  /**
   * @param oldestTimeDateLabel{string}
   * @return {GetActivityMsg}
   */
  setOldestTimeDateLabel(oldestTimeDateLabel) {
    this._oldestTimeDateLabel = oldestTimeDateLabel;
    return this;
  }
  /**
   * @return {number}
   */
  getMtime() {
    return this._mtime;
  }

  /**
   * @param mtime{number}
   * @return {GetActivityMsg}
   */
  setMtime(mtime) {
    this._mtime = mtime;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetActivityMsg.CLASS_ID;
    
	//Serializing _onlyComments
	if (this._onlyComments)
		json['onlyComments'] = this._onlyComments;

	//Serializing _skipActivityFromCurrentUser
	if (this._skipActivityFromCurrentUser)
		json['skipActivityFromCurrentUser'] = this._skipActivityFromCurrentUser;

	//Serializing _onlyNotifications
	if (this._onlyNotifications)
		json['onlyNotifications'] = this._onlyNotifications;

	//Serializing _onlyTasks
	if (this._onlyTasks)
		json['onlyTasks'] = this._onlyTasks;

	//Serializing _isMaxTime
	if (this._isMaxTime)
		json['isMaxTime'] = this._isMaxTime;

	//Serializing _oldestTimeDateLabel
	if (this._oldestTimeDateLabel)
		json['oldestTimeDateLabel'] = this._oldestTimeDateLabel;

	//Serializing _mtime
	if (this._mtime)
		json['mtime'] = this._mtime;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._onlyComments = json.hasOwnProperty("onlyComments")?json["onlyComments"]:false;
		this._skipActivityFromCurrentUser = json.hasOwnProperty("skipActivityFromCurrentUser")?json["skipActivityFromCurrentUser"]:false;
		this._onlyNotifications = json.hasOwnProperty("onlyNotifications")?json["onlyNotifications"]:false;
		this._onlyTasks = json.hasOwnProperty("onlyTasks")?json["onlyTasks"]:false;
		this._isMaxTime = json.hasOwnProperty("isMaxTime")?json["isMaxTime"]:false;
		this._oldestTimeDateLabel = json.hasOwnProperty("oldestTimeDateLabel")?json["oldestTimeDateLabel"]:null;
		this._mtime = json.hasOwnProperty("mtime")?json["mtime"]:0;


  }
}

/**
 * @returns {string}
 */
GetActivityMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.GetActivityMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexRemoteResurrectArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._repoId = null;
    /**
     * @type {string}
     * @private
     */
    this._server = null;
    /**
     * @type {boolean}
     * @private
     */
    this._includeSSInResurrect = false;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._infiles = null;

  }

    /**
   * @return {string}
   */
  getRepoId() {
    return this._repoId;
  }

  /**
   * @param repoId{string}
   * @return {FlexRemoteResurrectArgs}
   */
  setRepoId(repoId) {
    this._repoId = repoId;
    return this;
  }
  /**
   * @return {string}
   */
  getServer() {
    return this._server;
  }

  /**
   * @param server{string}
   * @return {FlexRemoteResurrectArgs}
   */
  setServer(server) {
    this._server = server;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIncludeSSInResurrect() {
    return this._includeSSInResurrect;
  }

  /**
   * @param includeSSInResurrect{boolean}
   * @return {FlexRemoteResurrectArgs}
   */
  setIncludeSSInResurrect(includeSSInResurrect) {
    this._includeSSInResurrect = includeSSInResurrect;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexRemoteResurrectArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {Array<String>}
   */
  getInfiles() {
    return this._infiles;
  }

  /**
   * @param infiles{Array<String>}
   * @return {FlexRemoteResurrectArgs}
   */
  setInfiles(infiles) {
    this._infiles = infiles;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexRemoteResurrectArgs.CLASS_ID;
    
	//Serializing _repoId
	if (this._repoId)
		json['repoId'] = this._repoId;

	//Serializing _server
	if (this._server)
		json['server'] = this._server;

	//Serializing _includeSSInResurrect
	if (this._includeSSInResurrect)
		json['includeSSInResurrect'] = this._includeSSInResurrect;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;
  if (this._infiles && this._infiles.length > 0) {
    let infiles_JSON = [];
    /**
     * @type {string}
     */
    this._infiles.forEach((o192) => {
      if (o192) {
        if (o192.serializeJson && (typeof (o192.serializeJson) === 'function')) {
          infiles_JSON.push(o192.serializeJson());
        } else {
          infiles_JSON.push(o192);
        }
      }
    });
    json['infiles'] = infiles_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._repoId = json.hasOwnProperty("repoId")?json["repoId"]:null;
		this._server = json.hasOwnProperty("server")?json["server"]:null;
		this._includeSSInResurrect = json.hasOwnProperty("includeSSInResurrect")?json["includeSSInResurrect"]:false;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		//set of type string
		this._infiles = [];
		let infilesJSONArray = json.hasOwnProperty("infiles") ? json["infiles"] : [];

		infilesJSONArray.forEach((o193)=>{
			if (o193){
				this._infiles.push(o193);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexRemoteResurrectArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteResurrectArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class UpdateTPMQueryQuery extends HttpOperation {

  constructor(name = "UpdateTPMQuery") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {UpdateTPMQueryMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{UpdateTPMQueryMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {UpdateTPMQueryResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = UpdateTPMQueryQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (UpdateTPMQueryQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new UpdateTPMQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new UpdateTPMQueryResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
UpdateTPMQueryQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.UpdateTPMQuery";
/**
 * @returns {string}
 */
UpdateTPMQueryQuery.QUERY_NAME = "UpdateTPMQuery";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class TimeLabelClass {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._dateLabel = null;
    /**
     * @type {string}
     * @private
     */
    this._timeLabel = null;

  }

    /**
   * @return {string}
   */
  getDateLabel() {
    return this._dateLabel;
  }

  /**
   * @param dateLabel{string}
   * @return {TimeLabelClass}
   */
  setDateLabel(dateLabel) {
    this._dateLabel = dateLabel;
    return this;
  }
  /**
   * @return {string}
   */
  getTimeLabel() {
    return this._timeLabel;
  }

  /**
   * @param timeLabel{string}
   * @return {TimeLabelClass}
   */
  setTimeLabel(timeLabel) {
    this._timeLabel = timeLabel;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TimeLabelClass.CLASS_ID;
    
	//Serializing _dateLabel
	if (this._dateLabel)
		json['dateLabel'] = this._dateLabel;

	//Serializing _timeLabel
	if (this._timeLabel)
		json['timeLabel'] = this._timeLabel;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._dateLabel = json.hasOwnProperty("dateLabel")?json["dateLabel"]:null;
		this._timeLabel = json.hasOwnProperty("timeLabel")?json["timeLabel"]:null;


  }
}

/**
 * @returns {string}
 */
TimeLabelClass.CLASS_ID = "com.zoom.vab.client.autogenerated.TimeLabelClass";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexLockCommandResponse {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._lockTime = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {string}
     * @private
     */
    this._username = null;

  }

    /**
   * @return {string}
   */
  getLockTime() {
    return this._lockTime;
  }

  /**
   * @param lockTime{string}
   * @return {FlexLockCommandResponse}
   */
  setLockTime(lockTime) {
    this._lockTime = lockTime;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexLockCommandResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {FlexLockCommandResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {string}
   */
  getUsername() {
    return this._username;
  }

  /**
   * @param username{string}
   * @return {FlexLockCommandResponse}
   */
  setUsername(username) {
    this._username = username;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexLockCommandResponse.CLASS_ID;
    
	//Serializing _lockTime
	if (this._lockTime)
		json['lockTime'] = this._lockTime;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;

	//Serializing _username
	if (this._username)
		json['username'] = this._username;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._lockTime = json.hasOwnProperty("lockTime")?json["lockTime"]:null;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		this._username = json.hasOwnProperty("username")?json["username"]:null;


  }
}

/**
 * @returns {string}
 */
FlexLockCommandResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexLockCommandResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class TimeAndDatePrettyFormatResp {

  constructor() {
    
        /**
     * @type {Array<TimeLabelClass>}
     * @private
     */
    this._timeLabelArray = null;

  }

    /**
   * @return {Array<TimeLabelClass>}
   */
  getTimeLabelArray() {
    return this._timeLabelArray;
  }

  /**
   * @param timeLabelArray{Array<TimeLabelClass>}
   * @return {TimeAndDatePrettyFormatResp}
   */
  setTimeLabelArray(timeLabelArray) {
    this._timeLabelArray = timeLabelArray;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = TimeAndDatePrettyFormatResp.CLASS_ID;
      if (this._timeLabelArray && this._timeLabelArray.length > 0) {
    let timeLabelArray_JSON = [];
    /**
     * @type {TimeLabelClass}
     */
    this._timeLabelArray.forEach((o216) => {
      if (o216) {
        if (o216.serializeJson && (typeof (o216.serializeJson) === 'function')) {
          timeLabelArray_JSON.push(o216.serializeJson());
        } else {
          timeLabelArray_JSON.push(o216);
        }
      }
    });
    json['timeLabelArray'] = timeLabelArray_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type TimeLabelClass
		this._timeLabelArray = [];
		let timeLabelArrayJSONArray = json.hasOwnProperty("timeLabelArray") ? json["timeLabelArray"] : [];

		timeLabelArrayJSONArray.forEach((o217)=>{
			if (o217){
				let classObj = new TimeLabelClass();
				classObj.deserializeJson(o217);
				this._timeLabelArray.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
TimeAndDatePrettyFormatResp.CLASS_ID = "com.zoom.vab.client.autogenerated.TimeAndDatePrettyFormatResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class OAuthLoginMsg {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._cancel = false;
    /**
     * @type {boolean}
     * @private
     */
    this._isNew = false;
    /**
     * @type {string}
     * @private
     */
    this._version = null;

  }

    /**
   * @return {boolean}
   */
  isCancel() {
    return this._cancel;
  }

  /**
   * @param cancel{boolean}
   * @return {OAuthLoginMsg}
   */
  setCancel(cancel) {
    this._cancel = cancel;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsNew() {
    return this._isNew;
  }

  /**
   * @param isNew{boolean}
   * @return {OAuthLoginMsg}
   */
  setIsNew(isNew) {
    this._isNew = isNew;
    return this;
  }
  /**
   * @return {string}
   */
  getVersion() {
    return this._version;
  }

  /**
   * @param version{string}
   * @return {OAuthLoginMsg}
   */
  setVersion(version) {
    this._version = version;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = OAuthLoginMsg.CLASS_ID;
    
	//Serializing _cancel
	if (this._cancel)
		json['cancel'] = this._cancel;

	//Serializing _isNew
	if (this._isNew)
		json['isNew'] = this._isNew;

	//Serializing _version
	if (this._version)
		json['version'] = this._version;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._cancel = json.hasOwnProperty("cancel")?json["cancel"]:false;
		this._isNew = json.hasOwnProperty("isNew")?json["isNew"]:false;
		this._version = json.hasOwnProperty("version")?json["version"]:null;


  }
}

/**
 * @returns {string}
 */
OAuthLoginMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.OAuthLoginMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexRemoteRenameResp {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._newName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;

  }

    /**
   * @return {string}
   */
  getNewName() {
    return this._newName;
  }

  /**
   * @param newName{string}
   * @return {FlexRemoteRenameResp}
   */
  setNewName(newName) {
    this._newName = newName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexRemoteRenameResp}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {FlexRemoteRenameResp}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexRemoteRenameResp.CLASS_ID;
    
	//Serializing _newName
	if (this._newName)
		json['newName'] = this._newName;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._newName = json.hasOwnProperty("newName")?json["newName"]:null;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;


  }
}

/**
 * @returns {string}
 */
FlexRemoteRenameResp.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexRemoteRenameResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexVABMultiAssetCheckoutQuery extends HttpOperation {

  constructor(name = "FlexVABMultiAssetCheckout") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexMultiAssetCheckoutArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexMultiAssetCheckoutArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexZoomCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexVABMultiAssetCheckoutQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexVABMultiAssetCheckoutQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexVABMultiAssetCheckoutQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexVABMultiAssetCheckout";
/**
 * @returns {string}
 */
FlexVABMultiAssetCheckoutQuery.QUERY_NAME = "FlexVABMultiAssetCheckout";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class LayerProperty {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._propertyName = null;
    /**
     * @type {boolean}
     * @private
     */
    this._displayFlag = false;
    /**
     * @type {string}
     * @private
     */
    this._propertyValue = null;

  }

    /**
   * @return {string}
   */
  getPropertyName() {
    return this._propertyName;
  }

  /**
   * @param propertyName{string}
   * @return {LayerProperty}
   */
  setPropertyName(propertyName) {
    this._propertyName = propertyName;
    return this;
  }
  /**
   * @return {boolean}
   */
  isDisplayFlag() {
    return this._displayFlag;
  }

  /**
   * @param displayFlag{boolean}
   * @return {LayerProperty}
   */
  setDisplayFlag(displayFlag) {
    this._displayFlag = displayFlag;
    return this;
  }
  /**
   * @return {string}
   */
  getPropertyValue() {
    return this._propertyValue;
  }

  /**
   * @param propertyValue{string}
   * @return {LayerProperty}
   */
  setPropertyValue(propertyValue) {
    this._propertyValue = propertyValue;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = LayerProperty.CLASS_ID;
    
	//Serializing _propertyName
	if (this._propertyName)
		json['propertyName'] = this._propertyName;

	//Serializing _displayFlag
	if (this._displayFlag)
		json['displayFlag'] = this._displayFlag;

	//Serializing _propertyValue
	if (this._propertyValue)
		json['propertyValue'] = this._propertyValue;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._propertyName = json.hasOwnProperty("propertyName")?json["propertyName"]:null;
		this._displayFlag = json.hasOwnProperty("displayFlag")?json["displayFlag"]:false;
		this._propertyValue = json.hasOwnProperty("propertyValue")?json["propertyValue"]:null;


  }
}

/**
 * @returns {string}
 */
LayerProperty.CLASS_ID = "com.zoom.vab.client.autogenerated.LayerProperty";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class ArchiveRestoreRequestQuery extends HttpOperation {

  constructor(name = "ArchiveRestoreRequest") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ArchiveRestoreRequestMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ArchiveRestoreRequestMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ArchiveRestoreRequestMsgRes}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = ArchiveRestoreRequestQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (ArchiveRestoreRequestQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ArchiveRestoreRequestMsgRes();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ArchiveRestoreRequestMsgRes();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
ArchiveRestoreRequestQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveRestoreRequest";
/**
 * @returns {string}
 */
ArchiveRestoreRequestQuery.QUERY_NAME = "ArchiveRestoreRequest";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class GetCredentialsVabQuery extends HttpOperation {

  constructor(name = "GetCredentialsVab") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {ServerRepoId}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{ServerRepoId}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {ZoomServerSpec}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetCredentialsVabQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetCredentialsVabQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new ZoomServerSpec();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new ZoomServerSpec();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetCredentialsVabQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetCredentialsVab";
/**
 * @returns {string}
 */
GetCredentialsVabQuery.QUERY_NAME = "GetCredentialsVab";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ArchiveRestoreRequestMsg {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._requestType = null;
    /**
     * @type {string}
     * @private
     */
    this._extraData = null;
    /**
     * @type {string}
     * @private
     */
    this._requestId = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._fuids = null;

  }

    /**
   * @return {string}
   */
  getRequestType() {
    return this._requestType;
  }

  /**
   * @param requestType{string}
   * @return {ArchiveRestoreRequestMsg}
   */
  setRequestType(requestType) {
    this._requestType = requestType;
    return this;
  }
  /**
   * @return {string}
   */
  getExtraData() {
    return this._extraData;
  }

  /**
   * @param extraData{string}
   * @return {ArchiveRestoreRequestMsg}
   */
  setExtraData(extraData) {
    this._extraData = extraData;
    return this;
  }
  /**
   * Type is string. Sent by client
   * @return {string}
   */
  getRequestId() {
    return this._requestId;
  }

  /**
   * @param requestId{string}
   * @return {ArchiveRestoreRequestMsg}
   */
  setRequestId(requestId) {
    this._requestId = requestId;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {ArchiveRestoreRequestMsg}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getFuids() {
    return this._fuids;
  }

  /**
   * @param fuids{Array<Integer>}
   * @return {ArchiveRestoreRequestMsg}
   */
  setFuids(fuids) {
    this._fuids = fuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ArchiveRestoreRequestMsg.CLASS_ID;
    
	//Serializing _requestType
	if (this._requestType)
		json['requestType'] = this._requestType;

	//Serializing _extraData
	if (this._extraData)
		json['extraData'] = this._extraData;

	//Serializing _requestId
	if (this._requestId)
		json['requestId'] = this._requestId;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;
  if (this._fuids && this._fuids.length > 0) {
    let fuids_JSON = [];
    /**
     * @type {int}
     */
    this._fuids.forEach((o12) => {
      if (o12) {
        if (o12.serializeJson && (typeof (o12.serializeJson) === 'function')) {
          fuids_JSON.push(o12.serializeJson());
        } else {
          fuids_JSON.push(o12);
        }
      }
    });
    json['fuids'] = fuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._requestType = json.hasOwnProperty("requestType")?json["requestType"]:null;
		this._extraData = json.hasOwnProperty("extraData")?json["extraData"]:null;
		this._requestId = json.hasOwnProperty("requestId")?json["requestId"]:null;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		//set of type int
		this._fuids = [];
		let fuidsJSONArray = json.hasOwnProperty("fuids") ? json["fuids"] : [];

		fuidsJSONArray.forEach((o13)=>{
			if (o13){
				this._fuids.push(o13);
			}
		});


  }
}

/**
 * @returns {string}
 */
ArchiveRestoreRequestMsg.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveRestoreRequestMsg";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ArchiveRestoreRequestMsgRes {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._jsonData = null;
    /**
     * @type {boolean}
     * @private
     */
    this._rv = false;
    /**
     * @type {boolean}
     * @private
     */
    this._hadr = false;
    /**
     * @type {string}
     * @private
     */
    this._url = null;

  }

    /**
   * @return {string}
   */
  getJsonData() {
    return this._jsonData;
  }

  /**
   * @param jsonData{string}
   * @return {ArchiveRestoreRequestMsgRes}
   */
  setJsonData(jsonData) {
    this._jsonData = jsonData;
    return this;
  }
  /**
   * @return {boolean}
   */
  isRv() {
    return this._rv;
  }

  /**
   * @param rv{boolean}
   * @return {ArchiveRestoreRequestMsgRes}
   */
  setRv(rv) {
    this._rv = rv;
    return this;
  }
  /**
   * @return {boolean}
   */
  isHadr() {
    return this._hadr;
  }

  /**
   * @param hadr{boolean}
   * @return {ArchiveRestoreRequestMsgRes}
   */
  setHadr(hadr) {
    this._hadr = hadr;
    return this;
  }
  /**
   * @return {string}
   */
  getUrl() {
    return this._url;
  }

  /**
   * @param url{string}
   * @return {ArchiveRestoreRequestMsgRes}
   */
  setUrl(url) {
    this._url = url;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ArchiveRestoreRequestMsgRes.CLASS_ID;
    
	//Serializing _jsonData
	if (this._jsonData)
		json['jsonData'] = this._jsonData;

	//Serializing _rv
	if (this._rv)
		json['rv'] = this._rv;

	//Serializing _hadr
	if (this._hadr)
		json['hadr'] = this._hadr;

	//Serializing _url
	if (this._url)
		json['url'] = this._url;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._jsonData = json.hasOwnProperty("jsonData")?json["jsonData"]:null;
		this._rv = json.hasOwnProperty("rv")?json["rv"]:false;
		this._hadr = json.hasOwnProperty("hadr")?json["hadr"]:false;
		this._url = json.hasOwnProperty("url")?json["url"]:null;


  }
}

/**
 * @returns {string}
 */
ArchiveRestoreRequestMsgRes.CLASS_ID = "com.zoom.vab.client.autogenerated.ArchiveRestoreRequestMsgRes";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexUnlockResponse {

  constructor() {
    
        /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._message = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._noLockAvailableBid2FuidMap = null;

  }

    /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexUnlockResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getMessage() {
    return this._message;
  }

  /**
   * @param message{string}
   * @return {FlexUnlockResponse}
   */
  setMessage(message) {
    this._message = message;
    return this;
  }
  /**
   * @return {java.util.Map<number,Integer>}
   */
  getNoLockAvailableBid2FuidMap() {
    return this._noLockAvailableBid2FuidMap;
  }

  /**
   * @param noLockAvailableBid2FuidMap{java.util.Map<number,Integer>}
   * @return {FlexUnlockResponse}
   */
  setNoLockAvailableBid2FuidMap(noLockAvailableBid2FuidMap) {
    this._noLockAvailableBid2FuidMap = noLockAvailableBid2FuidMap;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexUnlockResponse.CLASS_ID;
    
	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _message
	if (this._message)
		json['message'] = this._message;
    SerializationUtil.serializeHashMap(json,"noLockAvailableBid2FuidMap", this._noLockAvailableBid2FuidMap);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._message = json.hasOwnProperty("message")?json["message"]:null;
//Map of type INT. Decode as tree:false
		if (this._noLockAvailableBid2FuidMap == null)
			this._noLockAvailableBid2FuidMap = new HashMap();
		this._noLockAvailableBid2FuidMap.clear();
		let noLockAvailableBid2FuidMapJSONArray = json.hasOwnProperty("noLockAvailableBid2FuidMap") ? json["noLockAvailableBid2FuidMap"] : [];
		this._noLockAvailableBid2FuidMap = SerializationUtil.deserializeMap(noLockAvailableBid2FuidMapJSONArray);



  }
}

/**
 * @returns {string}
 */
FlexUnlockResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexUnlockResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexLockQuery extends HttpOperation {

  constructor(name = "FlexLock") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexLockCommandArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexLockCommandArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexLockCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexLockQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexLockQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexLockCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexLockCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexLockQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexLock";
/**
 * @returns {string}
 */
FlexLockQuery.QUERY_NAME = "FlexLock";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class FlexDeleteQuery extends HttpOperation {

  constructor(name = "FlexDelete") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {FlexDeleteCommandArgs}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{FlexDeleteCommandArgs}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {FlexZoomCommandResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = FlexDeleteQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (FlexDeleteQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new FlexZoomCommandResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
FlexDeleteQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexDelete";
/**
 * @returns {string}
 */
FlexDeleteQuery.QUERY_NAME = "FlexDelete";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ForkInfoQueryResp {

  constructor() {
    
        /**
     * @type {Array<GetListResponseDataObj>}
     * @private
     */
    this._dataList = null;

  }

    /**
   * @return {Array<GetListResponseDataObj>}
   */
  getDataList() {
    return this._dataList;
  }

  /**
   * @param dataList{Array<GetListResponseDataObj>}
   * @return {ForkInfoQueryResp}
   */
  setDataList(dataList) {
    this._dataList = dataList;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ForkInfoQueryResp.CLASS_ID;
      if (this._dataList && this._dataList.length > 0) {
    let dataList_JSON = [];
    /**
     * @type {GetListResponseDataObj}
     */
    this._dataList.forEach((o20) => {
      if (o20) {
        if (o20.serializeJson && (typeof (o20.serializeJson) === 'function')) {
          dataList_JSON.push(o20.serializeJson());
        } else {
          dataList_JSON.push(o20);
        }
      }
    });
    json['dataList'] = dataList_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		//set of type GetListResponseDataObj
		this._dataList = [];
		let dataListJSONArray = json.hasOwnProperty("dataList") ? json["dataList"] : [];

		dataListJSONArray.forEach((o21)=>{
			if (o21){
				let classObj = new GetListResponseDataObj();
				classObj.deserializeJson(o21);
				this._dataList.push(classObj);
			}
		});


  }
}

/**
 * @returns {string}
 */
ForkInfoQueryResp.CLASS_ID = "com.zoom.vab.client.autogenerated.ForkInfoQueryResp";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class GetLayerQuery extends HttpOperation {

  constructor(name = "GetLayer") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {GetLayerMessage}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{GetLayerMessage}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {GetLayerResponse}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = GetLayerQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (GetLayerQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new GetLayerResponse();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new GetLayerResponse();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
GetLayerQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.GetLayer";
/**
 * @returns {string}
 */
GetLayerQuery.QUERY_NAME = "GetLayer";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexLockStatusRequest {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._dirFuids = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._filePaths = null;

  }

    /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexLockStatusRequest}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getDirFuids() {
    return this._dirFuids;
  }

  /**
   * @param dirFuids{Array<Integer>}
   * @return {FlexLockStatusRequest}
   */
  setDirFuids(dirFuids) {
    this._dirFuids = dirFuids;
    return this;
  }

  /**
   * @return {Array<String>}
   */
  getFilePaths() {
    return this._filePaths;
  }

  /**
   * @param filePaths{Array<String>}
   * @return {FlexLockStatusRequest}
   */
  setFilePaths(filePaths) {
    this._filePaths = filePaths;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexLockStatusRequest.CLASS_ID;
    
	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;
  if (this._dirFuids && this._dirFuids.length > 0) {
    let dirFuids_JSON = [];
    /**
     * @type {int}
     */
    this._dirFuids.forEach((o77) => {
      if (o77) {
        if (o77.serializeJson && (typeof (o77.serializeJson) === 'function')) {
          dirFuids_JSON.push(o77.serializeJson());
        } else {
          dirFuids_JSON.push(o77);
        }
      }
    });
    json['dirFuids'] = dirFuids_JSON;
  }  
  if (this._filePaths && this._filePaths.length > 0) {
    let filePaths_JSON = [];
    /**
     * @type {string}
     */
    this._filePaths.forEach((o80) => {
      if (o80) {
        if (o80.serializeJson && (typeof (o80.serializeJson) === 'function')) {
          filePaths_JSON.push(o80.serializeJson());
        } else {
          filePaths_JSON.push(o80);
        }
      }
    });
    json['filePaths'] = filePaths_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		//set of type int
		this._dirFuids = [];
		let dirFuidsJSONArray = json.hasOwnProperty("dirFuids") ? json["dirFuids"] : [];

		dirFuidsJSONArray.forEach((o78)=>{
			if (o78){
				this._dirFuids.push(o78);
			}
		});
		//set of type string
		this._filePaths = [];
		let filePathsJSONArray = json.hasOwnProperty("filePaths") ? json["filePaths"] : [];

		filePathsJSONArray.forEach((o81)=>{
			if (o81){
				this._filePaths.push(o81);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexLockStatusRequest.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexLockStatusRequest";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexUnLockCommandArgs {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._remotePath = null;
    /**
     * @type {string}
     * @private
     */
    this._branch = null;
    /**
     * @type {Array<Integer>}
     * @private
     */
    this._infuids = null;

  }

    /**
   * @return {string}
   */
  getRemotePath() {
    return this._remotePath;
  }

  /**
   * @param remotePath{string}
   * @return {FlexUnLockCommandArgs}
   */
  setRemotePath(remotePath) {
    this._remotePath = remotePath;
    return this;
  }
  /**
   * @return {string}
   */
  getBranch() {
    return this._branch;
  }

  /**
   * @param branch{string}
   * @return {FlexUnLockCommandArgs}
   */
  setBranch(branch) {
    this._branch = branch;
    return this;
  }
  /**
   * @return {Array<Integer>}
   */
  getInfuids() {
    return this._infuids;
  }

  /**
   * @param infuids{Array<Integer>}
   * @return {FlexUnLockCommandArgs}
   */
  setInfuids(infuids) {
    this._infuids = infuids;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexUnLockCommandArgs.CLASS_ID;
    
	//Serializing _remotePath
	if (this._remotePath)
		json['remotePath'] = this._remotePath;

	//Serializing _branch
	if (this._branch)
		json['branch'] = this._branch;
  if (this._infuids && this._infuids.length > 0) {
    let infuids_JSON = [];
    /**
     * @type {int}
     */
    this._infuids.forEach((o56) => {
      if (o56) {
        if (o56.serializeJson && (typeof (o56.serializeJson) === 'function')) {
          infuids_JSON.push(o56.serializeJson());
        } else {
          infuids_JSON.push(o56);
        }
      }
    });
    json['infuids'] = infuids_JSON;
  }  


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._remotePath = json.hasOwnProperty("remotePath")?json["remotePath"]:null;
		this._branch = json.hasOwnProperty("branch")?json["branch"]:null;
		//set of type int
		this._infuids = [];
		let infuidsJSONArray = json.hasOwnProperty("infuids") ? json["infuids"] : [];

		infuidsJSONArray.forEach((o57)=>{
			if (o57){
				this._infuids.push(o57);
			}
		});


  }
}

/**
 * @returns {string}
 */
FlexUnLockCommandArgs.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexUnLockCommandArgs";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class FlexZoomCommandResponse {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._wcParentPath = null;
    /**
     * @type {boolean}
     * @private
     */
    this._isRunning = false;
    /**
     * @type {boolean}
     * @private
     */
    this._success = false;
    /**
     * @type {string}
     * @private
     */
    this._destPath = null;
    /**
     * @type {string}
     * @private
     */
    this._wcPath = null;
    /**
     * @type {number}
     * @private
     */
    this._progress = null;
    /**
     * @type {string}
     * @private
     */
    this._successMessage = null;
    /**
     * @type {string}
     * @private
     */
    this._progressMessage = null;

  }

    /**
   * @return {string}
   */
  getWcParentPath() {
    return this._wcParentPath;
  }

  /**
   * @param wcParentPath{string}
   * @return {FlexZoomCommandResponse}
   */
  setWcParentPath(wcParentPath) {
    this._wcParentPath = wcParentPath;
    return this;
  }
  /**
   * @return {boolean}
   */
  isIsRunning() {
    return this._isRunning;
  }

  /**
   * @param isRunning{boolean}
   * @return {FlexZoomCommandResponse}
   */
  setIsRunning(isRunning) {
    this._isRunning = isRunning;
    return this;
  }
  /**
   * @return {boolean}
   */
  isSuccess() {
    return this._success;
  }

  /**
   * @param success{boolean}
   * @return {FlexZoomCommandResponse}
   */
  setSuccess(success) {
    this._success = success;
    return this;
  }
  /**
   * @return {string}
   */
  getDestPath() {
    return this._destPath;
  }

  /**
   * @param destPath{string}
   * @return {FlexZoomCommandResponse}
   */
  setDestPath(destPath) {
    this._destPath = destPath;
    return this;
  }
  /**
   * @return {string}
   */
  getWcPath() {
    return this._wcPath;
  }

  /**
   * @param wcPath{string}
   * @return {FlexZoomCommandResponse}
   */
  setWcPath(wcPath) {
    this._wcPath = wcPath;
    return this;
  }
  /**
   * @return {number}
   */
  getProgress() {
    return this._progress;
  }

  /**
   * @param progress{number}
   * @return {FlexZoomCommandResponse}
   */
  setProgress(progress) {
    this._progress = progress;
    return this;
  }
  /**
   * @return {string}
   */
  getSuccessMessage() {
    return this._successMessage;
  }

  /**
   * @param successMessage{string}
   * @return {FlexZoomCommandResponse}
   */
  setSuccessMessage(successMessage) {
    this._successMessage = successMessage;
    return this;
  }
  /**
   * @return {string}
   */
  getProgressMessage() {
    return this._progressMessage;
  }

  /**
   * @param progressMessage{string}
   * @return {FlexZoomCommandResponse}
   */
  setProgressMessage(progressMessage) {
    this._progressMessage = progressMessage;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = FlexZoomCommandResponse.CLASS_ID;
    
	//Serializing _wcParentPath
	if (this._wcParentPath)
		json['wcParentPath'] = this._wcParentPath;

	//Serializing _isRunning
	if (this._isRunning)
		json['isRunning'] = this._isRunning;

	//Serializing _success
	if (this._success)
		json['success'] = this._success;

	//Serializing _destPath
	if (this._destPath)
		json['destPath'] = this._destPath;

	//Serializing _wcPath
	if (this._wcPath)
		json['wcPath'] = this._wcPath;

	//Serializing _progress
	if (this._progress)
		json['progress'] = this._progress;

	//Serializing _successMessage
	if (this._successMessage)
		json['successMessage'] = this._successMessage;

	//Serializing _progressMessage
	if (this._progressMessage)
		json['progressMessage'] = this._progressMessage;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._wcParentPath = json.hasOwnProperty("wcParentPath")?json["wcParentPath"]:null;
		this._isRunning = json.hasOwnProperty("isRunning")?json["isRunning"]:false;
		this._success = json.hasOwnProperty("success")?json["success"]:false;
		this._destPath = json.hasOwnProperty("destPath")?json["destPath"]:null;
		this._wcPath = json.hasOwnProperty("wcPath")?json["wcPath"]:null;
		this._progress = json.hasOwnProperty("progress")?json["progress"]:0;
		this._successMessage = json.hasOwnProperty("successMessage")?json["successMessage"]:null;
		this._progressMessage = json.hasOwnProperty("progressMessage")?json["progressMessage"]:null;


  }
}

/**
 * @returns {string}
 */
FlexZoomCommandResponse.CLASS_ID = "com.zoom.vab.client.autogenerated.FlexZoomCommandResponse";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class GetLayerMessage {

  constructor() {
    
        /**
     * @type {string}
     * @private
     */
    this._extra = null;
    /**
     * @type {number}
     * @private
     */
    this._fuid = null;
    /**
     * @type {number}
     * @private
     */
    this._id = null;
    /**
     * @type {number}
     * @private
     */
    this._bid = null;
    /**
     * @type {string}
     * @private
     */
    this._type = null;
    /**
     * @type {number}
     * @private
     */
    this._rrn = null;

  }

    /**
   * @return {string}
   */
  getExtra() {
    return this._extra;
  }

  /**
   * @param extra{string}
   * @return {GetLayerMessage}
   */
  setExtra(extra) {
    this._extra = extra;
    return this;
  }
  /**
   * @return {number}
   */
  getFuid() {
    return this._fuid;
  }

  /**
   * @param fuid{number}
   * @return {GetLayerMessage}
   */
  setFuid(fuid) {
    this._fuid = fuid;
    return this;
  }
  /**
   * @return {number}
   */
  getId() {
    return this._id;
  }

  /**
   * @param id{number}
   * @return {GetLayerMessage}
   */
  setId(id) {
    this._id = id;
    return this;
  }
  /**
   * @return {number}
   */
  getBid() {
    return this._bid;
  }

  /**
   * @param bid{number}
   * @return {GetLayerMessage}
   */
  setBid(bid) {
    this._bid = bid;
    return this;
  }
  /**
   * @return {string}
   */
  getType() {
    return this._type;
  }

  /**
   * @param type{string}
   * @return {GetLayerMessage}
   */
  setType(type) {
    this._type = type;
    return this;
  }
  /**
   * @return {number}
   */
  getRrn() {
    return this._rrn;
  }

  /**
   * @param rrn{number}
   * @return {GetLayerMessage}
   */
  setRrn(rrn) {
    this._rrn = rrn;
    return this;
  }


  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = GetLayerMessage.CLASS_ID;
    
	//Serializing _extra
	if (this._extra)
		json['extra'] = this._extra;

	//Serializing _fuid
	if (this._fuid)
		json['fuid'] = this._fuid;

	//Serializing _id
	if (this._id)
		json['id'] = this._id;

	//Serializing _bid
	if (this._bid)
		json['bid'] = this._bid;

	//Serializing _type
	if (this._type)
		json['type'] = this._type;

	//Serializing _rrn
	if (this._rrn)
		json['rrn'] = this._rrn;


    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		this._extra = json.hasOwnProperty("extra")?json["extra"]:null;
		this._fuid = json.hasOwnProperty("fuid")?json["fuid"]:0;
		this._id = json.hasOwnProperty("id")?json["id"]:0;
		this._bid = json.hasOwnProperty("bid")?json["bid"]:0;
		this._type = json.hasOwnProperty("type")?json["type"]:null;
		this._rrn = json.hasOwnProperty("rrn")?json["rrn"]:0;


  }
}

/**
 * @returns {string}
 */
GetLayerMessage.CLASS_ID = "com.zoom.vab.client.autogenerated.GetLayerMessage";
/**
* Static Variables if any.
*/
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

export class TimeAndDatePrettyFormatQuery extends HttpOperation {

  constructor(name = "TimeAndDatePrettyFormat") {
    super(name);
    /**
     * @type {string}
     */
    this.MESSAGE_DATA_TYPE = "ComplexType";
    /**
     * @type {string}
     */
    this.RESPONSE_DATA_TYPE = "ComplexType";
  }

  /**
   * @returns {TimeAndDatePrettyFormatMsg}
   */
  get message() {
    return this._message;
  }

  /**
   * @param message{TimeAndDatePrettyFormatMsg}
   */
  set message(message) {
    this._message = message;
  }

  /**
   * @returns {TimeAndDatePrettyFormatResp}
   */
  get response() {
    return this._response;
  }

  /**
   * @returns {ErrorID}
   */
  getError() {
    return this._errorId;
  }

  /**
   *
   * @return {Object}
   */
  serializeJson() {
    let row = {};
    switch (this.MESSAGE_DATA_TYPE) {
      case "ComplexType":
        if (this.message)
          row["message"] = this._message.serializeJson();
        break;
      case "SimpleType":
        row["message"] = this._message;
        break;
      case "ArrayType":
        SerializationUtil.serializeArray(row, "message", this._message);
        break;
      case "SetType":
        SerializationUtil.serializeSet(row, "message", this._message, true);
        break;
      case "MapType":
        SerializationUtil.serializeHashMap(row, "message", this._message);
        break;
      case "EnumType":
        row["message"] = this._message.serializeJson();
        break;
    }
    row["queryName"] = TimeAndDatePrettyFormatQuery.QUERY_NAME;
    return {"query": row}
  }


  deserializeJson(json) {
    if (json == null) {
      this._response = null;
    }
    else{
      //get query
      let query = json.query? json.query : null;
      if (query == null) {
        this._response = null;
        return;
      }
      let queryName = query.queryName ? query.queryName : null;
      if (null == queryName || !(queryName.toUpperCase() === (TimeAndDatePrettyFormatQuery.QUERY_NAME).toUpperCase())) {
        //throw new IllegalStateError("Invalid query response received: " + queryName);
        this._response = null;
        return;
      }
      let responseJSON = query.response ? query.response : null;
      switch (this.RESPONSE_DATA_TYPE) {
        case "ComplexType":
          this._response = new TimeAndDatePrettyFormatResp();
          this._response.deserializeJson(responseJSON);
          break;
        case "SimpleType":
          this._response = responseJSON;
          break;
        case "ArrayType":
          this._response = SerializationUtil.deserializeArray(responseJSON);
          break;
        case "SetType":
          this._response = SerializationUtil.deserializeSet(responseJSON);
          break;
        case "MapType":
          this._response = SerializationUtil.deserializeMap(responseJSON);
          break;
        case "EnumType":
          this._response = new TimeAndDatePrettyFormatResp();
          this._response.deserializeJson(responseJSON);
          break;
      }
    }
  }
}

/**
 * @returns {string}
 */
TimeAndDatePrettyFormatQuery.CLASS_ID = "com.zoom.vab.client.autogenerated.TimeAndDatePrettyFormat";
/**
 * @returns {string}
 */
TimeAndDatePrettyFormatQuery.QUERY_NAME = "TimeAndDatePrettyFormat";
/***
 * ######### AutoGenerated Code ###########
 * User: git
 * Date: Apr 29, 2024 11:03:08 AM
 */

//Register Package


export class ServerPermissionsData {

  constructor() {
    
        /**
     * @type {DisabledItemsData}
     * @private
     */
    this._disabledItemsData = null;
    /**
     * @type {HashMap}
     * @private
     */
    this._project2DisabledItems = null;

  }

    /**
   * @return {DisabledItemsData}
   */
  getDisabledItemsData() {
    return this._disabledItemsData;
  }

  /**
   * @param disabledItemsData{DisabledItemsData}
   * @return {ServerPermissionsData}
   */
  setDisabledItemsData(disabledItemsData) {
    this._disabledItemsData = disabledItemsData;
    return this;
  }
  /**
   * @return {java.util.Map<String,DisabledItemsData>}
   */
  getProject2DisabledItems() {
    return this._project2DisabledItems;
  }

  /**
   * @param project2DisabledItems{java.util.Map<String,DisabledItemsData>}
   * @return {ServerPermissionsData}
   */
  setProject2DisabledItems(project2DisabledItems) {
    this._project2DisabledItems = project2DisabledItems;
    return this;
  }



  /**
   * Serializes the current class and returns a json object.
   */
  serializeJson() {
    //initialising json object
    let json = {};
    json["class"] = ServerPermissionsData.CLASS_ID;
    
	//Serializing ComplexType _$arrayName
	if (this._disabledItemsData)
		json['disabledItemsData'] = this._disabledItemsData.serializeJson();
		    SerializationUtil.serializeHashMap(json,"project2DisabledItems", this._project2DisabledItems);
		

    return json;
  }

  /**
   * Deserializes json object and sets the current class.
   */
  deserializeJson(json) {
    //return If json object is null
    if( !json ) {
      return;
    }
    		if (json.hasOwnProperty("disabledItemsData")){
			if (!this._disabledItemsData && this._disabledItemsData == null)
				this._disabledItemsData = new DisabledItemsData();
			this._disabledItemsData.deserializeJson(json.hasOwnProperty("disabledItemsData") ? json["disabledItemsData"] : null);
		}

//Map of type STRING. Decode as tree:false
		if (this._project2DisabledItems == null)
			this._project2DisabledItems = new HashMap();
		this._project2DisabledItems.clear();
		let project2DisabledItemsJSONArray = json.hasOwnProperty("project2DisabledItems") ? json["project2DisabledItems"] : [];
		this._project2DisabledItems = SerializationUtil.deserializeMap(project2DisabledItemsJSONArray);



  }
}

/**
 * @returns {string}
 */
ServerPermissionsData.CLASS_ID = "com.zoom.vab.client.autogenerated.ServerPermissionsData";
/**
* Static Variables if any.
*/
